<template>
    <div class="design_studio design_studio_up product_details_update_v3">
        <div class="container"></div>
        <section id="typography" class="design_studio_tool">
            <!-- Headings & Paragraph Copy -->
            <div class="">
                <div class="row">
                    <div class="col-md-6 p-0 col-xl-3 col-lg-5 scroll-panel">
                        <div class="tools">
                            <!-- Left Menus -->
                            <LeftMenus
                                :design_count="design_count"
                                :patch-enabled="isPatchEnabledForCurrentService"
                                :show-name-number="
                                    isNameNumberAllowedForCurrentService
                                "
                                @open-sidebar="showMenu"
                            />

                            <div
                                class="tab-content dsAddtext"
                                id="myTabContent"
                            >
                                <div
                                    :class="
                                        active_class == 'active'
                                            ? 'main_panel_check tab-pane fade show active'
                                            : 'main_panel_check tab-pane fade'
                                    "
                                    id="default1"
                                    role="tabpanel"
                                    aria-labelledby="default1-tab"
                                >
                                    <Dashboard
                                        ref="dashBoardComp"
                                        :product_title="product_title"
                                        :product_number="product_number"
                                        :product_id="product_id"
                                        :genders="genders"
                                        :t_shirt_24_hour="
                                            product_items &&
                                            product_items.t_shirt_24_hour
                                        "
                                        :user_selected_values="
                                            user_selected_values
                                        "
                                        :activeColorIndex="activeColorIndex"
                                        :designAreaData="design_area_data"
                                    />
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade template_tab_main_box"
                                    id="templates"
                                    role="tabpanel"
                                    aria-labelledby="add-templates-tab"
                                >
                                    <div
                                        class="left_panel design_studio_panel template_panel"
                                    >
                                        <div class="template_inside_category">
                                            <div
                                                v-show="category_heading"
                                                class="tools_headding catgory_headding w-100 template_heading"
                                            >
                                                <h4 class="heading5">
                                                    Choose Category
                                                </h4>
                                                <a
                                                    href="#"
                                                    @click="
                                                        closeMenu('templates')
                                                    "
                                                    title="Close"
                                                    class="ml-auto"
                                                    ><img
                                                        src="/maincss/images/tool_close.svg"
                                                        alt=" "
                                                /></a>
                                            </div>
                                            <div
                                                v-show="
                                                    selected_category_heading
                                                "
                                                class="tools_headding select_catgory_headding w-100"
                                            >
                                                <h4 class="heading5">
                                                    <a
                                                        href="#"
                                                        @click="
                                                            closeSelectedCategory(
                                                                'templates'
                                                            )
                                                        "
                                                        class="text_primary_blue"
                                                        ><img
                                                            src="/maincss/images/tool_back_arrow.svg"
                                                            alt=" "
                                                            class="mr_12"
                                                        /><span
                                                            v-text="
                                                                template_name
                                                            "
                                                            id="template_name"
                                                        ></span>
                                                    </a>
                                                </h4>
                                                <a
                                                    href="#"
                                                    class="ml-auto"
                                                    @click="
                                                        closeSelectedCategory(
                                                            'templates'
                                                        )
                                                    "
                                                    title="Close"
                                                    ><img
                                                        src="/maincss/images/tool_close.svg"
                                                        alt=" "
                                                /></a>
                                            </div>
                                            <div
                                                v-show="category_heading"
                                                class="serach"
                                            >
                                                <div
                                                    class="search_field position-relative mg-b-12 search_desi"
                                                >
                                                    <input
                                                        type="text"
                                                        placeholder="Search for category"
                                                        v-model="
                                                            template_search_query
                                                        "
                                                        class="form-control bg-transparent"
                                                        style="
                                                            border-bottom: 1px
                                                                solid #ccc !important;
                                                        "
                                                    />
                                                    <img
                                                        v-if="
                                                            template_search_query
                                                        "
                                                        @click="
                                                            template_search_query =
                                                                '';
                                                            template_category_search();
                                                        "
                                                        class="cross_image cursor-pointer"
                                                        src="/maincss/images/close_popup.svg"
                                                        alt=" "
                                                    />
                                                    <a
                                                        href="#"
                                                        class="search_icon"
                                                        ><img
                                                            src="/maincss/images/side_bar_serach.svg"
                                                            alt=" "
                                                    /></a>
                                                </div>
                                            </div>
                                            <div
                                                v-show="category_heading"
                                                class="categorys two_col_category"
                                                v-if="
                                                    template_category_search.length >
                                                        0 &&
                                                    (template_search_query ==
                                                        null ||
                                                        template_search_query ==
                                                            '')
                                                "
                                            >
                                                <div
                                                    class="w-100 d-flex justify-content-center align-items-center desi_grid"
                                                >
                                                    <div
                                                        class="main-div"
                                                        v-for="(
                                                            template, ind
                                                        ) in template_category_search"
                                                        :key="ind"
                                                    >
                                                        <template>
                                                            <a
                                                                href="javascript:void(0);"
                                                                v-if="
                                                                    ind == 0 &&
                                                                    show_popular_templates
                                                                "
                                                                @click="
                                                                    showPopularTemplates
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                Popular
                                                            </a>
                                                            <a
                                                                href="#"
                                                                @click="
                                                                    selectTemplateCategory(
                                                                        template
                                                                    )
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                {{
                                                                    template.name
                                                                }}
                                                            </a>
                                                        </template>
                                                    </div>
                                                </div>
                                                <span
                                                    v-if="
                                                        !template_category_search ||
                                                        template_category_search.length ==
                                                            0
                                                    "
                                                    >No results found.</span
                                                >
                                            </div>
                                            <div
                                                class="categorys_open tem"
                                                v-show="category_heading"
                                                v-else-if="
                                                    template_category_search.length >
                                                        0 &&
                                                    (template_search_query !=
                                                        null ||
                                                        template_search_query !=
                                                            '')
                                                "
                                            >
                                                <div
                                                    id="avatarlist"
                                                    class="avatarlist new_template_main_box d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                                >
                                                    <span
                                                        v-if="
                                                            template_category_search &&
                                                            template_category_search.length ==
                                                                0
                                                        "
                                                        >No results found.</span
                                                    >
                                                    <div
                                                        v-for="(
                                                            cate_image, index
                                                        ) in template_category_search"
                                                        :key="index"
                                                        class="form-check pl-0 img-polaroid cat_tempalte_object_fit mb_767_fit"
                                                        :class="
                                                            cate_image.selected_images ==
                                                            true
                                                                ? 'active'
                                                                : ''
                                                        "
                                                    >
                                                        <label
                                                            class="checkbox_custom brand_logo_select"
                                                        >
                                                            <img
                                                                v-tooltip="
                                                                    cate_image.name
                                                                "
                                                                :src="
                                                                    cate_image.image
                                                                "
                                                                :alt="
                                                                    cate_image.name
                                                                "
                                                            />
                                                            <input
                                                                :id="
                                                                    selected_template_subcategory.id +
                                                                    '' +
                                                                    index
                                                                "
                                                                @click="
                                                                    setNewTemplateDesign(
                                                                        cate_image
                                                                    )
                                                                "
                                                                type="radio"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <span
                                                v-if="
                                                    template_category_search &&
                                                    category_heading &&
                                                    template_category_search.length ==
                                                        0
                                                "
                                                >No results found.</span
                                            >
                                            <div
                                                v-show="
                                                    selected_template_category_show
                                                "
                                                class="serach"
                                            >
                                                <div
                                                    class="search_field position-relative mg-b-12 search_desi"
                                                >
                                                    <input
                                                        type="text"
                                                        placeholder="Search for sub category"
                                                        v-model="
                                                            template_subcategory_search_query
                                                        "
                                                        class="form-control bg-transparent"
                                                        style="
                                                            border-bottom: 1px
                                                                solid #ccc !important;
                                                        "
                                                    />
                                                    <img
                                                        v-if="
                                                            template_subcategory_search_query
                                                        "
                                                        @click="
                                                            template_subcategory_search_query =
                                                                '';
                                                            template_subcategory_search();
                                                        "
                                                        class="cross_image cursor-pointer"
                                                        src="/maincss/images/close_popup.svg"
                                                        alt=" "
                                                    />
                                                    <a
                                                        href="#"
                                                        class="search_icon"
                                                        ><img
                                                            src="/maincss/images/side_bar_serach.svg"
                                                            alt=" "
                                                    /></a>
                                                </div>
                                            </div>
                                            <div
                                                v-show="
                                                    selected_template_category_show
                                                "
                                                class="categorys two_col_category"
                                                v-if="
                                                    template_subcategory_search.length >
                                                        0 &&
                                                    (template_subcategory_search_query ==
                                                        null ||
                                                        template_subcategory_search_query ==
                                                            '')
                                                "
                                            >
                                                <div
                                                    class="w-100 d-flex justify-content-center align-items-center desi_grid"
                                                    :key="index"
                                                >
                                                    <div
                                                        class="main-div"
                                                        v-for="(
                                                            template_sub_category,
                                                            index
                                                        ) in template_subcategory_search"
                                                        :key="index"
                                                    >
                                                        <template>
                                                            <a
                                                                href="#"
                                                                v-if="
                                                                    index % 2 ==
                                                                    0
                                                                "
                                                                @click="
                                                                    getCustomImages(
                                                                        template_sub_category
                                                                    )
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                {{
                                                                    template_sub_category.name
                                                                }}
                                                            </a>
                                                            <a
                                                                href="#"
                                                                v-if="
                                                                    (index +
                                                                        1) %
                                                                        2 !=
                                                                        0 &&
                                                                    index + 1 in
                                                                        template_subcategory_search
                                                                "
                                                                @click="
                                                                    getCustomImages(
                                                                        template_subcategory_search[
                                                                            index +
                                                                                1
                                                                        ]
                                                                    )
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                {{
                                                                    template_subcategory_search[
                                                                        index +
                                                                            1
                                                                    ].name
                                                                }}
                                                            </a>
                                                        </template>
                                                    </div>
                                                </div>
                                                <span
                                                    v-if="
                                                        !template_subcategory_search ||
                                                        template_subcategory_search.length ==
                                                            0
                                                    "
                                                    >No results found.</span
                                                >
                                            </div>
                                            <div
                                                class="categorys_open tem"
                                                v-show="
                                                    selected_template_category_show
                                                "
                                                v-else-if="
                                                    template_subcategory_search.length >
                                                        0 &&
                                                    (template_subcategory_search_query !=
                                                        null ||
                                                        template_subcategory_search_query !=
                                                            '')
                                                "
                                            >
                                                <div
                                                    id="avatarlist"
                                                    class="avatarlist new_template_main_box d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                                >
                                                    <span
                                                        v-if="
                                                            template_subcategory_search &&
                                                            template_subcategory_search.length ==
                                                                0
                                                        "
                                                        >No results found.</span
                                                    >
                                                    <div
                                                        v-for="(
                                                            cate_image, index
                                                        ) in template_subcategory_search"
                                                        :key="index"
                                                        class="form-check pl-0 img-polaroid cat_tempalte_object_fit mb_767_fit"
                                                        :class="
                                                            cate_image.selected_images ==
                                                            true
                                                                ? 'active'
                                                                : ''
                                                        "
                                                    >
                                                        <label
                                                            class="checkbox_custom brand_logo_select"
                                                        >
                                                            <img
                                                                v-tooltip="
                                                                    cate_image.name
                                                                "
                                                                :src="
                                                                    cate_image.image
                                                                "
                                                                :alt="
                                                                    cate_image.name
                                                                "
                                                            />
                                                            <input
                                                                :id="
                                                                    selected_template_subcategory.id +
                                                                    '' +
                                                                    index
                                                                "
                                                                @click="
                                                                    setNewTemplateDesign(
                                                                        cate_image
                                                                    )
                                                                "
                                                                type="radio"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <span
                                                v-if="
                                                    template_subcategory_search &&
                                                    selected_template_category_show &&
                                                    template_subcategory_search.length ==
                                                        0
                                                "
                                                >No results found.</span
                                            >
                                            <div
                                                class="categorys_open tem"
                                                v-show="
                                                    selected_template_subcategory_show
                                                "
                                            >
                                                <div
                                                    id="avatarlist"
                                                    class="avatarlist new_template_main_box d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                                >
                                                    <span
                                                        v-if="
                                                            selected_template_subcategory.template_images &&
                                                            selected_template_subcategory
                                                                .template_images
                                                                .length == 0
                                                        "
                                                        >No templates
                                                        found.</span
                                                    >
                                                    <div
                                                        v-for="(
                                                            cate_image, index
                                                        ) in selected_template_subcategory.template_images"
                                                        :key="index"
                                                        class="form-check pl-0 img-polaroid cat_tempalte_object_fit mb_767_fit"
                                                        :class="
                                                            cate_image.selected_images ==
                                                            true
                                                                ? 'active'
                                                                : ''
                                                        "
                                                    >
                                                        <label
                                                            class="checkbox_custom brand_logo_select"
                                                        >
                                                            <img
                                                                v-tooltip="
                                                                    cate_image.name
                                                                "
                                                                :src="
                                                                    cate_image.image
                                                                "
                                                                :alt="
                                                                    cate_image.name
                                                                "
                                                            />
                                                            <input
                                                                :id="
                                                                    selected_template_subcategory.id +
                                                                    '' +
                                                                    index
                                                                "
                                                                @click="
                                                                    setNewTemplateDesign(
                                                                        cate_image
                                                                    )
                                                                "
                                                                type="radio"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <ClipSetting
                                                :data="selectImageProps"
                                                :addDeleteBtn="addDeleteBtn"
                                                :closeEdit="closeEdit"
                                                :showMenu="showMenu"
                                                :selectedType="selectedType"
                                                :edit_template="edit_template"
                                                :canvasActiveObject="backCanvas"
                                                :selectedObjectColors="
                                                    selected_object_colors
                                                "
                                                @undoAndRedo="saveCanvasData"
                                                :rotationAngle="rotationAngle"
                                                :vendor_colors_list="
                                                    vendor_colors_list
                                                "
                                                :has-service-color-type="
                                                    hasServiceColorType
                                                "
                                                :decorationType="
                                                    gender_groups_items[
                                                        active_gender_key
                                                    ].item.decoration_type
                                                "
                                                :printAreaBond="printAreaBond"
                                                :active_flip="active_flip"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="main_panel_check tab-pane fade"
                                    id="add-text"
                                    role="tabpanel"
                                    aria-labelledby="add-text-tab"
                                >
                                    <AddText
                                        :data="textData"
                                        v-on:closeMenu="closeMenu"
                                        :addDeleteBtn="addDeleteBtn"
                                        :canvasActiveObject="backCanvas"
                                        :selectedObjectColors="
                                            selected_object_colors
                                        "
                                        :designBox="design_box"
                                        @undoAndRedo="saveCanvasData"
                                        :fontCanvasWidth="front_canvas_width"
                                        :fontCanvasHeight="front_canvas_height"
                                        :fontCanvasTop="front_canvas_top"
                                        :fontCanvasLeft="front_canvas_left"
                                        :rotationAngle="rotationAngle"
                                        :designAreaAngle="front_canvas_angle"
                                        @triggerLoader="triggerLoader"
                                        :vendor_colors_list="vendor_colors_list"
                                        :has-service-color-type="
                                            hasServiceColorType
                                        "
                                        :decorationType="
                                            gender_groups_items[
                                                active_gender_key
                                            ].item.decoration_type
                                        "
                                        :printAreaBond="printAreaBond"
                                        :active_flip="active_flip"
                                    />
                                </div>

                                <div
                                    class="main_panel_check tab-pane fade add_clip_art_main_box_sec"
                                    id="add-clipart"
                                    role="tabpanel"
                                    aria-labelledby="add-clipart-tab"
                                >
                                    <div
                                        class="left_panel design_studio_panel left_no_scroll"
                                        v-if="!clipart_subcategory_div"
                                    >
                                        <ClipSetting
                                            :data="selectImageProps"
                                            :addDeleteBtn="addDeleteBtn"
                                            :closeEdit="closeEdit"
                                            :showMenu="showMenu"
                                            :selectedType="selectedType"
                                            :edit_template="edit_template"
                                            :canvasActiveObject="backCanvas"
                                            :selectedObjectColors="
                                                selected_object_colors
                                            "
                                            @undoAndRedo="saveCanvasData"
                                            :rotationAngle="rotationAngle"
                                            @triggerLoader="triggerLoader"
                                            :vendor_colors_list="
                                                vendor_colors_list
                                            "
                                            :has-service-color-type="
                                                hasServiceColorType
                                            "
                                            :decorationType="
                                                gender_groups_items[
                                                    active_gender_key
                                                ].item.decoration_type
                                            "
                                            :printAreaBond="printAreaBond"
                                            :active_flip="active_flip"
                                        />
                                        <div v-if="clipart_category_div">
                                            <div
                                                v-show="category_heading"
                                                class="tools_headding catgory_headding w-100 artwork_cate"
                                            >
                                                <h4 class="heading5">
                                                    Artwork Categories
                                                </h4>
                                                <a
                                                    href="#"
                                                    @click="
                                                        closeMenu('add-clipart')
                                                    "
                                                    class="ml-auto"
                                                    title="Close"
                                                    ><img
                                                        src="/maincss/images/tool_close.svg"
                                                        alt=" "
                                                /></a>
                                            </div>
                                            <div
                                                v-show="
                                                    selected_category_heading
                                                "
                                                class="tools_headding select_catgory_headding w-100"
                                            >
                                                <h4 class="heading5">
                                                    <a
                                                        href="#"
                                                        @click="
                                                            closeSelectedCategory(
                                                                'clipart_image'
                                                            )
                                                        "
                                                        class="text_primary_blue"
                                                        ><img
                                                            src="/maincss/images/tool_back_arrow.svg"
                                                            alt=" "
                                                            class="mr_12"
                                                        /><span
                                                            v-text="
                                                                clipart_name
                                                            "
                                                            id="clipart_name"
                                                        ></span>
                                                    </a>
                                                </h4>
                                                <a
                                                    href="#"
                                                    class="ml-auto"
                                                    title="Close"
                                                    ><img
                                                        src="/maincss/images/tool_close.svg"
                                                        alt=" "
                                                /></a>
                                            </div>
                                            <div
                                                v-show="
                                                    category_heading ||
                                                    selected_category_heading
                                                "
                                                class="serach"
                                            >
                                                <div
                                                    class="search_field position-relative mg-b-12 search_desi"
                                                >
                                                    <input
                                                        type="text"
                                                        placeholder="Search here"
                                                        v-model="
                                                            clipart_search_query
                                                        "
                                                        class="form-control bg-transparent"
                                                        style="
                                                            border-bottom: 1px
                                                                solid #cccccc !important;
                                                        "
                                                    />
                                                    <img
                                                        v-if="
                                                            clipart_search_query
                                                        "
                                                        @click="
                                                            clipart_search_query =
                                                                '';
                                                            clipart_category_search();
                                                        "
                                                        class="cross_image cursor-pointer"
                                                        src="/maincss/images/close_popup.svg"
                                                        alt=" "
                                                    />
                                                    <a
                                                        href="#"
                                                        class="search_icon"
                                                        ><img
                                                            src="/maincss/images/side_bar_serach.svg"
                                                            alt=" "
                                                    /></a>
                                                </div>
                                            </div>

                                            <div
                                                v-show="category_heading"
                                                class="categorys two_col_category"
                                                v-if="
                                                    clipart_category_search.length >
                                                        0 &&
                                                    (clipart_search_query ==
                                                        null ||
                                                        clipart_search_query ==
                                                            '')
                                                "
                                            >
                                                <div
                                                    class="w-100 d-flex justify-content-center align-items-center desi_grid"
                                                >
                                                    <div
                                                        class="main-div"
                                                        v-for="(
                                                            clipart,
                                                            clipart_index
                                                        ) in clipart_category_search"
                                                        :key="clipart_index"
                                                    >
                                                        <template>
                                                            <a
                                                                href="javascript:void(0);"
                                                                v-if="
                                                                    clipart_index ==
                                                                        0 &&
                                                                    show_popular_cliparts
                                                                "
                                                                @click="
                                                                    showPopularCliparts
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                Popular
                                                            </a>
                                                            <a
                                                                href="#"
                                                                v-if="
                                                                    clipart_index %
                                                                        2 ==
                                                                    0
                                                                "
                                                                @click="
                                                                    getClipartCliparts(
                                                                        clipart.id,
                                                                        clipart.category_name
                                                                    )
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                {{
                                                                    clipart.category_name
                                                                }}
                                                            </a>
                                                            <a
                                                                href="#"
                                                                v-if="
                                                                    clipart_index >
                                                                        0 &&
                                                                    (clipart_index +
                                                                        1) %
                                                                        2 !=
                                                                        0 &&
                                                                    clipart_index +
                                                                        1 in
                                                                        clipart_category_search
                                                                "
                                                                @click="
                                                                    getClipartCliparts(
                                                                        clipart_category_search[
                                                                            clipart_index +
                                                                                1
                                                                        ].id,
                                                                        clipart_category_search[
                                                                            clipart_index +
                                                                                1
                                                                        ]
                                                                            .category_name
                                                                    )
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                {{
                                                                    clipart_category_search[
                                                                        clipart_index +
                                                                            1
                                                                    ]
                                                                        .category_name
                                                                }}
                                                            </a>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                v-show="category_heading"
                                                class="categorys_open"
                                                v-else-if="
                                                    clipart_category_search.length >
                                                        0 &&
                                                    (clipart_search_query !=
                                                        null ||
                                                        clipart_search_query !=
                                                            '')
                                                "
                                            >
                                                <div
                                                    id="avatarlist"
                                                    class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                                >
                                                    <div
                                                        v-for="(
                                                            cate_image, index
                                                        ) in clipart_category_search"
                                                        :key="index"
                                                        class="form-check pl-0 img-polaroid clipart_img_size"
                                                    >
                                                        <label
                                                            class="checkbox_custom brand_logo_select"
                                                            ><img
                                                                v-tooltip="
                                                                    cate_image.image_name
                                                                "
                                                                :src="
                                                                    cate_image.image_path
                                                                "
                                                                :alt="
                                                                    cate_image.image_path
                                                                "
                                                            />
                                                            <input
                                                                class="clipart_item"
                                                                @click="
                                                                    placeImage(
                                                                        $event,
                                                                        cate_image.image_path,
                                                                        cate_image.des_std_clipart_id,
                                                                        index,
                                                                        'clipart',
                                                                        cate_image
                                                                    )
                                                                "
                                                                type="radio"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <span v-else
                                                >No results found.</span
                                            >
                                            <div
                                                class="categorys_open"
                                                v-show="
                                                    selected_clipart_category_show
                                                "
                                            >
                                                <div
                                                    id="avatarlist"
                                                    class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                                >
                                                    <div
                                                        v-for="(
                                                            cate_image, index
                                                        ) in selected_clipart_category.DesignStudioClipartImagesModels"
                                                        :key="index"
                                                        class="form-check pl-0 img-polaroid clipart_img_size"
                                                    >
                                                        <label
                                                            class="checkbox_custom brand_logo_select"
                                                            ><img
                                                                v-tooltip="
                                                                    cate_image.image_name
                                                                "
                                                                :src="
                                                                    cate_image.image_path
                                                                "
                                                                :alt="
                                                                    cate_image.image_path
                                                                "
                                                            />
                                                            <input
                                                                class="clipart_item"
                                                                @click="
                                                                    placeImage(
                                                                        $event,
                                                                        cate_image.image_path,
                                                                        selected_clipart_category.id,
                                                                        index,
                                                                        'clipart',
                                                                        cate_image
                                                                    )
                                                                "
                                                                type="radio"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- here the end categoty-->
                                    <div
                                        class="left_panel design_studio_panel clipart_panel"
                                        v-if="clipart_subcategory_div"
                                    >
                                        <ClipSetting
                                            :data="selectImageProps"
                                            :addDeleteBtn="addDeleteBtn"
                                            :closeEdit="closeEdit"
                                            :showMenu="showMenu"
                                            :selectedType="selectedType"
                                            :edit_template="edit_template"
                                            :canvasActiveObject="backCanvas"
                                            :selectedObjectColors="
                                                selected_object_colors
                                            "
                                            @undoAndRedo="saveCanvasData"
                                            :rotationAngle="rotationAngle"
                                            @triggerLoader="triggerLoader"
                                            :vendor_colors_list="
                                                vendor_colors_list
                                            "
                                            :has-service-color-type="
                                                hasServiceColorType
                                            "
                                            :decorationType="
                                                gender_groups_items[
                                                    active_gender_key
                                                ].item.decoration_type
                                            "
                                            :printAreaBond="printAreaBond"
                                            :active_flip="active_flip"
                                        />
                                        <div
                                            v-show="category_heading"
                                            class="tools_headding catgory_headding w-100"
                                        >
                                            <h4 class="heading5">
                                                <a
                                                    href="#"
                                                    @click="
                                                        closeSelectedCategory(
                                                            'clipart'
                                                        )
                                                    "
                                                    class="text_primary_blue"
                                                    ><img
                                                        src="/maincss/images/tool_back_arrow.svg"
                                                        alt=" "
                                                        class="mr_12"
                                                    /><span
                                                        v-text="
                                                            clipart_category_name
                                                        "
                                                        id="clipart_category_name"
                                                    ></span>
                                                </a>
                                            </h4>
                                            <a
                                                href="#"
                                                @click="
                                                    closeMenu('add-clipart')
                                                "
                                                class="ml-auto"
                                                title="Close"
                                                ><img
                                                    src="/maincss/images/tool_close.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                        <div
                                            v-show="selected_category_heading"
                                            class="tools_headding select_catgory_headding w-100"
                                        >
                                            <h4 class="heading5">
                                                <a
                                                    href="#"
                                                    @click="
                                                        closeSelectedCategory(
                                                            'clipart_image'
                                                        )
                                                    "
                                                    class="text_primary_blue"
                                                    ><img
                                                        src="/maincss/images/tool_back_arrow.svg"
                                                        alt=" "
                                                        class="mr_12"
                                                    /><span
                                                        v-text="clipart_name"
                                                        id="clipart_name"
                                                    ></span>
                                                </a>
                                            </h4>
                                            <a
                                                href="#"
                                                @click="
                                                    closeMenu('add-clipart')
                                                "
                                                class="ml-auto"
                                                title="Close"
                                                ><img
                                                    src="/maincss/images/tool_close.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                        <div
                                            v-show="category_heading"
                                            class="serach"
                                        >
                                            <div
                                                class="search_field position-relative mg-b-12 search_desi"
                                            >
                                                <input
                                                    type="text"
                                                    placeholder="Search here"
                                                    v-model="
                                                        clipart_subcategory_search_query
                                                    "
                                                    class="form-control bg-transparent"
                                                    style="
                                                        border-bottom: 1px solid
                                                            #cccccc !important;
                                                    "
                                                />
                                                <img
                                                    v-if="
                                                        clipart_subcategory_search_query
                                                    "
                                                    @click="
                                                        clipart_subcategory_search_query =
                                                            '';
                                                        clipart_subcategory_search();
                                                    "
                                                    class="cross_image cursor-pointer"
                                                    src="/maincss/images/close_popup.svg"
                                                    alt=" "
                                                />
                                                <a href="#" class="search_icon"
                                                    ><img
                                                        src="/maincss/images/side_bar_serach.svg"
                                                        alt=" "
                                                /></a>
                                            </div>
                                        </div>
                                        <!--@click="getImages(clipart, 'clipart',clipart_index)"-->
                                        <div
                                            v-show="category_heading"
                                            class="categorys two_col_category"
                                            v-if="
                                                clipart_subcategory_search.length >
                                                    0 &&
                                                (clipart_subcategory_search_query ==
                                                    null ||
                                                    clipart_subcategory_search_query ==
                                                        '')
                                            "
                                        >
                                            <div
                                                class="w-100 d-flex justify-content-center align-items-center desi_grid"
                                            >
                                                <div
                                                    class="main-div"
                                                    v-for="(
                                                        clipart, clipart_index
                                                    ) in clipart_subcategory_search"
                                                    :key="clipart_index"
                                                >
                                                    <template>
                                                        <a
                                                            href="#"
                                                            v-if="
                                                                clipart_index %
                                                                    2 ==
                                                                0
                                                            "
                                                            @click="
                                                                getImages(
                                                                    clipart,
                                                                    'clipart',
                                                                    clipart_index
                                                                )
                                                            "
                                                            class="category_link w-100 d-flex justify-content-center align-items-center"
                                                        >
                                                            {{ clipart.name }}
                                                        </a>
                                                        <a
                                                            href="#"
                                                            v-if="
                                                                (clipart_index +
                                                                    1) %
                                                                    2 !=
                                                                    0 &&
                                                                clipart_index +
                                                                    1 in
                                                                    clipart_subcategory_search
                                                            "
                                                            @click="
                                                                getImages(
                                                                    clipart_subcategory_search[
                                                                        clipart_index +
                                                                            1
                                                                    ],
                                                                    'clipart',
                                                                    clipart_index +
                                                                        1
                                                                )
                                                            "
                                                            class="category_link w-100 d-flex justify-content-center align-items-center"
                                                        >
                                                            {{
                                                                clipart_subcategory_search[
                                                                    clipart_index +
                                                                        1
                                                                ].name
                                                            }}
                                                        </a>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            v-show="category_heading"
                                            class="categorys"
                                            v-else-if="
                                                clipart_subcategory_search.length >
                                                    0 &&
                                                (clipart_subcategory_search_query !=
                                                    null ||
                                                    clipart_subcategory_search_query !=
                                                        '')
                                            "
                                        >
                                            <div
                                                id="avatarlist"
                                                class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                            >
                                                <div
                                                    v-for="(
                                                        cate_image, index
                                                    ) in clipart_subcategory_search"
                                                    :key="index"
                                                    class="form-check pl-0 img-polaroid clipart_img_size"
                                                >
                                                    <label
                                                        class="checkbox_custom brand_logo_select"
                                                        ><img
                                                            v-tooltip="
                                                                cate_image.image_name
                                                            "
                                                            :src="
                                                                cate_image.image_path
                                                            "
                                                            :alt="
                                                                cate_image.image_path
                                                            "
                                                        />
                                                        <div
                                                            v-if="
                                                                cate_image.image_colors
                                                            "
                                                            v-html="
                                                                designColorsHtml(
                                                                    cate_image.image_colors
                                                                )
                                                            "
                                                        ></div>
                                                        <input
                                                            class="clipart_item"
                                                            @click="
                                                                placeImage(
                                                                    $event,
                                                                    cate_image.image_path,
                                                                    cate_image.des_std_clipart_id,
                                                                    index,
                                                                    'clipart',
                                                                    cate_image
                                                                )
                                                            "
                                                            type="radio"
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <span v-show="category_heading" v-else
                                            >No results found.</span
                                        >
                                        <div
                                            class="categorys_open"
                                            v-show="
                                                selected_clipart_category_show
                                            "
                                        >
                                            <div
                                                id="avatarlist"
                                                class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                            >
                                                <div
                                                    v-for="(
                                                        cate_image, index
                                                    ) in selected_clipart_category.DesignStudioClipartImagesModels"
                                                    :key="index"
                                                    class="form-check pl-0 img-polaroid clipart_img_size"
                                                >
                                                    <label
                                                        class="checkbox_custom brand_logo_select"
                                                        ><img
                                                            v-tooltip="
                                                                cate_image.image_name
                                                            "
                                                            :src="
                                                                cate_image.image_path
                                                            "
                                                            :alt="
                                                                cate_image.image_path
                                                            "
                                                        />
                                                        <div
                                                            v-if="
                                                                cate_image.image_colors
                                                            "
                                                            v-html="
                                                                designColorsHtml(
                                                                    cate_image.image_colors
                                                                )
                                                            "
                                                        ></div>
                                                        <input
                                                            class="clipart_item"
                                                            @click="
                                                                placeImage(
                                                                    $event,
                                                                    cate_image.image_path,
                                                                    selected_clipart_category.id,
                                                                    index,
                                                                    'clipart',
                                                                    cate_image
                                                                )
                                                            "
                                                            type="radio"
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                            <span
                                                v-show="
                                                    selected_clipart_category_show &&
                                                    selected_clipart_category
                                                        .DesignStudioClipartImagesModels
                                                        .length == 0
                                                "
                                                >No results found.</span
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade add_shap_frontend_box_custom"
                                    id="add-shape"
                                    role="tabpanel"
                                    aria-labelledby="add-shape-tab"
                                >
                                    <div
                                        class="left_panel design_studio_panel_pd shape_design_panel design_panel_new"
                                    >
                                        <ClipSetting
                                            :data="selectImageProps"
                                            :addDeleteBtn="addDeleteBtn"
                                            :closeEdit="closeEdit"
                                            :showMenu="showMenu"
                                            :selectedType="selectedType"
                                            :edit_template="edit_template"
                                            :canvasActiveObject="backCanvas"
                                            :selectedObjectColors="
                                                selected_object_colors
                                            "
                                            @undoAndRedo="saveCanvasData"
                                            :rotationAngle="rotationAngle"
                                            @triggerLoader="triggerLoader"
                                            :vendor_colors_list="
                                                vendor_colors_list
                                            "
                                            :has-service-color-type="
                                                hasServiceColorType
                                            "
                                            :decorationType="
                                                gender_groups_items[
                                                    active_gender_key
                                                ].item.decoration_type
                                            "
                                            :printAreaBond="printAreaBond"
                                            :active_flip="active_flip"
                                        />

                                        <div
                                            v-show="category_heading"
                                            class="tools_headding catgory_headding w-100 heading-pd"
                                        >
                                            <h4 class="heading5">Add Shape</h4>
                                            <a
                                                href="#"
                                                @click="closeMenu('add-shape')"
                                                class="ml-auto"
                                                title="Close"
                                                ><img
                                                    src="/maincss/images/tool_close.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                        <div
                                            v-show="category_heading"
                                            class="categorys_open mt_14 shape_open"
                                        >
                                            <div
                                                id="avatarlist"
                                                class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                            >
                                                <div
                                                    v-for="(
                                                        shape, index
                                                    ) in shapes"
                                                    :key="index"
                                                    class="form-check pl-0 img-polaroid add_shap_pd"
                                                >
                                                    <label
                                                        class="checkbox_custom brand_logo_select"
                                                        ><img
                                                            v-tooltip="
                                                                shape.image_name
                                                            "
                                                            :src="
                                                                shape.image_path
                                                            "
                                                            :alt="
                                                                shape.image_name
                                                            "
                                                        />
                                                        <input
                                                            type="radio"
                                                            @click="
                                                                placeImage(
                                                                    $event,
                                                                    shape.image_path,
                                                                    shape.image_path,
                                                                    index,
                                                                    'shape',
                                                                    shape
                                                                )
                                                            "
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Old Add Patch panel (commented out; use Add Patch panel below) -->
                                <!-- <div
                                    v-if="isPatchEnabledForCurrentService"
                                    class="main_panel_check tab-pane fade"
                                    id="add-patch"
                                    role="tabpanel"
                                    aria-labelledby="add-patch-tab"
                                >
                                    <div
                                        class="left_panel design_studio_panel_pd"
                                    >
                                        <ClipSetting ... />
                                        <div v-show="category_heading" class="tools_headding ..."><h4 class="heading5">Add Patch</h4>...</div>
                                        <div v-show="category_heading" class="categorys_open ... patches list ..."></div>
                                    </div>
                                </div> -->
                                <!-- Add Patch: search + material accordion -->
                                <div
                                    v-if="isPatchEnabledForCurrentService"
                                    class="main_panel_check tab-pane fade"
                                    id="add-patch-new"
                                    role="tabpanel"
                                    aria-labelledby="add-patch-new-tab"
                                >
                                    <div
                                        class="left_panel design_studio_panel_pd design_panel_new"
                                    >
                                        <ClipSetting
                                            :data="selectImageProps"
                                            :addDeleteBtn="addDeleteBtn"
                                            :closeEdit="closeEdit"
                                            :showMenu="showMenu"
                                            :selectedType="selectedType"
                                            :edit_template="edit_template"
                                            :canvasActiveObject="backCanvas"
                                            :selectedObjectColors="
                                                selected_object_colors
                                            "
                                            @undoAndRedo="saveCanvasData"
                                            :rotationAngle="rotationAngle"
                                            @triggerLoader="triggerLoader"
                                            :vendor_colors_list="
                                                vendor_colors_list
                                            "
                                            :has-service-color-type="
                                                hasServiceColorType
                                            "
                                            :decorationType="
                                                gender_groups_items[
                                                    active_gender_key
                                                ].item.decoration_type
                                            "
                                            :printAreaBond="printAreaBond"
                                            :active_flip="active_flip"
                                        />
                                        <div
                                            v-show="!edit_template"
                                            class="tools_headding catgory_headding w-100 heading-pd mt-4"
                                        >
                                            <h4 class="heading5">Add Patch</h4>
                                            <a
                                                href="#"
                                                @click.prevent="
                                                    closeMenu('add-patch-new')
                                                "
                                                class="ml-auto"
                                                title="Close"
                                            >
                                                <img
                                                    src="/maincss/images/tool_close.svg"
                                                    alt=" "
                                                />
                                            </a>
                                        </div>
                                        <div
                                            v-show="!edit_template"
                                            class="patch-new-search mb-2"
                                        >
                                            <div
                                                class="search_field position-relative"
                                            >
                                                <input
                                                    type="text"
                                                    placeholder="Search Patch"
                                                    v-model.trim="
                                                        patchNewSearchQuery
                                                    "
                                                    class="form-control bg-transparent"
                                                    style="
                                                        border-bottom: 1px solid
                                                            #ccc !important;
                                                    "
                                                />
                                                <a
                                                    v-show="
                                                        !patchNewSearchQuery
                                                    "
                                                    href="#"
                                                    class="search_icon"
                                                    aria-hidden="true"
                                                    tabindex="-1"
                                                    ><img
                                                        src="/maincss/images/side_bar_serach.svg"
                                                        alt="Search"
                                                /></a>
                                                <a
                                                    v-show="
                                                        !!patchNewSearchQuery
                                                    "
                                                    href="#"
                                                    class="search_icon patch-new-clear-icon"
                                                    title="Clear search"
                                                    @click.prevent="
                                                        clearPatchNewSearch
                                                    "
                                                    ><img
                                                        src="/maincss/images/close_popup.svg"
                                                        alt="Clear"
                                                /></a>
                                            </div>
                                        </div>
                                        <!-- Customer Patch Inventory -->
                                        <div
                                            v-show="
                                                !edit_template &&
                                                dsPatchInventory.length > 0
                                            "
                                            class="patch-inventory-ds mt_8 mb-2"
                                            style="
                                                background: #f0f7ff;
                                                border: 1px solid #d0e3f7;
                                                border-radius: 6px;
                                                padding: 10px 12px;
                                            "
                                        >
                                            <div
                                                style="
                                                    font-weight: 600;
                                                    font-size: 13px;
                                                    margin-bottom: 4px;
                                                    color: #1a3e6e;
                                                "
                                            >
                                                My Patch Inventory
                                            </div>
                                            <div
                                                style="
                                                    font-size: 12px;
                                                    color: #1a6e3a;
                                                    margin-bottom: 6px;
                                                "
                                            >
                                                {{
                                                    totalDsPatchInventoryQty
                                                }}
                                                patches available in your
                                                inventory. Used first in price
                                                calculation.
                                            </div>
                                            <div
                                                v-for="inv in dsPatchInventory"
                                                :key="'inv-' + inv.id"
                                                class="d-flex align-items-center justify-content-between"
                                                style="
                                                    padding: 3px 0;
                                                    font-size: 12px;
                                                    cursor: pointer;
                                                    border-bottom: 1px solid
                                                        #e0eaf5;
                                                "
                                                @click="
                                                    placeInventoryPatch(inv)
                                                "
                                            >
                                                <span>
                                                    <img
                                                        v-if="
                                                            inv.patch &&
                                                            inv.patch.image_path
                                                        "
                                                        :src="
                                                            inv.patch.image_path
                                                        "
                                                        :alt="
                                                            inv.patch.image_name
                                                        "
                                                        style="
                                                            width: 24px;
                                                            height: 24px;
                                                            object-fit: contain;
                                                            margin-right: 6px;
                                                        "
                                                    />
                                                    {{
                                                        inv.patch
                                                            ? inv.patch
                                                                  .image_name
                                                            : "Patch #" +
                                                              inv.patch_id
                                                    }}
                                                    <span
                                                        v-if="
                                                            inv.width &&
                                                            inv.height
                                                        "
                                                        style="
                                                            color: #666;
                                                            font-size: 11px;
                                                        "
                                                    >
                                                        ({{ inv.width }}" x
                                                        {{ inv.height }}")
                                                    </span>
                                                </span>
                                                <span
                                                    style="
                                                        font-weight: 600;
                                                        color: #1a6e3a;
                                                        font-size: 11px;
                                                    "
                                                >
                                                    {{
                                                        inv.remaining_quantity
                                                    }}
                                                    left
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            v-show="!edit_template"
                                            class="patch-new-accordion mt_14 shape_open add-patch"
                                        >
                                            <div
                                                v-if="
                                                    patchMaterialsNewFiltered.length ===
                                                        0 && !patchNewLoading
                                                "
                                                class="text-muted small"
                                            >
                                                No materials available.
                                            </div>
                                            <div
                                                v-if="patchNewLoading"
                                                class="text-muted small"
                                            >
                                                Loading...
                                            </div>
                                            <div
                                                v-for="material in patchMaterialsNewFiltered"
                                                :key="material.id"
                                                class="patch-new-material-section border-bottom mb-2"
                                            >
                                                <a
                                                    href="javascript:void(0)"
                                                    class="d-flex align-items-center justify-content-between patch-new-material-header"
                                                    @click.prevent="
                                                        toggleMaterialNew(
                                                            material.id
                                                        )
                                                    "
                                                >
                                                    <span
                                                        class="patch_acco_title"
                                                        >{{
                                                            material.name
                                                        }}</span
                                                    >
                                                    <img
                                                        v-if="
                                                            expandedMaterialIdsNew.indexOf(
                                                                material.id
                                                            ) >= 0
                                                        "
                                                        src="/maincss/images/border_arrow.svg"
                                                        alt="collapse"
                                                        class="arrow_icon up"
                                                    />
                                                    <img
                                                        v-else
                                                        src="/maincss/images/border_arrow.svg"
                                                        alt="expand"
                                                        class="arrow_icon"
                                                    />
                                                </a>
                                                <div
                                                    v-show="
                                                        expandedMaterialIdsNew.indexOf(
                                                            material.id
                                                        ) >= 0
                                                    "
                                                    class="patch-new-patches-grid"
                                                >
                                                    <div
                                                        v-for="(
                                                            patch, index
                                                        ) in filteredPatchesByMaterial(
                                                            material.id
                                                        )"
                                                        :key="
                                                            patch.id +
                                                            '-' +
                                                            index
                                                        "
                                                        class="form-check patch-new-grid-item"
                                                    >
                                                        <label
                                                            class="checkbox_custom brand_logo_select"
                                                        >
                                                            <img
                                                                v-tooltip="
                                                                    patch.image_name
                                                                "
                                                                :src="
                                                                    patch.image_path
                                                                "
                                                                :alt="
                                                                    patch.image_name
                                                                "
                                                            />
                                                            <input
                                                                type="radio"
                                                                :name="
                                                                    'patch-new-' +
                                                                    material.id
                                                                "
                                                                @click="
                                                                    placeImage(
                                                                        $event,
                                                                        patch.image_path,
                                                                        patch.image_path,
                                                                        index,
                                                                        'patch',
                                                                        {
                                                                            ...patch,
                                                                            material_id:
                                                                                material.id
                                                                        }
                                                                    )
                                                                "
                                                            />
                                                        </label>
                                                        <div
                                                            class="patch-new-name small text-center mt-1"
                                                        >
                                                            {{
                                                                patch.image_name
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div
                                                        v-if="
                                                            filteredPatchesByMaterial(
                                                                material.id
                                                            ).length === 0
                                                        "
                                                        class="small text-muted w-100 py-2"
                                                    >
                                                        No patches found.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade"
                                    id="nn-tab"
                                    role="tabpanel"
                                    aria-labelledby="nn-tab"
                                >
                                    <NameAndNumber
                                        ref="nameAndNumberRef"
                                        :activeGenderKey="active_gender_key"
                                        :activeServiceData="
                                            currentActiveServiceData
                                        "
                                        :activeColorIndex="activeColorIndex"
                                        :selectedCheckbox="selectedCheckbox"
                                        @activeFrontType="activeFrontType"
                                        :canvasActiveObject="backCanvas"
                                        :frontCanvasTop="front_canvas_top"
                                        :frontCanvasLeft="front_canvas_left"
                                        v-on:closeMenu="closeMenu"
                                        @flipTshirt="flipTshirt"
                                        @undoAndRedo="saveCanvasData"
                                        @updateNameNumberFees="
                                            updateNameNumberFees
                                        "
                                        :designBox="design_box"
                                        :adminOptions="adminOptions"
                                        :gender-groups-items="
                                            gender_groups_items
                                        "
                                    />
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade"
                                    id="distress-effects"
                                    role="tabpanel"
                                    aria-labelledby="distress-effects-tab"
                                >
                                    <div
                                        class="left_panel design_studio_panel_pd"
                                    >
                                        <DistressImageList
                                            :addDistressImage="
                                                add_distress_images
                                            "
                                            :showImageList="showImageList"
                                            @closeImageList="closeImageList"
                                            :canvasActiveObj="backCanvas"
                                            v-on:set-value="updateDistressImage"
                                            :selectedDistressImage="
                                                selectedDistressImage
                                            "
                                            @undoAndRedo="saveCanvasData"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade upload_main_panel"
                                    id="upload"
                                    role="tabpanel"
                                    aria-labelledby="add-upload-tab"
                                >
                                    <div
                                        class="left_panel design_studio_panel_images"
                                    >
                                        <ClipSetting
                                            :data="selectImageProps"
                                            :addDeleteBtn="addDeleteBtn"
                                            :closeEdit="closeEdit"
                                            :showMenu="showMenu"
                                            :selectedType="selectedType"
                                            :edit_template="edit_template"
                                            :canvasActiveObject="backCanvas"
                                            :selectedObjectColors="
                                                selected_object_colors
                                            "
                                            @undoAndRedo="saveCanvasData"
                                            :rotationAngle="rotationAngle"
                                            @triggerLoader="triggerLoader"
                                            :vendor_colors_list="
                                                vendor_colors_list
                                            "
                                            :has-service-color-type="
                                                hasServiceColorType
                                            "
                                            :decorationType="
                                                gender_groups_items[
                                                    active_gender_key
                                                ].item.decoration_type
                                            "
                                            :printAreaBond="printAreaBond"
                                            :active_flip="active_flip"
                                        />
                                        <!-- Upload tab: list, form, current image and colors (component) -->
                                        <UploadImageV3
                                            :category-heading="category_heading"
                                            :uploaded-images="uploadedImages"
                                            :show-upload-form="showUploadForm"
                                            :uploaded-image-name="
                                                uploaded_image_name
                                            "
                                            :current-upload-record="
                                                currentUploadRecord
                                            "
                                            :uploaded-design-image="
                                                uploaded_design_image
                                            "
                                            :uploaded-image-top-colors="
                                                uploadedImageTopColors
                                            "
                                            :desired-color-count="
                                                desiredColorCount
                                            "
                                            :empty-boxes-count="emptyBoxesCount"
                                            :vendor-colors-list="
                                                vendor_colors_list
                                            "
                                            :has-service-color-type="
                                                hasServiceColorType
                                            "
                                            :decoration-type="
                                                gender_groups_items[
                                                    active_gender_key
                                                ].item.decoration_type
                                            "
                                            :service-color-type="
                                                gender_groups_items[
                                                    active_gender_key
                                                ] &&
                                                gender_groups_items[
                                                    active_gender_key
                                                ].activeServiceData &&
                                                gender_groups_items[
                                                    active_gender_key
                                                ].activeServiceData
                                                    .master_service
                                                    ? gender_groups_items[
                                                          active_gender_key
                                                      ].activeServiceData
                                                          .master_service
                                                          .color_type || ''
                                                    : ''
                                            "
                                            @close="
                                                cancelUploadDraft();
                                                closeMenu('upload');
                                            "
                                            @back="showUploadForm = false"
                                            @upload-new="onUploadNewImage"
                                            @file-change="croppie_upload_image"
                                            @submit-upload="saveUploadDraft"
                                            @select-image="
                                                showUploadForm = true;
                                                bindUploadedDesignImage(
                                                    $event.image,
                                                    $event.image_data
                                                );
                                            "
                                            @delete-image="
                                                deleteUploadedImage($event)
                                            "
                                            @update:uploadedImageName="
                                                onUploadImageNameUpdated($event)
                                            "
                                            @update:desiredColorCount="
                                                desiredColorCount = $event
                                            "
                                            @add-color-slot="
                                                addColorSlot($event)
                                            "
                                            @select-color-from-list="
                                                updateUploadedColorFromList(
                                                    $event
                                                )
                                            "
                                            @delete-color="deleteColor($event)"
                                            @add-new-color-box="addNewColorBox"
                                            @save-upload-draft="saveUploadDraft"
                                            @cancel-upload-draft="
                                                cancelUploadDraft
                                            "
                                        />
                                        <!-- Crop popup (kept in parent for refs) -->
                                        <div
                                            class="modal login-form-popup fade h-auto"
                                            id="crop_modal"
                                            tabindex="-1"
                                            aria-labelledby="login"
                                            aria-hidden="true"
                                            data-keyboard="false"
                                            data-backdrop="static"
                                        >
                                            <div class="modal-content">
                                                <div class="modal-body">
                                                    <a
                                                        href="#"
                                                        class="popup-close"
                                                        id="popup-close"
                                                        data-dismiss="modal"
                                                    >
                                                        <img
                                                            src="/maincss/images/cancel.svg"
                                                            alt=" "
                                                        />
                                                    </a>
                                                    <div class="login-form">
                                                        <h3>Upload and Crop</h3>
                                                        <!--crop tool-->
                                                        <div
                                                            class="upload_crop_design_studio"
                                                        >
                                                            <input
                                                                class="crop_bdr"
                                                                id="crop_bdr"
                                                                type="file"
                                                                @change="
                                                                    croppie
                                                                "
                                                            />

                                                            <small
                                                                class="form-text text-error"
                                                                v-if="
                                                                    crop_image_validation ==
                                                                    1
                                                                "
                                                                >Incorrect image
                                                                format.Please
                                                                upload the Png,
                                                                Jpg, Jpeg, Svg
                                                                image
                                                                formats</small
                                                            >
                                                            <small
                                                                class="form-text text-error"
                                                                v-if="
                                                                    image_size_validation ==
                                                                    1
                                                                "
                                                                >Please upload
                                                                images greater
                                                                than 1000px X
                                                                1000px</small
                                                            >
                                                            <vue-croppie
                                                                ref="croppieRef"
                                                                :enableOrientation="
                                                                    true
                                                                "
                                                                :enableResize="
                                                                    false
                                                                "
                                                                :mouseWheelZoom="
                                                                    false
                                                                "
                                                                :boundary="{
                                                                    width: 300,
                                                                    height: 300
                                                                }"
                                                                :viewport="{
                                                                    width: 200,
                                                                    height: 200,
                                                                    type: 'square'
                                                                }"
                                                            >
                                                            </vue-croppie>
                                                        </div>
                                                        <!-- the result -->
                                                        <!-- <img :src="cropped"> -->
                                                        <!-- Rotate angle is Number -->
                                                        <div
                                                            class="crp_bottom_btn"
                                                        >
                                                            <button
                                                                class="btn btn_outline_primary border_primary_blue text_primary_blue apply_upload"
                                                                type="button"
                                                                @click="
                                                                    rotate(-90)
                                                                "
                                                            >
                                                                Rotate Left
                                                            </button>
                                                            <button
                                                                class="btn btn_outline_primary border_primary_blue text_primary_blue apply_upload"
                                                                type="button"
                                                                @click="
                                                                    rotate(90)
                                                                "
                                                            >
                                                                Rotate Right
                                                            </button>
                                                            <button
                                                                style="
                                                                    background-color: #f2790c !important;
                                                                    color: #fff !important;
                                                                    border: 1px
                                                                        solid
                                                                        #f2790c !important;
                                                                "
                                                                class="btn btn_outline_primary border_primary_blue text_primary_blue apply_upload"
                                                                type="button"
                                                                @click="crop"
                                                                :disabled="
                                                                    !uploaded_design_image
                                                                "
                                                            >
                                                                Crop
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade"
                                    id="designs"
                                    role="tabpanel"
                                    aria-labelledby="designs-tab"
                                >
                                    <MyDesigns
                                        :design_tab_active="design_tab_active"
                                        :current_design_id="current_design_id"
                                        :statusFilter="1"
                                        :serviceFilter="myDesignServiceFilter"
                                        :productCategoryId="
                                            product_items.category_id
                                        "
                                        @close-design="closeMenu('designs')"
                                        @set-new-design="setNewDesign"
                                        @open-design-history="openDesignHistory"
                                    />
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade"
                                    id="archive"
                                    role="tabpanel"
                                    aria-labelledby="archive-tab"
                                >
                                    <MyDesigns
                                        :design_tab_active="archive_tab_active"
                                        :current_design_id="current_design_id"
                                        :statusFilter="0"
                                        :serviceFilter="myDesignServiceFilter"
                                        :productCategoryId="
                                            product_items.category_id
                                        "
                                        @close-design="closeMenu('archive')"
                                        @set-new-design="setNewDesign"
                                        @open-design-history="openDesignHistory"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-md-6 p-0 col-xl-7 col-lg-7 design-area-v3"
                        style="position: relative"
                    >
                        <!-- Design History Panel (Right Side Drawer) -->
                        <div
                            v-if="showDesignHistory"
                            class="design-history-overlay"
                            @click.self="closeDesignHistory"
                        >
                            <div class="design-history-drawer">
                                <DesignHistory
                                    :designId="selectedDesignHistoryId"
                                    @close-history="closeDesignHistory"
                                />
                            </div>
                        </div>
                        <div class="desin_studio_center_main_area">
                            <div class="desin_studio_center_right_panel">
                                <div class="bg-white h-100 design_studio_right_side">
                                    <div class="reser_button"></div>
        
                                    <div align="center" class="" style="">
                                        <div class="clearfix">
                                            <div
                                                class="pull-right"
                                                align=""
                                                id="imageeditor"
                                                style="display: none"
                                            >
                                                <div class="btn-group">
                                                    <button
                                                        id="remove-selected"
                                                        class="btn"
                                                        title="Delete selected item"
                                                        @click="delete_object()"
                                                    >
                                                        <i
                                                            class="icon-trash"
                                                            style="height: 19px"
                                                        ></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
        
                                    <!--  EDITOR      -->
                                    <div class="mx-auto">
                                        <div
                                            class="back_front_t-shirt right_sec_design_studio_t_shirt"
                                            style="display: none"
                                        >
                                            <div
                                                class="btn_front front active"
                                                v-show="front_show"
                                            ></div>
                                            <div
                                                class="btn_front back"
                                                v-show="back_show"
                                            ></div>
                                            <div
                                                class="btn_front left"
                                                v-show="left_show"
                                            >
                                                <button
                                                    id="left_flipbtn"
                                                    type="button"
                                                    class="btn"
                                                    title="Left"
                                                    @click="flipTshirt('left')"
                                                    data-original-title="Show Left View"
                                                    :disabled="disable_tshirt_canvas"
                                                >
                                                    <img
                                                        name="tshirtview"
                                                        id=""
                                                        src="/maincss/design-studio/img/lft_sl.png"
                                                    />
                                                </button>
                                                <p>Left</p>
                                            </div>
                                            <div
                                                class="btn_front right"
                                                v-show="right_show"
                                            >
                                                <button
                                                    id="right_flipbtn"
                                                    type="button"
                                                    class="btn"
                                                    title="Right"
                                                    @click="flipTshirt('right')"
                                                    data-original-title="Show Right View"
                                                    :disabled="disable_tshirt_canvas"
                                                >
                                                    <img
                                                        name="tshirtview"
                                                        id=""
                                                        src="/maincss/design-studio/img/rgt_slv.png"
                                                    />
                                                </button>
                                                <p>Right</p>
                                            </div>
                                        </div>
                                        <div
                                            class="reset-btn"
                                            style="display: none !important"
                                        ></div>
                                        <div class="design_area_section">
                                            <div
                                                class="design_area_block design_area_block_msg_overlay"
                                            >
                                                <div
                                                    v-show="
                                                        imageZoomMode &&
                                                        !imageZoomMessageDismissed
                                                    "
                                                    class="image-zoom-canvas-message message-with-close"
                                                    :class="{
                                                        visible:
                                                            imageZoomMode &&
                                                            !imageZoomMessageDismissed
                                                    }"
                                                >
                                                    Use mouse wheel for zoom in and out
                                                    <button
                                                        type="button"
                                                        class="message-close-btn"
                                                        aria-label="Close"
                                                        @click="
                                                            imageZoomMessageDismissed = true
                                                        "
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                                <div
                                                    v-if="
                                                        currentViewHasCustomBox &&
                                                        !imageZoomMode &&
                                                        !imageUnavailableMessageDismissed
                                                    "
                                                    class="custom_box_message_ds message-with-close"
                                                >
                                                    Image currently unavailable. Use the
                                                    Imprint Area below for your artwork.
                                                    A proof will be sent for your
                                                    approval prior to production.
                                                    <button
                                                        type="button"
                                                        class="message-close-btn"
                                                        aria-label="Close"
                                                        @click="
                                                            imageUnavailableMessageDismissed = true
                                                        "
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                                <div
                                                    id="shirtDiv"
                                                    :class="[
                                                        'page',
                                                        'mx-auto',
                                                        designAreaMarginTopClass
                                                    ]"
                                                    :style="shirtDivStyle"
                                                >
                                                    <div
                                                        v-show="imageZoomMode"
                                                        class="image-zoom-overlay"
                                                        @wheel.prevent="
                                                            onImageZoomWheel
                                                        "
                                                        @mousedown="onImagePanStart"
                                                    ></div>
                                                    <div
                                                        id="drawingArea"
                                                        class=""
                                                        :style="`
                                                        position: absolute;
                                                        left: 0;
                                                        width: ${effectiveDesignAreaWidth}px;
                                                        height: ${effectiveDesignAreaHeight}px;`"
                                                    >
                                                        <fabric-canvas
                                                            :id="'bcanvas'"
                                                            :height="
                                                                effectiveDesignAreaHeight
                                                            "
                                                            :width="
                                                                effectiveDesignAreaWidth
                                                            "
                                                            :stateful="false"
                                                            @canvas-updated="
                                                                canvasImageUpdated
                                                            "
                                                        >
                                                        </fabric-canvas>
                                                    </div>
                                                    <fabric-canvas
                                                        :id="'tcanvas'"
                                                        :height="
                                                            effectiveDesignAreaHeight
                                                        "
                                                        :width="
                                                            effectiveDesignAreaWidth
                                                        "
                                                        :stateful="true"
                                                        @canvas-updated="
                                                            canvasBackUpdated
                                                        "
                                                        @object-moved="objMoved"
                                                        @object-moving="objMoving"
                                                        @object-scaling="objScaling"
                                                        @object-rotating="objRotating"
                                                        @object-skweing="objSkewing"
                                                        @object-modified="objModified"
                                                        @object-removed="objRemoved"
                                                        @selection-created="objSelected"
                                                        @selection-updated="objSelected"
                                                        @selection-cleared="
                                                            objSelectionCleared
                                                        "
                                                        @drop="objDropped"
                                                        @after-render="afterRender"
                                                        @mousedown="objMouseDown"
                                                        @mouseup="objMouseUp"
                                                    >
                                                    </fabric-canvas>
                                                </div>
                                            </div>
                                            <div class="undo-redo-btn">
                                                <p>Decoration Method:</p>
                                                <p class="method_name">
                                                    {{ decorationMethodName }}
                                                </p>
                                                <button
                                                    class="undo-btn"
                                                    id="undoObj"
                                                    disabled
                                                >
                                                    Undo
                                                    <img
                                                        src="/maincss/design-studio/img/Undo.svg"
                                                        alt=""
                                                        class="undo"
                                                    />
                                                    <img
                                                        class="undo-inable"
                                                        src="/maincss/design-studio/img/Undo-ac.svg"
                                                        alt=""
                                                    />
                                                </button>
        
                                                <button
                                                    class="redo-btn"
                                                    id="redoObj"
                                                    disabled
                                                >
                                                    Redo
                                                    <img
                                                        src="/maincss/design-studio/img/Redo.svg"
                                                        alt=""
                                                        class="redo"
                                                    />
                                                    <img
                                                        class="redo-inable"
                                                        src="/maincss/design-studio/img/Redo-ac.svg"
                                                        alt=""
                                                    />
                                                </button>
                                                <button
                                                    class="redo-btn reset"
                                                    id="newResetbtn"
                                                    data-toggle="modal"
                                                    data-target="#reset_popup"
                                                    disabled
                                                >
                                                    Reset
                                                    <img
                                                        src="/maincss/design-studio/img/reset_desi.png"
                                                        alt=""
                                                        class="redo"
                                                    />
                                                </button>
                                                <label
                                                    class="canvas-zoom-toggle"
                                                    title="Turn on to zoom and pan the product image with scroll and drag"
                                                    @click.stop
                                                >
                                                    <input
                                                        type="checkbox"
                                                        v-model="imageZoomMode"
                                                        @change="onImageZoomModeChange"
                                                        @click.stop
                                                    />
                                                    <span
                                                        class="canvas-zoom-toggle-label"
                                                        >Image Zoom</span
                                                    >
                                                </label>
                                            </div>
                                            <div class="row slider_row desktop_color_slider">
                                                <!-- Slider -->
                                                <div class="col-md-6">
                                                    <div
                                                        class="design_studio_footer design_studio_s design_studio_slider design_slider_with_color"
                                                    >
                                                        <div class="design_footer-flex">
                                                            <div
                                                                class="col-md-12 slider_col"
                                                            >
                                                                <ColorOwlCarousel
                                                                    :user_selected_values="
                                                                        user_selected_values
                                                                    "
                                                                    :activeColorIndex="
                                                                        activeColorIndex
                                                                    "
                                                                    @set-canvas-color="
                                                                        SetColorCanvas
                                                                    "
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="back_front_t-shirt right_sec_design_studio_t_shirt direction_block"
                                        >
                                            <PrintAreaIcons
                                                ref="printAreaIcons"
                                                @flipTshirt="flipTshirt"
                                                @getPrintAreaParent="getPrintAreaParent"
                                                @viewAllDesignAreas="
                                                    openAllDesignAreasPreview
                                                "
                                                @changePrintArea="
                                                    (flip) => {
                                                        this.imageZoomMessageDismissed = false;
                                                        this.imageUnavailableMessageDismissed = false;
                                                        this.active_flip = flip;
                                                        this.selected_art_dimensions = null;
                                                    }
                                                "
                                                :front_show="front_show"
                                                :back_show="back_show"
                                                :left_show="left_show"
                                                :right_show="right_show"
                                                :product_design_area="design_area_data"
                                                :current_flip="active_flip"
                                                :selected-art-size="
                                                    selected_art_dimensions
                                                "
                                                :gender_groups="gender_groups_items"
                                                :disabled="colors_validation != ''"
                                                :colors-validation="colors_validation"
                                            >
                                            </PrintAreaIcons>
                                        </div>
        
                                        <div class="row" style="margin-right: -3px">
                                            <div class="col-md-4">
                                                <div
                                                    class="design_studio_footer design_studio_s design_studio_slider design_slider_with_color p-0"
                                                >
                                                    <div
                                                        class="col-md-12 artwork_colors pl-0"
                                                    >
                                                        <div
                                                            class="new_arts_color1"
                                                            v-show="
                                                                current_stock_colors.length
                                                            "
                                                        >
                                                            <label>{{
                                                                stockColorsLabel
                                                            }}</label>
                                                            <div
                                                                class="ui-palette-box mb_20 present_color"
                                                                style="
                                                                    grid-template-columns: repeat(
                                                                        auto-fill,
                                                                        minmax(
                                                                            1.75rem,
                                                                            1fr
                                                                        )
                                                                    );
                                                                    display: grid;
                                                                    height: 28px;
                                                                "
                                                            >
                                                                <template
                                                                    v-for="(
                                                                        color, index
                                                                    ) in current_stock_colors"
                                                                >
                                                                    <div
                                                                        :key="index"
                                                                        v-if="
                                                                            color.hex !=
                                                                            tshirt_color
                                                                        "
                                                                        class="marign_color"
                                                                        :style="
                                                                            'display: grid; background:' +
                                                                            color.hex +
                                                                            ';'
                                                                        "
                                                                        v-tooltip="{
                                                                            content:
                                                                                color.name
                                                                                    ? `${color.name}<br/>${color.hex}`
                                                                                    : color.hex,
                                                                            html: true
                                                                        }"
                                                                    ></div>
                                                                </template>
                                                            </div>
                                                            <div
                                                                v-if="
                                                                    colors_validation &&
                                                                    false
                                                                "
                                                                style="color: red"
                                                            >
                                                                {{ colors_validation }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4 p-0">
                                                <div
                                                    class="design_studio_footer design_studio_s design_studio_slider design_slider_with_color p-0"
                                                >
                                                    <div
                                                        class="col-md-12 artwork_colors pl-0"
                                                    >
                                                        <div
                                                            class="new_arts_color1"
                                                            v-show="
                                                                current_specialty_ink_colors &&
                                                                current_specialty_ink_colors.length
                                                            "
                                                        >
                                                            <label
                                                                >Specialty Color</label
                                                            >
                                                            <div
                                                                style="
                                                                    text-align: left;
                                                                    font-weight: normal;
                                                                    font-size: 13px;
                                                                    line-height: 22px;
                                                                    letter-spacing: 0px;
                                                                    color: #2b2b2b;
                                                                    opacity: 1;
                                                                    margin-bottom: 10px;
                                                                "
                                                            >
                                                                ({{
                                                                    icPriceFormat(
                                                                        totalSpecialtyInkUpcharge
                                                                    )
                                                                }})
                                                            </div>
                                                            <div
                                                                class="ui-palette-box mb_20 present_color"
                                                                style="
                                                                    grid-template-columns: repeat(
                                                                        auto-fill,
                                                                        minmax(
                                                                            1.75rem,
                                                                            1fr
                                                                        )
                                                                    );
                                                                    display: grid;
                                                                    height: 28px;
                                                                "
                                                            >
                                                                <template
                                                                    v-for="(
                                                                        color, index
                                                                    ) in current_specialty_ink_colors"
                                                                >
                                                                    <div
                                                                        :key="index"
                                                                        v-if="
                                                                            color.hex !=
                                                                            tshirt_color
                                                                        "
                                                                        class="marign_color"
                                                                        :style="
                                                                            'display: grid; background:' +
                                                                            color.hex +
                                                                            ';'
                                                                        "
                                                                        v-tooltip="{
                                                                            content:
                                                                                color.name
                                                                                    ? `${
                                                                                          color.name
                                                                                      }<br/>${
                                                                                          color.hex
                                                                                      }<br/>Upcharge: ${icPriceFormat(
                                                                                          color.upcharge
                                                                                      )}`
                                                                                    : `${
                                                                                          color.hex
                                                                                      }<br/>Upcharge: ${icPriceFormat(
                                                                                          color.upcharge
                                                                                      )}`,
                                                                            html: true
                                                                        }"
                                                                    ></div>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3 p-0">
                                                <div
                                                    class="design_studio_footer design_studio_s design_studio_slider design_slider_with_color p-0"
                                                >
                                                    <div
                                                        class="col-md-12 artwork_colors pl-0"
                                                    >
                                                        <div
                                                            class="new_arts_color1"
                                                            v-show="
                                                                showCombinedCustomAndThread
                                                            "
                                                        >
                                                            <label>{{
                                                                combinedCustomAndThreadLabel
                                                            }}</label>
                                                            <div
                                                                v-if="
                                                                    combinedCustomAndThreadPrice >
                                                                    0
                                                                "
                                                                style="
                                                                    text-align: left;
                                                                    font-weight: normal;
                                                                    font-size: 13px;
                                                                    line-height: 22px;
                                                                    letter-spacing: 0px;
                                                                    color: #2b2b2b;
                                                                    opacity: 1;
                                                                    margin-bottom: 10px;
                                                                "
                                                            >
                                                                ({{
                                                                    icPriceFormat(
                                                                        combinedCustomAndThreadPrice
                                                                    )
                                                                }})
                                                            </div>
                                                            <div
                                                                class="ui-palette-box mb_20 present_color"
                                                                style="
                                                                    grid-template-columns: repeat(
                                                                        auto-fill,
                                                                        minmax(
                                                                            1.75rem,
                                                                            1fr
                                                                        )
                                                                    );
                                                                    display: grid;
                                                                    height: 28px;
                                                                "
                                                            >
                                                                <template
                                                                    v-for="(
                                                                        color, index
                                                                    ) in combinedCustomAndThreadColors"
                                                                >
                                                                    <div
                                                                        :key="index"
                                                                        v-if="
                                                                            color !=
                                                                            tshirt_color
                                                                        "
                                                                        class="marign_color"
                                                                        v-tooltip="
                                                                            color
                                                                        "
                                                                        :style="
                                                                            'display: grid; background:' +
                                                                            color +
                                                                            ';'
                                                                        "
                                                                    ></div>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                  
                                </div>
                                <div
                                class="d-md-flex mt_20 cost_total_col outside_costs col-xl-2 col-md-6 pl-2 drawer_panel"
                            >
                                <div class="outside_costs_items">
                                    <div class="quantity d-flex align-items-center">
                                        <h4 class="font_size_22 mb-0 ml_10">Qty</h4>
                                        <h3 class="font_size_35 mb-0 ml_10 font_w_light">
                                            {{
                                                gender_groups_items[active_gender_key]
                                                    .total_qty
                                            }}
                                        </h3>
                                    </div>
        
                                    <div
                                        class="quantity d-flex align-items-center ml_10"
                                    >
                                        <h4 class="font_size_22 mb-0">Total Cost</h4>
        
                                        <h3
                                            class="font_size_35 mb-0 ml_10 d-flex font_bold"
                                        >
                                            {{
                                                icPriceFormat(
                                                    gender_groups_items[
                                                        active_gender_key
                                                    ].total_cost
                                                )
                                            }}
                                        </h3>
                                    </div>
                                    <div
                                        v-if="(parseFloat(patchCostTotal) || 0) > 0"
                                        class="quantity d-flex align-items-center ml_10"
                                        :title="patchCostTooltipText || undefined"
                                    >
                                        <h4 class="font_size_22 mb-0">Patch Cost</h4>
                                        <h3 class="font_size_35 mb-0 ml_10 d-flex">
                                            {{ icPriceFormat(patchCostTotal) }}
                                        </h3>
                                    </div>
                                    <button
                                        type="button"
                                        class="btn btn-primary v3-btn"
                                        data-toggle="modal"
                                        data-target="#exampleModalRight"
                                    >
                                        Colors & Qty Details
                                    </button>
                                </div>
                                <div class="row slider_row responsive_color_slider">
                                    <!-- Slider -->
                                    <div class="col-md-6">
                                        <div
                                            class="design_studio_footer design_studio_s design_studio_slider design_slider_with_color"
                                        >
                                            <div class="design_footer-flex">
                                                <div
                                                    class="col-md-12 slider_col"
                                                >
                                                    <ColorOwlCarousel
                                                        :user_selected_values="
                                                            user_selected_values
                                                        "
                                                        :activeColorIndex="
                                                            activeColorIndex
                                                        "
                                                        @set-canvas-color="
                                                            SetColorCanvas
                                                        "
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="design_studio_bottom_btns">
                                <div class="buttons_inner">
                                    <div class="left_btn">
                                        <router-link
                                            v-if="!is24Tshirt"
                                            :to="{
                                                name: 'product_details_new',
                                                params: {
                                                    id_of_product: product_id
                                                }
                                            }"
                                            class="back_to_product_btn"
                                            >Back to Product</router-link
                                        >
                                        <router-link
                                            v-else
                                            :to="{
                                                name: '24hoursTShirts',
                                                params: {
                                                    id_of_product: product_id
                                                }
                                            }"
                                            class="back_to_product_btn"
                                            >Back to Product</router-link
                                        >
                                    </div>
                                    <div class="right_btn">
                                        <button
                                            v-if="
                                                isAuthenticatedClient &&
                                                colors_validation == ''
                                            "
                                            data-toggle="modal"
                                            class="create_build_btn d-none"
                                            @click="saveNewDesigns('')"
                                        >
                                            CREATE BUILD
                                        </button>
                                        <button
                                            v-if="
                                                isAuthenticatedClient &&
                                                colors_validation != ''
                                            "
                                            data-toggle="modal"
                                            class="create_build_btn d-none"
                                            disabled
                                        >
                                            CREATE BUILD
                                        </button>
                                        <a
                                            v-if="
                                                isAuthenticatedClient &&
                                                colors_validation == ''
                                            "
                                            href="javascript:void(0);"
                                            class="add_to_cart_btn"
                                            @click="saveNewDesigns('cart')"
                                        >
                                            Add To Cart
                                        </a>
                                        <button
                                            v-if="
                                                isAuthenticatedClient &&
                                                colors_validation != ''
                                            "
                                            class="add_to_cart_btn"
                                            disabled
                                        >
                                            Add To Cart
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                  
                    <div
                        class="design_studio_drawer modal fade drawer right-align"
                        id="exampleModalRight"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                    >
                        <div class="drawer_modal">
                            <div
                                class="modal-dialog main_dialog_drawer"
                                role="document"
                            >
                                <div class="modal-content">
                                    <div class="modal-header drawer_header">
                                        <button
                                            type="button"
                                            class="close"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                        >
                                            <span aria-hidden="true"
                                                >&times;</span
                                            >
                                        </button>
                                    </div>
                                    <div
                                        class="back_front_t-shirt right_sec_design_studio_t_shirt direction_block"
                                    >
                                        <div class="right_section_main">
                                            <div class="modal-body">
                                                <ItemDetails
                                                    ref="ItemDetails"
                                                    :product-id="product_id"
                                                    :product="product_items"
                                                    :tshirt-sides="tshirtSides"
                                                    :imprint-locations="
                                                        user_selected_values[
                                                            parseInt(
                                                                activeColorIndex
                                                            )
                                                        ].imprint_locations
                                                    "
                                                    :gender-groups="
                                                        gender_groups_items
                                                    "
                                                    :vendor-colors="
                                                        vendor_colors_list
                                                    "
                                                    :active-color-index="
                                                        activeColorIndex
                                                    "
                                                    :decoration-colors="
                                                        design_current_colors
                                                    "
                                                    :all-decoration-colors="
                                                        all_decoration_colors
                                                    "
                                                    :total-non-standard-fees="
                                                        total_non_standard_fees
                                                    "
                                                    :addToCart="addToCart"
                                                    :non-standard-fee-per-color="
                                                        non_standard_fee_per_color
                                                    "
                                                    :total-non-standard-colors="
                                                        total_non_standard_colors
                                                    "
                                                    :saveNewDesigns="
                                                        saveNewDesigns
                                                    "
                                                    :updatePrintAreas="
                                                        updatePrintAreas
                                                    "
                                                    :canvasDesignsStatus="
                                                        canvas_designs_status
                                                    "
                                                    :colorsValidation="
                                                        colors_validation
                                                    "
                                                    :colorsCount="colors_count"
                                                    :cart-quantity="
                                                        cart_quantity
                                                    "
                                                    @updateNameAndNumbers="
                                                        changeNameAndNumbersAfterQtyUpdate
                                                    "
                                                    :useImprintcityTemplate="
                                                        receivedPricingFlag
                                                    "
                                                    :active-decoration-service="
                                                        currentActiveServiceData
                                                    "
                                                    :other-services="
                                                        applicableOtherServices
                                                    "
                                                    :selected-rush-option-id="
                                                        selectedRushOptionId
                                                    "
                                                    :selected-rush-option-date="
                                                        selectedRushOptionDate
                                                    "
                                                    :vendor-services="
                                                        vendorServices
                                                    "
                                                    :patch-cost="patchCostTotal"
                                                    :patch-cost-warning="
                                                        patchCostWarning
                                                    "
                                                    :patch-cost-tooltip="
                                                        patchCostTooltipText
                                                    "
                                                    :patch-slab-quantity="
                                                        patchSlabQuantity
                                                    "
                                                    :patch-cost-details="
                                                        patchCostDetails
                                                    "
                                                    @color-deleted="
                                                        onColorDeleted
                                                    "
                                                />
                                            </div>
                                            <div class="modal-footer d-none">
                                                <div class="design_studio_btns">
                                                    <div
                                                        class="bottom_btn back-pro-btn_add_cart default_tab_bottom_btn"
                                                    >
                                                        <router-link
                                                            v-if="!is24Tshirt"
                                                            :to="{
                                                                name: 'product_details_new',
                                                                params: {
                                                                    id_of_product:
                                                                        product_id
                                                                }
                                                            }"
                                                            class="back_to"
                                                            >Back to
                                                            Product</router-link
                                                        >
                                                        <router-link
                                                            v-else
                                                            :to="{
                                                                name: '24hoursTShirts',
                                                                params: {
                                                                    id_of_product:
                                                                        product_id
                                                                }
                                                            }"
                                                            class="back_to"
                                                            >Back to
                                                            Product</router-link
                                                        >
                                                    </div>
                                                    <div
                                                        class="save_btn"
                                                        v-if="
                                                            isAuthenticatedClient
                                                        "
                                                    >
                                                        <a
                                                            href="javascript:void(0);"
                                                            v-if="
                                                                colors_validation ==
                                                                ''
                                                            "
                                                            class="add_cart btn"
                                                            @click="
                                                                saveNewDesigns(
                                                                    'cart'
                                                                )
                                                            "
                                                        >
                                                            Add To cart
                                                        </a>
                                                        <button
                                                            v-else
                                                            class="btn btn_orange bg_primary_orange text_white w-100 mt_10 mb_10 btn_h60"
                                                            style="
                                                                background-color: #f2790c !important;
                                                            "
                                                            disabled
                                                        >
                                                            Add To cart
                                                        </button>
                                                        <button
                                                            data-toggle="modal"
                                                            v-if="
                                                                colors_validation ==
                                                                ''
                                                            "
                                                            class="btn btn_orange bg_primary_orange text_white w-100 mt_10 mb_10 btn_h60 save-blue-btn d-none"
                                                            style="
                                                                max-width: 80%;
                                                                background: 0%
                                                                    0% no-repeat
                                                                    padding-box
                                                                    rgb(
                                                                        35,
                                                                        132,
                                                                        204
                                                                    ) !important;
                                                            "
                                                            @click="
                                                                saveNewDesigns(
                                                                    ''
                                                                )
                                                            "
                                                        >
                                                            CREATE BUILD
                                                        </button>
                                                        <button
                                                            data-toggle="modal"
                                                            v-else
                                                            class="btn btn_orange bg_primary_orange text_white w-100 mt_10 mb_10 btn_h60 save-blue-btn d-none"
                                                            style="
                                                                max-width: 80%;
                                                                background: 0%
                                                                    0% no-repeat
                                                                    padding-box
                                                                    rgb(
                                                                        35,
                                                                        132,
                                                                        204
                                                                    ) !important;
                                                            "
                                                            disabled
                                                        >
                                                            CREATE BUILD
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 p-0">
                        <div class="design_studio_footer" style="display: none">
                            <!-- slider start -->
                            <div class="design_footer-flex">
                                <div class="col-md-8 col-lg-4"></div>

                                <!-- right sec start -->
                                <div class="col-md-12 col-lg-8">
                                    <div class="rgt_design_studios"></div>
                                </div>
                                <!-- right sec end -->
                            </div>

                            <!-- slider end -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Share Modal -->
        <div
            class="modal login-form-popup fade h-auto"
            id="share_design_modal"
            tabindex="-1"
            aria-labelledby="design-studio"
            data-backdrop="static"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <a
                            href="#"
                            @click="copied = false"
                            id="popup-close"
                            data-dismiss="modal"
                            class="popup-close"
                            data-original-title=""
                            title=""
                            ><img src="/maincss/images/cancel.svg" alt=" "
                        /></a>
                        <input
                            type="text"
                            id="share_link_input"
                            readonly
                            :value="shareable_link"
                            class="form-control"
                        />
                        <div class="my_30 d-flex justify-content-center">
                            <button
                                type="button"
                                v-if="!copied"
                                @click="copyClipboard"
                                class="btn btn_orange bg_primary_orange text_white"
                            >
                                Copy Link
                            </button>
                            <button
                                type="button"
                                v-else
                                class="btn btn_orange bg_primary_orange text_white"
                            >
                                Copied
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Saved Design Modal -->
        <div
            class="modal login-form-popup fade h-auto"
            id="save_design_modal"
            tabindex="-1"
            aria-labelledby="design-studio"
            data-backdrop="static"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable design_build_modal"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{
                                saved_type != "cart"
                                    ? "Save Design/Build"
                                    : "Save Design"
                            }}
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form
                        method="post"
                        @submit.prevent="save_all_design"
                        data-vv-scope="add_save_form"
                    >
                        <div class="modal-body">
                            <div v-if="saved_type != 'cart'">
                                <label for="inputPassword5"
                                    >Select Item Type</label
                                >
                                <br />
                                <div
                                    class="custom-control custom-radio custom-control-inline"
                                >
                                    <input
                                        type="radio"
                                        id="single"
                                        v-model="saved_design.item_type"
                                        :value="'single'"
                                        name="single"
                                        class="custom-control-input"
                                    />
                                    <label
                                        class="custom-control-label"
                                        for="single"
                                        >Single Item</label
                                    >
                                </div>
                                <div
                                    class="custom-control custom-radio custom-control-inline"
                                >
                                    <input
                                        type="radio"
                                        id="build"
                                        v-model="saved_design.item_type"
                                        :value="'build'"
                                        name="build"
                                        class="custom-control-input"
                                    />
                                    <label
                                        class="custom-control-label"
                                        for="build"
                                        >Multiple Item Application (Create a
                                        Build)</label
                                    >
                                </div>
                            </div>
                            <div class="">
                                <input
                                    type="text"
                                    v-model="saved_design.name"
                                    name="title name"
                                    required="required"
                                    placeholder="Enter title Name"
                                    value=""
                                    class="form-control"
                                    maxlength="101"
                                    v-validate="'required|max:100'"
                                />

                                <small
                                    class="form-text text-error text-left"
                                    v-show="
                                        errors.has('add_save_form.title name')
                                    "
                                >
                                    {{
                                        errors.first("add_save_form.title name")
                                    }}
                                </small>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn_white border border-primary text_blue mt_20 mb_10 btn_h60"
                                data-dismiss="modal"
                            >
                                CANCEL
                            </button>
                            <button
                                type="submit"
                                class="add_cart btn btn_orange bg_primary_orange text_white mt_20 mb_10 btn_h60"
                                data-original-title=""
                                title=""
                            >
                                save
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <AllDesignPreviewModal
            :show="allDesignPreviewModal"
            :loading="allDesignPreviewLoading"
            :images="allDesignPreviewImages"
            :product-color="allDesignPreviewProductColor"
            @close="allDesignPreviewModal = false"
            @select-location="onAllDesignPreviewSelectLocation"
        />

        <!-- reset popup start -->
        <div
            id="reset_popup"
            tabindex="-1"
            aria-labelledby="login"
            data-keyboard="false"
            data-backdrop="static"
            class="modal login-form-popup fade h-auto"
            aria-modal="true"
            role="dialog"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <a
                            href="#"
                            id="popup-close"
                            data-dismiss="modal"
                            class="popup-close"
                            ><img src="/maincss/images/cancel.svg" alt=" "
                        /></a>
                        <div class="login-form">
                            <h3>Warning!</h3>
                            <p class="m-0">
                                Are you sure want to reset your design
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-center my_20"
                        >
                            <a
                                href="Javascript:void(0);"
                                class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_46 mr_8 mb_10"
                                @click="clearDesigns()"
                                >Reset Design</a
                            >
                            <a
                                href="Javascript:void(0);"
                                data-dismiss="modal"
                                class="btn btn_orange bg_primary_orange text_white py_18 px_64 ml_8 mb_10"
                                >Keep Design</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- reset popup end  -->

        <!-- Model for sleeve design area Start -->
        <div
            id="show_sleeve"
            tabindex="-1"
            aria-labelledby="login"
            data-keyboard="false"
            data-backdrop="static"
            class="modal login-form-popup fade h-auto"
            aria-modal="true"
            role="dialog"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="basicModalLabel3">
                            Sleeve Design Area
                        </h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <img
                                src="/maincss/images/cancel.svg"
                                alt="Cancel Button"
                            />
                        </button>
                    </div>
                    <div class="modal-body img-popup-body">
                        <div class="login-form">
                            <div class="design_area_right_side_image_popup">
                                <fabric-canvas
                                    :id="`1122334455`"
                                    :height="defaultHeightCanvas"
                                    :width="defaultWidthCanvas"
                                    :stateful="true"
                                    @canvas-updated="canvasBackSleeveUpdated"
                                    @object-scaling="objScaling"
                                    @object-moving="objMoving"
                                >
                                    <fabric-background-image
                                        :id="`34566788`"
                                        :url="background_image"
                                        :scaleX="defaultWidthCanvas / imgWidth"
                                        :scaleY="
                                            defaultHeightCanvas / imgHeight
                                        "
                                        @image-loaded="imageLoaded"
                                    >
                                    </fabric-background-image>
                                </fabric-canvas>
                            </div>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-center my_20"
                        >
                            <a
                                href="#"
                                data-dismiss="modal"
                                class="btn btn-outline-primary bg_white mr_20"
                                >OK</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Model for design area end -->

        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
                <span class="load-value" v-if="popup_sync_count > 0"
                    >{{ popup_sync_count }} %
                </span>
            </div>
        </div>

        <!-- START DESIGNING POPUP -->
        <div
            class="modal fade h-auto login-form-popup"
            id="design-confirmation-modal"
            tabindex="-1"
            aria-hidden="true"
            data-keyboard="false"
            data-backdrop="static"
        >
            <div class="modal-dialog modal-dialog-centered upload-artwork">
                <div class="modal-content">
                    <div class="modal-body">
                        <a
                            href="#"
                            class="popup-close art_poup_close"
                            id="popup-close"
                            data-dismiss="modal"
                        >
                            <img
                                src="/maincss/images/cancel.svg"
                                v-tooltip="'Close'"
                                alt=" "
                            />
                        </a>
                        <div class="login-form">
                            <h5 class="mb_40">
                                Do you want to design more colors?
                            </h5>

                            <div class="upload_design">
                                <div
                                    class="d-flex justify-content-center mb_20 start_design_btn_box"
                                >
                                    <button
                                        class="btn btn_orange bg_primary_orange text_white mx_6"
                                        type="button"
                                        @click="changeTshirtColor()"
                                    >
                                        Continue
                                    </button>
                                    <a
                                        href="javascript:void(0)"
                                        class="btn btn_outline_primary border_primary_blue text_primary_blue mx_6"
                                        data-dismiss="modal"
                                        >Cancel</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <DesignLocationMismatchModal
            :design-name="designLocationMismatch.designName"
            :required-flips="designLocationMismatch.requiredFlips"
            :available-flips="designLocationMismatch.availableFlips"
        />
        <DesignImprintTooSmallModal
            :design-name="designImprintTooSmall.designName"
        />
    </div>
</template>

<script>
import commonData from "@/common/common.data";
import { mapGetters } from "vuex";
import { fabric } from "fabric";
import vueFabricWrapper from "vue-fabric-wrapper";
import ApiService from "@/common/api.service";
import { ecommDisplayNameMixin } from "@/common/ecommDisplayName.service";
import ColourPicker from "@/components/ColourPicker";
import AddText from "@/components/DesignerTool/AddText/AddTextV3";
import ClipSetting from "@/components/DesignerTool/ClipSetting/ClipSettingV3";
import NameAndNumber from "@/components/DesignerTool/NameAndNumber/v3/NameAndNumber";
import DistressImageList from "@/components/DesignerTool/components/DistressImageList.vue";
import LeftMenus from "../V3/DesignStudioLeftMenus.vue";
import ColorOwlCarousel from "@/components/DesignerTool/ColorOwlCarousel";
import Dashboard from "@/components/design_studio/v3/Dashboard";
import MyDesigns from "@/components/design_studio/v3/MyDesignsV3";
import PrintAreaIcons from "@/components/design_studio/v3/PrintAreaIcons";
import AllDesignPreviewModal from "@/components/design_studio/v3/AllDesignPreviewModal";
import ItemDetails from "@/components/design_studio/v3/ItemDetails";
import { prepareImprintLocationsForSuppressCart } from "@/common/itemSuppressDisplayShared";
import DesignLocationMismatchModal from "@/components/design_studio/v3/DesignLocationMismatchModal.vue";
import DesignImprintTooSmallModal from "@/components/design_studio/v3/DesignImprintTooSmallModal.vue";
// Browser build: class with getPalette(imgElement, colorCount, quality). Node "main" export is getColor/getPalette only.
import ColorThief from "colorthief/dist/color-thief.umd.js";

var canvas;

var listLine = [];

fabric.Group.prototype.toObject = (function (toObject) {
    return function () {
        return fabric.util.object.extend(toObject.call(this), {
            ctype: "",
            iextension: "",
            image_name: "",
            image_path: "",
            width_inch: "",
            height_inch: ""
        });
    };
})(fabric.Group.prototype.toObject);
var design_tool = {
    name: "DesignStudio",
    mixins: [ecommDisplayNameMixin],
    async beforeRouteLeave(to, from, next) {
        let _this = this;

        if (from.name == "DesignStudioV3" && from.name != "product_details") {
            let designStatus = false;
            let previouscanvasList = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );
            if (previouscanvasList != null) {
                if ("front" in previouscanvasList) {
                    if (previouscanvasList["front"] !== "") {
                        JSON.parse(previouscanvasList["front"]).objects.forEach(
                            (canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            }
                        );
                    }
                }
                if ("back" in previouscanvasList) {
                    if (previouscanvasList["back"] !== "") {
                        JSON.parse(previouscanvasList["back"]).objects.forEach(
                            (canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            }
                        );
                    }
                }
                if ("left" in previouscanvasList) {
                    if (previouscanvasList["left"] !== "") {
                        JSON.parse(previouscanvasList["left"]).objects.forEach(
                            (canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            }
                        );
                    }
                }
                if ("right" in previouscanvasList) {
                    if (previouscanvasList["right"] !== "") {
                        JSON.parse(previouscanvasList["right"]).objects.forEach(
                            (canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            }
                        );
                    }
                }
            }
            if (designStatus) {
                if (!_this.skip_leave_confirm_box) {
                    _this.$dialog
                        .confirm(
                            "Leave Design Studio? Changes made may not be saved.",
                            {
                                okText: "Yes",
                                cancelText: "No"
                            }
                        )
                        .then(async function () {
                            next();
                        })
                        .catch(function () {
                            next(false);
                        });

                    _this.skip_leave_confirm_box = false;
                } else {
                    next();
                }
            } else {
                next();
            }
        } else {
            next();
        }
    },
    components: {
        "colour-picker": ColourPicker,
        AddText: AddText,
        ClipSetting: ClipSetting,
        NameAndNumber: NameAndNumber,
        DistressImageList: DistressImageList,
        FabricCanvas: vueFabricWrapper.FabricCanvas,
        FabricImageFromURL: vueFabricWrapper.FabricImageFromURL,
        FabricRectangle: vueFabricWrapper.FabricRectangle,
        FabricGroup: vueFabricWrapper.FabricGroup,
        FabricBackgroundImage: vueFabricWrapper.FabricBackgroundImage,
        LeftMenus: LeftMenus,
        ColorOwlCarousel: ColorOwlCarousel,
        Dashboard: Dashboard,
        MyDesigns: MyDesigns,
        PrintAreaIcons,
        AllDesignPreviewModal,
        ItemDetails,
        DesignLocationMismatchModal,
        DesignImprintTooSmallModal,
        UploadImageV3: () =>
            import("@/components/design_studio/v3/UploadImageV3.vue"),
        DesignHistory: () =>
            import("@/components/design_studio/v3/DesignHistory.vue")
    },
    emits: ["closeMenu"],
    data() {
        return {
            isLoader: false,
            selectImageProps: {
                rotation: 0,
                flipX: false,
                flipY: false,
                center: "left"
            },
            tshirtImage: "", //frontside image of tshirt
            selected_template_category_show: true, //to show templates category
            selected_template_subcategory_show: false,
            selected_template_subcategory: { template_images: [] },
            selected_custom_template_show: false, //to show custom template
            selected_clipart_category_show: true, //to show clipart category
            category_heading: true, //to show category heading
            edit_template: false, //to enable template edit option
            selected_category_heading: false, //to selected category heading
            selected_template_category: [],
            selected_custom_template: [], //selected template category array
            selected_clipart_category: [], //selected clipart category array
            template_search_query: null, //template search input value
            template_subcategory_search_query: null,
            clipart_search_query: null, //clipart search input value
            design_search_query: null, //saved designs search input value
            template_name: "", //selected template name
            clipart_name: "", //selected clipart name
            active_class: "active", //genders tab active class
            uploadImages: [], //array of images that are going to upload
            image_width: null, //width of cropped image
            image_height: null, //height of cropped image
            image_size: null, //size of cropped image
            uploaded_design_image: null,
            uploadedImageTopColors: [], // top colors extracted from last uploaded image (hex) - stays visible after upload
            foundColorsCount: 0, // count of colors found by ColorThief (not user-added)
            desiredColorCount: null, // optional: how many colors user wants to see
            tempUploadedFile: null, // temporary storage for file info before upload
            currentUploadRecord: null, // current upload row (id, image_name, image_colors) for saving colors
            uploadDraftSnapshot: null,
            uploadDraftDirty: false,
            uploadedImages: [], //array of uploaded images from  DB
            savedDesigns: [], //array of saved designs from DB
            step: 1, //step count for name&numbers
            text: "", //text variable for Add text
            genders: [], //selected genders array from product details page
            user_selected_values: [], //values from product details
            active_gender: "", //current active gender tab
            active_gender_key: 0, //current active gender key value
            canvas_elements: [], //canvas objects array
            templates: [], //templates array from DB
            cliparts: [], //clipart array from DB
            shapes: [], //shapes array from DB
            patches: [], //pathces array from DB
            // Add Patch (New) - material accordion
            patchMaterialsNew: [],
            patchesByMaterialNew: {},
            patchNewSearchQuery: "",
            expandedMaterialIdsNew: [],
            patchNewLoading: false,
            dsPatchInventory: [],
            // Patch price calculation (Design Studio)
            patchCostTotal: 0,
            patchCostWarning: "",
            patchCostTooltipText: "",
            patchSlabQuantity: 0,
            patchCostDetails: [], // [{ patchName, slab, perPatchPrice, total }] for Run Charge-style tooltip
            patchPriceCache: {}, // materialId -> { patchId -> { name, quantity -> { retail_price } } }
            canvasVersion: 0,
            product_items: {}, //product details object
            design_name: "", //name of the design
            dataURL: null, //dataurl of design,going to save
            product_title: "", //product title on home page
            product_number: "", //product number on home page
            product_id: "", //product Id
            base_price: "", //base_price on home page
            design_count: 0, //My designs count
            apiurl: ApiService.apiUrl(), //api url
            croppieImage: "", //cropped image
            crop_image_validation: 0, //cropped image validation
            image_size_validation: 0, //uploaded image size validation
            zoom: 1, //zoom level
            zoom_in: 0, //zoom in step
            zoom_out: 1, //zoom out step
            text_shape: false, //enable text shape tab in Add text
            add_text: true, //enable add text tab in Add text
            active_flip: "back", //active T-shirt side
            canvasList: { front: "" },
            textData: {},
            selectedType: "", //
            clipart_category: [], //clipart subcategory
            clipart_subcategory_div: false, //clipart subcategory div flag
            clipart_category_div: false, //clipart category div flag
            clipart_subcategory_search_query: null,
            clipart_category_name: "", //selected clipart category name
            imgHeight: 1,
            imgWidth: 1,
            backCanvas: null,
            // Image (preview) zoom mode: when true, scroll to zoom and drag to pan the product image
            imageZoomMode: false,
            imageZoomMin: 0.5,
            imageZoomMax: 3,
            imagePanX: 0,
            imagePanY: 0,
            imagePanLast: null,
            isImagePanning: false,
            _imagePanMoveHandler: null,
            _imagePanUpHandler: null,
            saved_design: {
                name: null,
                item_type: "single",
                product_id: "",
                user_id: "",
                canvas_json: [],
                design_json: [],
                status: 1,
                save_canvas_images: "",
                canvas_design_colors: "",
                enabled_service: null
            },
            product_all_colors: [],
            activeIndex: undefined,
            activeColorIndex: undefined,
            saved_design_list: [],
            design_tab_active: false,
            archive_tab_active: false,
            showDesignHistory: false,
            selectedDesignHistoryId: null,
            designLocationMismatch: {
                designName: "This design",
                requiredFlips: [],
                availableFlips: []
            },
            designImprintTooSmall: {
                designName: "This design"
            },
            preserveSavedDesignPositions: false,
            saved_Template_design_list: [],
            save_design_button: true,
            add_distress_images: true,
            current_design_id: null,
            current_template_id: null,
            original_canvas_json: null, // Store original canvas JSON when design is loaded from My Designs
            distress_images: { front: "" },
            shareable_link: null,
            copied: false,
            disable_tshirt_canvas: false,
            design_area_data: "",
            front_show: "",
            selectedRushOptionId: null,
            selectedRushOptionDate: null,
            vendorServices: [],
            back_show: "",
            left_show: "",
            right_show: "",
            background_image: "/maincss/design-studio/img/crew_front.png",
            background_image_sleeve:
                "/maincss/design-studio/img/crew_front.png",
            front_canvas_height: 0,
            front_canvas_width: 0,
            front_canvas_top: "",
            front_canvas_left: "",
            front_canvas_angle: 0,
            saved_json_data: null,
            selectedCheckbox: false,
            backSleeveCanvas: null,
            popup_canvas_height: 0,
            popup_canvas_width: 0,
            popup_canvas_top: "",
            popup_canvas_left: "",
            uploaded_image_name: "",
            selectedDistressImage: "",
            show_popular_cliparts: false,
            show_popular_templates: false,
            selected_object_colors: [],
            vendor_colors_list: [],
            design_box: "",
            cart_save_design: false,
            all_templates_images: [],
            all_cliparts_images: [],
            is24Tshirt: false,
            imageCanvas: "",
            cart_status: "",
            undo: [],
            redo: [],
            state: [],
            undoRedoData: null,
            undoObject: 0,
            undoActive: false,
            redoActive: false,
            firstImageActive: 0,
            uploadModuleCanvas: 0,
            imagesSelectedCanvasType: "",
            removeBackCanvas: true,
            front_icon_canvas_type:
                "/maincss/design-studio/img/tshirt_front.png",
            back_icon_canvas_type: "/maincss/design-studio/img/tshirt_back.png",
            left_icon_canvas_type: "/maincss/design-studio/img/lft_sl.png",
            right_icon_canvas_type: "/maincss/design-studio/img/rgt_slv.png",
            save_design_images: "",
            only_save_designs: false,
            active_product_type: "",
            rotationAngle: 0,
            defaultWidthCanvas: 530,
            defaultHeightCanvas: 630,
            sideBarCanvasStatus: true,
            front_canvas_images: [],
            showUploadForm: false,
            design_current_colors: [],
            popup_sync_count: 0,
            skip_leave_confirm_box: false,
            current_print_area: "",
            front_canvas_width_inch: "",
            front_canvas_height_inch: "",
            canvas_designs_status: false,
            tshirt_color: "",
            design_area_inches: [],
            colors_count: 0,
            colors_validation: "",
            selected_clipart_category_id: "",
            vinyl_color_list: [],
            total_non_standard_colors: [],
            total_non_standard_fees: 0,
            current_standard_colors: [],
            current_specialty_ink_colors: [],
            current_stock_colors: [],
            current_custom_colors: [],
            gender_groups_items: [],
            all_decoration_colors: {},
            tshirtSides: ["front", "back", "left", "right"],
            saved_type: "",
            cart_items: [],
            cart_quantity: 0,
            non_standard_fee_per_color: 0,
            printAreaBond: null,
            receivedPricingFlag: null,
            allDesignPreviewModal: false,
            allDesignPreviewImages: [],
            allDesignPreviewLoading: false,
            allDesignPreviewProductColor: "#ffffff",
            imageZoomMessageDismissed: false,
            imageUnavailableMessageDismissed: false,
            selected_art_dimensions: null
        };
    },
    // computed: {
    //     ...mapGetters([
    //         "isAuthenticatedClient",
    //         "currentUserClient",
    //         "adminOptions"
    //     ]),
    //     tag() {
    //         return this.$route.params.tag;
    //     }
    // },
    // beforeDestroy() {
    //     document.removeEventListener("keydown", this.controlUndoRedoObject);
    // },
    methods: {
        buildPatchCostDetailsForCart() {
            const details = Array.isArray(this.patchCostDetails)
                ? this.patchCostDetails
                : [];
            return details.map((row) => {
                const patchName =
                    row && row.patchName != null
                        ? String(row.patchName).trim()
                        : "";
                const materialName =
                    row && row.materialName != null
                        ? String(row.materialName).trim()
                        : "";
                const hasWidth =
                    row && row.width != null && String(row.width).trim() !== "";
                const hasHeight =
                    row &&
                    row.height != null &&
                    String(row.height).trim() !== "";
                const dimension =
                    hasWidth && hasHeight
                        ? `${String(row.width).trim()}" x ${String(row.height).trim()}"`
                        : "";
                const composedPatchName =
                    patchName +
                    (materialName ? ` (${materialName})` : "") +
                    (dimension ? ` - ${dimension}` : "");
                return {
                    ...row,
                    quantity:
                        parseInt(row && row.quantity, 10) ||
                        parseInt(row && row.totalQty, 10) ||
                        0,
                    patchName: composedPatchName,
                    materialName: null,
                    width: null,
                    height: null
                };
            });
        },
        onUploadImageNameUpdated(name) {
            this.uploaded_image_name = name;
            this.uploadDraftDirty = true;
        },
        setUploadDraftSnapshot() {
            this.uploadDraftSnapshot = {
                currentUploadRecord: this.currentUploadRecord
                    ? { ...this.currentUploadRecord }
                    : null,
                uploaded_image_name: this.uploaded_image_name || "",
                uploaded_design_image: this.uploaded_design_image || null,
                uploadedImageTopColors: (
                    this.uploadedImageTopColors || []
                ).slice()
            };
            this.uploadDraftDirty = false;
        },
        cancelUploadDraft() {
            if (this.uploadDraftSnapshot) {
                this.currentUploadRecord = this.uploadDraftSnapshot
                    .currentUploadRecord
                    ? { ...this.uploadDraftSnapshot.currentUploadRecord }
                    : null;
                this.uploaded_image_name =
                    this.uploadDraftSnapshot.uploaded_image_name || "";
                this.uploaded_design_image =
                    this.uploadDraftSnapshot.uploaded_design_image || null;
                this.uploadedImageTopColors = (
                    this.uploadDraftSnapshot.uploadedImageTopColors || []
                ).slice();
            } else {
                this.currentUploadRecord = null;
                this.uploaded_image_name = "";
                this.uploaded_design_image = null;
                this.uploadedImageTopColors = [];
            }
            this.tempUploadedFile = null;
            this.image_uploaded = {};
            this.uploadDraftDirty = false;
            this.showUploadForm = false;
            if (this.backCanvas) {
                this.backCanvas.discardActiveObject();
                this.backCanvas.requestRenderAll();
            }
        },
        saveUploadDraft() {
            if (this.currentUploadRecord && this.currentUploadRecord.id) {
                this.saveUploadColors();
                this.setUploadDraftSnapshot();
                this.$toast.success("Colors saved successfully", {
                    position: "top-right"
                });
                this.showUploadForm = false;
                if (this.backCanvas) {
                    this.backCanvas.discardActiveObject();
                    this.backCanvas.requestRenderAll();
                }
                return;
            }
            if (!this.image_uploaded || !this.image_uploaded.image) {
                this.$toast.error("Please choose image first", {
                    position: "top-right"
                });
                return;
            }
            this.ImageUpload();
        },
        dedupeColors(colors) {
            const seen = new Set();
            return (colors || []).filter((c) => {
                const key = (c || "").toUpperCase();
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });
        },
        addNewColorBox() {
            const white = "#FFFFFF";
            if (
                !this.uploadedImageTopColors
                    .map((c) => c.toUpperCase())
                    .includes(white)
            ) {
                this.uploadedImageTopColors.push(white);
                this.uploadDraftDirty = true;
            } else {
                this.$toast.info("White color already exists", {
                    position: "top-right"
                });
            }
        },
        addColorSlot(index) {
            const white = "#FFFFFF";
            if (
                this.uploadedImageTopColors
                    .map((c) => c.toUpperCase())
                    .includes(white)
            ) {
                this.$toast.info("White color already exists", {
                    position: "top-right"
                });
                return;
            }
            const safeIndex =
                typeof index === "number" &&
                index >= 0 &&
                index <= this.uploadedImageTopColors.length
                    ? index
                    : this.uploadedImageTopColors.length;
            this.uploadedImageTopColors.splice(safeIndex, 0, white);
            this.uploadDraftDirty = true;
        },
        updateUploadedColorFromList(payload) {
            if (!payload || typeof payload.index !== "number") return;
            const index = payload.index;
            const colorHex = payload.colorHex
                ? payload.colorHex.toUpperCase()
                : null;
            if (
                !colorHex ||
                index < 0 ||
                index >= this.uploadedImageTopColors.length
            )
                return;
            // Check if same hex already exists at a different index
            const duplicate = this.uploadedImageTopColors.findIndex(
                (c, i) => i !== index && c.toUpperCase() === colorHex
            );
            if (duplicate !== -1) {
                this.$toast.info("This color already exists in the list", {
                    position: "top-right"
                });
                return;
            }
            this.$set(this.uploadedImageTopColors, index, colorHex);
            this.uploadDraftDirty = true;
        },
        deleteColor(index) {
            // Allow deleting any color (including found/fetched) when more than 1 remains
            if (this.uploadedImageTopColors.length > 1) {
                const updated = this.uploadedImageTopColors.slice();
                updated.splice(index, 1);
                this.uploadedImageTopColors = updated;
                this.uploadDraftDirty = true;
            }
        },
        saveUploadColors() {
            const payload = {
                number_of_colors: this.uploadedImageTopColors.length,
                colors: this.uploadedImageTopColors
            };
            if (this.currentUploadRecord && this.currentUploadRecord.id) {
                ApiService.patch(
                    "/design-studio-upload/" + this.currentUploadRecord.id,
                    payload
                )
                    .then(() => {})
                    .catch((err) => {
                        if (err.response && err.response.status === 401) {
                            this.$router.push({ name: "/client/login" });
                        }
                    });
            }
            // Write colors (and name) back to matching upload objects on canvas so it stays in sync.
            const objects =
                this.backCanvas && this.backCanvas._objects
                    ? this.backCanvas._objects
                    : [];
            let updatedCanvasObject = false;
            objects.forEach((obj) => {
                const ctype = obj.ctype || (obj.get && obj.get("ctype"));
                if (ctype !== "upload") return;
                const uploadId =
                    obj.uploadId != null
                        ? obj.uploadId
                        : obj.get && obj.get("uploadId");
                const match =
                    !this.currentUploadRecord ||
                    uploadId === this.currentUploadRecord.id ||
                    (uploadId == null && this.currentUploadRecord.id == null);
                if (!match) return;
                if (obj.set) {
                    obj.set("image_colors", JSON.stringify(payload));
                    if (this.uploaded_image_name != null) {
                        obj.set("image_name", this.uploaded_image_name);
                    }
                } else {
                    obj.image_colors = JSON.stringify(payload);
                    if (this.uploaded_image_name != null)
                        obj.image_name = this.uploaded_image_name;
                }
                updatedCanvasObject = true;
            });
            if (updatedCanvasObject && this.backCanvas) {
                this.backCanvas.requestRenderAll();
                this.saveCanvasData();
            }
            // Right panel: show combined colors for this side (all uploads), not just this one.
            this.refreshCombinedColorsForCurrentSide();
        },
        // Recompute right-panel colors from all upload objects on current canvas (combined list).
        refreshCombinedColorsForCurrentSide() {
            const objects =
                this.backCanvas && this.backCanvas._objects
                    ? this.backCanvas._objects
                    : [];
            const uploadObjects = objects.filter(
                (o) =>
                    o.ctype === "upload" ||
                    (o.get && o.get("ctype") === "upload")
            );
            let combined = (this.design_current_colors || []).slice();
            if (uploadObjects.length > 0) {
                uploadObjects.forEach((obj) => {
                    const raw =
                        obj.image_colors != null
                            ? obj.image_colors
                            : obj.get && obj.get("image_colors");
                    if (!raw) return;
                    try {
                        const parsed =
                            typeof raw === "string" ? JSON.parse(raw) : raw;
                        const list =
                            parsed && Array.isArray(parsed.colors)
                                ? parsed.colors
                                : [];
                        list.forEach((hex) => {
                            if (
                                hex &&
                                typeof hex === "string" &&
                                !combined.includes(hex)
                            ) {
                                combined.push(hex);
                            }
                        });
                    } catch (e) {}
                });
            }
            if (combined.length === 0) return;
            this.design_current_colors = combined;
            let get_canvas_colors = {};
            try {
                get_canvas_colors = JSON.parse(
                    localStorage.getItem("canvas_design_colors") || "{}"
                );
            } catch (e) {
                get_canvas_colors = {};
            }
            get_canvas_colors[this.active_flip] = combined;
            this.all_decoration_colors = get_canvas_colors;
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify(get_canvas_colors)
            );
        },
        // Push left-panel upload image colors to right-side Item Details (design_current_colors, all_decoration_colors, localStorage).
        syncUploadColorsToDecorationColors() {
            if (
                !this.uploadedImageTopColors ||
                !this.uploadedImageTopColors.length
            )
                return;
            const colors = this.uploadedImageTopColors.slice();
            let get_canvas_colors = {};
            try {
                get_canvas_colors = JSON.parse(
                    localStorage.getItem("canvas_design_colors") || "{}"
                );
            } catch (e) {
                get_canvas_colors = {};
            }
            this.design_current_colors = colors;
            get_canvas_colors[this.active_flip] = colors;
            this.all_decoration_colors = get_canvas_colors;
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify(get_canvas_colors)
            );
        },
        // Load upload panel from the selected canvas object (clipart-like: selected upload shows its edit screen and colors).
        loadUploadFromCanvasObject(obj) {
            if (!obj || obj.ctype !== "upload") return;
            const uploadId =
                obj.uploadId != null
                    ? obj.uploadId
                    : obj.get
                    ? obj.get("uploadId")
                    : null;
            const imagePath = obj.image_path || obj.get("image_path");
            const imageName =
                obj.image_name != null ? obj.image_name : obj.get("image_name");
            const imageColorsRaw =
                obj.image_colors != null
                    ? obj.image_colors
                    : obj.get("image_colors");
            this.currentUploadRecord = {
                id: uploadId,
                image_name: imageName || "",
                image: imagePath || ""
            };
            this.uploaded_design_image = imagePath
                ? this.setUrl(imagePath)
                : null;
            this.uploaded_image_name = imageName || "";
            try {
                if (imageColorsRaw) {
                    const parsed =
                        typeof imageColorsRaw === "string"
                            ? JSON.parse(imageColorsRaw)
                            : imageColorsRaw;
                    this.uploadedImageTopColors =
                        parsed && Array.isArray(parsed.colors)
                            ? parsed.colors.slice()
                            : [];
                } else {
                    this.uploadedImageTopColors = [];
                }
            } catch (e) {
                this.uploadedImageTopColors = [];
            }
            // Do not sync selected upload's colors to right panel; right panel shows combined colors for the side (see canvasBackUpdated)
            this.showUploadForm = true;
        },
        // getPrintAreaBounds() {
        //     // First, let's try to find the print area object on canvas
        //     const allObjects = this.backCanvas.getObjects();
        //     // Look for the dotted rectangle (print area)
        //      const printAreaObject = allObjects.find(obj => {
        //             // Common properties for print area objects
        //             return (  obj.name === 'printArea' ||
        //                 obj.id === 'printArea' ||
        //                 obj.type === 'rect' && obj.strokeDashArray ||
        //                 obj.stroke === 'dashed' ||
        //                 obj.selectable === false ||
        //                 (obj.stroke && obj.fill === 'transparent')
        //             );
        //         });
        //         if (printAreaObject) {
        //             this.printAreaBond  = printAreaObject.getBoundingRect();
        //         }
        //     // If not found, let's log all objects to identify the print area manually
        //     allObjects.forEach((obj, index) => {
        //         const boundingRect = obj.getBoundingRect();
        //         console.log(`Object ${index}:`, {
        //             type: obj.type,
        //             name: obj.name,
        //             id: obj.id,
        //             stroke: obj.stroke,
        //             strokeDashArray: obj.strokeDashArray,
        //             fill: obj.fill,
        //             selectable: obj.selectable,
        //             visible: obj.visible,
        //             left: obj.left,
        //             top: obj.top,
        //             width: obj.width,
        //             height: obj.height,
        //             boundingRect: boundingRect
        //         });
        //     });
        // },
        triggerLoader(currentStatus) {
            this.isLoader = currentStatus;
            this.prepareImprintLocations();
        },
        checkObjectCanvas() {
            let designStatus = false;
            let previouscanvasList = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );
            if (previouscanvasList != null) {
                if ("front" in previouscanvasList) {
                    if (previouscanvasList["front"] !== "") {
                        JSON.parse(previouscanvasList["front"]).objects.forEach(
                            (canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            }
                        );
                    }
                }
                if ("back" in previouscanvasList) {
                    if (previouscanvasList["back"] !== "") {
                        JSON.parse(previouscanvasList["back"]).objects.forEach(
                            (canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            }
                        );
                    }
                }
                if ("left" in previouscanvasList) {
                    if (previouscanvasList["left"] !== "") {
                        JSON.parse(previouscanvasList["left"]).objects.forEach(
                            (canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            }
                        );
                    }
                }
                if ("right" in previouscanvasList) {
                    if (previouscanvasList["right"] !== "") {
                        JSON.parse(previouscanvasList["right"]).objects.forEach(
                            (canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            }
                        );
                    }
                }
            }
            this.canvas_designs_status = designStatus;
            return designStatus;
        },
        getPrintAreaParent(print_area) {
            this.current_print_area = print_area;
            let currentFlip =
                this.active_flip.charAt(0).toUpperCase() +
                this.active_flip.slice(1);
            let currentData = this.current_print_area.filter(function (
                printData
            ) {
                if (printData.label.includes(currentFlip)) return printData;
            });
            let productData = this.design_area_data.filter(function (
                printData
            ) {
                if (printData.label.includes(currentFlip)) return printData;
            });

            // Add null/undefined checks to prevent errors
            if (
                productData.length > 0 &&
                productData[0] &&
                productData[0].widthIn != null
            ) {
                this.front_canvas_width_inch = parseFloat(
                    productData[0].widthIn
                );
            } else if (
                currentData.length > 0 &&
                currentData[0] &&
                currentData[0].widthIn != null
            ) {
                this.front_canvas_width_inch = parseFloat(
                    currentData[0].widthIn
                );
            }

            if (
                productData.length > 0 &&
                productData[0] &&
                productData[0].heightIn != null
            ) {
                this.front_canvas_height_inch = parseFloat(
                    productData[0].heightIn
                );
            } else if (
                currentData.length > 0 &&
                currentData[0] &&
                currentData[0].heightIn != null
            ) {
                this.front_canvas_height_inch = parseFloat(
                    currentData[0].heightIn
                );
            }
        },
        siderBarChange(e) {
            let _this = this;
            if (e && _this.sideBarCanvasStatus) {
                // Selection cleared (outer click): Fabric often doesn't pass deselected in event — if Names & Numbers panel is open, unhighlight it
                var isSelectionCleared =
                    typeof e === "object" &&
                    !("target" in e) &&
                    (!("deselected" in e) ||
                        !e.deselected ||
                        !e.deselected.length);
                if (isSelectionCleared) {
                    var nnTabOpen = document.querySelector(
                        "#nn-tab.show.active"
                    );
                    if (nnTabOpen) {
                        if (
                            _this.$refs.nameAndNumberRef &&
                            typeof _this.$refs.nameAndNumberRef
                                .runCloseCleanup === "function"
                        ) {
                            _this.$refs.nameAndNumberRef.runCloseCleanup();
                        }
                        var nnTab = document.querySelector("#nn-tab");
                        var nnTab1 = document.getElementById("nn-tab1");
                        if (nnTab) {
                            nnTab.classList.remove("active");
                            nnTab.classList.remove("show");
                        }
                        if (nnTab1) nnTab1.classList.remove("active");
                    }
                }
                if (
                    typeof e == "object" &&
                    ("target" in e || "deselected" in e)
                ) {
                    let selectedObject =
                        "target" in e
                            ? e.target
                            : e.deselected && e.deselected[0];
                    if (!selectedObject) {
                        // has target/deselected key but no object (e.g. cleared)
                        if (document.querySelector("#nn-tab.show.active")) {
                            if (
                                _this.$refs.nameAndNumberRef &&
                                typeof _this.$refs.nameAndNumberRef
                                    .runCloseCleanup === "function"
                            ) {
                                _this.$refs.nameAndNumberRef.runCloseCleanup();
                            }
                            var nnTab = document.querySelector("#nn-tab");
                            var nnTab1 = document.getElementById("nn-tab1");
                            if (nnTab) {
                                nnTab.classList.remove("active");
                                nnTab.classList.remove("show");
                            }
                            if (nnTab1) nnTab1.classList.remove("active");
                        }
                    } else {
                        // Check if deselected/selected object is name/number (or group containing name/number)
                        var isNameNumber =
                            _this.isNameNumberObject(selectedObject) ||
                            (selectedObject &&
                                selectedObject.type === "group" &&
                                selectedObject.getObjects &&
                                selectedObject.getObjects().some(function (o) {
                                    return _this.isNameNumberObject(o);
                                }));
                        if (isNameNumber && "deselected" in e) {
                            // Outer click / deselect: unhighlight Names & Numbers tab and run cleanup (like Add Clipart)
                            if (
                                _this.$refs.nameAndNumberRef &&
                                typeof _this.$refs.nameAndNumberRef
                                    .runCloseCleanup === "function"
                            ) {
                                _this.$refs.nameAndNumberRef.runCloseCleanup();
                            }
                            var nnTab = document.querySelector("#nn-tab");
                            var nnTab1 = document.getElementById("nn-tab1");
                            if (nnTab) {
                                nnTab.classList.remove("active");
                                nnTab.classList.remove("show");
                            }
                            if (nnTab1) nnTab1.classList.remove("active");
                        } else if (
                            selectedObject.type == "text" &&
                            !isNameNumber
                        ) {
                            document
                                .querySelector("#add-" + selectedObject.type)
                                .classList.remove("active");
                            document
                                .querySelector("#add-" + selectedObject.type)
                                .classList.remove("show");
                            document
                                .querySelector(
                                    "#add-" + selectedObject.type + "-tab"
                                )
                                .classList.remove("active");
                        } else if (
                            selectedObject.ctype === "clipart" ||
                            selectedObject.ctype === "templates" ||
                            selectedObject.ctype === "shape" ||
                            selectedObject.ctype === "patch" ||
                            selectedObject.ctype === "upload"
                        ) {
                            if (selectedObject.ctype === "upload") {
                                document
                                    .querySelector("#" + selectedObject.ctype)
                                    .classList.remove("active");
                            } else {
                                document
                                    .querySelector(
                                        "#add-" + selectedObject.ctype
                                    )
                                    .classList.remove("active");
                                document
                                    .querySelector(
                                        "#add-" + selectedObject.ctype
                                    )
                                    .classList.remove("show");
                            }
                            document
                                .querySelector(
                                    "#add-" + selectedObject.ctype + "-tab"
                                )
                                .classList.remove("active");
                        }
                    }
                }
                if (document.querySelector(".deleteBtn")) {
                    document.querySelector(".deleteBtn").remove();
                    document.querySelector(".rotationBtn").remove();
                    document.querySelector(".rotationBtn").remove();
                }
                document.querySelector("#default1").classList.add("active");
                document.querySelector("#default1").classList.add("show");
                // Whenever default1 panel is shown, clear Names & Numbers left nav highlight
                var nnTab1 = document.getElementById("nn-tab1");
                if (nnTab1) nnTab1.classList.remove("active");
            }
            _this.sideBarCanvasStatus = true;
        },
        changeTshirtColor() {
            let _this = this;
            let previousColorIndex =
                localStorage.getItem("colorIndex") != null
                    ? parseInt(localStorage.getItem("colorIndex")) + 1
                    : 0;
            if (
                previousColorIndex ==
                parseInt(_this.user_selected_values.length)
            ) {
                previousColorIndex = 0;
            }
            _this.activeIndex =
                _this.user_selected_values[previousColorIndex].color_id;
            localStorage.setItem("colorIndex", previousColorIndex);
            _this.activeColorIndex = previousColorIndex;
            _this.flipTshirt(_this.active_flip);
            /* eslint-disable */
            $("#design-confirmation-modal").modal("hide");
            /* eslint-enable */
        },
        setUrl(url) {
            if (!url || url === null || url === undefined) {
                return "";
            }
            if (url.includes("http://") || url.includes("https://")) {
                return url;
            }

            return this.apiurl + url;
        },
        // Convert image src URLs in canvas JSON to data URLs so temp canvas is not tainted (JPEG/PNG raster uploads)
        async convertCanvasJsonImageUrlsToDataUrls(jsonObj) {
            if (!jsonObj || !jsonObj.objects || !Array.isArray(jsonObj.objects))
                return;
            const _this = this;
            const convertOne = async (obj) => {
                if (
                    obj.type === "image" &&
                    obj.src &&
                    typeof obj.src === "string" &&
                    !obj.src.startsWith("data:")
                ) {
                    try {
                        // Blob URLs: fetch with mode "cors" can fail; use Image + canvas for reliable conversion
                        if (obj.src.startsWith("blob:")) {
                            const dataUrl = await new Promise(
                                (resolve, reject) => {
                                    const img = new Image();
                                    img.crossOrigin = "anonymous";
                                    img.onload = () => {
                                        try {
                                            const c =
                                                document.createElement(
                                                    "canvas"
                                                );
                                            c.width =
                                                img.naturalWidth || img.width;
                                            c.height =
                                                img.naturalHeight || img.height;
                                            const ctx = c.getContext("2d");
                                            if (ctx) ctx.drawImage(img, 0, 0);
                                            resolve(c.toDataURL("image/png"));
                                        } catch (err) {
                                            reject(err);
                                        }
                                    };
                                    img.onerror = () =>
                                        reject(
                                            new Error("Blob image load failed")
                                        );
                                    img.src = obj.src;
                                }
                            );
                            obj.src = dataUrl;
                            return;
                        }
                        const fullUrl = obj.src.includes("http")
                            ? obj.src
                            : _this.setUrl(obj.src);
                        const res = await fetch(fullUrl, { mode: "cors" });
                        if (!res.ok) return;
                        const blob = await res.blob();
                        const dataUrl = await new Promise((resolve, reject) => {
                            const r = new FileReader();
                            r.onload = () => resolve(r.result);
                            r.onerror = reject;
                            r.readAsDataURL(blob);
                        });
                        obj.src = dataUrl;
                    } catch (e) {
                        // CORS or fetch failed; leave src as-is (may still taint)
                    }
                }
                if (obj.objects && Array.isArray(obj.objects)) {
                    for (const child of obj.objects) await convertOne(child);
                }
            };
            for (const obj of jsonObj.objects) await convertOne(obj);
        },
        // Wait for Fabric image objects to finish loading before exporting (fixes PNG without image when use_custom_box)
        waitForCanvasImagesToLoad(canvas, maxMs = 500) {
            return new Promise((resolve) => {
                const start = Date.now();
                const check = () => {
                    const objs = canvas.getObjects && canvas.getObjects();
                    if (!objs || !objs.length) {
                        resolve();
                        return;
                    }
                    const images = objs.filter((o) => o.type === "image");
                    const getEl = (o) =>
                        o.getElement && o.getElement ? o.getElement() : null;
                    const allDone = images.every((o) => {
                        const el = getEl(o);
                        return !el || el.complete;
                    });
                    if (allDone || Date.now() - start > maxMs) {
                        resolve();
                        return;
                    }
                    requestAnimationFrame(check);
                };
                requestAnimationFrame(check);
            });
        },
        /**
         * Snapshot clipPath on object tree (for filled-artwork export).
         */
        _snapshotClipPathsForExport(obj) {
            const snaps = [];
            const walk = (o) => {
                if (!o) return;
                snaps.push({ o, clip: o.clipPath || null });
                if (o.clipPath) {
                    o.set("clipPath", null);
                }
                if (o._objects && o._objects.length) {
                    o._objects.forEach(walk);
                }
            };
            walk(obj);
            return snaps;
        },
        _restoreClipPathsFromSnapshot(snaps) {
            (snaps || []).forEach(({ o, clip }) => {
                if (o && typeof o.set === "function") {
                    o.set("clipPath", clip || null);
                }
            });
        },
        /**
         * Snapshot objectCaching (Fabric group/SVG raster cache can export blank if stale).
         */
        _snapshotObjectCachingForExport(obj) {
            const snaps = [];
            const walk = (o) => {
                if (!o) return;
                snaps.push({
                    o,
                    v:
                        o.objectCaching !== undefined
                            ? o.objectCaching
                            : true
                });
                o.set("objectCaching", false);
                if (typeof o._clearCache === "function") {
                    try {
                        o._clearCache();
                    } catch (e) {
                        /* ignore */
                    }
                }
                if (o._objects && o._objects.length) {
                    o._objects.forEach(walk);
                }
            };
            walk(obj);
            return snaps;
        },
        _restoreObjectCachingFromSnapshot(snaps) {
            (snaps || []).forEach(({ o, v }) => {
                if (o && typeof o.set === "function") {
                    o.set("objectCaching", v);
                }
            });
        },
        /**
         * For each canvas_images row (image_name), export that Fabric object as PNG
         * and attach data URL on payload as filled_artwork_data.
         * Backend add-to-cart will upload and persist filled_artwork_url (Option A).
         */
        async attachFilledArtworkUrlsForCart(
            tempCanvas,
            canvas_images
        ) {
            if (
                !this.isAuthenticatedClient ||
                !tempCanvas ||
                !Array.isArray(canvas_images) ||
                canvas_images.length === 0
            ) {
                return;
            }
            const objs =
                tempCanvas.getObjects && tempCanvas.getObjects()
                    ? tempCanvas.getObjects()
                    : [];
            const getName = (o) => {
                if (!o) return "";
                if (typeof o.image_name === "string" && o.image_name) {
                    return o.image_name;
                }
                if (o.get && typeof o.get === "function") {
                    const v = o.get("image_name");
                    return typeof v === "string" ? v : "";
                }
                return "";
            };
            let layerIdx = 0;
            for (const row of canvas_images) {
                if (!row || !row.image_name) {
                    layerIdx++;
                    continue;
                }
                const fabricObj = objs.find(
                    (o) => getName(o) === row.image_name
                );
                if (!fabricObj) {
                    layerIdx++;
                    continue;
                }
                let dataUrl = "";
                const clipSnaps = this._snapshotClipPathsForExport(fabricObj);
                const cacheSnaps = this._snapshotObjectCachingForExport(fabricObj);
                try {
                    if (typeof fabricObj.setCoords === "function") {
                        fabricObj.setCoords();
                    }
                    if (fabricObj.dirty !== undefined) {
                        fabricObj.set("dirty", true);
                    }
                    if (
                        fabricObj.toDataURL &&
                        typeof fabricObj.toDataURL === "function"
                    ) {
                        dataUrl = fabricObj.toDataURL({
                            format: "png",
                            multiplier: 2
                        });
                    }
                } catch (e) {
                    dataUrl = "";
                } finally {
                    this._restoreObjectCachingFromSnapshot(cacheSnaps);
                    this._restoreClipPathsFromSnapshot(clipSnaps);
                    if (typeof fabricObj.setCoords === "function") {
                        fabricObj.setCoords();
                    }
                }
                if (!dataUrl || typeof dataUrl !== "string" || dataUrl.length < 64) {
                    layerIdx++;
                    continue;
                }
                row.filled_artwork_data = dataUrl;
                layerIdx++;
            }
            if (tempCanvas && typeof tempCanvas.requestRenderAll === "function") {
                tempCanvas.requestRenderAll();
            }
        },
        // Trim transparent area from exported design image so saved "My Designs"
        // shows only artwork bounds (no product image / no large empty canvas).
        async trimTransparentPixelsFromDataUrl(dataUrl) {
            if (!dataUrl || typeof dataUrl !== "string") return dataUrl;
            return new Promise((resolve) => {
                try {
                    const img = new Image();
                    img.onload = () => {
                        try {
                            const canvas = document.createElement("canvas");
                            canvas.width = img.naturalWidth || img.width;
                            canvas.height = img.naturalHeight || img.height;
                            const ctx = canvas.getContext("2d");
                            if (!ctx || canvas.width <= 0 || canvas.height <= 0) {
                                resolve(dataUrl);
                                return;
                            }
                            ctx.drawImage(img, 0, 0);
                            const imageData = ctx.getImageData(
                                0,
                                0,
                                canvas.width,
                                canvas.height
                            );
                            const pixels = imageData.data;
                            let minX = canvas.width;
                            let minY = canvas.height;
                            let maxX = -1;
                            let maxY = -1;

                            for (let y = 0; y < canvas.height; y++) {
                                for (let x = 0; x < canvas.width; x++) {
                                    const alpha = pixels[
                                        (y * canvas.width + x) * 4 + 3
                                    ];
                                    if (alpha > 0) {
                                        if (x < minX) minX = x;
                                        if (y < minY) minY = y;
                                        if (x > maxX) maxX = x;
                                        if (y > maxY) maxY = y;
                                    }
                                }
                            }

                            if (maxX < minX || maxY < minY) {
                                resolve(dataUrl);
                                return;
                            }

                            const cropWidth = maxX - minX + 1;
                            const cropHeight = maxY - minY + 1;
                            // Keep some transparent breathing space so saved
                            // thumbnail does not look over-zoomed in My Designs.
                            const padRatio = 0.22;
                            const padX = Math.max(
                                8,
                                Math.round(cropWidth * padRatio)
                            );
                            const padY = Math.max(
                                8,
                                Math.round(cropHeight * padRatio)
                            );
                            const outCanvas = document.createElement("canvas");
                            outCanvas.width = cropWidth + padX * 2;
                            outCanvas.height = cropHeight + padY * 2;
                            const outCtx = outCanvas.getContext("2d");
                            if (!outCtx) {
                                resolve(dataUrl);
                                return;
                            }
                            outCtx.drawImage(
                                canvas,
                                minX,
                                minY,
                                cropWidth,
                                cropHeight,
                                padX,
                                padY,
                                cropWidth,
                                cropHeight
                            );
                            resolve(
                                outCanvas.toDataURL("image/png", 1.0) || dataUrl
                            );
                        } catch (e) {
                            resolve(dataUrl);
                        }
                    };
                    img.onerror = () => resolve(dataUrl);
                    img.src = dataUrl;
                } catch (e) {
                    resolve(dataUrl);
                }
            });
        },
        activeFrontType(event) {
            this.disable_tshirt_canvas = event;
        },
        disableResetBtn() {
            let _this = this;
            /* eslint-disable */
            if (_this.backCanvas._objects.length <= 1) {
                $("#newResetbtn").prop("disabled", true);
            } else {
                $("#newResetbtn").prop("disabled", false);
            }
            /* eslint-enable */
        },
        saveCanvasData() {
            var _this = this;
            // clear the redo stack
            /* eslint-disable */
            if (_this.redo.length == 0)
                $("#redoObj").prop("disabled", true).removeClass("active");
            $(".new_arts_color").removeClass("d-none");
            // initial call won't have a state
            if (_this.state.length) {
                let keys = localStorage.getItem("active_flip");
                var obj = {};
                obj[keys] = _this.state;
                _this.undo.push(obj);
                $("#undoObj").prop("disabled", false).addClass("active");
            }
            /* eslint-enable */
            _this.disableResetBtn();
            _this.state = JSON.stringify(_this.backCanvas);
            _this.canvasVersion++;
            _this.$nextTick(() => {
                if (typeof _this.calculatePatchCost === "function") {
                    _this.calculatePatchCost();
                }
            });
        },
        // For any flip with no product image: get effective visible design area size in pixels for PNG export.
        getEffectiveDesignAreaDimensionsForFlip(flip) {
            if (!this.design_area_data) return null;
            let areas = Array.isArray(this.design_area_data)
                ? this.design_area_data
                : typeof this.design_area_data === "object"
                ? Object.values(this.design_area_data)
                : [];
            if (!areas.length) return null;
            let currentFlip = flip.charAt(0).toUpperCase() + flip.slice(1);
            let area = areas.find(
                (a) =>
                    a &&
                    a.label &&
                    (a.label === currentFlip ||
                        (flip === "front" &&
                            a.label.toLowerCase().includes("front")) ||
                        (flip === "back" &&
                            a.label.toLowerCase().includes("back")) ||
                        (flip === "left" &&
                            a.label.toLowerCase().includes("left")) ||
                        (flip === "right" &&
                            a.label.toLowerCase().includes("right")))
            );
            if (!area) return null;
            let hasValidImage =
                ((area.image && String(area.image).trim() !== "") ||
                    (area.thumbnail && String(area.thumbnail).trim() !== "")) &&
                String(area.image || area.thumbnail).toLowerCase() !== "null";
            if (area.use_custom_box !== true && hasValidImage) return null;
            let widthInch =
                area.widthIn != null
                    ? parseFloat(area.widthIn)
                    : area.width != null
                    ? parseFloat(area.width)
                    : null;
            let heightInch =
                area.heightIn != null
                    ? parseFloat(area.heightIn)
                    : area.height != null
                    ? parseFloat(area.height)
                    : null;
            if (
                typeof widthInch !== "number" ||
                isNaN(widthInch) ||
                widthInch <= 0 ||
                typeof heightInch !== "number" ||
                isNaN(heightInch) ||
                heightInch <= 0
            )
                return null;
            let maxW = this.defaultWidthCanvas * 0.95;
            let maxH = this.defaultHeightCanvas * 0.95;

            // Convert inches to pixels (96 DPI for web)
            let widthPx = widthInch * 96;
            let heightPx = heightInch * 96;

            // Calculate scale to fit within canvas
            let scale = Math.min(maxW / widthPx, maxH / heightPx);

            return {
                width: Math.round(widthPx * scale),
                height: Math.round(heightPx * scale)
            };
        },
        getProductImageUrlsForPreview() {
            const urls = { front: "", back: "", left: "", right: "" };
            const group =
                this.gender_groups_items &&
                this.gender_groups_items[this.active_gender_key];
            const item = group && group.item;
            const newProductImages = item && item.NewProductImages;
            const activeColorHash =
                localStorage.getItem("active_tshirt_color") ||
                (this.user_selected_values &&
                    this.user_selected_values[this.active_gender_key] &&
                    this.user_selected_values[this.active_gender_key]
                        .color_hash) ||
                "";
            const colors = group && group.colors;
            const currentColor =
                colors &&
                activeColorHash &&
                colors.find(
                    (c) =>
                        (c.hex &&
                            c.hex.toUpperCase() ===
                                String(activeColorHash).toUpperCase()) ||
                        (c.hash &&
                            c.hash.toUpperCase() ===
                                String(activeColorHash).toUpperCase()) ||
                        (c.color_hash &&
                            c.color_hash.toUpperCase() ===
                                String(activeColorHash).toUpperCase())
                );
            const colorId = currentColor && currentColor.id;
            if (newProductImages && colorId != null) {
                newProductImages.forEach((npi) => {
                    if (npi.color_id != colorId) return;
                    if (npi.type === "front") urls.front = npi.url || "";
                    if (npi.type === "back") urls.back = npi.url || "";
                    if (npi.type === "left") urls.left = npi.url || "";
                    if (npi.type === "right") urls.right = npi.url || "";
                });
            }
            if (this.design_area_data && Array.isArray(this.design_area_data)) {
                const byLabel = (label) => {
                    const area = this.design_area_data.find(
                        (a) =>
                            a &&
                            (a.label === label ||
                                (a.label_show &&
                                    a.label_show.toLowerCase() ===
                                        label.toLowerCase()))
                    );
                    if (area && area.thumbnail) {
                        return this.setUrl
                            ? this.setUrl(area.thumbnail)
                            : area.thumbnail;
                    }
                    return "";
                };
                if (!urls.front) urls.front = byLabel("Front");
                if (!urls.back) urls.back = byLabel("Back");
                if (!urls.left)
                    urls.left = byLabel("Left") || byLabel("Left Sleeve");
                if (!urls.right)
                    urls.right = byLabel("Right") || byLabel("Right Sleeve");
            }
            return urls;
        },
        /** Product color for Left/Right preview background (same as cart) */
        getProductColorForPreview() {
            const group =
                this.gender_groups_items &&
                this.gender_groups_items[this.active_gender_key];
            const activeColorHash =
                localStorage.getItem("active_tshirt_color") ||
                (this.user_selected_values &&
                    this.user_selected_values[this.active_gender_key] &&
                    this.user_selected_values[this.active_gender_key]
                        .color_hash) ||
                "";
            const colors = group && group.colors;
            const currentColor =
                colors &&
                activeColorHash &&
                colors.find(
                    (c) =>
                        (c.hex &&
                            c.hex.toUpperCase() ===
                                String(activeColorHash).toUpperCase()) ||
                        (c.hash &&
                            c.hash.toUpperCase() ===
                                String(activeColorHash).toUpperCase()) ||
                        (c.color_hash &&
                            c.color_hash.toUpperCase() ===
                                String(activeColorHash).toUpperCase())
                );
            if (currentColor) {
                return (
                    currentColor.hex ||
                    currentColor.hash ||
                    currentColor.color_hash ||
                    activeColorHash ||
                    "#FFFFFF"
                );
            }
            return activeColorHash || "#FFFFFF";
        },
        // Return true when this side is selected in design_area_data
        isFlipSelectedForPreview(flip) {
            if (
                !this.design_area_data ||
                !Array.isArray(this.design_area_data)
            ) {
                return true;
            }
            const key = flip.toLowerCase();
            const area = this.design_area_data.find((a) => {
                if (!a || !a.label) return false;
                const label = a.label.toLowerCase();
                if (key === "left") return label.includes("left");
                if (key === "right") return label.includes("right");
                return label === key;
            });
            if (!area || area.selected === undefined) {
                return true;
            }
            return !!area.selected;
        },
        // Return true when design_area_data has an image or thumbnail for this side
        hasDesignAreaImageForFlip(flip) {
            if (!this.design_area_data || !Array.isArray(this.design_area_data))
                return false;
            const currentFlip = flip.charAt(0).toUpperCase() + flip.slice(1);
            const area = this.design_area_data.find(
                (a) =>
                    a &&
                    (a.label === currentFlip ||
                        (flip === "left" &&
                            (a.label === "Left Sleeve" ||
                                (a.label &&
                                    a.label.toLowerCase().includes("left")))) ||
                        (flip === "right" &&
                            (a.label === "Right Sleeve" ||
                                (a.label &&
                                    a.label.toLowerCase().includes("right")))))
            );
            if (!area) return false;
            const hasImage =
                (area.image && area.image !== "" && area.image !== null) ||
                (area.thumbnail &&
                    area.thumbnail !== "" &&
                    area.thumbnail !== null);
            return !!hasImage;
        },
        // Return true when design area for this flip has use_custom_box (show rectangle in preview)
        useCustomBoxForFlip(flip) {
            if (!this.design_area_data || !Array.isArray(this.design_area_data))
                return false;
            const currentFlip = flip.charAt(0).toUpperCase() + flip.slice(1);
            const area = this.design_area_data.find(
                (a) =>
                    a &&
                    (a.label === currentFlip ||
                        (flip === "left" &&
                            (a.label === "Left Sleeve" ||
                                (a.label &&
                                    a.label.toLowerCase().includes("left")))) ||
                        (flip === "right" &&
                            (a.label === "Right Sleeve" ||
                                (a.label &&
                                    a.label.toLowerCase().includes("right")))))
            );
            return !!(area && area.use_custom_box === true);
        },
        async generateDesignPreviewPngs() {
            const _this = this;
            const activeFlip =
                localStorage.getItem("active_flip") || this.active_flip;
            let new_canvas_elements = JSON.parse(
                localStorage.getItem("new_canvas_elements") || "{}"
            );
            if (this.backCanvas) {
                new_canvas_elements[activeFlip] = JSON.stringify(
                    this.backCanvas
                );
            }
            const flips = [];
            if (this.front_show) flips.push("front");
            if (this.back_show) flips.push("back");
            if (this.left_show) flips.push("left");
            if (this.right_show) flips.push("right");
            const productImageUrls = this.getProductImageUrlsForPreview();
            const productColorForPreview = this.getProductColorForPreview();
            const image_response = [];
            for (const flip of flips) {
                // Skip sides that are not selected in design_area_data (like disabled print areas)
                if (!this.isFlipSelectedForPreview(flip)) {
                    continue;
                }
                const objects = new_canvas_elements[flip]
                    ? JSON.parse(new_canvas_elements[flip]).objects
                    : [];
                if (objects.length === 0) {
                    image_response.push({
                        label: flip,
                        url: "",
                        empty: true
                    });
                    continue;
                }
                const tempCanvas = new fabric.Canvas();
                let rectHeight = 0;
                let rectWidth = 0;
                let rectTop = 0;
                let rectLeft = 0;
                objects.forEach((canvas_obj) => {
                    if (
                        "clipPath" in canvas_obj &&
                        canvas_obj.clipPath &&
                        canvas_obj.clipPath.type === "rect"
                    ) {
                        rectHeight = canvas_obj.clipPath.height;
                        rectWidth = canvas_obj.clipPath.width;
                        rectTop = canvas_obj.clipPath.top;
                        rectLeft = canvas_obj.clipPath.left;
                    }
                });
                // For left/right: always use rectangle (effDims) when no product image. For front/back: use rectangle when use_custom_box or no design area image.
                const useRectForFrontBack =
                    (flip === "front" || flip === "back") &&
                    (this.useCustomBoxForFlip(flip) ||
                        !this.hasDesignAreaImageForFlip(flip));
                const effDims =
                    flip === "left" || flip === "right"
                        ? this.getEffectiveDesignAreaDimensionsForFlip(flip)
                        : useRectForFrontBack
                        ? this.getEffectiveDesignAreaDimensionsForFlip(flip)
                        : null;
                if (effDims && effDims.width > 0 && effDims.height > 0) {
                    tempCanvas.setWidth(effDims.width);
                    tempCanvas.setHeight(effDims.height);
                    let bgColor = productColorForPreview || "#FFFFFF";
                    if (
                        !bgColor ||
                        bgColor === "null" ||
                        bgColor === "#null" ||
                        bgColor === ""
                    )
                        bgColor = "#FFFFFF";
                    tempCanvas.setBackgroundColor(
                        bgColor,
                        tempCanvas.renderAll.bind(tempCanvas)
                    );
                } else {
                    tempCanvas.setWidth(this.defaultWidthCanvas);
                    tempCanvas.setHeight(this.defaultHeightCanvas);
                }
                let localCanvasJson = JSON.parse(new_canvas_elements[flip]);
                if (
                    localCanvasJson.objects &&
                    localCanvasJson.objects.length > 0
                ) {
                    localCanvasJson.objects = localCanvasJson.objects.filter(
                        (val) => val.type !== "rect"
                    );
                }
                // Set crossOrigin and convert image URLs to data URLs so images render in export (fixes custom box PNG without image)
                const jsonForLoad = JSON.parse(JSON.stringify(localCanvasJson));
                const setCrossOriginOnImages = (objects) => {
                    if (!objects || !Array.isArray(objects)) return;
                    objects.forEach((obj) => {
                        if (
                            obj.type === "image" ||
                            (obj.src && obj.crossOrigin == null)
                        ) {
                            obj.crossOrigin = "anonymous";
                        }
                        if (obj.objects) setCrossOriginOnImages(obj.objects);
                    });
                };
                if (jsonForLoad.objects)
                    setCrossOriginOnImages(jsonForLoad.objects);
                await this.convertCanvasJsonImageUrlsToDataUrls(jsonForLoad);
                const designOnlyResult = await new Promise((resolve) => {
                    tempCanvas.loadFromJSON(
                        JSON.stringify(jsonForLoad),
                        function () {
                            if (
                                effDims &&
                                effDims.width > 0 &&
                                effDims.height > 0
                            ) {
                                tempCanvas.getObjects().forEach(function (obj) {
                                    if (obj.clipPath) obj.set("clipPath", null);
                                });
                            }
                            // Wait for image objects to finish loading so PNG export includes them (custom box fix)
                            _this
                                .waitForCanvasImagesToLoad(tempCanvas)
                                .then(() => {
                                    tempCanvas.renderAll();
                                    let url = "";
                                    if (
                                        effDims &&
                                        effDims.width > 0 &&
                                        effDims.height > 0
                                    ) {
                                        url = tempCanvas.toDataURL({
                                            left: 0,
                                            top: 0,
                                            width: effDims.width,
                                            height: effDims.height,
                                            format: "image/png",
                                            quality: 1.0
                                        });
                                    } else if (rectHeight > 0 && rectTop > 0) {
                                        url = tempCanvas.toDataURL({
                                            left: rectLeft,
                                            top: rectTop,
                                            width: rectWidth,
                                            height: rectHeight,
                                            format: "image/png",
                                            quality: 1.0
                                        });
                                    } else if (
                                        effDims &&
                                        effDims.width > 0 &&
                                        effDims.height > 0
                                    ) {
                                        url = tempCanvas.toDataURL({
                                            left: 0,
                                            top: 0,
                                            width: effDims.width,
                                            height: effDims.height,
                                            format: "image/png",
                                            quality: 1.0
                                        });
                                    } else {
                                        url = tempCanvas.toDataURL({
                                            format: "image/png",
                                            quality: 1.0
                                        });
                                    }
                                    resolve({ url, tempCanvas });
                                });
                        }
                    );
                });
                const canvasImgUrl = productImageUrls[flip] || "";
                // When effDims is set we use rectangle-only output (no product image overlay)
                if (
                    canvasImgUrl &&
                    canvasImgUrl !== "" &&
                    !effDims &&
                    typeof _this.loadImageAsync === "function"
                ) {
                    try {
                        const imgObj = await _this.loadImageAsync(canvasImgUrl);
                        const scaleX = _this.defaultWidthCanvas / imgObj.width;
                        const scaleY =
                            _this.defaultHeightCanvas / imgObj.height;
                        const scale = Math.min(scaleX, scaleY);
                        const scaledWidth = imgObj.width * scale;
                        const scaledHeight = imgObj.height * scale;
                        const left =
                            (_this.defaultWidthCanvas - scaledWidth) / 2;
                        const top =
                            (_this.defaultHeightCanvas - scaledHeight) / 2;
                        designOnlyResult.tempCanvas.setBackgroundColor(
                            null,
                            designOnlyResult.tempCanvas.renderAll.bind(
                                designOnlyResult.tempCanvas
                            )
                        );
                        await designOnlyResult.tempCanvas.setBackgroundImage(
                            imgObj,
                            designOnlyResult.tempCanvas.renderAll.bind(
                                designOnlyResult.tempCanvas
                            ),
                            {
                                scaleX: scale,
                                scaleY: scale,
                                left: left,
                                top: top,
                                crossOrigin: "anonymous"
                            }
                        );
                        if (imgObj._element != null) {
                            image_response.push({
                                label: flip,
                                url: designOnlyResult.tempCanvas.toDataURL({
                                    left: left,
                                    top: top,
                                    width: scaledWidth,
                                    height: scaledHeight,
                                    multiplier: 0.6
                                })
                            });
                        } else {
                            image_response.push({
                                label: flip,
                                url: designOnlyResult.url
                            });
                        }
                    } catch (e) {
                        image_response.push({
                            label: flip,
                            url: designOnlyResult.url
                        });
                    }
                } else {
                    image_response.push({
                        label: flip,
                        url: designOnlyResult.url
                    });
                }
            }
            return image_response;
        },
        async openAllDesignAreasPreview() {
            this.allDesignPreviewModal = true;
            this.allDesignPreviewLoading = true;
            this.allDesignPreviewImages = [];
            this.allDesignPreviewProductColor =
                this.getProductColorForPreview() || "#ffffff";
            try {
                const images = await this.generateDesignPreviewPngs();
                // Add flags so modal knows: base image for this side, and use_custom_box (rectangle)
                this.allDesignPreviewImages = images.map((img) => ({
                    ...img,
                    hasDesignAreaImage: this.hasDesignAreaImageForFlip(
                        img.label
                    ),
                    useCustomBox: this.useCustomBoxForFlip(img.label)
                }));
            } catch (e) {
                if (this.$toast) {
                    this.$toast.error(
                        "Could not generate preview. Please try again.",
                        { position: "top-right" }
                    );
                }
                this.allDesignPreviewModal = false;
            } finally {
                this.allDesignPreviewLoading = false;
            }
        },
        onAllDesignPreviewSelectLocation(location) {
            if (
                location &&
                ["front", "back", "left", "right"].includes(location)
            ) {
                this.flipTshirt(location);
                this.allDesignPreviewModal = false;
            }
        },
        replay(playStack, saveStack, buttonsOn, buttonsOff) {
            var _this = this;
            /* eslint-disable */
            var obj = {};
            if (saveStack.length == 0 && this.undoObject == 0) {
                let keys = localStorage.getItem("active_flip");
                obj[keys] = _this.state;
                saveStack.push(obj);
                this.undoObject++;
            } else {
                if (
                    _this.state.hasOwnProperty("front") ||
                    _this.state.hasOwnProperty("back") ||
                    _this.state.hasOwnProperty("left") ||
                    _this.state.hasOwnProperty("right")
                ) {
                    saveStack.push(_this.state);
                } else {
                    let keys = localStorage.getItem("active_flip");
                    obj[keys] = _this.state;
                    saveStack.push(obj);
                }
            }
            _this.state = playStack.pop();
            var on = $(buttonsOn);
            var off = $(buttonsOff);
            /* eslint-enable */
            // turn both buttons off for the moment to prevent rapid clicking
            on.prop("disabled", true).removeClass("active");
            off.prop("disabled", true).removeClass("active");
            let objt = 0;
            if (_this.state) {
                objt = Object.keys(_this.state);
            }

            let k = playStack[playStack.length - 1];
            // here change canvas area for undo
            if (k && _this.undoActive) {
                _this.flipTshirt(Object.keys(k)[0]);
            }
            if (_this.redoActive) {
                let p = saveStack[saveStack.length - 1];
                if (p) {
                    _this.flipTshirt(Object.keys(p)[0]);
                }
            }
            _this.backCanvas.clear();
            if (objt[0] == 0 || objt == 0) {
                if (JSON.parse(_this.state).objects.length > 0) {
                    let stateData = JSON.parse(_this.state);
                    stateData.objects.map(function (val, key) {
                        if (val.type == "rect") {
                            stateData.objects[key]["selectable"] = false;
                            stateData.objects[key]["evented"] = false;
                        }
                    });
                    _this.state = JSON.stringify(stateData);
                }

                fabric.util.enlivenObjects(
                    JSON.parse(_this.state).objects,
                    function (objects) {
                        const descriptors = JSON.parse(_this.state).objects;
                        objects.forEach(function (o, idx) {
                            let type1 = o.ctype;
                            let objType1 = o.objType;
                            let extension = o.iextension;
                            let product_id = o.product_id;
                            const desc = descriptors && descriptors[idx];
                            const patch_id = desc && desc.patch_id;
                            const material_id = desc && desc.material_id;
                            if (
                                type1 === "patch" &&
                                patch_id != null &&
                                material_id != null
                            ) {
                                if (o.set) {
                                    o.set("patch_id", patch_id);
                                    o.set("material_id", material_id);
                                } else {
                                    o.patch_id = patch_id;
                                    o.material_id = material_id;
                                }
                            }
                            o.toObject = (function (toObject) {
                                return function () {
                                    const base = {
                                        ctype: type1,
                                        objType: objType1,
                                        image_name: o.image_name,
                                        image_path: o.image_path,
                                        width_inch: o.width_inch,
                                        height_inch: o.height_inch,
                                        iextension: extension,
                                        product_id: product_id
                                    };
                                    if (
                                        type1 === "patch" &&
                                        patch_id != null &&
                                        material_id != null
                                    ) {
                                        base.patch_id = patch_id;
                                        base.material_id = material_id;
                                    }
                                    return fabric.util.object.extend(
                                        toObject.call(this),
                                        base
                                    );
                                };
                            })(o.toObject);
                            _this.backCanvas.add(o);
                            // Re-apply fixed-size locks for patch objects
                            if (type1 === "patch") {
                                o.set({
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    lockUniScaling: true,
                                    hasControls: true
                                });
                                if (
                                    typeof o.setControlsVisibility ===
                                    "function"
                                ) {
                                    o.setControlsVisibility({
                                        mt: false,
                                        mb: false,
                                        ml: false,
                                        mr: false,
                                        tl: false,
                                        tr: false,
                                        bl: false,
                                        br: false,
                                        mtr: true
                                    });
                                }
                            }
                        });

                        _this.backCanvas.renderAll();
                        // now turn the buttons back on if applicable
                        on.prop("disabled", false).addClass("active");

                        // on.AddClass("undo_active");
                        if (playStack.length) {
                            off.prop("disabled", false).addClass("active");
                        }
                    }
                );
                // EnlivenObjects instead of loadFromJSON in fabric js

                saveStack = [];
                return;
            }
            let overlay_img_status = false;
            if (JSON.parse(_this.state[objt[0]]).objects.length > 0) {
                let stateData = JSON.parse(_this.state[objt[0]]);
                stateData.objects.map(function (val, key) {
                    if (val.type == "rect") {
                        stateData.objects[key]["selectable"] = false;
                        stateData.objects[key]["evented"] = false;
                    }
                });
                if (!("overlayImage" in stateData)) {
                    overlay_img_status = true;
                }
                _this.state[objt[0]] = JSON.stringify(stateData);
            }

            // EnlivenObjects instead of loadFromJSON in fabric js
            fabric.util.enlivenObjects(
                JSON.parse(_this.state[objt[0]]).objects,
                function (objects) {
                    const descriptors = JSON.parse(
                        _this.state[objt[0]]
                    ).objects;
                    objects.forEach(function (o, idx) {
                        let type1 = o.ctype;
                        let objType1 = o.objType;
                        let extension = o.iextension;
                        let product_id = o.product_id;
                        const desc = descriptors && descriptors[idx];
                        const patch_id = desc && desc.patch_id;
                        const material_id = desc && desc.material_id;
                        if (
                            type1 === "patch" &&
                            patch_id != null &&
                            material_id != null
                        ) {
                            if (o.set) {
                                o.set("patch_id", patch_id);
                                o.set("material_id", material_id);
                            } else {
                                o.patch_id = patch_id;
                                o.material_id = material_id;
                            }
                        }
                        if (type1 === "upload" && desc) {
                            if (o.set) {
                                if (desc.uploadId != null)
                                    o.set("uploadId", desc.uploadId);
                                if (desc.image_name != null)
                                    o.set("image_name", desc.image_name);
                                if (desc.image_path != null)
                                    o.set("image_path", desc.image_path);
                                if (desc.image_colors != null)
                                    o.set("image_colors", desc.image_colors);
                            } else {
                                if (desc.uploadId != null)
                                    o.uploadId = desc.uploadId;
                                if (desc.image_name != null)
                                    o.image_name = desc.image_name;
                                if (desc.image_path != null)
                                    o.image_path = desc.image_path;
                                if (desc.image_colors != null)
                                    o.image_colors = desc.image_colors;
                            }
                        }
                        o.toObject = (function (toObject) {
                            return function () {
                                const base = {
                                    ctype: type1,
                                    objType: objType1,
                                    image_name: o.image_name,
                                    image_path: o.image_path,
                                    width_inch: o.width_inch,
                                    height_inch: o.height_inch,
                                    iextension: extension,
                                    product_id: product_id
                                };
                                if (
                                    type1 === "patch" &&
                                    patch_id != null &&
                                    material_id != null
                                ) {
                                    base.patch_id = patch_id;
                                    base.material_id = material_id;
                                }
                                if (type1 === "upload") {
                                    base.uploadId =
                                        o.uploadId != null
                                            ? o.uploadId
                                            : o.get && o.get("uploadId");
                                    base.image_colors =
                                        o.image_colors != null
                                            ? o.image_colors
                                            : o.get && o.get("image_colors");
                                }
                                return fabric.util.object.extend(
                                    toObject.call(this),
                                    base
                                );
                            };
                        })(o.toObject);
                        _this.backCanvas.add(o);
                        // Re-apply fixed-size locks for patch objects
                        if (type1 === "patch") {
                            o.set({
                                lockScalingX: true,
                                lockScalingY: true,
                                lockUniScaling: true,
                                hasControls: true
                            });
                            if (typeof o.setControlsVisibility === "function") {
                                o.setControlsVisibility({
                                    mt: false,
                                    mb: false,
                                    ml: false,
                                    mr: false,
                                    tl: false,
                                    tr: false,
                                    bl: false,
                                    br: false,
                                    mtr: true
                                });
                            }
                        }
                    });
                    if (overlay_img_status) {
                        _this.backCanvas.overlayImage = null;
                        _this.distress_images[objt[0]] = "";
                        overlay_img_status = false;
                    }
                    _this.backCanvas.renderAll();
                    // now turn the buttons back on if applicable
                    on.prop("disabled", false).addClass("active");

                    // on.AddClass("undo_active");
                    if (playStack.length) {
                        off.prop("disabled", false).addClass("active");
                        // off.addClass("redo_active");
                    }
                }
            );
        },
        controlUndoRedoObject(e) {
            var _this = this;
            if (
                !(
                    (e.keyCode === 90 && e.ctrlKey) ||
                    (e.keyCode === 89 && e.ctrlKey)
                )
            ) {
                return;
            }
            e.preventDefault();

            // Check pressed button is Z - Ctrl+Z.
            if (e.keyCode === 90 && e.ctrlKey && _this.undo.length > 0) {
                _this.undoActive = true;
                _this.redoActive = false;
                _this.replay(_this.undo, _this.redo, "#redoObj", this);
            }
            /* eslint-disable */
            if (_this.undo.length == 0) {
                $("#undoObj").prop("disabled", true);
                $("#undoObj").removeClass("active");
                $("#redoObj").prop("disabled", false);
                $("#redoObj").addClass("active");
                $("#newResetbtn").prop("disabled", true);
                $(".new_arts_color").addClass("d-none");
            }
            // Check pressed button is Y - Ctrl+Y.
            if (e.keyCode === 89 && e.ctrlKey && _this.redo.length > 0) {
                _this.undoActive = false;
                _this.redoActive = true;
                _this.replay(_this.redo, _this.undo, "#undoObj", this);
                $(".new_arts_color").removeClass("d-none");
                $("#newResetbtn").prop("disabled", false);
            }
            if (_this.redo.length == 0) {
                $("#redoObj").prop("disabled", true);
                $("#redoObj").removeClass("active");
                $("#undoObj").prop("disabled", false);
                $("#undoObj").addClass("active");
            }
            /* eslint-enable */
        },
        objectClone(ev) {
            var _this = this;

            // function to check the detection
            ev = ev || window.event; // Event object 'ev'
            var key = ev.which || ev.keyCode; // Detecting keyCode

            // Ignore cloning when user is typing inside an input/textarea/contenteditable
            var target = ev.target || ev.srcElement;
            if (target) {
                var tagName = (target.tagName || "").toLowerCase();
                if (
                    tagName === "input" ||
                    tagName === "textarea" ||
                    target.isContentEditable
                ) {
                    return;
                }
            }

            // Detecting Ctrl
            var ctrl = ev.ctrlKey ? ev.ctrlKey : key === 17 ? true : false;

            var activeObject = _this.backCanvas.getActiveObject();
            if ((key == 86 && ctrl) || key === 46) {
                if (!activeObject) {
                    // _this.$toast.error("Please select object in Canvas", {
                    //     position: "top-right",
                    //     queue: true
                    // });
                    return;
                }
            }
            // If key pressed is V and if ctrl is true.
            if (key == 86 && ctrl && activeObject) {
                activeObject.clone(function (cobj) {
                    cobj.set("top", cobj.top + 20);
                    cobj.set("left", cobj.left + 20);
                    _this.backCanvas.add(cobj);
                    _this.backCanvas.renderAll();
                    _this.saveCanvasData();
                });
                _this.$toast.success("Object cloned successfully.", {
                    position: "top-right",
                    queue: true
                });
            }
            if (key === 46) {
                if (activeObject) {
                    _this.delete_object();
                    _this.$toast.success("Object deleted successfully.", {
                        position: "top-right",
                        queue: true
                    });
                }
            }
        },
        resetElements(type = null) {
            var front_select_canvas = document.querySelector("#nn-tab1");
            // Add null check to prevent classList error
            var isActives =
                front_select_canvas &&
                front_select_canvas.classList.contains("active");
            /* eslint-disable */
            $(".deleteBtn").remove();
            $(".rotationBtn").remove();
            $(".front").removeClass("active");
            $(".left").removeClass("active");
            $(".right").removeClass("active");
            $(".back").removeClass("active");
            $(".nav-link.active").removeClass("active");
            $(".main_panel_check.show.active")
                .removeClass("show")
                .removeClass("active");
            $("#default1").addClass("active").addClass("show");
            if (
                isActives &&
                (type == "front" ||
                    type == "back" ||
                    type == "left" ||
                    type == "right")
            ) {
                if (
                    this.isEmbroideryServiceForNameNumber &&
                    type !== "front"
                ) {
                    var nnTabEmb = document.querySelector("#nn-tab");
                    var nnTab1Emb = document.querySelector("#nn-tab1");
                    if (nnTabEmb) {
                        nnTabEmb.classList.remove("active");
                        nnTabEmb.classList.remove("show");
                    }
                    if (nnTab1Emb) {
                        nnTab1Emb.classList.remove("active");
                    }
                    return;
                }
                $("#default1").removeClass("active").removeClass("show");
                var nnTab = document.querySelector("#nn-tab");
                var nnTab1 = document.querySelector("#nn-tab1");
                if (nnTab) {
                    nnTab.classList.add("active");
                    nnTab.classList.add("show");
                }
                if (nnTab1) {
                    nnTab1.classList.add("active");
                }
                this.selectedCheckbox = false;
                if (this.$refs.nameAndNumberRef) {
                    this.$refs.nameAndNumberRef.enableName();
                    if (type == "front") {
                        this.$refs.nameAndNumberRef.disableName();
                    }
                }
            } else {
                var nnTab = document.querySelector("#nn-tab");
                if (nnTab) {
                    nnTab.classList.remove("active");
                    nnTab.classList.remove("show");
                }
                var nnTab1 = document.getElementById("nn-tab1");
                if (nnTab1) nnTab1.classList.remove("active");
            }
            /* eslint-enable */
        },
        addDesignArea() {
            let _this = this;
            if (this.cart_save_design) return;
            if (!_this.backCanvas) return;

            // Check if use_custom_box is enabled
            let flip = this.active_flip;
            let currentArea = this.design_area_data
                ? this.design_area_data.find(
                      (area) =>
                          (flip === "front" &&
                              area.label &&
                              area.label.toLowerCase().includes("front")) ||
                          (flip === "back" &&
                              area.label &&
                              area.label.toLowerCase().includes("back")) ||
                          (flip === "left" &&
                              area.label &&
                              area.label.toLowerCase().includes("left")) ||
                          (flip === "right" &&
                              area.label &&
                              area.label.toLowerCase().includes("right"))
                  )
                : null;

            // Handle custom box case - use existing fallback method
            if (currentArea && currentArea.use_custom_box === true) {
                let dimensions = this.getEffectiveDesignAreaDimensionsForFlip(
                    this.active_flip
                );
                if (dimensions) {
                    // Remove old rectangles
                    _this.backCanvas.getObjects().forEach(function (obj) {
                        if (
                            obj.type === "rect" &&
                            obj.selectable === false &&
                            obj.evented === false
                        ) {
                            _this.backCanvas.remove(obj);
                        }
                    });

                    // Custom box: no dashed line (stroke hidden). Rect at (0,0) so clipPath matches canvas coords.
                    let square = new fabric.Rect({
                        width: dimensions.width,
                        height: dimensions.height,
                        left: 0,
                        top: 0,
                        fill: "transparent",
                        absolutePositioned: true,
                        stroke: "transparent",
                        strokeWidth: 0,
                        selectable: false,
                        evented: false
                    });
                    _this.design_box = square;
                    _this.backCanvas.add(square);
                    _this.backCanvas.renderAll();
                    return;
                }
            }

            // Existing flow
            let hasValidImage =
                _this.background_image &&
                _this.background_image !== "" &&
                _this.background_image !== "null" &&
                _this.background_image !== null &&
                typeof _this.background_image === "string" &&
                _this.background_image.trim() !== "" &&
                !_this.background_image.includes("null");

            if (!hasValidImage) {
                _this.design_box = "";
                return;
            }

            _this.backCanvas.getObjects().forEach(function (obj) {
                if (
                    obj.type === "rect" &&
                    obj.selectable === false &&
                    obj.evented === false
                ) {
                    _this.backCanvas.remove(obj);
                }
            });

            let square = new fabric.Rect({
                width: _this.front_canvas_width,
                height: _this.front_canvas_height,
                left: _this.front_canvas_left,
                top: _this.front_canvas_top,
                angle: _this.front_canvas_angle,
                fill: "transparent",
                absolutePositioned: true,
                stroke: "black",
                strokeDashArray: [5, 5],
                strokeWidth: 2,
                selectable: false,
                evented: false
            });
            _this.design_box = square;
            _this.backCanvas.add(square);
            _this.backCanvas.renderAll();
        },
        showDesignSleeve() {
            let _this = this;
            let rectangle = new fabric.Rect({
                width: parseFloat(_this.popup_canvas_width),
                height: parseFloat(_this.popup_canvas_height),
                top: parseFloat(_this.popup_canvas_top),
                left: parseFloat(_this.popup_canvas_left),
                fill: "",
                stroke: "black",
                strokeDashArray: [5, 5],
                strokeWidth: 1,
                selectable: false
            });
            _this.backSleeveCanvas.clear();
            _this.backSleeveCanvas.renderAll();
            fabric.Image.fromURL(_this.background_image_sleeve, (imgObj) => {
                // Calculate scale to maintain aspect ratio (contain approach)
                const scaleX = _this.defaultWidthCanvas / imgObj.width;
                const scaleY = _this.defaultHeightCanvas / imgObj.height;
                const scale = Math.min(scaleX, scaleY);

                // Calculate scaled dimensions and center position
                const scaledWidth = imgObj.width * scale;
                const scaledHeight = imgObj.height * scale;
                const left = (_this.defaultWidthCanvas - scaledWidth) / 2;
                const top = (_this.defaultHeightCanvas - scaledHeight) / 2;

                _this.backSleeveCanvas.setBackgroundImage(
                    imgObj,
                    _this.backSleeveCanvas.renderAll.bind(
                        _this.backSleeveCanvas
                    ),
                    {
                        backgroundColor:
                            _this.user_selected_values[_this.active_gender_key]
                                .color_hash,
                        scaleX: scale,
                        scaleY: scale,
                        left: left,
                        top: top
                    }
                );
                _this.imgHeight = imgObj.height;
                _this.imgWidth = imgObj.width;
            });
            _this.backSleeveCanvas.add(rectangle);
            _this.backSleeveCanvas.renderAll();
            /* eslint-disable */
            $(`#show_sleeve`).modal("show");
            /* eslint-enable */
            this.$forceUpdate();
        },

        //Sets colors_validation only for the active location (current flip) so user can navigate to other locations.
        updateColorsValidationExceed() {
            if (
                !this.colors_count ||
                !this.gender_groups_items ||
                !this.gender_groups_items[this.active_gender_key]
            ) {
                this.colors_validation = "";
                return;
            }
            const gender = this.gender_groups_items[this.active_gender_key];
            const activeServiceData = gender.activeServiceData;
            if (activeServiceData && activeServiceData.is_full_color === true) {
                this.colors_validation = "";
                return;
            }
            const imprintLocations = gender.imprint_locations || [];
            const colors = gender.colors || [];
            const activeIdx =
                this.activeColorIndex >= 0 ? this.activeColorIndex : 0;
            const colorToCheck = colors[activeIdx] || colors[0];
            const colorImprintLocs =
                colorToCheck && colorToCheck.imprint_locations
                    ? colorToCheck.imprint_locations
                    : [];
            const locationToKey = (loc) => {
                if (!loc || !loc.location) return null;
                const l = String(loc.location).toLowerCase().trim();
                if (l.indexOf("left") !== -1) return "left";
                if (l.indexOf("right") !== -1) return "right";
                if (l.indexOf("front") !== -1) return "front";
                if (l.indexOf("back") !== -1) return "back";
                return l;
            };
            const activeKey = (this.active_flip || "").toLowerCase().trim();
            for (let i = 0; i < imprintLocations.length; i++) {
                const loc = imprintLocations[i];
                if (!loc.is_selected) continue;
                if (locationToKey(loc) !== activeKey) continue;
                const totalColors =
                    colorImprintLocs[i] && colorImprintLocs[i].colors
                        ? colorImprintLocs[i].colors.length
                        : 0;
                if (totalColors > this.colors_count) {
                    this.colors_validation =
                        "A maximum of " +
                        this.colors_count +
                        " colors can be used on each side location for this decoration.";
                    return;
                }
                break;
            }
            this.colors_validation = "";
        },

        validateData(genders) {
            let minimum_quantity;

            let total_qty = 0;
            let quantity_error = false;
            let color_names = [];
            // Validation minimum quantity
            genders.forEach((gender) => {
                if (gender.colors) {
                    gender.colors.forEach((color) => {
                        if (!color.total_qty_gender_wise) {
                            color_names.push(color.color_name);
                            quantity_error = true;
                        }
                    });
                }

                total_qty = total_qty + gender.total_qty_gender_wise;
            });

            let decoration_type = genders[0]["item"].decoration_type;
            let price_decoration_bulk =
                genders[0]["item"].price_decoration_bulk;

            if (decoration_type == 1 || decoration_type == 5) {
                minimum_quantity =
                    price_decoration_bulk["print_location1"][0].quantity;
            } else if (decoration_type == 2 || decoration_type == 4) {
                minimum_quantity = price_decoration_bulk[0].quantity1;
            }

            if (quantity_error) {
                this.$toast.error(
                    `${color_names.join(
                        ","
                    )} atleast one single quantity is required`,
                    { position: "top-right", queue: true }
                );
                return false;
            }

            if (total_qty == 0) {
                this.$toast.error(
                    "Please select color and quantity to design",
                    { position: "top-right", queue: true }
                );
                return false;
            } else if (parseInt(total_qty) < parseInt(minimum_quantity)) {
                this.$toast.error(
                    "Quantity should be greater than or equal to " +
                        minimum_quantity,
                    { position: "top-right", queue: true }
                );
                return false;
            }

            // Validating name & numbers
            let empty_name_numbers_color_names = [];
            let name_and_number_enabled = false;
            const imprintLocations =
                this.gender_groups_items[this.active_gender_key]
                    .imprint_locations;
            this.gender_groups_items[this.active_gender_key].colors.forEach(
                (color) => {
                    imprintLocations.forEach((location) => {
                        let locKey = location.location.toLowerCase().trim();
                        let viewKey = locKey;
                        if (viewKey === "left sleeve") viewKey = "left";
                        if (viewKey === "right sleeve") viewKey = "right";
                        let is_name_and_number_enabled =
                            color.selected_name_number[locKey] ||
                            color.selected_name_number[viewKey];
                        if (
                            is_name_and_number_enabled &&
                            is_name_and_number_enabled["name"]
                        ) {
                            let notEmpty = false;
                            if (Array.isArray(color.name_and_number_json)) {
                                notEmpty = color.name_and_number_json.find(
                                    (nn) => nn.name != ""
                                );
                            } else if (
                                color.name_and_number_json &&
                                typeof color.name_and_number_json === "object"
                            ) {
                                let arr = color.name_and_number_json[viewKey];
                                if (arr && arr.length)
                                    notEmpty = arr.find((nn) => nn.name != "");
                            }
                            if (!notEmpty) {
                                empty_name_numbers_color_names.push(
                                    color.color_name
                                );
                            }
                            name_and_number_enabled = true;
                        }

                        if (
                            is_name_and_number_enabled &&
                            is_name_and_number_enabled["number"]
                        ) {
                            let notEmpty = false;
                            if (Array.isArray(color.name_and_number_json)) {
                                notEmpty = color.name_and_number_json.find(
                                    (nn) => nn.number != ""
                                );
                            } else if (
                                color.name_and_number_json &&
                                typeof color.name_and_number_json === "object"
                            ) {
                                let arr = color.name_and_number_json[viewKey];
                                if (arr && arr.length)
                                    notEmpty = arr.find(
                                        (nn) => nn.number != ""
                                    );
                            }
                            if (!notEmpty) {
                                empty_name_numbers_color_names.push(
                                    color.color_name
                                );
                            }
                            name_and_number_enabled = true;
                        }
                    });
                }
            );

            empty_name_numbers_color_names = [
                ...new Set(empty_name_numbers_color_names)
            ];
            if (empty_name_numbers_color_names.length > 0) {
                this.$toast.error(
                    `Atleast one name or number is required for selected name & numbers.`,
                    { position: "top-right", queue: true }
                );
                return false;
            }

            if (!name_and_number_enabled) {
                // Validating ink/thread colors
                let is_locations_selected = false;
                let is_area_colors_empty = false;
                let is_colors_empty = false;
                for (let gender of genders) {
                    if (gender.colors) {
                        gender.colors.forEach((color) => {
                            for (let location of color.imprint_locations) {
                                if (location.is_selected) {
                                    is_locations_selected = true;
                                    if (location.colors.length == 0) {
                                        is_area_colors_empty = true;
                                        return;
                                    } else {
                                        let is_selected = location.colors.find(
                                            (color) => color.color == null
                                        );
                                        if (is_selected) {
                                            is_colors_empty = true;
                                            return;
                                        }
                                    }
                                }
                            }
                        });
                    }
                }

                let errorText = "";
                if (decoration_type == 1 || decoration_type == 5) {
                    errorText = "imprint";
                } else if (decoration_type == 2 || decoration_type == 4) {
                    errorText = "embroidery";
                }

                if (!is_locations_selected) {
                    this.$toast.error(`Please select ${errorText} locations.`, {
                        position: "top-right",
                        queue: true
                    });
                    return false;
                } else if (is_colors_empty) {
                    this.$toast.error(
                        `Please select all imprint colors for selected ${errorText} locations.`,
                        { position: "top-right", queue: true }
                    );
                    return false;
                } else if (is_area_colors_empty) {
                    this.$toast.error(
                        `Please select colors for selected ${errorText} locations.`,
                        { position: "top-right", queue: true }
                    );
                    return false;
                }
            }

            // Color exceed: design + name/number must not exceed service limit per location (right panel validation)
            const colors_count = this.colors_count || 0;
            if (colors_count > 0) {
                const isFullColorService =
                    genders[0].activeServiceData &&
                    genders[0].activeServiceData.is_full_color === true;
                if (!isFullColorService) {
                    for (const gender of genders) {
                        const imprintLocations = gender.imprint_locations || [];
                        const firstColor =
                            (gender.colors && gender.colors[0]) || null;
                        const colorImprintLocs =
                            firstColor && firstColor.imprint_locations
                                ? firstColor.imprint_locations
                                : [];
                        for (let i = 0; i < imprintLocations.length; i++) {
                            const loc = imprintLocations[i];
                            if (!loc.is_selected) continue;
                            const totalColors =
                                colorImprintLocs[i] &&
                                colorImprintLocs[i].colors
                                    ? colorImprintLocs[i].colors.length
                                    : 0;
                            if (totalColors > colors_count) {
                                const msg =
                                    "A maximum of " +
                                    colors_count +
                                    " colors can be used on each side location for this decoration.";
                                this.colors_validation = msg;
                                this.$nextTick(() => {
                                    this.colors_validation = msg;
                                });
                                return false;
                            }
                        }
                    }
                }
            }

            return true;
        },

        // Get current cart items
        getCartItems() {
            new Promise((resolve, reject) => {
                ApiService.get("/cart")
                    .then(({ data }) => {
                        this.cart_items = data.cart_items;
                        this.updateCartQuantity();
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },

        // Its prepares current items quantity
        updateCartQuantity() {
            let selectedColorsIds = this.gender_groups_items[
                this.active_gender_key
            ].colors.map((color) => color.id);

            this.cart_quantity = 0;
            this.cart_items.forEach((cartItem) => {
                if (
                    cartItem.item_id == this.product_items.id &&
                    !cartItem.build_id
                ) {
                    const sameColor = selectedColorsIds.includes(
                        cartItem.color_id
                    );
                    const sameDecorationMethod =
                        cartItem.decoration_type ==
                        this.product_items.decoration_type;
                    const sameDecorationPriceTemplate =
                        cartItem.decoration_price_template ==
                        this.product_items.decoration_price_template;
                    if (
                        !sameColor &&
                        sameDecorationMethod &&
                        sameDecorationPriceTemplate
                    ) {
                        this.cart_quantity += parseInt(cartItem.total_quantity);
                    }
                }
            });
        },

        async addToCart() {
            let _this = this;
            if (!this.isAuthenticatedClient) {
                /* eslint-disable */
                $("#login").modal("show");
                return;
                /* eslint-enable */
            }
            let designStatus = this.checkObjectCanvas();
            if (!designStatus && _this.colors_validation == "") {
                _this.$toast.clear();
                _this.$toast.error(
                    "Please add some design ( Text, Clipart or ArtWork ) to this product",
                    {
                        duration: 2000,
                        position: "top-right",
                        queue: false
                    }
                );
                return;
            }
            // Sync name/number from panel to colors first so add-to-cart gets correct counts
            if (
                this.$refs.nameAndNumberRef &&
                typeof this.$refs.nameAndNumberRef.saveAllViewsToColor ===
                    "function"
            ) {
                this.$refs.nameAndNumberRef.saveAllViewsToColor();
            }
            //   let design_items = JSON.parse(localStorage.getItem("design"));
            let design_items = JSON.parse(
                JSON.stringify(this.gender_groups_items)
            );
            if (design_items.length == 0) {
                return;
            }

            if (!this.validateData(design_items)) {
                return;
            }

            if (design_items[0]["item"]["price_decoration_bulk"]) {
                let decoration_pricing = "";
                if (
                    typeof design_items[0]["item"]["price_decoration_bulk"] ===
                    "string"
                ) {
                    decoration_pricing = JSON.parse(
                        design_items[0]["item"]["price_decoration_bulk"]
                    );
                } else {
                    decoration_pricing =
                        design_items[0]["item"]["price_decoration_bulk"];
                }
                let total_cart_quantity = parseInt(design_items[0].total_qty);
                if (decoration_pricing) {
                    if (
                        design_items[0]["item"].decoration_type == 1 ||
                        design_items[0]["item"].decoration_type == 5
                    ) {
                        let minimum_quantity =
                            decoration_pricing["print_location1"][0][
                                "quantity"
                            ];
                        if (minimum_quantity > total_cart_quantity) {
                            this.$toast.error(
                                "Quantity should be greater than " +
                                    minimum_quantity,
                                {
                                    position: "top-right",
                                    queue: true
                                }
                            );
                            return;
                        }
                    } else if (design_items[0]["item"].decoration_type == 2 || design_items[0]["item"].decoration_type == 4) {
                        let minimum_quantity =
                            decoration_pricing[0]["quantity1"];
                        if (minimum_quantity > total_cart_quantity) {
                            this.$toast.error(
                                "Quantity should be greater than " +
                                    minimum_quantity,
                                {
                                    position: "top-right",
                                    queue: true
                                }
                            );
                            return;
                        }
                    } else if (design_items[0]["item"].decoration_type == 3) {
                        let minimum_quantity =
                            decoration_pricing[0]["quantity"];
                        if (minimum_quantity > total_cart_quantity) {
                            this.$toast.error(
                                "Quantity should be greater than " +
                                    minimum_quantity,
                                {
                                    position: "top-right",
                                    queue: true
                                }
                            );
                            return;
                        }
                    }
                }
            }

            let allColorAndSizesname = "";
            let allColorAndSizesnumber = "";
            let nameAndNumbers = [];

            if (this.$refs.nameAndNumberRef.addInputName) {
                nameAndNumbers =
                    this.$refs.nameAndNumberRef.addInputName.filter(
                        (nn) => nn.name != "" || nn.number
                    );
            }
            if (nameAndNumbers.length > 0) {
                allColorAndSizesname =
                    this.$refs.nameAndNumberRef.colorSizesForName;
                allColorAndSizesnumber =
                    this.$refs.nameAndNumberRef.colorSizesForNumber;
            }

            designStatus = this.checkObjectCanvas();
            let new_canvas_elements = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );
            if (!designStatus) {
                this.$toast.error("Please add design on the Product !", {
                    position: "top-right"
                });
                this.isLoader = false;
                return false;
            }
            let parsedJson = new_canvas_elements ? new_canvas_elements : null;
            _this.active_flip = localStorage.getItem("active_flip");
            parsedJson[_this.active_flip] = JSON.stringify(_this.backCanvas);
            if (parsedJson && this.build_id) {
                this.saved_design.build_id = this.build_id;
            }
            if (parsedJson && this.build_item_id) {
                this.saved_design.build_item_id = this.build_item_id;
            }
            let flips = [];
            let get_canvas_colors = JSON.parse(
                localStorage.getItem("canvas_design_colors")
            );
            get_canvas_colors[_this.active_flip] = _this.design_current_colors;
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify(get_canvas_colors)
            );
            if (!this.front_show) {
                delete parsedJson.front;
                delete get_canvas_colors.front;
            } else {
                flips.push("front");
            }
            if (!this.back_show) {
                delete parsedJson.back;
                delete get_canvas_colors.back;
            } else {
                flips.push("back");
            }
            if (!this.left_show) {
                delete parsedJson.left;
                delete get_canvas_colors.left;
            } else {
                flips.push("left");
            }
            if (!this.right_show) {
                delete parsedJson.right;
                delete get_canvas_colors.right;
            } else {
                flips.push("right");
            }
            this.saved_design.canvas_json = JSON.stringify(parsedJson);
            localStorage.setItem(
                "new_canvas_elements",
                JSON.stringify(parsedJson)
            );
            new_canvas_elements = parsedJson;
            let get_product = JSON.parse(JSON.stringify(this.product_items));
            if (typeof JSON.parse(get_product.design_areas) == "string") {
                get_product = JSON.parse(get_product.design_areas);
            }
            let image_response = [];

            this.cart_save_design = false;
            // if only save design
            if (this.only_save_designs) {
                this.save_design_images = image_response;
                return;
            }
            this.isLoader = true;
            let allitems = [];

            // Generate a short unique id (used as fallback when design_id is absent)
            const generateBatchId = () =>
                Date.now().toString(36) +
                Math.random().toString(36).substr(2, 6);

            // Map: serviceId -> batchId  (so all colors of the same service share one id per addToCart call)
            const batchIdByService = {};

            const buildAssemblyKey = (
                savedDesignId,
                serviceId,
                decoratorId,
                vendorId
            ) => {
                // serviceId is the only hard requirement (without a service there is no decoration)
                const svcId =
                    serviceId !== undefined &&
                    serviceId !== null &&
                    serviceId !== ""
                        ? String(serviceId)
                        : null;
                if (!svcId) return null;

                // decorator / vendor: use "0" when absent so the key is still formed
                const decId =
                    decoratorId !== undefined &&
                    decoratorId !== null &&
                    decoratorId !== ""
                        ? String(decoratorId)
                        : "0";
                const venId =
                    vendorId !== undefined &&
                    vendorId !== null &&
                    vendorId !== ""
                        ? String(vendorId)
                        : "0";

                // If we have a real saved design ID, embed it in the key so it
                // stays consistent across multiple addToCart calls for the same design.
                const designPart =
                    savedDesignId !== undefined &&
                    savedDesignId !== null &&
                    savedDesignId !== "" &&
                    savedDesignId !== "null" &&
                    savedDesignId !== "undefined"
                        ? String(savedDesignId)
                        : null;

                if (designPart) {
                    return [designPart, svcId, decId, venId].join("|");
                }

                // No saved design ID → use a per-service batch UUID so all colors
                // added in this single addToCart call are still grouped together.
                if (!batchIdByService[svcId]) {
                    batchIdByService[svcId] = generateBatchId();
                }
                return [
                    "batch",
                    batchIdByService[svcId],
                    svcId,
                    decId,
                    venId
                ].join("|");
            };
            const getVendorIdFromProduct = (product) => {
                if (!product || typeof product !== "object") return null;
                return (
                    product.vendor_id ||
                    product.default_vendor_id ||
                    (product.Vendor && product.Vendor.id) ||
                    (product.vendor && product.vendor.id) ||
                    // Fallback in models where default decorator acts as vendor mapping.
                    product.default_decorator_id ||
                    null
                );
            };
            const getServiceIdFromCartDecoration = (cartItem) => {
                if (!cartItem) return null;
                let decoration = cartItem.decoration;
                if (typeof decoration === "string") {
                    try {
                        decoration = JSON.parse(decoration);
                    } catch (e) {
                        decoration = null;
                    }
                }
                if (decoration && decoration.id != null && decoration.id !== "") {
                    return String(decoration.id);
                }
                if (
                    decoration &&
                    decoration.master_service &&
                    decoration.master_service.id != null
                ) {
                    return String(decoration.master_service.id);
                }
                if (cartItem.decoration_type != null) {
                    return `type_${cartItem.decoration_type}`;
                }
                return null;
            };
            const existingAssemblyKeys = new Set();
            const existingParentCartIdsByDesignAssemblyColor = {};
            let assemblyParentSetupByKey = {};
            let assemblyParentSetupByLooseKey = {};
            let assemblySetupUpgradeAfterAdd = null;
            // Always load cart for assembly-parent setup totals — do not gate on
            // current_design_id or assemblyParentSetupByKey stays empty and
            // /update-assembly-parent-setup never runs.
            let cartItemsForAssembly = [];
            try {
                const { data } = await ApiService.get("/cart-new");
                cartItemsForAssembly =
                    data && Array.isArray(data.cart_items)
                        ? data.cart_items
                        : [];
            } catch (e) {
                cartItemsForAssembly = [];
            }
            // eslint-disable-next-line no-console

            cartItemsForAssembly.forEach((cartItem) => {
                if (
                    !cartItem.group_assembly_id ||
                    cartItem.group_assembly_id === "null" ||
                    cartItem.group_assembly_id === "undefined"
                ) {
                    return;
                }
                const hasAssemblyParentFlag =
                    cartItem.assembly_parent !== undefined &&
                    cartItem.assembly_parent !== null;
                const isAssemblyParent =
                    !hasAssemblyParentFlag ||
                    parseInt(cartItem.assembly_parent, 10) === 1;
                // Always seed assembly keys from cart parents so the next add is a
                // child even when current_design_id is missing (was breaking isAssemblyParentLine).
                if (isAssemblyParent) {
                    existingAssemblyKeys.add(cartItem.group_assembly_id);
                }
                if (!isAssemblyParent) {
                    return;
                }
                let effectiveSetup = parseFloat(cartItem.setup_fee || 0);
                if (cartItem.setup_fees_details) {
                    try {
                        const parsed =
                            typeof cartItem.setup_fees_details === "string"
                                ? JSON.parse(cartItem.setup_fees_details)
                                : cartItem.setup_fees_details;
                        if (parsed && parsed.total != null) {
                            effectiveSetup = Math.max(
                                effectiveSetup,
                                parseFloat(parsed.total || 0)
                            );
                        }
                    } catch (e) {
                        /* ignore */
                    }
                }
                const gid = String(cartItem.group_assembly_id);
                assemblyParentSetupByKey[gid] = {
                    cartId: cartItem.id,
                    setupFee: effectiveSetup,
                };
                const sdRaw = cartItem.saved_design_id;
                const sdNorm =
                    sdRaw !== undefined &&
                    sdRaw !== null &&
                    sdRaw !== "" &&
                    String(sdRaw) !== "null" &&
                    String(sdRaw) !== "undefined"
                        ? String(sdRaw)
                        : null;
                const svcFromCart = getServiceIdFromCartDecoration(cartItem);
                if (sdNorm && svcFromCart) {
                    const loose = `${sdNorm}|${svcFromCart}`;
                    const prev = assemblyParentSetupByLooseKey[loose];
                    const cid = parseInt(cartItem.id, 10) || 0;
                    if (!prev || cid < prev._sortId) {
                        assemblyParentSetupByLooseKey[loose] = {
                            cartId: cartItem.id,
                            setupFee: effectiveSetup,
                            _sortId: cid,
                        };
                    }
                }
            });
            if (this.current_design_id) {
                try {
                    const cartItems =
                        cartItemsForAssembly.length > 0
                            ? cartItemsForAssembly
                            : [];
                    cartItems.forEach((cartItem) => {
                        const hasAssemblyParentFlag =
                            cartItem.assembly_parent !== undefined &&
                            cartItem.assembly_parent !== null;
                        const isAssemblyParent =
                            !hasAssemblyParentFlag ||
                            parseInt(cartItem.assembly_parent, 10) === 1;

                        // Use stored group_assembly_id only for parent lines.
                        if (
                            cartItem.group_assembly_id &&
                            cartItem.group_assembly_id !== "null" &&
                            cartItem.group_assembly_id !== "undefined"
                        ) {
                            const existingSavedDesignId =
                                cartItem.saved_design_id !== undefined &&
                                cartItem.saved_design_id !== null &&
                                cartItem.saved_design_id !== "" &&
                                cartItem.saved_design_id !== "null" &&
                                cartItem.saved_design_id !== "undefined"
                                    ? String(cartItem.saved_design_id)
                                    : null;
                            const existingGroupAssemblyId = String(
                                cartItem.group_assembly_id
                            );
                            const existingColorId =
                                cartItem.color_id !== undefined &&
                                cartItem.color_id !== null
                                    ? String(cartItem.color_id)
                                    : null;
                            const existingItemId =
                                cartItem.item_id !== undefined &&
                                cartItem.item_id !== null
                                    ? String(cartItem.item_id)
                                    : null;
                            if (
                                isAssemblyParent &&
                                existingSavedDesignId &&
                                existingGroupAssemblyId &&
                                existingColorId &&
                                existingItemId &&
                                cartItem.id
                            ) {
                                const replaceKey = [
                                    existingSavedDesignId,
                                    existingGroupAssemblyId,
                                    existingColorId,
                                    existingItemId
                                ].join("|");
                                if (
                                    !existingParentCartIdsByDesignAssemblyColor[
                                        replaceKey
                                    ]
                                ) {
                                    existingParentCartIdsByDesignAssemblyColor[
                                        replaceKey
                                    ] = cartItem.id;
                                }
                            }
                            if (isAssemblyParent) {
                                existingAssemblyKeys.add(
                                    cartItem.group_assembly_id
                                );
                            }
                            return;
                        }

                        // If this cart line is marked as child, it should never block
                        // the current add-to-cart payload from becoming parent.
                        if (!isAssemblyParent) {
                            return;
                        }
                        const savedDesignId = cartItem.saved_design_id;
                        const decoratorId =
                            cartItem.main_new_product &&
                            cartItem.main_new_product.default_decorator_id
                                ? cartItem.main_new_product.default_decorator_id
                                : null;
                        const vendorId = cartItem.main_new_product
                            ? getVendorIdFromProduct(cartItem.main_new_product)
                            : null;
                        let serviceId = null;
                        let decoration = cartItem.decoration;
                        if (typeof decoration === "string") {
                            try {
                                decoration = JSON.parse(decoration);
                            } catch (e) {
                                decoration = null;
                            }
                        }
                        if (decoration) {
                            // Priority 1: decoration.id is the direct service ID
                            if (decoration.id) {
                                serviceId = decoration.id;
                            } else if (
                                decoration.master_service &&
                                decoration.master_service.id
                            ) {
                                // Priority 2: legacy master_service.id
                                serviceId = decoration.master_service.id;
                            }
                        }
                        // Fallback for decoration_type 1/2/3 where decoration JSON is absent
                        if (!serviceId && cartItem.decoration_type != null) {
                            serviceId = `type_${cartItem.decoration_type}`;
                        }
                        const assemblyKey = buildAssemblyKey(
                            savedDesignId,
                            serviceId,
                            decoratorId,
                            vendorId
                        );
                        if (assemblyKey) {
                            existingAssemblyKeys.add(assemblyKey);
                        }
                    });
                } catch (e) {
                    // If cart processing fails, continue with current request payload logic.
                }
            }
            const assemblyParentBySavedDesignId = {};
            existingAssemblyKeys.forEach((id) => {
                assemblyParentBySavedDesignId[id] = true;
            });
            // eslint-disable-next-line no-console
            const parentCartIdsToRemove = new Set();
            /* eslint-disable */
            let user_product_id = "";
            for (const [genderIndex, design_item] of Object.entries(
                design_items
            )) {
                let total_quantity = 0;
                let total_price = 0;
                user_product_id = "Mydesign_cart" + "_" + Date.now();
                this.save_design_images = image_response;

                // Prepare setup_fees_details once for all colors (same for all)
                let setupFeesDetailsForAllColors = null;
                const activeServiceData =
                    _this.gender_groups_items[_this.active_gender_key]
                        .activeServiceData;
                const masterService =
                    activeServiceData && activeServiceData.master_service
                        ? activeServiceData.master_service
                        : null;
                const decorationType =
                    design_item && design_item.item
                        ? parseInt(design_item.item.decoration_type) || 0
                        : 0;
                const useProductSetupSource =
                    decorationType === 1 ||
                    decorationType === 2 ||
                    decorationType === 4 ||
                    decorationType === 5;
                const productSetupPricing =
                    activeServiceData && activeServiceData.product_master_service
                        ? activeServiceData.product_master_service
                        : null;
                const setupFeeColor1 = parseFloat(
                    useProductSetupSource
                        ? (productSetupPricing &&
                              productSetupPricing.setup_fee_color1 !== undefined
                              ? productSetupPricing.setup_fee_color1
                              : 0)
                        : masterService &&
                          masterService.setup_fee_color1 !== undefined
                        ? masterService.setup_fee_color1
                        : 0
                );
                const setupFeeMulticolor = parseFloat(
                    useProductSetupSource
                        ? (productSetupPricing &&
                              productSetupPricing.setup_fee_multicolor !==
                                  undefined
                              ? productSetupPricing.setup_fee_multicolor
                              : 0)
                        : masterService &&
                          masterService.setup_fee_multicolor !== undefined
                        ? masterService.setup_fee_multicolor
                        : 0
                );

                if (
                    design_item.imprint_locations &&
                    design_item.imprint_locations.length > 0 &&
                    masterService
                ) {
                    const imprintLocationsForSetup = JSON.parse(
                        JSON.stringify(design_item.imprint_locations)
                    );

                    const suppressAdditionalSetupRunChargeForSetup =
                        Number(
                            (activeServiceData &&
                                activeServiceData.product_master_service &&
                                activeServiceData.product_master_service
                                    .suppress_additional_setup_run_charge) ||
                                (activeServiceData &&
                                    activeServiceData.master_service &&
                                    activeServiceData.master_service
                                        .suppress_additional_setup_run_charge) ||
                                0
                        ) === 1;
                    let canvasStoreForSetup = {};
                    try {
                        canvasStoreForSetup = JSON.parse(
                            localStorage.getItem("new_canvas_elements") ||
                                "{}"
                        );
                    } catch (e) {
                        canvasStoreForSetup = {};
                    }
                    prepareImprintLocationsForSuppressCart(
                        imprintLocationsForSetup,
                        suppressAdditionalSetupRunChargeForSetup,
                        canvasStoreForSetup
                    );

                    // Helper function to check if name/number is enabled for a location
                    const hasNameNumberForLocation = (location) => {
                        if (
                            !design_item.colors ||
                            !Array.isArray(design_item.colors)
                        ) {
                            return false;
                        }
                        const locationKey = location.location
                            .toLowerCase()
                            .trim();
                        return design_item.colors.some((color) => {
                            const selectedNameNumber =
                                color.selected_name_number || {};
                            const locationNameNumber =
                                selectedNameNumber[locationKey] || {};
                            return (
                                locationNameNumber.name === true ||
                                locationNameNumber.number === true
                            );
                        });
                    };

                    const locationSetupFees = imprintLocationsForSetup
                        .filter((loc) => {
                            if (!loc.is_selected) return false;

                            // Check if name/number is enabled for this location
                            const hasNameNumber = hasNameNumberForLocation(loc);

                            // Check if full color is selected
                            const isFullColor =
                                loc.is_full_color === true ||
                                loc.no_of_color === "full_color" ||
                                loc.no_of_color === "Full color";

                            if (isFullColor) {
                                // For full color, check actual color count from colors array
                                if (loc.colors && Array.isArray(loc.colors)) {
                                    const actualColorCount = loc.colors.filter(
                                        (colorObj) => {
                                            return (
                                                colorObj &&
                                                colorObj.color &&
                                                (colorObj.color.color_id !==
                                                    undefined ||
                                                    colorObj.color
                                                        .color_value ||
                                                    colorObj.color.hex)
                                            );
                                        }
                                    ).length;
                                    // Include if has colors OR has name/number
                                    return (
                                        actualColorCount > 0 || hasNameNumber
                                    );
                                }
                                // If colors array not available, check full_color_count or name/number
                                return (
                                    (loc.full_color_count &&
                                        loc.full_color_count > 0) ||
                                    hasNameNumber
                                );
                            }

                            // For normal colors, check no_of_color OR name/number
                            const colorCount = parseInt(loc.no_of_color) || 0;
                            return colorCount > 0 || hasNameNumber;
                        })
                        .map((loc, index) => {
                            // Check if name/number is enabled for this location
                            const hasNameNumber = hasNameNumberForLocation(loc);

                            // Check if full color is selected
                            const isFullColor =
                                loc.is_full_color === true ||
                                loc.no_of_color === "full_color" ||
                                loc.no_of_color === "Full color";

                            let colorCount = 0;

                            if (isFullColor) {
                                // For full color, get actual color count from colors array
                                if (loc.colors && Array.isArray(loc.colors)) {
                                    colorCount = loc.colors.filter(
                                        (colorObj) => {
                                            return (
                                                colorObj &&
                                                colorObj.color &&
                                                (colorObj.color.color_id !==
                                                    undefined ||
                                                    colorObj.color
                                                        .color_value ||
                                                    colorObj.color.hex)
                                            );
                                        }
                                    ).length;
                                } else if (loc.full_color_count) {
                                    // Fallback to full_color_count if available
                                    colorCount =
                                        parseInt(loc.full_color_count) || 0;
                                }

                                // If still 0 but has name/number, for full color service use multicolor fee
                                // Set colorCount to 2 to trigger multicolor fee for fee_structure 2
                                if (colorCount === 0 && hasNameNumber) {
                                    colorCount = 2; // Will trigger multicolor fee for fee_structure 2
                                } else if (colorCount === 0) {
                                    colorCount = 1;
                                }
                            } else {
                                // For normal colors, use no_of_color
                                colorCount = parseInt(loc.no_of_color) || 0;

                                // If no colors but has name/number, use minimum 1 color
                                if (colorCount === 0 && hasNameNumber) {
                                    colorCount = 1;
                                }
                            }

                            // Price per color based on fee_structure
                            let pricePerColor = 0;
                            let quantity = 1; // Default quantity is 1

                            if (masterService.fee_structure == "1") {
                                // Per Color: same price for all colors, quantity = color count
                                pricePerColor = setupFeeColor1;
                                quantity = colorCount;
                            } else if (masterService.fee_structure == "2") {
                                // Tiered: 1 color = setup_fee_color1, 2+ colors = setup_fee_multicolor
                                // Quantity is always 1 for tiered structure
                                quantity = 1;

                                // For full color service with only name/number (no design colors), use multicolor fee
                                if (
                                    isFullColor &&
                                    colorCount === 2 &&
                                    hasNameNumber
                                ) {
                                    pricePerColor = setupFeeMulticolor;
                                } else {
                                    pricePerColor =
                                        colorCount === 1
                                            ? setupFeeColor1
                                            : setupFeeMulticolor;
                                }
                            }

                            if (
                                suppressAdditionalSetupRunChargeForSetup &&
                                loc.is_group_primary === false
                            ) {
                                return {
                                    name:
                                        "Setup Fee Location " +
                                        (index + 1) +
                                        " (" +
                                        loc.location +
                                        ")",
                                    quantity: 0,
                                    per_price: 0,
                                    total: 0,
                                    is_suppressed_by_group: true
                                };
                            }

                            return {
                                name:
                                    "Setup Fee Location " +
                                    (index + 1) +
                                    " (" +
                                    loc.location +
                                    ")",
                                quantity: quantity,
                                per_price: pricePerColor,
                                total: quantity * pricePerColor
                            };
                        });

                    // Calculate total of all locations
                    const totalSetupFee = locationSetupFees.reduce(
                        (sum, loc) => sum + parseFloat(loc.total || 0),
                        0
                    );

                    setupFeesDetailsForAllColors = {
                        fee_structure: masterService.fee_structure || "1",
                        setup_fee_color1: setupFeeColor1,
                        setup_fee_multicolor: setupFeeMulticolor,
                        locations: locationSetupFees,
                        total: totalSetupFee
                    };
                }

                // Prepare rush_fee_breakdown once for all colors (same for all)
                // Note: Rush fee breakdown will be calculated per color with correct quantity
                // We'll create a function to calculate it for each color
                const calculateRushFeeBreakdown = (colorQuantity) => {
                    if (
                        !_this.selectedRushOptionId ||
                        _this.selectedRushOptionId === ""
                    ) {
                        return null;
                    }

                    const rushFeeServices = [];
                    let rushFeeTotal = 0;

                    // Get selected rush option price from vendorServices
                    let selectedRushOptionPrice = 0;
                    let selectedRushOptionLabel = null;
                    const rushOptionLabels = {
                        rush1: "Rush 1 Day",
                        rush3: "Rush 3 Day",
                        rush5: "Rush 5 Day",
                        rush7: "Rush 7 Day",
                        rush_package: "Rush Package"
                    };
                    selectedRushOptionLabel =
                        rushOptionLabels[_this.selectedRushOptionId] || null;

                    // Find vendor service that matches the active service ID
                    if (
                        activeServiceData &&
                        activeServiceData.master_service &&
                        activeServiceData.master_service.id &&
                        _this.vendorServices &&
                        _this.vendorServices.length > 0
                    ) {
                        const activeServiceId =
                            activeServiceData.master_service.id;
                        const vendorService = _this.vendorServices.find(
                            (vs) => vs.id === activeServiceId
                        );

                        if (vendorService) {
                            switch (_this.selectedRushOptionId) {
                                case "rush1":
                                    selectedRushOptionPrice = parseFloat(
                                        vendorService.rush1 || 0
                                    );
                                    break;
                                case "rush3":
                                    selectedRushOptionPrice = parseFloat(
                                        vendorService.rush3 || 0
                                    );
                                    break;
                                case "rush5":
                                    selectedRushOptionPrice = parseFloat(
                                        vendorService.rush5 || 0
                                    );
                                    break;
                                case "rush7":
                                    selectedRushOptionPrice = parseFloat(
                                        vendorService.rush7 || 0
                                    );
                                    break;
                                case "rush_package":
                                    selectedRushOptionPrice = parseFloat(
                                        vendorService.rush_package || 0
                                    );
                                    break;
                            }
                        }
                    }

                    // Add selected rush option to breakdown if price > 0
                    // Rush options are per order, not per item
                    if (
                        selectedRushOptionPrice > 0 &&
                        selectedRushOptionLabel
                    ) {
                        // Store delivery date separately
                        let deliveryDate = null;
                        let formattedDeliveryDate = null;
                        if (_this.selectedRushOptionDate) {
                            try {
                                const date = new Date(
                                    _this.selectedRushOptionDate
                                );
                                if (!isNaN(date.getTime())) {
                                    deliveryDate = _this.selectedRushOptionDate; // Store as ISO string
                                    const mm = String(
                                        date.getMonth() + 1
                                    ).padStart(2, "0");
                                    const dd = String(date.getDate()).padStart(
                                        2,
                                        "0"
                                    );
                                    const yyyy = date.getFullYear();
                                    formattedDeliveryDate = `${mm}/${dd}/${yyyy}`;
                                }
                            } catch (e) {
                                console.error(
                                    "Error formatting rush option date:",
                                    e
                                );
                            }
                        }

                        // Check if it's rush_package or other rush options
                        const isRushPackage =
                            _this.selectedRushOptionId === "rush_package";

                        // Set fee_structure: rush_package = "Per Order", others = "Per Item"
                        const feeStructure = isRushPackage
                            ? "Per Order"
                            : "Per Item";

                        // Set quantity: rush_package = 1, others = colorQuantity
                        const serviceQuantity = isRushPackage
                            ? 1
                            : colorQuantity;

                        // Calculate total: retail_cost * quantity
                        const serviceTotal =
                            selectedRushOptionPrice * serviceQuantity;

                        rushFeeServices.push({
                            service_id: _this.selectedRushOptionId,
                            service_name: selectedRushOptionLabel,
                            delivery_date: deliveryDate, // ISO string format
                            formatted_delivery_date: formattedDeliveryDate, // MM/DD/YYYY format
                            fee_structure: feeStructure, // rush_package = "Per Order", others = "Per Item"
                            retail_cost: selectedRushOptionPrice,
                            net_cost: 0, // Can be calculated if needed
                            quantity: serviceQuantity, // rush_package = 1, others = colorQuantity
                            total: serviceTotal, // retail_cost * quantity
                            rollup_fee_id: 6,
                            is_rush_option: true
                        });
                        rushFeeTotal += serviceTotal;
                    }

                    // Get rush fee services (rollup_fee_id = 6) from other_services_list
                    if (
                        activeServiceData &&
                        activeServiceData.other_services_list &&
                        Array.isArray(activeServiceData.other_services_list)
                    ) {
                        const rushFeeOtherServices =
                            activeServiceData.other_services_list.filter(
                                (service) => {
                                    const rollupService =
                                        service.rollup_service || {};
                                    const serviceFeeId =
                                        rollupService.rollup_fee_id !==
                                            undefined &&
                                        rollupService.rollup_fee_id !== null
                                            ? rollupService.rollup_fee_id
                                            : service.rollup_fee_id !==
                                                  undefined &&
                                              service.rollup_fee_id !== null
                                            ? service.rollup_fee_id
                                            : null;
                                    return serviceFeeId === 6;
                                }
                            );

                        // Process each rush fee service
                        rushFeeOtherServices.forEach((service) => {
                            const servicePrice = parseFloat(
                                service.retail_cost || 0
                            );

                            // Only add if service has a price
                            if (servicePrice > 0) {
                                // Check fee_structure - multiply by quantity if fee_structure = 6 (Per Item)
                                const rollupService =
                                    service.rollup_service || {};
                                const feeStructure =
                                    service.fee_structure === "Per Item" ||
                                    service.fee_structure === 6 ||
                                    rollupService.fee_structure_name ===
                                        "Per Item";

                                // Use color quantity for per-item services
                                const quantity = feeStructure
                                    ? colorQuantity
                                    : 1;

                                const serviceTotal = feeStructure
                                    ? servicePrice * quantity
                                    : servicePrice;

                                rushFeeServices.push({
                                    service_id: service.master_service
                                        ? service.master_service.id
                                        : null,
                                    service_name: service.master_service
                                        ? service.master_service.service_name
                                        : service.name || "Service",
                                    fee_structure: feeStructure
                                        ? "Per Item"
                                        : "Per Order",
                                    retail_cost: servicePrice,
                                    net_cost: parseFloat(service.net_cost || 0),
                                    quantity: quantity,
                                    total: serviceTotal,
                                    rollup_fee_id: 6,
                                    is_rush_option: false
                                });
                                rushFeeTotal += serviceTotal;
                            }
                        });
                    }

                    // Create rush fee breakdown structure
                    if (rushFeeServices.length > 0) {
                        return {
                            services: rushFeeServices,
                            total: parseFloat(rushFeeTotal.toFixed(2))
                        };
                    }
                    return null;
                };

                for (let [colorIndex, color] of Object.entries(
                    design_item["colors"]
                )) {
                    let items = [];
                    let image_response_back = [];
                    let selected_design_images = [];
                    design_items[0]["item"]["NewProductImages"].forEach(
                        (colors) => {
                            if (
                                colors.color_id == color.id &&
                                colors.type == "front"
                            ) {
                                selected_design_images.push({
                                    front: colors.url
                                });
                            }
                            if (
                                colors.color_id == color.id &&
                                colors.type == "back"
                            ) {
                                selected_design_images.push({
                                    back: colors.url
                                });
                            }
                            if (
                                colors.color_id == color.id &&
                                colors.type == "left"
                            ) {
                                selected_design_images.push({
                                    left: colors.url
                                });
                            }
                            if (
                                colors.color_id == color.id &&
                                colors.type == "right"
                            ) {
                                selected_design_images.push({
                                    right: colors.url
                                });
                            }
                        }
                    );
                    // Managed front/back image did not select from admin
                    if (selected_design_images.length == 0) {
                        design_items[0]["item"]["NewProductImages"].forEach(
                            (colors) => {
                                if (
                                    colors.color_id == color.id &&
                                    selected_design_images.length == 0
                                ) {
                                    selected_design_images.push({
                                        front: colors.url
                                    });
                                    selected_design_images.push({
                                        back: colors.url
                                    });
                                }
                            }
                        );
                    }
                    let selected_flip = flips;
                    if (image_response_back.length == 0) {
                        let front_designs = {};
                        for (let flip1 of selected_flip) {
                            // await selected_flip.forEach(async (flip1) => {
                            let objects = new_canvas_elements[flip1]
                                ? JSON.parse(new_canvas_elements[flip1]).objects
                                : [];
                            if (objects.length == 0) {
                                continue;
                            }
                            let tempCanvas = new fabric.Canvas();
                            let rectHeight = 0;
                            let rectWidth = 0;
                            let rectTop = 0;
                            let rectLeft = 0;
                            for (let canvas_obj of objects) {
                                if (
                                    "clipPath" in canvas_obj &&
                                    canvas_obj.clipPath.type == "rect"
                                ) {
                                    rectHeight = canvas_obj.clipPath.height;
                                    rectWidth = canvas_obj.clipPath.width;
                                    rectTop = canvas_obj.clipPath.top;
                                    rectLeft = canvas_obj.clipPath.left;
                                }
                            }
                            // For no-image views use current product's effective visible design area (effDims).
                            let hasCustomBoxFlip1 =
                                typeof _this.useCustomBoxForFlip ===
                                    "function" &&
                                _this.useCustomBoxForFlip(flip1);
                            let effDims = hasCustomBoxFlip1
                                ? _this.getEffectiveDesignAreaDimensionsForFlip(
                                      flip1
                                  )
                                : null;
                            if (
                                effDims &&
                                effDims.width > 0 &&
                                effDims.height > 0
                            ) {
                                tempCanvas.setWidth(effDims.width);
                                tempCanvas.setHeight(effDims.height);
                                // Add-to-cart PNG:
                                let bgColor = null;
                                if (hasCustomBoxFlip1) {
                                    bgColor =
                                        localStorage.getItem(
                                            "active_tshirt_color"
                                        ) ||
                                        (_this.user_selected_values &&
                                            _this.user_selected_values[
                                                _this.active_gender_key
                                            ] &&
                                            _this.user_selected_values[
                                                _this.active_gender_key
                                            ].color_hash) ||
                                        "#FFFFFF";
                                    if (
                                        !bgColor ||
                                        bgColor === "null" ||
                                        bgColor === "#null" ||
                                        bgColor === ""
                                    ) {
                                        bgColor = "#FFFFFF";
                                    }
                                }
                                tempCanvas.setBackgroundColor(
                                    bgColor,
                                    tempCanvas.renderAll.bind(tempCanvas)
                                );
                            } else {
                                tempCanvas.setWidth(this.defaultWidthCanvas);
                                tempCanvas.setHeight(this.defaultHeightCanvas);
                            }
                            let localCanvasJson = JSON.parse(
                                new_canvas_elements[flip1]
                            );
                            let canvas_images = [];
                            if (localCanvasJson.objects.length > 0) {
                                localCanvasJson.objects =
                                    localCanvasJson.objects.filter(function (
                                        val
                                    ) {
                                        return val.type != "rect";
                                    });
                                if (localCanvasJson.objects.length == 0)
                                    continue;

                                // Build per-location colors from all_decoration_colors for this flip/location
                                let locationColors = [];
                                try {
                                    const flipKey =
                                        flip1 && typeof flip1 === "string"
                                            ? flip1.toLowerCase()
                                            : (
                                                  _this.active_flip || ""
                                              ).toLowerCase();
                                    const hexColors =
                                        (_this.all_decoration_colors &&
                                            _this.all_decoration_colors[
                                                flipKey
                                            ]) ||
                                        (_this.all_decoration_colors &&
                                            _this.all_decoration_colors[
                                                flip1
                                            ]) ||
                                        [];
                                    if (Array.isArray(hexColors)) {
                                        locationColors = hexColors
                                            .map((colorHex) => {
                                                let vendorColor =
                                                    _this.vendor_colors_list &&
                                                    _this.vendor_colors_list.find(
                                                        (vendorColor) =>
                                                            vendorColor &&
                                                            vendorColor.color_value &&
                                                            vendorColor.color_value
                                                                .toLowerCase()
                                                                .trim() ===
                                                                String(colorHex)
                                                                    .toLowerCase()
                                                                    .trim()
                                                    );
                                                if (vendorColor) {
                                                    return {
                                                        name:
                                                            vendorColor.color_name ||
                                                            "",
                                                        hex:
                                                            vendorColor.color_value ||
                                                            ""
                                                    };
                                                }
                                                if (colorHex) {
                                                    return {
                                                        name: "",
                                                        hex: String(colorHex)
                                                    };
                                                }
                                                return null;
                                            })
                                            .filter(Boolean);
                                    }
                                } catch (e) {
                                    // ignore and leave locationColors empty
                                }

                                localCanvasJson.objects.forEach(
                                    (canvas_obj) => {
                                        if (canvas_obj.image_name) {
                                            canvas_images.push({
                                                image_name:
                                                    canvas_obj.image_name,
                                                image_path:
                                                    canvas_obj.image_path,
                                                height_inch:
                                                    canvas_obj.height_inch,
                                                width_inch:
                                                    canvas_obj.width_inch,
                                                // Per-location colors for admin imprint locations row
                                                colors: locationColors
                                            });
                                        }
                                    }
                                );
                            }
                            // Set crossOrigin on image objects so temp canvas is not tainted and toDataURL() works (add-to-cart export)
                            const jsonForLoad = JSON.parse(
                                JSON.stringify(localCanvasJson)
                            );
                            const setCrossOriginOnImages = (objects) => {
                                if (!objects || !Array.isArray(objects)) return;
                                objects.forEach((obj) => {
                                    if (
                                        obj.type === "image" ||
                                        (obj.src && obj.crossOrigin == null)
                                    ) {
                                        obj.crossOrigin = "anonymous";
                                    }
                                    if (obj.objects)
                                        setCrossOriginOnImages(obj.objects);
                                });
                            };
                            if (jsonForLoad.objects)
                                setCrossOriginOnImages(jsonForLoad.objects);
                            await _this.convertCanvasJsonImageUrlsToDataUrls(
                                jsonForLoad
                            );
                            await new Promise((resolveLoad) => {
                                tempCanvas.loadFromJSON(
                                    JSON.stringify(jsonForLoad),
                                    function () {
                                        if (
                                            effDims &&
                                            effDims.width > 0 &&
                                            effDims.height > 0
                                        ) {
                                            tempCanvas
                                                .getObjects()
                                                .forEach(function (obj) {
                                                    if (obj.clipPath)
                                                        obj.set(
                                                            "clipPath",
                                                            null
                                                        );
                                                });
                                        }
                                        // Wait for image objects to load so PNG includes design (custom box fix)
                                        _this
                                            .waitForCanvasImagesToLoad(
                                                tempCanvas,
                                                1200
                                            )
                                            .then(async () => {
                                                tempCanvas.renderAll();
                                                if (
                                                    effDims &&
                                                    effDims.width > 0 &&
                                                    effDims.height > 0
                                                ) {
                                                    front_designs[flip1] =
                                                        tempCanvas.toDataURL({
                                                            left: 0,
                                                            top: 0,
                                                            width: effDims.width,
                                                            height: effDims.height,
                                                            format: "image/png",
                                                            quality: 1.0
                                                        });
                                                } else if (
                                                    rectHeight > 0 &&
                                                    rectTop > 0
                                                ) {
                                                    front_designs[flip1] =
                                                        tempCanvas.toDataURL({
                                                            left: rectLeft,
                                                            top: rectTop,
                                                            width: rectWidth,
                                                            height: rectHeight
                                                        });
                                                } else if (
                                                    effDims &&
                                                    effDims.width > 0 &&
                                                    effDims.height > 0
                                                ) {
                                                    front_designs[flip1] =
                                                        tempCanvas.toDataURL({
                                                            left: 0,
                                                            top: 0,
                                                            width: effDims.width,
                                                            height: effDims.height,
                                                            format: "image/png",
                                                            quality: 1.0
                                                        });
                                                } else {
                                                    front_designs[flip1] =
                                                        tempCanvas.toDataURL({
                                                            multiplier: 0.6
                                                        });
                                                }
                                                await _this.attachFilledArtworkUrlsForCart(
                                                    tempCanvas,
                                                    canvas_images
                                                );
                                                resolveLoad();
                                            });
                                    }
                                );
                            });
                            // For all views (front, back, left, right): load product background image if available
                            let canvasImgUrlArr = selected_design_images.filter(
                                function (currentImage) {
                                    return currentImage[flip1];
                                }
                            );
                            let designAreaForFlip = null;
                            if (
                                _this.design_area_data &&
                                Array.isArray(_this.design_area_data)
                            ) {
                                designAreaForFlip = _this.design_area_data.find(
                                    (a) =>
                                        a &&
                                        a.label &&
                                        (a.label ===
                                            flip1.charAt(0).toUpperCase() +
                                                flip1.slice(1) ||
                                            (flip1 === "front" &&
                                                a.label
                                                    .toLowerCase()
                                                    .includes("front")) ||
                                            (flip1 === "back" &&
                                                a.label
                                                    .toLowerCase()
                                                    .includes("back")) ||
                                            (flip1 === "left" &&
                                                (a.label === "Left" ||
                                                    (a.label &&
                                                        a.label
                                                            .toLowerCase()
                                                            .includes(
                                                                "left"
                                                            )))) ||
                                            (flip1 === "right" &&
                                                (a.label === "Right" ||
                                                    (a.label &&
                                                        a.label
                                                            .toLowerCase()
                                                            .includes(
                                                                "right"
                                                            )))))
                                );
                            }
                            let canvasImgUrl = "";
                            if (
                                !(
                                    designAreaForFlip &&
                                    designAreaForFlip.use_custom_box === true
                                ) &&
                                canvasImgUrlArr.length > 0
                            ) {
                                canvasImgUrl = canvasImgUrlArr[0][flip1];
                            } else if (
                                flip1 === "front" ||
                                flip1 === "back" ||
                                flip1 === "left" ||
                                flip1 === "right"
                            ) {
                                // If no product image and design area has thumbnail (and not use_custom_box), use it
                                if (
                                    designAreaForFlip &&
                                    designAreaForFlip.thumbnail &&
                                    designAreaForFlip.use_custom_box !== true
                                ) {
                                    canvasImgUrl = _this.setUrl
                                        ? _this.setUrl(
                                              designAreaForFlip.thumbnail
                                          )
                                        : designAreaForFlip.thumbnail;
                                }
                            }

                            // If product background image is available (and not use_custom_box), load it and combine with design
                            if (canvasImgUrl && canvasImgUrl !== "") {
                                let imgObj = await _this.loadImageAsync(
                                    canvasImgUrl
                                );
                                // Calculate scale to maintain aspect ratio (contain approach)
                                const scaleX =
                                    _this.defaultWidthCanvas / imgObj.width;
                                const scaleY =
                                    _this.defaultHeightCanvas / imgObj.height;
                                const scale = Math.min(scaleX, scaleY); // Use smaller scale to maintain aspect ratio

                                // Calculate scaled dimensions and center position
                                const scaledWidth = imgObj.width * scale;
                                const scaledHeight = imgObj.height * scale;
                                const left =
                                    (_this.defaultWidthCanvas - scaledWidth) /
                                    2;
                                const top =
                                    (_this.defaultHeightCanvas - scaledHeight) /
                                    2;

                                // Set canvas background to transparent to avoid showing canvas edges
                                tempCanvas.setBackgroundColor(
                                    null,
                                    tempCanvas.renderAll.bind(tempCanvas)
                                );

                                await tempCanvas.setBackgroundImage(
                                    imgObj,
                                    tempCanvas.renderAll.bind(tempCanvas),
                                    {
                                        scaleX: scale,
                                        scaleY: scale,
                                        left: left,
                                        top: top,
                                        crossOrigin: "anonymous"
                                    }
                                );
                                _this.imgHeight = imgObj.height;
                                _this.imgWidth = imgObj.width;
                                if (imgObj._element === null) {
                                    _this.$toast.error(
                                        "Something went wrong while loading the design area images, please refresh the page and try again.",
                                        {
                                            position: "top-right",
                                            queue: true,
                                            duration: 10000,
                                            pauseOnHover: true
                                        }
                                    );
                                } else {
                                    // Crop to actual image bounds to avoid canvas background
                                    image_response_back.push({
                                        label: flip1,
                                        url: tempCanvas.toDataURL({
                                            left: left,
                                            top: top,
                                            width: scaledWidth,
                                            height: scaledHeight,
                                            multiplier: 0.6
                                        }),
                                        design_image: front_designs[flip1],
                                        canvas_images: canvas_images
                                    });
                                }
                            } else {
                                // For views without product background image: use design area crop if available
                                if (
                                    effDims &&
                                    effDims.width > 0 &&
                                    effDims.height > 0
                                ) {
                                    image_response_back.push({
                                        label: flip1,
                                        url: tempCanvas.toDataURL({
                                            left: 0,
                                            top: 0,
                                            width: effDims.width,
                                            height: effDims.height,
                                            multiplier: 0.6
                                        }),
                                        design_image: front_designs[flip1],
                                        canvas_images: canvas_images
                                    });
                                } else if (rectHeight > 0 && rectTop > 0) {
                                    image_response_back.push({
                                        label: flip1,
                                        url: tempCanvas.toDataURL({
                                            left: rectLeft,
                                            top: rectTop,
                                            width: rectWidth,
                                            height: rectHeight,
                                            multiplier: 0.6
                                        }),
                                        design_image: front_designs[flip1],
                                        canvas_images: canvas_images
                                    });
                                } else {
                                    image_response_back.push({
                                        label: flip1,
                                        url: tempCanvas.toDataURL({
                                            multiplier: 0.6
                                        }),
                                        design_image: front_designs[flip1],
                                        canvas_images: canvas_images
                                    });
                                }
                            }
                        }
                    }

                    color["unique_sizes"].forEach((size) => {
                        total_quantity =
                            total_quantity + parseInt(size.quantity || 0);
                        total_price =
                            total_price + parseFloat(size.total_cost || 0);
                        items.push({
                            sub_product_id: size.id,
                            user_id: _this.currentUserClient.id,
                            case_price: size.price_base || 0,
                            markup_price: size.markup_price || 0,
                            markup_percentage:
                                design_item.markup_percentage || 0,
                            ink_price: size.ink_price || 0,
                            decoration_discount_percentage:
                                size.decoration_discount_percentage || 0,
                            decoration_discount_value:
                                size.decoration_discount_value || 0,
                            single_location_price:
                                size.single_location_price || 0,
                            quantity: size.quantity || 0,
                            discount: size.discount ? size.discount : 0.0,
                            unit_price: size.cost || 0,
                            total_price: size.total_cost || 0
                        });
                    });

                    if (!color.name_and_number_json) {
                        color.name_and_number_json = [];
                    }

                    if (Array.isArray(color.name_and_number_json)) {
                        color.name_and_number_json =
                            color.name_and_number_json.filter(
                                (data) => data.name || data.number
                            );
                    } else if (
                        color.name_and_number_json &&
                        typeof color.name_and_number_json === "object"
                    ) {
                        ["front", "back", "left", "right"].forEach((view) => {
                            if (
                                color.name_and_number_json[view] &&
                                Array.isArray(color.name_and_number_json[view])
                            ) {
                                color.name_and_number_json[view] =
                                    color.name_and_number_json[view].filter(
                                        (data) => data.name || data.number
                                    );
                            }
                        });
                    }

                    // Get activeServiceData (already enriched in Product Details)
                    const activeServiceData =
                        _this.gender_groups_items[_this.active_gender_key]
                            .activeServiceData;
                    const suppressAdditionalSetupRunCharge =
                        Number(
                            (activeServiceData &&
                                activeServiceData.product_master_service &&
                                activeServiceData.product_master_service
                                    .suppress_additional_setup_run_charge) ||
                                (activeServiceData &&
                                    activeServiceData.master_service &&
                                    activeServiceData.master_service
                                        .suppress_additional_setup_run_charge) ||
                                0
                        ) === 1;
                    const roundToTwo = (value) => {
                        const parsed = parseFloat(value);
                        if (Number.isNaN(parsed)) return "0.00";
                        return parsed.toFixed(2);
                    };
                    let imprint_locations = JSON.parse(
                        JSON.stringify(design_item.imprint_locations)
                    );
                    let canvasStoreForAddToCart = {};
                    try {
                        canvasStoreForAddToCart = JSON.parse(
                            localStorage.getItem("new_canvas_elements") ||
                                "{}"
                        );
                    } catch (e) {
                        canvasStoreForAddToCart = {};
                    }
                    prepareImprintLocationsForSuppressCart(
                        imprint_locations,
                        suppressAdditionalSetupRunCharge,
                        canvasStoreForAddToCart
                    );

                    const savedDesignId = _this.current_design_id || null;
                    // Determine assemblyServiceId:
                    // Priority 1: activeServiceData.id  (the direct vendor-decoration-service ID)
                    // Priority 2: activeServiceData.master_service.id  (legacy)
                    // Priority 3: "type_N" fallback for decoration_type 1/2/3 with no service data
                    const assemblyServiceId =
                        activeServiceData && activeServiceData.id
                            ? activeServiceData.id
                            : activeServiceData &&
                              activeServiceData.master_service &&
                              activeServiceData.master_service.id
                            ? activeServiceData.master_service.id
                            : `type_${design_item.item.decoration_type}`;
                    const assemblyDecoratorId =
                        _this.product_items &&
                        _this.product_items.default_decorator_id
                            ? _this.product_items.default_decorator_id
                            : null;
                    const assemblyVendorId = getVendorIdFromProduct(
                        _this.product_items
                    );
                    const assemblyKey = buildAssemblyKey(
                        savedDesignId,
                        assemblyServiceId,
                        assemblyDecoratorId,
                        assemblyVendorId
                    );
                    const replaceParentKey =
                        savedDesignId &&
                        assemblyKey && design_item &&
                        design_item.item &&
                        design_item.item.id !== undefined &&
                        design_item.item.id !== null &&
                        color &&
                        color.id !== undefined &&
                        color.id !== null
                            ? [savedDesignId, assemblyKey, color.id, design_item.item.id].join("|")
                            : null;
                    const matchingParentCartId = replaceParentKey
                        ? existingParentCartIdsByDesignAssemblyColor[
                              replaceParentKey
                          ] || null
                        : null;
                    const isReplacingExistingParent = !!matchingParentCartId;
                    const isAssemblyParentLine = assemblyKey
                        ? isReplacingExistingParent ||
                          !assemblyParentBySavedDesignId[assemblyKey]
                        : true;
                    if (assemblyKey && isAssemblyParentLine) {
                        assemblyParentBySavedDesignId[assemblyKey] = true;
                    }
                    if (isReplacingExistingParent) {
                        parentCartIdsToRemove.add(matchingParentCartId);
                    }

                    const incomingAssemblySetupTotal =
                        setupFeesDetailsForAllColors &&
                        setupFeesDetailsForAllColors.total != null
                            ? parseFloat(
                                  setupFeesDetailsForAllColors.total || 0
                              )
                            : parseFloat(design_item.total_setup_fee || 0);
                    const parentMetaStrict =
                        assemblyKey &&
                        assemblyParentSetupByKey[assemblyKey]
                            ? assemblyParentSetupByKey[assemblyKey]
                            : null;
                    let parentMetaLoose = null;
                    if (savedDesignId && assemblyServiceId) {
                        const looseKey = `${String(savedDesignId)}|${String(
                            assemblyServiceId
                        )}`;
                        parentMetaLoose =
                            assemblyParentSetupByLooseKey[looseKey] || null;
                    }
                    const parentMetaForUpgrade =
                        parentMetaStrict || parentMetaLoose;
                    const looseKeyForLog =
                        savedDesignId && assemblyServiceId
                            ? `${String(savedDesignId)}|${String(
                                  assemblyServiceId
                              )}`
                            : null;
                    const upgradeEligible =
                        !isAssemblyParentLine &&
                        !!parentMetaForUpgrade &&
                        !!assemblyKey &&
                        incomingAssemblySetupTotal >
                            parseFloat(parentMetaForUpgrade.setupFee || 0) +
                                0.0001;
                    if (
                        assemblyKey ||
                        existingAssemblyKeys.size > 0 ||
                        Object.keys(assemblyParentSetupByKey).length > 0
                    ) 
                    if (upgradeEligible) {
                        assemblySetupUpgradeAfterAdd = {
                            parentCartId: parentMetaForUpgrade.cartId,
                            setup_fee: incomingAssemblySetupTotal,
                            setup_fees_details: setupFeesDetailsForAllColors,
                        };
                    }

                    // Prepare decoration object (other_services_list already enriched in Product Details)
                    const decorationData = {
                        ...activeServiceData
                    };
                    if (!decorationData.master_service) {
                        decorationData.master_service = {};
                    }
                    decorationData.master_service.suppress_additional_setup_run_charge =
                        suppressAdditionalSetupRunCharge ? 1 : 0;
                    // Keep other_services_list unchanged for assembly children.
                    // One-time setup/custom-color is controlled by setup_fees_details/non_standard data,
                    // while services should remain available for per-line calculations in cart.

                    // Per-color name/number font: use first view that has name/number data (front, back, left, right), else active view, else ref
                    let fontNameForColor = allColorAndSizesname;
                    let fontNumberForColor = allColorAndSizesnumber;
                    // Per-location name/number color, font, size (front, back, left, right can each be different)
                    const font_color_sizes_name_per_location = {};
                    const font_color_sizes_number_per_location = {};
                    ["front", "back", "left", "right"].forEach(function (loc) {
                        if (color.view_settings && color.view_settings[loc]) {
                            const vs = color.view_settings[loc];
                            if (vs.nameSettings) {
                                font_color_sizes_name_per_location[loc] = {
                                    nameFontFamily:
                                        vs.nameSettings.fontFamily || "Verdana",
                                    nameFontColor:
                                        vs.nameSettings.fontColor || "#000000",
                                    nameFontSize:
                                        vs.nameSettings.fontSize || "21",
                                    color_id:
                                        vs.nameSettings.colorId != null
                                            ? vs.nameSettings.colorId
                                            : vs.nameSettings.color_id || null,
                                    decor_upcharge:
                                        vs.nameSettings.decor_upcharge != null
                                            ? vs.nameSettings.decor_upcharge
                                            : 0
                                };
                            }
                            if (vs.numberSettings) {
                                font_color_sizes_number_per_location[loc] = {
                                    numberFontFamily:
                                        vs.numberSettings.fontFamily ||
                                        "Verdana",
                                    numberFontColor:
                                        vs.numberSettings.fontColor ||
                                        "#000000",
                                    numberFontSize:
                                        vs.numberSettings.fontSize || "96",
                                    color_id:
                                        vs.numberSettings.colorId != null
                                            ? vs.numberSettings.colorId
                                            : vs.numberSettings.color_id ||
                                              null,
                                    decor_upcharge:
                                        vs.numberSettings.decor_upcharge != null
                                            ? vs.numberSettings.decor_upcharge
                                            : 0
                                };
                            }
                        }
                    });
                    // Use per-location when available; else legacy single object for backward compat
                    const hasPerLocationName =
                        Object.keys(font_color_sizes_name_per_location).length >
                        0;
                    const hasPerLocationNumber =
                        Object.keys(font_color_sizes_number_per_location)
                            .length > 0;
                    let legacyFontName = allColorAndSizesname;
                    let legacyFontNumber = allColorAndSizesnumber;
                    if (!hasPerLocationName || !hasPerLocationNumber) {
                        const viewsToCheck = ["front", "back", "left", "right"];
                        let viewWithData = _this.active_flip || "front";
                        if (color.name_and_number_json) {
                            if (
                                Array.isArray(color.name_and_number_json) &&
                                color.name_and_number_json.length > 0 &&
                                color.name_and_number_json.some(function (nn) {
                                    return (
                                        (nn &&
                                            nn.name &&
                                            String(nn.name).trim()) ||
                                        (nn.number != null && nn.number !== "")
                                    );
                                })
                            ) {
                                viewWithData = _this.active_flip || "front";
                            } else if (
                                typeof color.name_and_number_json === "object"
                            ) {
                                for (const v of viewsToCheck) {
                                    const arr = color.name_and_number_json[v];
                                    if (
                                        Array.isArray(arr) &&
                                        arr.length > 0 &&
                                        arr.some(function (nn) {
                                            return (
                                                (nn &&
                                                    nn.name &&
                                                    String(nn.name).trim()) ||
                                                (nn.number != null &&
                                                    nn.number !== "")
                                            );
                                        })
                                    ) {
                                        viewWithData = v;
                                        break;
                                    }
                                }
                            }
                        }
                        if (
                            color.view_settings &&
                            color.view_settings[viewWithData]
                        ) {
                            const vs = color.view_settings[viewWithData];
                            if (vs.nameSettings && !hasPerLocationName)
                                legacyFontName = {
                                    nameFontFamily:
                                        vs.nameSettings.fontFamily || "Verdana",
                                    nameFontColor:
                                        vs.nameSettings.fontColor || "#000000",
                                    nameFontSize:
                                        vs.nameSettings.fontSize || "21"
                                };
                            if (vs.numberSettings && !hasPerLocationNumber)
                                legacyFontNumber = {
                                    numberFontFamily:
                                        vs.numberSettings.fontFamily ||
                                        "Verdana",
                                    numberFontColor:
                                        vs.numberSettings.fontColor ||
                                        "#000000",
                                    numberFontSize:
                                        vs.numberSettings.fontSize || "96"
                                };
                        }
                    }

                    allitems.push({
                        user_id: _this.currentUserClient.id,
                        item_id: design_item.item.id,
                        gender_size_id: design_item.gender_id,
                        color_id: color.id,
                        saved_design_id: savedDesignId,
                        decoration_type: design_item.item.decoration_type,
                        decoration_price_template:
                            design_item.item.decoration_price_template,
                        price_decoration_bulk:
                            design_item.item.price_decoration_bulk,
                        more_decorations: design_item.item.more_decoration,
                        items: items,
                        imprint_locations: isAssemblyParentLine
                            ? imprint_locations
                            : null,
                        imprint_locations_price:
                            colorIndex == 0 && isAssemblyParentLine
                                ? design_item.total_color_fee
                                : 0,
                        total_design_fee: color.total_design_fee,
                        total_quantity: color.total_qty_gender_wise,
                        total_price: color.total_cost_gender_wise,
                        setup_fee:
                            colorIndex == 0 && isAssemblyParentLine
                                ? design_item.total_setup_fee
                                : 0.0,
                        subtotal_price: color.total_cost_gender_wise,
                        artwork: design_item.item_artwork,
                        design_image: image_response_back,
                        design_area_inches: JSON.stringify(
                            _this.design_area_inches
                        ),
                        item_prices: (() => {
                            // Use same count logic as display (countNameNumberFromJson: excludes placeholders, all locations)
                            const selectedNameNumber =
                                color.selected_name_number || {
                                    front: { name: false, number: false },
                                    back: { name: false, number: false },
                                    left: { name: false, number: false },
                                    right: { name: false, number: false }
                                };
                            var counts = _this.countNameNumberFromJson
                                ? _this.countNameNumberFromJson(
                                      color.name_and_number_json,
                                      color.selected_name_number
                                  )
                                : {
                                      frontNameCount: 0,
                                      frontNumberCount: 0,
                                      backNameCount: 0,
                                      backNumberCount: 0,
                                      leftNameCount: 0,
                                      leftNumberCount: 0,
                                      rightNameCount: 0,
                                      rightNumberCount: 0
                                  };
                            var frontNameCount = counts.frontNameCount || 0;
                            var frontNumberCount = counts.frontNumberCount || 0;
                            var backNameCount = counts.backNameCount || 0;
                            var backNumberCount = counts.backNumberCount || 0;
                            var leftNameCount = counts.leftNameCount || 0;
                            var leftNumberCount = counts.leftNumberCount || 0;
                            var rightNameCount = counts.rightNameCount || 0;
                            var rightNumberCount = counts.rightNumberCount || 0;

                            // Calculate per prices (fees / count)
                            const frontNumberPerPrice =
                                frontNumberCount > 0
                                    ? (color.front_number_fees || 0) /
                                      frontNumberCount
                                    : 0;
                            const frontNumberDecorUpPerPrice =
                                frontNumberCount > 0
                                    ? (color.front_number_decor_up_fees || 0) /
                                      frontNumberCount
                                    : 0;

                            const backNamePerPrice =
                                backNameCount > 0
                                    ? (color.back_name_fees || 0) /
                                      backNameCount
                                    : 0;
                            const backNameDecorUpPerPrice =
                                backNameCount > 0
                                    ? (color.back_name_decor_up_fees || 0) /
                                      backNameCount
                                    : 0;

                            const backNumberPerPrice =
                                backNumberCount > 0
                                    ? (color.back_number_fees || 0) /
                                      backNumberCount
                                    : 0;
                            const backNumberDecorUpPerPrice =
                                backNumberCount > 0
                                    ? (color.back_number_decor_up_fees || 0) /
                                      backNumberCount
                                    : 0;

                            const frontNamePerPrice =
                                frontNameCount > 0
                                    ? (color.front_name_fees || 0) /
                                      frontNameCount
                                    : 0;
                            const frontNameDecorUpPerPrice =
                                frontNameCount > 0
                                    ? (color.front_name_decor_up_fees || 0) /
                                      frontNameCount
                                    : 0;
                            const leftNamePerPrice =
                                leftNameCount > 0
                                    ? (color.left_name_fees || 0) /
                                      leftNameCount
                                    : 0;
                            const leftNumberPerPrice =
                                leftNumberCount > 0
                                    ? (color.left_number_fees || 0) /
                                      leftNumberCount
                                    : 0;
                            const rightNamePerPrice =
                                rightNameCount > 0
                                    ? (color.right_name_fees || 0) /
                                      rightNameCount
                                    : 0;
                            const rightNumberPerPrice =
                                rightNumberCount > 0
                                    ? (color.right_number_fees || 0) /
                                      rightNumberCount
                                    : 0;

                            // Structure exactly like selected_name_number, with count/fees/per_price when true (front, back, left, right)
                            return {
                                selected_name_number: {
                                    front: {
                                        name:
                                            selectedNameNumber.front &&
                                            selectedNameNumber.front.name
                                                ? {
                                                      front_name_count:
                                                          frontNameCount,
                                                      front_name_fees:
                                                          color.front_name_fees ||
                                                          0,
                                                      front_name_decor_up_fees:
                                                          color.front_name_decor_up_fees ||
                                                          0,
                                                      front_name_per_price:
                                                          frontNamePerPrice,
                                                      front_name_decor_up_per_price:
                                                          frontNameDecorUpPerPrice
                                                  }
                                                : false,
                                        number:
                                            selectedNameNumber.front &&
                                            selectedNameNumber.front.number
                                                ? {
                                                      front_number_count:
                                                          frontNumberCount,
                                                      front_number_fees:
                                                          color.front_number_fees ||
                                                          0,
                                                      front_number_decor_up_fees:
                                                          color.front_number_decor_up_fees ||
                                                          0,
                                                      front_number_per_price:
                                                          frontNumberPerPrice,
                                                      front_number_decor_up_per_price:
                                                          frontNumberDecorUpPerPrice
                                                  }
                                                : false
                                    },
                                    back: {
                                        name:
                                            selectedNameNumber.back &&
                                            selectedNameNumber.back.name
                                                ? {
                                                      back_name_count:
                                                          backNameCount,
                                                      back_name_fees:
                                                          color.back_name_fees ||
                                                          0,
                                                      back_name_decor_up_fees:
                                                          color.back_name_decor_up_fees ||
                                                          0,
                                                      back_name_per_price:
                                                          backNamePerPrice,
                                                      back_name_decor_up_per_price:
                                                          backNameDecorUpPerPrice
                                                  }
                                                : false,
                                        number:
                                            selectedNameNumber.back &&
                                            selectedNameNumber.back.number
                                                ? {
                                                      back_number_count:
                                                          backNumberCount,
                                                      back_number_fees:
                                                          color.back_number_fees ||
                                                          0,
                                                      back_number_decor_up_fees:
                                                          color.back_number_decor_up_fees ||
                                                          0,
                                                      back_number_per_price:
                                                          backNumberPerPrice,
                                                      back_number_decor_up_per_price:
                                                          backNumberDecorUpPerPrice
                                                  }
                                                : false
                                    },
                                    left: {
                                        name:
                                            selectedNameNumber.left &&
                                            selectedNameNumber.left.name
                                                ? {
                                                      left_name_count:
                                                          leftNameCount,
                                                      left_name_fees:
                                                          color.left_name_fees ||
                                                          0,
                                                      left_name_per_price:
                                                          leftNamePerPrice
                                                  }
                                                : false,
                                        number:
                                            selectedNameNumber.left &&
                                            selectedNameNumber.left.number
                                                ? {
                                                      left_number_count:
                                                          leftNumberCount,
                                                      left_number_fees:
                                                          color.left_number_fees ||
                                                          0,
                                                      left_number_per_price:
                                                          leftNumberPerPrice
                                                  }
                                                : false
                                    },
                                    right: {
                                        name:
                                            selectedNameNumber.right &&
                                            selectedNameNumber.right.name
                                                ? {
                                                      right_name_count:
                                                          rightNameCount,
                                                      right_name_fees:
                                                          color.right_name_fees ||
                                                          0,
                                                      right_name_per_price:
                                                          rightNamePerPrice
                                                  }
                                                : false,
                                        number:
                                            selectedNameNumber.right &&
                                            selectedNameNumber.right.number
                                                ? {
                                                      right_number_count:
                                                          rightNumberCount,
                                                      right_number_fees:
                                                          color.right_number_fees ||
                                                          0,
                                                      right_number_per_price:
                                                          rightNumberPerPrice
                                                  }
                                                : false
                                    }
                                }
                            };
                        })(),
                        non_standard_fees: isAssemblyParentLine
                            ? color.non_standard_fees
                            : 0,
                        non_standard_colors: isAssemblyParentLine
                            ? color.non_standard_colors
                            : [],
                        decoration_colors: color.decoration_colors,
                        location_decoration_colors: {
                            front: get_canvas_colors.front || [],
                            back: get_canvas_colors.back || [],
                            left: get_canvas_colors.left || [],
                            right: get_canvas_colors.right || []
                        },
                        // Cart/order expect { front, back, left, right, selected_name_number }; selection lives inside same JSON (no extra column)
                        name_and_number_json:
                            this.buildNameNumberJsonForCart(color),
                        font_color_sizes_name: hasPerLocationName
                            ? font_color_sizes_name_per_location
                            : legacyFontName || null,
                        font_color_sizes_number: hasPerLocationNumber
                            ? font_color_sizes_number_per_location
                            : legacyFontNumber || null,
                        t_shirt_24_hour: this.is24Tshirt,
                        decoration: JSON.stringify(decorationData),
                        setup_fees_details:
                            isAssemblyParentLine && setupFeesDetailsForAllColors
                            ? JSON.stringify(setupFeesDetailsForAllColors)
                            : null,
                        rush_fee_breakdown: (() => {
                            const breakdown = calculateRushFeeBreakdown(
                                color.total_qty_gender_wise
                            );
                            return breakdown ? JSON.stringify(breakdown) : null;
                        })(),
                        patch_cost:
                            colorIndex == 0 ? _this.patchCostTotal || 0 : 0,
                        patch_cost_details:
                            colorIndex == 0 &&
                            _this.patchCostDetails &&
                            _this.patchCostDetails.length > 0
                                ? JSON.stringify(
                                      _this.buildPatchCostDetailsForCart()
                                  )
                                : null,
                        // Assembly group identifier: same value for all items sharing the same
                        // saved_design_id + service + decorator + vendor combination.
                        // Format: "{saved_design_id}|{service_id}|{decorator_id}|{vendor_id}"
                        // null when the item does not belong to any assembly.
                        group_assembly_id: assemblyKey || null,
                        // Exactly one line per assembly carries one-time setup/custom color fees.
                        assembly_parent: isAssemblyParentLine ? 1 : 0
                    });
                }
            }
            /* eslint-enable */
            if (parentCartIdsToRemove.size > 0) {
                await Promise.allSettled(
                    Array.from(parentCartIdsToRemove).map((cartId) =>
                        ApiService.post("/remove-cart", { cart_id: cartId })
                    )
                );
            }
            try {
                await ApiService.post("/add-to-cart", allitems);
                if (
                    assemblySetupUpgradeAfterAdd &&
                    assemblySetupUpgradeAfterAdd.parentCartId
                ) {
                    try {
                        const detailsPayload =
                            assemblySetupUpgradeAfterAdd.setup_fees_details;
                        // eslint-disable-next-line no-console
                        await ApiService.post("/update-assembly-parent-setup", {
                            parent_cart_id:
                                assemblySetupUpgradeAfterAdd.parentCartId,
                            setup_fee: assemblySetupUpgradeAfterAdd.setup_fee,
                            setup_fees_details:
                                typeof detailsPayload === "string"
                                    ? detailsPayload
                                    : JSON.stringify(detailsPayload),
                        });
                        // eslint-disable-next-line no-console
                    } catch (upErr) {
                        console.log(response)
                    }
                } 
                this.$root.$emit("update-cart", { type: "success" });
                this.flipTshirt("front");

                this.isLoader = false;
                let colorIdArr =
                    localStorage.getItem("colorIdArr") != null
                        ? localStorage.getItem("colorIdArr").split(",")
                        : [];
                colorIdArr.push(this.activeIndex);
                if (colorIdArr.length > 0)
                    localStorage.setItem("colorIdArr", colorIdArr.join(","));
                this.skip_leave_confirm_box = true;
                this.$router.push({
                    name: "cartV3"
                });
            } catch (err) {
                const response = err && err.response;
                if (
                    response &&
                    response.data &&
                    response.data.error
                ) {
                    this.$toast.error(
                        "Access denied, images not uploading to server",
                        {
                            position: "top-right"
                        }
                    );
                }
                this.isLoader = false;
            }
        },
        shareDesign() {
            this.copied = false;
            let local_data = {};
            let keys = [
                "design",
                "canvas_elements",
                "new_canvas_elements",
                "product_id",
                "product_items",
                "active_tshirt_color",
                "active_gender",
                "active_gender_key"
            ];
            keys.forEach((key) => {
                local_data[key] = localStorage.getItem(key);
            });
            let params = {
                design_data: local_data
            };

            this.isLoader = true;
            ApiService.post("/share-design", params)
                .then(({ data }) => {
                    this.shareable_link =
                        window.location.origin +
                        "/design-studio/design/" +
                        data.share_design.id;
                    /* eslint-disable */
                    $("#share_design_modal").modal("show");
                    $(document).on("show.bs.modal", ".modal", function () {
                        $(".modal").not(this).modal("hide");
                    });
                    /* eslint-enable */
                    this.isLoader = false;
                })
                .then((response) => {
                    this.isLoader = false;
                    // console.log(response);
                });
        },
        getShareDesign(id) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(`/get-share-design/${id}`)
                    .then(({ data }) => {
                        let design_data = JSON.parse(
                            data.share_design.design_data
                        );
                        for (const [key, value] of Object.entries(
                            design_data
                        )) {
                            localStorage.setItem(key, value);
                        }
                        localStorage.setItem(
                            "share_design_id",
                            data.share_design.id
                        );
                        this.isLoader = false;
                        resolve(data);
                    })
                    .then((response) => {
                        this.isLoader = false;
                        // console.log(response);
                        reject(response);
                    });
            });
        },
        copyClipboard() {
            // Get the text field
            var copyText = document.getElementById("share_link_input");

            // Select the text field
            copyText.select();
            copyText.setSelectionRange(0, 99999); // For mobile devices

            // Copy the text inside the text field
            navigator.clipboard.writeText(copyText.value);

            this.copied = true;
        },
        delay(delayInms) {
            return new Promise((resolve) => setTimeout(resolve, delayInms));
        },
        normalizeFontWeightForToolbar(fw) {
            if (fw === "bold" || fw === 700 || fw === "700" || fw === "BOLD") {
                return "bold";
            }
            if (
                fw === "normal" ||
                fw === 400 ||
                fw === "400" ||
                fw === "" ||
                fw == null
            ) {
                return "100";
            }
            return String(fw);
        },
        computeHorizontalAlignKey(selectedObject) {
            if (
                !selectedObject ||
                typeof selectedObject.getBoundingRect !== "function"
            ) {
                return "center";
            }
            const bound = selectedObject.getBoundingRect();
            const offsetX =
                selectedObject.left - (bound.left + bound.width / 2);
            const printArea = this.printAreaBond;

            if (
                printArea &&
                typeof printArea.left === "number" &&
                Number.isFinite(printArea.width) &&
                printArea.width > 0 &&
                (this.active_flip === "front" || this.active_flip === "back")
            ) {
                const leftTarget = printArea.left + bound.width / 2 + offsetX;
                const centerTarget =
                    printArea.left + printArea.width / 2 + offsetX;
                const rightTarget =
                    printArea.left +
                    printArea.width -
                    bound.width / 2 +
                    offsetX;

                const dLeft = Math.abs(selectedObject.left - leftTarget);
                const dCenter = Math.abs(selectedObject.left - centerTarget);
                const dRight = Math.abs(selectedObject.left - rightTarget);

                if (dLeft <= dCenter && dLeft <= dRight) return "left";
                if (dRight <= dCenter && dRight <= dLeft) return "right";
                return "center";
            }

            const canvas = selectedObject.canvas;
            const cw = canvas && canvas.width ? canvas.width : 0;
            if (cw > 0) {
                const centerX = bound.left + bound.width / 2;
                const third = cw / 3;
                if (centerX < third) return "left";
                if (centerX > (2 * cw) / 3) return "right";
                return "center";
            }
            return "center";
        },
        syncEditToolbarFromFabricObject(obj) {
            if (!obj || !this.backCanvas) {
                return;
            }
            const active = this.backCanvas.getActiveObject();
            if (active !== obj) {
                return;
            }

            const objType =
                obj.objType ||
                (obj.toObject &&
                    typeof obj.toObject === "function" &&
                    obj.toObject().objType) ||
                "";
            const isNameNumber =
                objType === "name" ||
                objType === "number" ||
                (typeof objType === "string" &&
                    (objType.startsWith("name_") ||
                        objType.startsWith("number_")));

            const align = this.computeHorizontalAlignKey(obj);
            const fx = !!obj.flipX;
            const fy = !!obj.flipY;

            if (obj.type === "text" && !isNameNumber) {
                const fw = this.normalizeFontWeightForToolbar(obj.fontWeight);
                this.textData = {
                    ...this.textData,
                    flipX: fx,
                    flipY: fy,
                    center: align,
                    textAlign: obj.textAlign || "left",
                    fontWeight: fw,
                    fontStyle: obj.fontStyle || "",
                    textUDecoration: obj.underline ? "underline" : "",
                    textDecoration: obj.linethrough ? "linethrough" : ""
                };
            } else if (
                obj.ctype === "clipart" ||
                obj.ctype === "templates" ||
                obj.ctype === "shape" ||
                obj.ctype === "patch" ||
                obj.ctype === "upload"
            ) {
                this.selectImageProps = {
                    ...this.selectImageProps,
                    rotation: obj.angle,
                    flipX: fx,
                    flipY: fy,
                    center: align
                };
            }
        },
        objSelected(e) {
            let _this = this;
            _this.onObjectSelected(e);
        },
        objRotating(e) {
            if (!e) {
                return;
            }
            let _this = this;
            this.rotationAngle = parseInt(e.target.angle);
            _this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );
        },
        objSkewing(e) {
            let _this = this;
            _this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );
        },
        objModified(e) {
            if (!e || !e.target) {
                return;
            }
            let _this = this;
            _this.isLoader = true;

            var obj = e.target;
            obj.setCoords();
            _this.centerObjectInsideDesignAreaOnDrop(obj);
            _this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );
            _this.syncSelectedArtDimensions(e.target);
            _this.syncEditToolbarFromFabricObject(obj);
            _this.saveCanvasData();
            _this.getStoreDesign();
            _this.isLoader = false;
        },
        getActiveDesignAreaBounds() {
            const left = parseFloat(this.front_canvas_left);
            const top = parseFloat(this.front_canvas_top);
            const width = parseFloat(this.front_canvas_width);
            const height = parseFloat(this.front_canvas_height);

            if (
                !Number.isFinite(left) ||
                !Number.isFinite(top) ||
                !Number.isFinite(width) ||
                !Number.isFinite(height) ||
                width <= 0 ||
                height <= 0
            ) {
                return null;
            }

            return {
                left,
                top,
                right: left + width,
                bottom: top + height,
                centerX: left + width / 2,
                centerY: top + height / 2
            };
        },
        isObjectFullyOutsideDesignArea(obj, bounds) {
            if (!obj || !bounds || typeof obj.getBoundingRect !== "function") {
                return false;
            }

            const rect = obj.getBoundingRect(true, true);
            if (!rect) {
                return false;
            }

            const objRight = rect.left + rect.width;
            const objBottom = rect.top + rect.height;

            // Snap to center only when object is completely outside design area.
            // If any part intersects with the design area, keep current position.
            return (
                objRight < bounds.left ||
                rect.left > bounds.right ||
                objBottom < bounds.top ||
                rect.top > bounds.bottom
            );
        },
        centerObjectInsideDesignAreaOnDrop(obj) {
            if (!obj || obj.selectable === false) {
                return;
            }

            const bounds = this.getActiveDesignAreaBounds();
            if (!bounds || !this.isObjectFullyOutsideDesignArea(obj, bounds)) {
                return;
            }

            obj.set({
                originX: "center",
                originY: "center",
                left: bounds.centerX,
                top: bounds.centerY
            });
            obj.setCoords();
            if (this.backCanvas && typeof this.backCanvas.renderAll === "function") {
                this.backCanvas.renderAll();
            }
        },
        objRemoved(e) {
            if (!e || !e.target) {
                return;
            }
            let obj = e.target;
            let _this = this;
            const deletedNameNumberTypes = [];
            const collectDeletedNameNumberTypes = (target) => {
                if (!target) return;
                const ot =
                    target.objType ||
                    (target.toObject &&
                        typeof target.toObject === "function" &&
                        target.toObject().objType);
                if (
                    typeof ot === "string" &&
                    /^(name|number)_(front|back|left|right)$/.test(ot)
                ) {
                    deletedNameNumberTypes.push(ot);
                }
                if (target._objects && Array.isArray(target._objects)) {
                    target._objects.forEach((child) =>
                        collectDeletedNameNumberTypes(child)
                    );
                }
            };
            collectDeletedNameNumberTypes(obj);
            var colors = [];
            // Get all the unique colors of the deleted objects on the canvas
            /* eslint-disable */
            if ("_objects" in obj) {
                colors = obj._objects.reduce(function (
                    accumulator,
                    currentObject
                ) {
                    if (
                        currentObject.get("fill") &&
                        !accumulator.includes(currentObject.get("fill"))
                    ) {
                        accumulator.push(currentObject.get("fill"));
                    } else if (
                        currentObject.ctype == "shape" ||
                        "text" in currentObject
                    ) {
                        if (
                            currentObject.get("fill") &&
                            !accumulator.includes(currentObject.get("fill"))
                        ) {
                            accumulator.push(currentObject.get("fill"));
                        }
                    }
                    return accumulator;
                },
                []);
            } else if (
                obj.ctype == "clipart" ||
                obj.ctype == "patch" ||
                obj.ctype == "shape" ||
                obj.ctype == "upload" ||
                "text" in obj
            ) {
                if (obj.get("fill") && !colors.includes(obj.get("fill"))) {
                    colors.push(obj.get("fill"));
                }
                if (
                    "text" in obj &&
                    obj.get("stroke") &&
                    !accumulator.includes(obj.get("stroke"))
                ) {
                    accumulator.push(obj.get("stroke"));
                }
                if (
                    "text" in obj &&
                    obj.get("shadow") &&
                    !accumulator.includes(obj.get("shadow"))
                ) {
                    accumulator.push(obj.get("shadow").color);
                }
            }
            /* eslint-enable */
            colors.forEach(function (currentValue) {
                let currentIndex =
                    _this.design_current_colors.indexOf(currentValue);
                if (currentIndex > -1)
                    _this.design_current_colors.splice(currentIndex);
            });

            let get_canvas_colors = JSON.parse(
                localStorage.getItem("canvas_design_colors")
            );
            get_canvas_colors[_this.active_flip] = _this.design_current_colors;
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify(get_canvas_colors)
            );

            _this.checkObjectCanvas();
            _this.updateAdditionalFeesInDashboard();
            if (
                deletedNameNumberTypes.length > 0 &&
                _this.$refs.nameAndNumberRef &&
                typeof _this.$refs.nameAndNumberRef.syncDeletedCanvasObjects ===
                    "function"
            ) {
                _this.$refs.nameAndNumberRef.syncDeletedCanvasObjects(
                    deletedNameNumberTypes
                );
            }
            // Recalculate patch pricing when a patch is removed (object already removed from canvas)
            const patchRemoved =
                obj.ctype === "patch" ||
                (obj.get && obj.get("ctype") === "patch") ||
                (obj._objects &&
                    obj._objects.some(
                        (o) =>
                            (o.get && o.get("ctype") === "patch") ||
                            o.ctype === "patch"
                    ));
            if (
                patchRemoved &&
                typeof _this.calculatePatchCost === "function"
            ) {
                _this.$nextTick(() => _this.calculatePatchCost());
            }
        },
        objResizing(e) {
            var obj = e.target;
            obj.setCoords();
            let _this = this;
            _this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );
        },
        objSelectionCleared(e) {
            let _this = this;
            _this.selected_art_dimensions = null;
            _this.siderBarChange(e);
        },
        objMoved(e) {
            if (!e || !e.target) {
                return;
            }
            var obj = e.target;
            obj.setCoords();
        },
        objMoving(e) {
            if (!e) {
                return;
            }
            var obj = e.target;

            obj.setCoords();
            let _this = this;
            _this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );

            if (
                obj.height > obj.canvas.height ||
                obj.width > obj.canvas.width
            ) {
                obj.scaleY = obj._stateProperties.scaleY;
                obj.scaleX = obj._stateProperties.scaleX;
            }

            if (
                obj.getBoundingRect().top - obj.cornerSize / 2 < 0 ||
                obj.getBoundingRect().left - obj.cornerSize / 2 < 0
            ) {
                obj.top = Math.max(
                    obj.top,
                    obj.top - obj.getBoundingRect().top + obj.cornerSize / 2
                );
                obj.left = Math.max(
                    obj.left,
                    obj.left - obj.getBoundingRect().left + obj.cornerSize / 2
                );
            }
            if (
                obj.getBoundingRect().top +
                    obj.getBoundingRect().height +
                    obj.cornerSize >
                    obj.canvas.height ||
                obj.getBoundingRect().left +
                    obj.getBoundingRect().width +
                    obj.cornerSize >
                    obj.canvas.width
            ) {
                obj.top = Math.min(
                    obj.top,
                    obj.canvas.height -
                        obj.getBoundingRect().height +
                        obj.top -
                        obj.getBoundingRect().top -
                        obj.cornerSize / 2
                );
                obj.left = Math.min(
                    obj.left,
                    obj.canvas.width -
                        obj.getBoundingRect().width +
                        obj.left -
                        obj.getBoundingRect().left -
                        obj.cornerSize / 2
                );
            }
        },
        objScaling(e) {
            if (!e) {
                return;
            }
            let _this = this;
            _this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );
        },
        buildNameNumberJsonForCart(color) {
            const selected =
                color && color.selected_name_number
                    ? color.selected_name_number
                    : {};
            const nn = color ? color.name_and_number_json : null;
            const sourceRows = Array.isArray(nn)
                ? nn
                : nn && typeof nn === "object" && Array.isArray(nn.front)
                ? nn.front
                : [];
            const cleanedRows = sourceRows
                .map((row) => ({
                    ...row,
                    name:
                        row && row.name != null ? String(row.name).trim() : "",
                    number:
                        row && row.number != null
                            ? String(row.number).trim()
                            : ""
                }))
                .filter((row) => row.name !== "" || row.number !== "");
            const byLoc = {};
            ["front", "back", "left", "right"].forEach((loc) => {
                const locSel = selected && selected[loc] ? selected[loc] : {};
                const nameOn = !!locSel.name;
                const numberOn = !!locSel.number;
                if (!nameOn && !numberOn) {
                    byLoc[loc] = [];
                    return;
                }
                byLoc[loc] = cleanedRows
                    .map((row) => ({
                        ...row,
                        name: nameOn ? row.name : "",
                        number: numberOn ? row.number : ""
                    }))
                    .filter((row) => row.name !== "" || row.number !== "");
            });
            return {
                front: byLoc.front,
                back: byLoc.back,
                left: byLoc.left,
                right: byLoc.right,
                selected_name_number: selected
            };
        },
        overImageLoaded(img) {
            this.overImgHeight = img.height;
            this.overImgWidth = img.width;
        },
        objDropped() {
            // eslint-disable-next-line no-console
        },
        dragStart(e) {
            // eslint-disable-next-line no-console

            e.dataTransfer.setData("text/plain", "mmmmmeeeee");
        },
        afterRender() {
            this.getStoreDesign();

            if (this.backCanvas._objects.length > 0) {
                this.save_design_button = false;
            } else {
                this.save_design_button = true;
            }
        },
        canvasUpdated() {
            // Write some code
        },
        canvasImageUpdated(c) {
            this.imageCanvas = c;
        },
        canvasBackUpdated(c) {
            if (this.backCanvas && this._imageZoomOffHandler) {
                this.backCanvas.off("object:added", this._imageZoomOffHandler);
            }
            this.backCanvas = c;
            this._imageZoomOffHandler = (e) => {
                if (!e || !e.target) return;
                if (e.target.type === "rect" && e.target.selectable === false)
                    return;
                this.turnOffImageZoomIfActive();
            };
            if (c && c.on) {
                c.on("object:added", this._imageZoomOffHandler);
            }
            let _this = this;
            let matchRgbaColor =
                /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
            _this.design_current_colors = [];
            // Get all the unique colors of the objects on the canvas
            var colors = [];
            this.backCanvas._objects.forEach(function (currentObject) {
                let accumulator = [];
                if ("_objects" in currentObject) {
                    accumulator = currentObject._objects.reduce(function (
                        accumulator1,
                        currentObject1
                    ) {
                        // Get fill color
                        if (
                            currentObject1.get("fill") &&
                            !accumulator1.includes(currentObject1.get("fill"))
                        ) {
                            accumulator1.push(currentObject1.get("fill"));
                        }
                        // For shapes with _objects, also count stroke (outline) color
                        if (
                            currentObject.ctype == "shape" &&
                            currentObject1.get("stroke") &&
                            currentObject1.get("stroke") !== "transparent" &&
                            currentObject1.get("stroke") !== "none" &&
                            currentObject1.get("stroke") !== "" &&
                            !accumulator1.includes(currentObject1.get("stroke"))
                        ) {
                            accumulator1.push(currentObject1.get("stroke"));
                        }
                        return accumulator1;
                    },
                    []);
                    // Also check main object's stroke for shapes with _objects
                    if (
                        currentObject.ctype == "shape" &&
                        currentObject.get("stroke") &&
                        currentObject.get("stroke") !== "transparent" &&
                        currentObject.get("stroke") !== "none" &&
                        currentObject.get("stroke") !== "" &&
                        !accumulator.includes(currentObject.get("stroke"))
                    ) {
                        accumulator.push(currentObject.get("stroke"));
                    }
                } else if (
                    currentObject.ctype == "clipart" ||
                    currentObject.ctype == "patch" ||
                    currentObject.ctype == "shape" ||
                    currentObject.ctype === "upload" ||
                    "text" in currentObject
                ) {
                    // Skip fill/stroke for uploads: their colors come from image_colors only (avoid default black from fabric Image/SVG)
                    if (currentObject.ctype !== "upload") {
                        if (
                            currentObject.get("fill") &&
                            !accumulator.includes(currentObject.get("fill"))
                        ) {
                            accumulator.push(currentObject.get("fill"));
                        }
                        // For shapes, also count stroke (outline) color
                        if (
                            currentObject.ctype == "shape" &&
                            currentObject.get("stroke") &&
                            !accumulator.includes(currentObject.get("stroke"))
                        ) {
                            accumulator.push(currentObject.get("stroke"));
                        }
                        if (
                            "text" in currentObject &&
                            currentObject.get("stroke") &&
                            !accumulator.includes(currentObject.get("stroke"))
                        ) {
                            accumulator.push(currentObject.get("stroke"));
                        }
                        if (
                            "text" in currentObject &&
                            currentObject.get("shadow") &&
                            !accumulator.includes(currentObject.get("shadow"))
                        ) {
                            accumulator.push(currentObject.get("shadow").color);
                        }
                    }
                }
                /* eslint-disable */
                if (
                    currentObject.name === "printArea" ||
                    currentObject.id === "printArea" ||
                    (currentObject.type === "rect" &&
                        currentObject.strokeDashArray) ||
                    currentObject.stroke === "dashed" ||
                    currentObject.selectable === false ||
                    (currentObject.stroke &&
                        currentObject.fill === "transparent")
                ) {
                    _this.printAreaBond = currentObject.getBoundingRect();
                }
                /* eslint-enable */
                if (accumulator.length > 0)
                    colors = [...colors, ...accumulator];
            });

            let vinylColorHexCodes = this.vinyl_color_list.map(
                (color) => color.hex
            );
            const rgba2hex = (rgba) =>
                `#${rgba
                    .match(
                        /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/
                    )
                    .slice(1)
                    .map((n, i) =>
                        (i === 3
                            ? Math.round(parseFloat(n) * 255)
                            : parseFloat(n)
                        )
                            .toString(16)
                            .padStart(2, "0")
                            .replace("NaN", "")
                    )
                    .join("")}`;
            let activeTshirtColor = localStorage.getItem("active_tshirt_color");
            colors.forEach(function (currentValue, key) {
                if (matchRgbaColor.exec(currentValue) != null) {
                    let newHexColor = rgba2hex(currentValue);
                    colors[key] = newHexColor;
                    currentValue = newHexColor;
                }
                if (
                    !_this.design_current_colors.includes(currentValue) &&
                    !vinylColorHexCodes.includes(currentValue) &&
                    !matchRgbaColor.exec(currentValue) &&
                    activeTshirtColor.toUpperCase() !=
                        currentValue.toUpperCase()
                ) {
                    _this.design_current_colors.push(currentValue);
                }
            });

            // Check if active service has is_full_color enabled
            let isFullColorService = false;
            if (
                _this.gender_groups_items &&
                _this.gender_groups_items[_this.active_gender_key]
            ) {
                const activeServiceData =
                    _this.gender_groups_items[_this.active_gender_key]
                        .activeServiceData;
                if (
                    activeServiceData &&
                    activeServiceData.is_full_color === true
                ) {
                    isFullColorService = true;
                }
            }

            // Skip color count validation for full color services
            if (!isFullColorService) {
                _this.updateColorsValidationExceed();
                if (
                    _this.colors_validation === "" &&
                    _this.design_current_colors.length > _this.colors_count
                ) {
                    _this.colors_validation =
                        "A maximum of " +
                        _this.colors_count +
                        " colors can be used on each side location for this decoration.";
                }
            } else {
                _this.colors_validation = "";
            }

            // Use current flip's stored colors when available; only use left-panel upload colors when the selected object is that upload (fixes wrong side colors after flip)
            let get_canvas_colors = {};
            try {
                get_canvas_colors = JSON.parse(
                    localStorage.getItem("canvas_design_colors") || "{}"
                );
            } catch (e) {
                get_canvas_colors = {};
            }
            const objects = this.backCanvas._objects || [];
            const uploadObjects = objects.filter(
                (o) =>
                    o.ctype === "upload" ||
                    (o.get && o.get("ctype") === "upload")
            );
            if (uploadObjects.length > 0) {
                const combined = (_this.design_current_colors || []).slice();
                uploadObjects.forEach((obj) => {
                    const raw =
                        obj.image_colors != null
                            ? obj.image_colors
                            : obj.get && obj.get("image_colors");
                    if (!raw) return;
                    try {
                        const parsed =
                            typeof raw === "string" ? JSON.parse(raw) : raw;
                        const list =
                            parsed && Array.isArray(parsed.colors)
                                ? parsed.colors
                                : [];
                        list.forEach((hex) => {
                            if (
                                hex &&
                                typeof hex === "string" &&
                                !combined.includes(hex)
                            ) {
                                combined.push(hex);
                            }
                        });
                    } catch (e) {}
                });
                if (combined.length > 0) {
                    _this.design_current_colors = combined;
                } else {
                    const storedForFlip =
                        get_canvas_colors[_this.active_flip] &&
                        Array.isArray(get_canvas_colors[_this.active_flip]) &&
                        get_canvas_colors[_this.active_flip].length > 0;
                    if (storedForFlip) {
                        _this.design_current_colors =
                            get_canvas_colors[_this.active_flip].slice();
                    }
                }
            }

            get_canvas_colors[_this.active_flip] = _this.design_current_colors;
            this.all_decoration_colors = get_canvas_colors;
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify(get_canvas_colors)
            );

            if (_this.design_box == "") {
                // Only call addDesignArea if image is available for left/right
                if (
                    _this.active_flip == "left" ||
                    _this.active_flip == "right"
                ) {
                    let hasValidImage =
                        _this.background_image &&
                        _this.background_image !== "" &&
                        _this.background_image !== "null" &&
                        _this.background_image !== null &&
                        typeof _this.background_image === "string" &&
                        _this.background_image.trim() !== "" &&
                        !_this.background_image.includes("null");
                    if (hasValidImage) {
                        _this.addDesignArea();
                    }
                } else {
                    // Front/back - always add design area
                    _this.addDesignArea();
                }
            }

            _this.checkObjectCanvas();
            _this.updateAdditionalFeesInDashboard();
        },

        prepareImprintLocations(
            disableColors = true,
            current_active_flip = null
        ) {
            let local_flip = current_active_flip
                ? current_active_flip
                : this.active_flip;
            let decoration_colors =
                this.all_decoration_colors[local_flip] || [];
            const validHexColorPattern =
                /^#(?:[0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
            const validDecorationColors = Array.isArray(decoration_colors)
                ? decoration_colors.filter(
                      (colorHex) =>
                          typeof colorHex === "string" &&
                          validHexColorPattern.test(colorHex.trim())
                  )
                : [];

            // Get custom color fee from VendorOtherServices for decoration type 1 and 2
            const decoration_type =
                this.gender_groups_items[this.active_gender_key].item
                    .decoration_type;
            const activeServiceData =
                this.gender_groups_items[this.active_gender_key]
                    .activeServiceData;
            const serviceName =
                activeServiceData && activeServiceData.name
                    ? activeServiceData.name.toLowerCase()
                    : "";

            let non_standard_fees = 0;

            // For decoration type 1 and 2, get from vendor fees (only if rollup_fee_id exists)
            if (
                decoration_type == 1 ||
                decoration_type == 5 ||
                decoration_type == 2 ||
                decoration_type == 4
            ) {
                let colorMixFeePerColor = this.getColorMixFeeFromVendorServices(
                    decoration_type,
                    serviceName
                );
                if (colorMixFeePerColor !== null && colorMixFeePerColor > 0) {
                    non_standard_fees = colorMixFeePerColor;
                }
                // No fallback - only use VendorFees with rollup_fee_id
            } else if (decoration_type == 0) {
                // For PCNA, try to get from vendor fees (only if rollup_fee_id exists)
                let colorMixFeePerColor = this.getColorMixFeeFromVendorServices(
                    decoration_type,
                    serviceName
                );
                if (colorMixFeePerColor !== null && colorMixFeePerColor > 0) {
                    non_standard_fees = colorMixFeePerColor;
                }
                // No fallback - only use VendorFees with rollup_fee_id
            }
            // For other decoration types, no fee (no fallback)

            let imprint_locations =
                this.gender_groups_items[0].imprint_locations;
            if (this.all_decoration_colors[local_flip]) {
                let locationIndex = imprint_locations.findIndex((location) => {
                    if (!location || !location.location) return false;
                    const locLower = location.location.toLowerCase().trim();
                    // Exact match
                    if (locLower === local_flip) {
                        return true;
                    }
                    // Handle compound names like "left sleeve" matching "left"
                    if (local_flip === "left" && locLower.includes("left")) {
                        return true;
                    }
                    if (local_flip === "right" && locLower.includes("right")) {
                        return true;
                    }
                    if (local_flip === "front" && locLower.includes("front")) {
                        return true;
                    }
                    if (local_flip === "back" && locLower.includes("back")) {
                        return true;
                    }
                    return false;
                });
                if (locationIndex >= 0 && decoration_colors) {
                    imprint_locations[locationIndex].colors = [];
                    validDecorationColors.forEach((colorHex) => {
                        let vendorColor = this.vendor_colors_list.find(
                            (vendorColor) =>
                                vendorColor.color_value.toLowerCase() ==
                                colorHex.toLowerCase()
                        );
                        let nonStandardColor = {
                            color_id: 0,
                            color_name: "Mix Color",
                            color_pms: "Non Standard",
                            non_standard_fee: non_standard_fees,
                            decor_upcharge: 0,
                            color_value: colorHex,
                            swatches: "",
                            category: "Non Standard",
                            shades: []
                        };
                        if (
                            imprint_locations[locationIndex].colors.length <
                            this.colors_count
                        ) {
                            imprint_locations[locationIndex].colors.push({
                                color: vendorColor || nonStandardColor,
                                color_cost: 0.0,
                                cost_cost: 0,
                                cost_sum_added: false
                            });
                        }
                    });

                    // Set no_of_color based on decoration colors length
                    if (
                        activeServiceData &&
                        activeServiceData.is_full_color === true
                    ) {
                        // For full color service, if design has more than 1 color, set to "full_color"
                        if (validDecorationColors.length > 1) {
                            imprint_locations[locationIndex].no_of_color =
                                "full_color";
                            imprint_locations[
                                locationIndex
                            ].is_full_color = true;
                            // Initialize full_color_count with actual color count
                            imprint_locations[locationIndex].full_color_count =
                                validDecorationColors.length;
                        } else if (validDecorationColors.length === 1) {
                            // If only 1 color, set to 1
                            imprint_locations[locationIndex].no_of_color = 1;
                            imprint_locations[
                                locationIndex
                            ].is_full_color = false;
                        } else {
                            // If no design colors, set to null (user will select from dropdown)
                            imprint_locations[locationIndex].no_of_color = null;
                            imprint_locations[
                                locationIndex
                            ].is_full_color = false;
                        }
                    } else {
                        imprint_locations[locationIndex].no_of_color =
                            validDecorationColors.length > 0
                                ? validDecorationColors.length
                                : null;
                        imprint_locations[locationIndex].is_full_color = false;
                    }

                    if (imprint_locations[locationIndex].no_of_color == null) {
                        imprint_locations[locationIndex].collapse = false;
                    }
                }
            }

            this.gender_groups_items[0].imprint_locations = JSON.parse(
                JSON.stringify(imprint_locations)
            );
            this.gender_groups_items[0].colors.forEach((color) => {
                color.imprint_locations = JSON.parse(
                    JSON.stringify(imprint_locations)
                );
                // Also copy full_color_count and is_full_color to all fabric colors
                color.imprint_locations.forEach((loc, idx) => {
                    if (imprint_locations[idx]) {
                        loc.full_color_count =
                            imprint_locations[idx].full_color_count;
                        loc.is_full_color =
                            imprint_locations[idx].is_full_color;
                    }
                });
            });
            if (
                this.$refs.ItemDetails &&
                typeof this.$refs.ItemDetails.calculatePricing === "function"
            ) {
                this.$refs.ItemDetails.calculatePricing(this.active_gender_key);
            }
            if (
                this.$refs.ItemDetails &&
                typeof this.$refs.ItemDetails.disableImprintLocations ===
                    "function"
            ) {
                this.$refs.ItemDetails.disableImprintLocations(disableColors);
            }
            // Restore name/number colors into right dropdowns (prepareImprintLocations may have reset current flip)
            this.$nextTick(() => {
                if (
                    this.$refs.ItemDetails &&
                    typeof this.$refs.ItemDetails
                        .syncNameNumberColorsForAllColors === "function"
                ) {
                    this.$refs.ItemDetails.syncNameNumberColorsForAllColors();
                }
                if (
                    this.$refs.ItemDetails &&
                    typeof this.$refs.ItemDetails
                        .syncNameNumberColorsToImprintLocations === "function"
                ) {
                    this.$refs.ItemDetails.syncNameNumberColorsToImprintLocations();
                }
            });
        },

        onColorDeleted(payload) {
            if (
                !payload ||
                payload.genderIndex === undefined ||
                !this.gender_groups_items[payload.genderIndex]
            ) {
                return;
            }
            this.gender_groups_items[payload.genderIndex].colors =
                payload.colors.slice();
            this.activeColorIndex = 0;
            this.user_selected_values = [];
            this.gender_groups_items.forEach((element, ind) => {
                if (element.colors && Array.isArray(element.colors)) {
                    element.colors.forEach((color) => {
                        const cost =
                            color.unique_sizes && color.unique_sizes[0]
                                ? color.unique_sizes[0].cost
                                : 0;
                        this.user_selected_values.push({
                            color_id: color.id,
                            color: color.color_name,
                            swatches: color.swatches,
                            color_hash: color.hash,
                            shades: color.shades,
                            category: color.category,
                            default_selection: color.default_selection,
                            total_qty_gender_wise: color.total_qty_gender_wise,
                            total_cost_gender_wise:
                                color.total_cost_gender_wise,
                            unit_price: cost,
                            unique_sizes: color.unique_sizes,
                            imprint_locations: color.imprint_locations,
                            gender: this.genders[ind] || ""
                        });
                    });
                }
            });
            this.$nextTick(() => {
                if (this.user_selected_values.length > 0) {
                    const first = this.user_selected_values[0];
                    this.SetColorCanvas(first.color_hash, first.color_id);
                }
            });
        },

        updatePrintAreas(selected_index = -1) {
            let active_areas = {
                front: false,
                back: false,
                left: false,
                right: false
            };
            // Use active_gender_key instead of hardcoded [0]
            let imprint_locations =
                this.gender_groups_items[this.active_gender_key || 0]
                    .imprint_locations;
            let local_selected_index = "";

            // Map imprint_locations to active_areas using label matching (not label_show)
            imprint_locations.forEach((location, key) => {
                // Find matching design area by comparing location with label (not label_show)
                let matchingArea = null;
                if (
                    this.design_area_data &&
                    Array.isArray(this.design_area_data)
                ) {
                    matchingArea = this.design_area_data.find((area) => {
                        // Match by label_show first (since imprint_locations uses label_show), then by label
                        const locationLower = location.location
                            .toLowerCase()
                            .trim();
                        const areaLabelShow = (area.label_show || "")
                            .toLowerCase()
                            .trim();
                        const areaLabel = (area.label || "")
                            .toLowerCase()
                            .trim();
                        return (
                            locationLower === areaLabelShow ||
                            locationLower === areaLabel
                        );
                    });
                }

                // Determine location key from matching area's label (not label_show)
                let locationKey = null;
                if (matchingArea) {
                    locationKey = matchingArea.label.toLowerCase().trim();
                } else {
                    // Fallback: try to match location string directly
                    const locLower = location.location.toLowerCase().trim();
                    if (locLower.includes("front") || locLower === "fron") {
                        locationKey = "front";
                    } else if (locLower.includes("back")) {
                        locationKey = "back";
                    } else if (locLower.includes("left")) {
                        locationKey = "left";
                    } else if (locLower.includes("right")) {
                        locationKey = "right";
                    }
                }

                if (locationKey && active_areas.hasOwnProperty(locationKey)) {
                    active_areas[locationKey] = location.is_selected;
                    this[`${locationKey}_show`] = location.is_selected;
                }

                if (location.is_selected && local_selected_index == "")
                    local_selected_index = key;
            });

            // Update design_area_data selected property based on imprint_locations
            if (this.design_area_data && Array.isArray(this.design_area_data)) {
                this.design_area_data.forEach((area) => {
                    const locationKey = area.label.toLowerCase().trim();
                    // Handle "Left Sleeve" and "Right Sleeve" labels
                    if (locationKey.includes("left")) {
                        this.$set(area, "selected", active_areas.left);
                    } else if (locationKey.includes("right")) {
                        this.$set(area, "selected", active_areas.right);
                    } else if (active_areas.hasOwnProperty(locationKey)) {
                        this.$set(area, "selected", active_areas[locationKey]);
                    }
                });
            }

            // Skip if called from plus icon click
            if (selected_index != -1 && !this._fromPlusIconClick) {
                if (imprint_locations[selected_index].is_selected) {
                    let viewType = imprint_locations[selected_index].location
                        .toLowerCase()
                        .trim();
                    if (viewType.includes("left")) {
                        viewType = "left";
                    } else if (viewType.includes("right")) {
                        viewType = "right";
                    } else if (viewType.includes("front")) {
                        viewType = "front";
                    } else if (viewType.includes("back")) {
                        viewType = "back";
                    }
                    if (viewType !== this.active_flip) {
                        this.flipTshirt(viewType);
                    }
                } else {
                    if (
                        local_selected_index !== "" &&
                        imprint_locations[local_selected_index] &&
                        !this._fromPlusIconClick
                    ) {
                        let viewType = imprint_locations[
                            local_selected_index
                        ].location
                            .toLowerCase()
                            .trim();
                        if (viewType.includes("left")) {
                            viewType = "left";
                        } else if (viewType.includes("right")) {
                            viewType = "right";
                        } else if (viewType.includes("front")) {
                            viewType = "front";
                        } else if (viewType.includes("back")) {
                            viewType = "back";
                        }
                        if (viewType !== this.active_flip) {
                            this.flipTshirt(viewType);
                        }
                    }
                }
            }

            if (this.$refs.printAreaIcons) {
                this.$refs.printAreaIcons.$forceUpdate();
            }
        },

        canvasBackSleeveUpdated(c) {
            this.backSleeveCanvas = c;
        },

        objMouseDown(option) {
            /* eslint-disable */
            if (typeof option.target != "undefined") {
                return;
            } else {
                var startY = option.e.offsetY,
                    startX = option.e.offsetX;
            }
            /* eslint-enable */
        },
        objMouseUp() {
            this.canvas.off("mouse:move");
        },
        imageLoaded(img) {
            this.imgHeight = img.height;
            this.imgWidth = img.width;
        },
        showImageList() {
            this.add_distress_images = true;
        },
        closeImageList() {
            this.active_class = "active";
            document
                .querySelector("#distress-effects-tab")
                .classList.remove("active");
            document
                .querySelector("#distress-effects")
                .classList.remove("active");
            document
                .querySelector("#distress-effects")
                .classList.remove("show");
            document.querySelector("#default1").classList.add("active");
            document.querySelector("#default1").classList.add("show");
            var nnTab1 = document.getElementById("nn-tab1");
            if (nnTab1) nnTab1.classList.remove("active");
            this.$forceUpdate();
        },
        async updateDistressImage(url) {
            let _this = this;
            _this.isLoader = true;
            if (!_this.backCanvas) {
                return;
            }
            if (_this.uploadModuleCanvas == 0) {
                _this.uploadModuleCanvas++;
                _this.saveCanvasData();
            }

            _this.distress_images[_this.active_flip] = url;
            _this.selectedDistressImage = url;

            try {
                let activeColor = localStorage.getItem("active_tshirt_color");
                let img = "";
                await fabric.loadSVGFromURL(
                    url,
                    async function (objects, options) {
                        objects.forEach((element) => {
                            element.fill = activeColor;
                        });
                        img = await fabric.util.groupSVGElements(
                            objects,
                            options
                        );

                        // console.log(img);
                        if (
                            _this.active_flip == "front" ||
                            _this.active_flip == "back"
                        ) {
                            img.set({
                                scaleX: _this.front_canvas_width / img.width,
                                scaleY: _this.front_canvas_height / img.height,
                                objectCaching: false,
                                left: _this.front_canvas_left,
                                top: _this.front_canvas_top,
                                originX: "left",
                                originY: "top",
                                // opacity:0.8,
                                globalCompositeOperation: "source-atop"
                            });
                        } else {
                            img.set({
                                scaleX: _this.backCanvas.getWidth() / img.width,
                                scaleY:
                                    _this.backCanvas.getHeight() / img.height,
                                objectCaching: false,
                                originX: "left",
                                originY: "top",
                                //opacity:0.2,
                                globalCompositeOperation: "source-atop"
                            });
                        }
                        _this.backCanvas.setOverlayImage(
                            img,
                            _this.backCanvas.renderAll.bind(_this.backCanvas)
                        );

                        _this.isLoader = false;
                        _this = "";
                    },
                    null,
                    { crossOrigin: "Anonymous" }
                );
            } catch (isError) {
                if (isError) {
                    _this.$toast.error(
                        "something went wrong, please choose other effect",
                        {
                            position: "top-right"
                        }
                    );
                }
                _this.isLoader = false;
            }
        },
        getLocalDesign(get_saved_design = null) {
            let _this = this;
            const preserveSavedDesignPositions =
                _this.preserveSavedDesignPositions === true;
            _this.active_flip = localStorage.getItem("active_flip");

            _this.canvasList = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );

            if (
                _this.canvasList &&
                _this.canvasList.products_id != undefined &&
                "distress_images" in _this.canvasList
            ) {
                _this.distress_images = _this.canvasList.distress_images;
                if (_this.distress_images[_this.active_flip]) {
                    this.updateDistressImage(
                        _this.distress_images[_this.active_flip]
                    );
                    this.add_distress_images = true;
                } else {
                    _this.selectedDistressImage = null;
                }
            }

            let new_product_id = localStorage.getItem("product_id");

            if (
                _this.canvasList &&
                _this.canvasList.products_id != undefined &&
                _this.canvasList.products_id != new_product_id &&
                get_saved_design == null
            ) {
                _this.canvasList = { front: "", back: "" };
                localStorage.setItem(
                    "new_canvas_elements",
                    JSON.stringify(_this.canvasList)
                );
                return false;
            }

            if (_this.canvasList == null) {
                _this.canvasList = { front: "", back: "" };
            }

            if (_this.canvasList[_this.active_flip]) {
                fabric.util.enlivenObjects(
                    JSON.parse(this.canvasList[this.active_flip]).objects,
                    function (objects) {
                        var origRenderOnAddRemove =
                            _this.backCanvas.renderOnAddRemove;
                        _this.backCanvas.renderOnAddRemove = false;
                        const descriptors = JSON.parse(
                            _this.canvasList[_this.active_flip]
                        ).objects;
                        objects.forEach(function (o, idx) {
                            let type1 = o.ctype;
                            let objType1 = o.objType;
                            let extension = o.iextension;
                            let product_id = o.product_id;
                            const desc = descriptors && descriptors[idx];
                            const patch_id = desc && desc.patch_id;
                            const material_id = desc && desc.material_id;
                            if (
                                type1 === "patch" &&
                                patch_id != null &&
                                material_id != null
                            ) {
                                if (o.set) {
                                    o.set("patch_id", patch_id);
                                    o.set("material_id", material_id);
                                } else {
                                    o.patch_id = patch_id;
                                    o.material_id = material_id;
                                }
                            }
                            o.toObject = (function (toObject) {
                                return function () {
                                    const base = {
                                        ctype: type1,
                                        objType: objType1,
                                        image_name: o.image_name,
                                        image_path: o.image_path,
                                        width_inch: o.width_inch,
                                        height_inch: o.height_inch,
                                        iextension: extension,
                                        product_id: product_id
                                    };
                                    if (
                                        type1 === "patch" &&
                                        patch_id != null &&
                                        material_id != null
                                    ) {
                                        base.patch_id = patch_id;
                                        base.material_id = material_id;
                                    }
                                    return fabric.util.object.extend(
                                        toObject.call(this),
                                        base
                                    );
                                };
                            })(o.toObject);
                            if (o.type !== "rect") {
                                _this.backCanvas.add(o);
                            }
                            // Re-apply fixed-size locks for patch objects
                            if (type1 === "patch") {
                                o.set({
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    lockUniScaling: true,
                                    hasControls: true
                                });
                                if (
                                    typeof o.setControlsVisibility ===
                                    "function"
                                ) {
                                    o.setControlsVisibility({
                                        mt: false,
                                        mb: false,
                                        ml: false,
                                        mr: false,
                                        tl: false,
                                        tr: false,
                                        bl: false,
                                        br: false,
                                        mtr: true
                                    });
                                }
                            }
                        });
                        _this.backCanvas.renderOnAddRemove =
                            origRenderOnAddRemove;
                        _this.backCanvas.preserveObjectStacking = true;
                        _this.backCanvas.renderAll();
                    }
                ); //end enlivenObjects
                // Only call addDesignArea if image is available or use_custom_box for left/right
                if (
                    _this.active_flip == "left" ||
                    _this.active_flip == "right"
                ) {
                    let hasValidImage =
                        _this.background_image &&
                        _this.background_image !== "" &&
                        _this.background_image !== "null" &&
                        _this.background_image !== null &&
                        typeof _this.background_image === "string" &&
                        _this.background_image.trim() !== "" &&
                        !_this.background_image.includes("null");

                    let currentArea = null;
                    if (
                        _this.design_area_data &&
                        Array.isArray(_this.design_area_data)
                    ) {
                        let currentFlip =
                            _this.active_flip.charAt(0).toUpperCase() +
                            _this.active_flip.slice(1);
                        currentArea = _this.design_area_data.find(function (
                            area
                        ) {
                            return area.label === currentFlip;
                        });
                    }
                    let useCustomBox =
                        currentArea && currentArea.use_custom_box === true;

                    if (hasValidImage || useCustomBox) {
                        // Get design area dimensions from design_area_data for left/right
                        let designAreaDimensions = null;
                        let designAreaElement = currentArea;

                        if (designAreaElement) {
                            if (
                                designAreaElement.width &&
                                designAreaElement.height
                            ) {
                                designAreaDimensions = {
                                    left:
                                        parseFloat(designAreaElement.left) || 0,
                                    top: parseFloat(designAreaElement.top) || 0,
                                    width: parseFloat(designAreaElement.width),
                                    height: parseFloat(
                                        designAreaElement.height
                                    ),
                                    centerX:
                                        (parseFloat(designAreaElement.left) ||
                                            0) +
                                        parseFloat(designAreaElement.width) / 2,
                                    centerY:
                                        (parseFloat(designAreaElement.top) ||
                                            0) +
                                        parseFloat(designAreaElement.height) / 2
                                };
                                // Set front_canvas variables for addDesignArea
                                _this.front_canvas_width =
                                    designAreaElement.width;
                                _this.front_canvas_height =
                                    designAreaElement.height;
                                _this.front_canvas_left =
                                    designAreaElement.left;
                                _this.front_canvas_top = designAreaElement.top;
                                _this.front_canvas_angle =
                                    designAreaElement.angle || 0;
                            } else if (useCustomBox) {
                                // use_custom_box: dimensions from admin; position (0,0) to match canvas coords
                                let fallbackDim =
                                    _this.getEffectiveDesignAreaDimensionsForFlip(
                                        _this.active_flip
                                    );
                                if (fallbackDim) {
                                    designAreaDimensions = {
                                        left: 0,
                                        top: 0,
                                        width: fallbackDim.width,
                                        height: fallbackDim.height,
                                        centerX: fallbackDim.width / 2,
                                        centerY: fallbackDim.height / 2
                                    };
                                    _this.front_canvas_width =
                                        fallbackDim.width;
                                    _this.front_canvas_height =
                                        fallbackDim.height;
                                    _this.front_canvas_left = 0;
                                    _this.front_canvas_top = 0;
                                    _this.front_canvas_angle = 0;
                                }
                            }
                        }

                        _this.addDesignArea();

                        // Apply clipPath and center/resize objects for left/right with image (name-number alag)
                        if (designAreaDimensions && _this.design_box) {
                            _this.backCanvas
                                .getObjects()
                                .forEach(function (obj) {
                                    if (obj.type !== "rect") {
                                        if (_this.isNameNumberObject(obj))
                                            return;
                                        // Calculate scale to fit object within 80% of design area
                                        let objWidth =
                                            obj.width * (obj.scaleX || 1);
                                        let objHeight =
                                            obj.height * (obj.scaleY || 1);
                                        let maxWidth =
                                            designAreaDimensions.width * 0.8;
                                        let maxHeight =
                                            designAreaDimensions.height * 0.8;

                                        if (objWidth > 0 && objHeight > 0) {
                                            let scaleX = maxWidth / objWidth;
                                            let scaleY = maxHeight / objHeight;
                                            let scale = Math.min(
                                                scaleX,
                                                scaleY,
                                                1
                                            );

                                            if (scale < 1) {
                                                obj.set({
                                                    scaleX:
                                                        (obj.scaleX || 1) *
                                                        scale,
                                                    scaleY:
                                                        (obj.scaleY || 1) *
                                                        scale
                                                });
                                            }
                                        }

                                        if (!preserveSavedDesignPositions) {
                                            obj.set({
                                                left: designAreaDimensions.centerX,
                                                top: designAreaDimensions.centerY,
                                                originX: "center",
                                                originY: "center"
                                            });
                                        }

                                        // Apply clipPath
                                        obj.set("clipPath", _this.design_box);
                                        obj.setCoords();
                                    }
                                });
                            // Preserve name/number position on view switch - only re-apply clipPath
                            if (_this.design_box) {
                                _this.backCanvas
                                    .getObjects()
                                    .forEach(function (obj) {
                                        if (
                                            obj.type !== "rect" &&
                                            _this.isNameNumberObject(obj)
                                        ) {
                                            obj.set(
                                                "clipPath",
                                                _this.design_box
                                            );
                                            obj.setCoords();
                                        }
                                    });
                            }
                        }
                        _this.backCanvas.renderAll();
                    } else {
                        // No image - clear clipPath and center in visible design area (resized canvas)
                        let centerX = _this.effectiveDesignAreaWidth / 2;
                        let centerY = _this.effectiveDesignAreaHeight / 2;
                        _this.backCanvas.getObjects().forEach(function (obj) {
                            if (obj.type !== "rect") {
                                if (_this.isNameNumberObject(obj)) return;
                                if (obj.clipPath) {
                                    obj.set("clipPath", null);
                                }
                                if (!preserveSavedDesignPositions) {
                                    obj.set({
                                        left: centerX,
                                        top: centerY,
                                        originX: "center",
                                        originY: "center"
                                    });
                                }
                                obj.setCoords();
                            }
                        });
                        _this.centerNameNumberInVisibleArea();
                        _this.backCanvas.renderAll();
                    }
                } else {
                    let hasValidImage =
                        _this.background_image &&
                        _this.background_image !== "" &&
                        _this.background_image !== "null" &&
                        _this.background_image !== null &&
                        typeof _this.background_image === "string" &&
                        _this.background_image.trim() !== "" &&
                        !_this.background_image.includes("null");

                    let currentAreaFrontBack = null;
                    if (
                        _this.design_area_data &&
                        Array.isArray(_this.design_area_data)
                    ) {
                        let currentFlip =
                            _this.active_flip.charAt(0).toUpperCase() +
                            _this.active_flip.slice(1);
                        currentAreaFrontBack = _this.design_area_data.find(
                            function (area) {
                                return area.label === currentFlip;
                            }
                        );
                    }
                    let useCustomBoxFrontBack =
                        currentAreaFrontBack &&
                        currentAreaFrontBack.use_custom_box === true;

                    if (hasValidImage || useCustomBoxFrontBack) {
                        if (useCustomBoxFrontBack && !hasValidImage) {
                            let fallbackDim =
                                _this.getEffectiveDesignAreaDimensionsForFlip(
                                    _this.active_flip
                                );
                            if (fallbackDim) {
                                _this.front_canvas_width = fallbackDim.width;
                                _this.front_canvas_height = fallbackDim.height;
                                _this.front_canvas_left = 0;
                                _this.front_canvas_top = 0;
                                _this.front_canvas_angle = 0;
                            }
                        }
                        _this.addDesignArea();

                        // Center and resize objects within print area for front/back
                        if (
                            _this.design_box &&
                            _this.front_canvas_width &&
                            _this.front_canvas_height
                        ) {
                            let designAreaCenter = {
                                centerX:
                                    parseFloat(_this.front_canvas_left) +
                                    parseFloat(_this.front_canvas_width) / 2,
                                centerY:
                                    parseFloat(_this.front_canvas_top) +
                                    parseFloat(_this.front_canvas_height) / 2,
                                width: parseFloat(_this.front_canvas_width),
                                height: parseFloat(_this.front_canvas_height)
                            };

                            _this.backCanvas
                                .getObjects()
                                .forEach(function (obj) {
                                    if (obj.type !== "rect") {
                                        if (_this.isNameNumberObject(obj))
                                            return;
                                        let objWidth =
                                            obj.width * (obj.scaleX || 1);
                                        let objHeight =
                                            obj.height * (obj.scaleY || 1);
                                        let maxWidth =
                                            designAreaCenter.width * 0.8;
                                        let maxHeight =
                                            designAreaCenter.height * 0.8;

                                        if (objWidth > 0 && objHeight > 0) {
                                            let scaleX = maxWidth / objWidth;
                                            let scaleY = maxHeight / objHeight;
                                            let scale = Math.min(
                                                scaleX,
                                                scaleY,
                                                1
                                            );

                                            if (scale < 1) {
                                                obj.set({
                                                    scaleX:
                                                        (obj.scaleX || 1) *
                                                        scale,
                                                    scaleY:
                                                        (obj.scaleY || 1) *
                                                        scale
                                                });
                                            }
                                        }

                                        if (!preserveSavedDesignPositions) {
                                            obj.set({
                                                left: designAreaCenter.centerX,
                                                top: designAreaCenter.centerY,
                                                originX: "center",
                                                originY: "center"
                                            });
                                        }

                                        obj.set("clipPath", _this.design_box);
                                        obj.setCoords();
                                    }
                                });
                            _this.centerNameNumberInDesignArea();
                        }
                        _this.backCanvas.renderAll();
                    } else {
                        let centerX = _this.effectiveDesignAreaWidth / 2;
                        let centerY = _this.effectiveDesignAreaHeight / 2;
                        _this.backCanvas.getObjects().forEach(function (obj) {
                            if (obj.type !== "rect") {
                                if (_this.isNameNumberObject(obj)) return;
                                if (obj.clipPath) {
                                    obj.set("clipPath", null);
                                }
                                if (!preserveSavedDesignPositions) {
                                    obj.set({
                                        left: centerX,
                                        top: centerY,
                                        originX: "center",
                                        originY: "center"
                                    });
                                }
                                obj.setCoords();
                            }
                        });
                        _this.centerNameNumberInVisibleArea();
                        _this.backCanvas.renderAll();
                        // Preserve name/number position on view switch - only re-apply clipPath
                        if (_this.design_box) {
                            _this.backCanvas
                                .getObjects()
                                .forEach(function (obj) {
                                    if (
                                        obj.type !== "rect" &&
                                        _this.isNameNumberObject(obj)
                                    ) {
                                        obj.set("clipPath", _this.design_box);
                                        obj.setCoords();
                                    }
                                });
                        }
                    }
                }
            }
        },
        getStoreDesign() {
            let _this = this;
            _this.active_flip = localStorage.getItem("active_flip");

            let canvasObject = JSON.stringify(_this.backCanvas);
            let canvasList1 = {};

            let previouscanvasList = {};
            previouscanvasList = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );
            if (previouscanvasList != null) {
                if (
                    previouscanvasList["front"] != null &&
                    _this.active_flip != "front"
                ) {
                    canvasList1["front"] = previouscanvasList["front"];
                }
                if (
                    previouscanvasList["back"] != null &&
                    _this.active_flip != "back"
                ) {
                    canvasList1["back"] = previouscanvasList["back"];
                }
                if (
                    previouscanvasList["left"] != null &&
                    _this.active_flip != "left"
                ) {
                    canvasList1["left"] = previouscanvasList["left"];
                }
                if (
                    previouscanvasList["right"] != null &&
                    _this.active_flip != "right"
                ) {
                    canvasList1["right"] = previouscanvasList["right"];
                }
            }
            canvasList1[_this.active_flip] = canvasObject;
            canvasList1["products_id"] = localStorage.getItem("product_id");
            canvasList1["distress_images"] = _this.distress_images;
            if (canvasList1["distress_images"][_this.active_flip]) {
                _this.add_distress_images = true;
            }
            localStorage.setItem(
                "new_canvas_elements",
                JSON.stringify(canvasList1)
            );
        },
        getClipartCliparts(category_id, clipart_category_name) {
            var _this = this;
            _this.isLoader = true;
            new Promise(() => {
                ApiService.post("/all-designStudioCliparts/" + category_id)
                    .then(({ data }) => {
                        _this.isLoader = false;
                        const rows =
                            (data.clipart_list && data.clipart_list.rows) || [];
                        if (rows.length === 0) {
                            // Subcategory has no cliparts (incl. edit back case): show main category list
                            _this.cliparts = [];
                            _this.clipart_subcategory_div = false;
                            _this.clipart_category_div = true;
                            _this.clipart_name = "";
                            _this.category_heading = true;
                            _this.selected_category_heading = false;
                        } else {
                            _this.cliparts = rows;
                            _this.clipart_subcategory_div = true;
                            _this.clipart_category_div = false;
                            _this.selected_clipart_category_id = category_id;
                            _this.clipart_category_name = clipart_category_name;
                        }
                    })
                    .catch((response) => {
                        _this.isLoader = false;
                        // console.log(response);
                    });
            });
        },
        auto_grow(element) {
            element.style.height = "5px";
            element.style.height = element.scrollHeight + "px";
        },

        //add_text tab
        signalChange(e) {
            document.querySelector("#rotationValue").value = Number(
                e.target.value
            );
            document.querySelector("#rotationValueInput").value = Number(
                e.target.value
            );
        },
        open_text_tab(tab) {
            if (tab == "add_text") {
                this.add_text = true;
                this.text_shape = false;
            } else if (tab == "text_shape") {
                this.add_text = false;
                this.text_shape = true;
            }
        },
        zoomin() {
            this.zoom_in = 1;
            this.zoom_out = 0;
            /* eslint-disable */
            if (this.zoom >= 1.15) {
                return false;
            } else {
                this.zoom += 0.05;
                if (typeof $ !== "undefined" && $(".images-barr").length) {
                    $(".images-barr").slider({ value: this.zoom });
                }
            }
            /* eslint-enable */
        },
        resize() {
            setTimeout(function () {
                if (window.canvas) window.canvas.calcOffset();
            }, 200);
        },
        zoomout() {
            this.zoom_out = 1;
            this.zoom_in = 0;
            /* eslint-disable */
            if (this.zoom <= 0.8) {
                return false;
            } else {
                this.zoom -= 0.05;
                if (typeof $ !== "undefined" && $(".images-barr").length) {
                    $(".images-barr").slider({ value: this.zoom });
                }
            }
            /* eslint-enable */
        },
        //ZOOM end
        // Image (product preview) zoom: scroll to zoom, drag overlay to pan
        onImageZoomModeChange() {
            this.$nextTick(() => {
                if (this.imageZoomMode) {
                    this.enableImageZoomPan();
                } else {
                    this.disableImageZoomPan();
                }
            });
        },
        // Turn off Image Zoom toggle when user adds any design (so they can interact with the new design)
        turnOffImageZoomIfActive() {
            if (this.imageZoomMode) {
                this.imageZoomMode = false;
                this.disableImageZoomPan();
            }
        },
        onImageZoomWheel(e) {
            if (!this.imageZoomMode) return;
            const delta = e.deltaY > 0 ? -0.08 : 0.08;
            let z = (this.zoom != null ? this.zoom : 1) + delta;
            z = Math.min(this.imageZoomMax, Math.max(this.imageZoomMin, z));
            this.zoom = z;
            if (typeof $ !== "undefined" && $(".images-barr").length) {
                $(".images-barr").slider({ value: this.zoom });
            }
        },
        onImagePanStart(e) {
            if (!this.imageZoomMode) return;
            this.isImagePanning = true;
            this.imagePanLast = { x: e.clientX, y: e.clientY };
            this.enableImageZoomPan();
        },
        enableImageZoomPan() {
            if (this._imagePanMoveHandler) return;
            const _this = this;
            this._imagePanMoveHandler = function (e) {
                if (!_this.isImagePanning || !_this.imagePanLast) return;
                _this.imagePanX =
                    (_this.imagePanX || 0) + (e.clientX - _this.imagePanLast.x);
                _this.imagePanY =
                    (_this.imagePanY || 0) + (e.clientY - _this.imagePanLast.y);
                _this.imagePanLast = { x: e.clientX, y: e.clientY };
            };
            this._imagePanUpHandler = function () {
                _this.isImagePanning = false;
                _this.imagePanLast = null;
                document.removeEventListener(
                    "mousemove",
                    _this._imagePanMoveHandler
                );
                document.removeEventListener(
                    "mouseup",
                    _this._imagePanUpHandler
                );
                _this._imagePanMoveHandler = null;
                _this._imagePanUpHandler = null;
            };
            document.addEventListener("mousemove", this._imagePanMoveHandler);
            document.addEventListener("mouseup", this._imagePanUpHandler);
        },
        disableImageZoomPan() {
            if (this._imagePanMoveHandler) {
                document.removeEventListener(
                    "mousemove",
                    this._imagePanMoveHandler
                );
            }
            if (this._imagePanUpHandler) {
                document.removeEventListener(
                    "mouseup",
                    this._imagePanUpHandler
                );
            }
            this._imagePanMoveHandler = null;
            this._imagePanUpHandler = null;
            this.isImagePanning = false;
            this.imagePanLast = null;
            this.imagePanX = 0;
            this.imagePanY = 0;
            this.zoom = 1;
            if (typeof $ !== "undefined" && $(".images-barr").length) {
                $(".images-barr").slider({ value: 1 });
            }
        },
        //croppie function start
        bind() {
            // Randomize cat photos, nothing special here.
            /* eslint-disable */
            let url = this.images[Math.floor(Math.random() * 4)];
            this.$refs.croppieRef.bind({
                url: "/maincss/design-studio/img/design-st-upload.jpg"
            });
            fabricImageFromUrl;
            /* eslint-enable */
        },
        rotate(rotationAngle) {
            // Rotates the image
            this.$refs.croppieRef.rotate(rotationAngle);
        },
        croppie(e) {
            var _this = this;
            /* eslint-disable */
            $(".cr-slider").prop("disabled", false);
            /* eslint-enable */
            var files = e.target.files || e.dataTransfer.files;
            if (files && !files.length) return;
            this.image_size = files[0].size / (1024 * 1024);
            if (parseInt(this.image_size) > 5) {
                this.$toast.error(
                    "Size exceeded. Please upload image upto 5MB size."
                );
                return;
            }

            if (
                ![
                    "image/svg+xml",
                    "image/jpeg",
                    "image/png",
                    "image/jpg"
                ].includes(files[0]["type"])
            ) {
                this.$toast.error("Please upload jpeg, png, jpg only.", {
                    position: "top-right"
                });
            } else {
                this.crop_image_validation = 0;
                var file = files[0];
                var reader = new FileReader();
                reader.onload = (e) => {
                    var image = new Image();
                    image.src = e.target.result;
                    image.onload = () => {
                        _this.uploaded_design_image = e.target.result;
                        _this.image_size_validation = 0;

                        this.image_uploaded = {
                            image: e.target.result,
                            size: _this.image_size.toFixed(2) + "MB",
                            dimension: image.width + "x" + image.height,
                            image_name: this.uploaded_image_name
                        };
                        // Set temp upload file so ColorThief can extract colors after API success
                        this.tempUploadedFile = {
                            type: file.type,
                            imageElement: image
                        };
                        var extractedColors = [];
                        var isRaster =
                            file.type &&
                            file.type.match(/^image\/(jpeg|png|jpg|webp)$/i);
                        if (isRaster && image) {
                            try {
                                var colorThief = new ColorThief();
                                var palette = colorThief.getPalette(image, 6);
                                if (palette && palette.length > 0) {
                                    extractedColors = (palette || []).map(
                                        function (rgb) {
                                            var r = rgb[0];
                                            var g = rgb[1];
                                            var b = rgb[2];
                                            return (
                                                "#" +
                                                [r, g, b]
                                                    .map(function (x) {
                                                        return x
                                                            .toString(16)
                                                            .padStart(2, "0");
                                                    })
                                                    .join("")
                                            );
                                        }
                                    );
                                }
                            } catch (err) {}
                        }
                        extractedColors = _this.dedupeColors(extractedColors);
                        _this.uploadedImageTopColors = extractedColors;
                        _this.foundColorsCount = extractedColors.length;
                        _this.uploadDraftDirty = true;
                    };
                };
            }

            reader.readAsDataURL(files[0]);
        },
        croppie_upload_image(e) {
            var files = e.target.files || e.dataTransfer.files;
            var _this = this;
            /* eslint-disable */
            $(".cr-slider").prop("disabled", false);
            /* eslint-enable */
            if (files && !files.length) return;
            var file = files[0];
            this.image_size = file.size / (1024 * 1024);
            if (parseInt(this.image_size) > 5) {
                this.$toast.error(
                    "Size exceeded. Please upload image upto 5MB size."
                );
                return;
            }

            // if (
            //     ![
            //         "image/svg+xml",
            //     ].includes(files[0]["type"])
            // ) {
            //     this.$toast.error("Please upload svg only.", {
            //         position: "top-right"
            //     });
            // } else {
            this.crop_image_validation = 0;
            var reader = new FileReader();
            reader.onload = (e) => {
                var image = new Image();
                image.src = e.target.result;
                image.onload = () => {
                    _this.uploaded_design_image = e.target.result;
                    _this.image_size_validation = 0;

                    this.image_uploaded = {
                        image: e.target.result,
                        size: _this.image_size.toFixed(2) + "MB",
                        dimension: image.width + "x" + image.height,
                        image_name: this.uploaded_image_name
                    };
                    // Set temp upload file so ColorThief can extract colors after API success
                    this.tempUploadedFile = {
                        type: file.type,
                        imageElement: image
                    };

                    var extractedColors = [];
                    var isRaster =
                        file.type &&
                        file.type.match(/^image\/(jpeg|png|jpg|webp)$/i);
                    if (isRaster && image) {
                        try {
                            var colorThief = new ColorThief();
                            var palette = colorThief.getPalette(image, 6);
                            if (palette && palette.length > 0) {
                                extractedColors = (palette || []).map(function (
                                    rgb
                                ) {
                                    var r = rgb[0];
                                    var g = rgb[1];
                                    var b = rgb[2];
                                    return (
                                        "#" +
                                        [r, g, b]
                                            .map(function (x) {
                                                return x
                                                    .toString(16)
                                                    .padStart(2, "0");
                                            })
                                            .join("")
                                    );
                                });
                            }
                        } catch (err) {}
                    }
                    extractedColors = _this.dedupeColors(extractedColors);
                    _this.uploadedImageTopColors = extractedColors;
                    _this.foundColorsCount = extractedColors.length;
                    _this.uploadDraftDirty = true;
                };
            };
            //}

            reader.readAsDataURL(file);
        },
        crop() {
            this.image_width = 200;
            this.image_height = 200;
            let options = {
                type: "base64",
                size: { width: this.image_width, height: this.image_height },
                format: "svg"
            };
            this.$refs.croppieRef.result(options, (output) => {
                this.croppieImage = output;
                this.image_uploaded = {
                    image: this.croppieImage,
                    size: this.image_size.toFixed(2) + "MB",
                    dimension: this.image_width + "x" + this.image_height
                };
            });
            this.uploadDraftDirty = true;
        },
        //croppie function end

        //api method
        getTemplateData() {
            //get all template data
            /* eslint-disable */
            let product_type_temp_id = 0;
            product_type_temp_id = this.active_product_type;
            let productId = product_type_temp_id ? product_type_temp_id : 0;
            /* eslint-enable */
            ApiService.get("/all-data-template")
                .then(({ data }) => {
                    this.templates = data.all_data.templates;

                    // If active_product_type is null, show all templates (skip filtering)
                    if (!this.active_product_type) {
                        // Keep all templates as is - no filtering
                        return;
                    }

                    let filtered_templates = [];
                    this.templates.forEach((template) => {
                        let subCategories = [];
                        template.DesignStudioTemplateSubCategories.forEach(
                            (subCat) => {
                                subCat.DesignStudioSaveTemplateModels =
                                    subCat.DesignStudioSaveTemplateModels.filter(
                                        (image) =>
                                            image.product_type_id ==
                                            this.active_product_type
                                    );
                                if (
                                    subCat.DesignStudioSaveTemplateModels
                                        .length > 0
                                ) {
                                    subCategories.push(subCat);
                                }
                            }
                        );
                        if (subCategories.length > 0) {
                            template.DesignStudioTemplateSubCategories =
                                subCategories;
                            filtered_templates.push(template);
                        }
                    });
                    this.templates = filtered_templates;
                })
                .catch(({ response }) => {
                    // console.log(response);
                });
            //get saved designs
            if (this.isAuthenticatedClient) {
                ApiService.post("/saved-designs")
                    .then(({ data }) => {
                        this.savedDesigns = data.savedDesigns;
                        this.design_count = this.savedDesigns
                            ? this.savedDesigns.length
                            : 0;
                    })
                    .catch(({ response }) => {
                        // console.log(response);
                    });
            }
        },
        refetchClipartCategories() {
            return ApiService.get("/all-data")
                .then(({ data }) => {
                    this.clipart_category = data.all_data.cliparts || [];
                    return data;
                })
                .catch(({ response }) => {
                    // console.log(response);
                });
        },
        getData() {
            //get all
            ApiService.get("/all-data")
                .then(({ data }) => {
                    this.clipart_category = data.all_data.cliparts;
                    this.shapes = data.all_data.shapes;
                    this.patches = data.all_data.patches;
                })
                .catch(({ response }) => {
                    // console.log(response);
                });
            //get saved designs
            if (this.isAuthenticatedClient) {
                ApiService.post("/saved-designs")
                    .then(({ data }) => {
                        this.savedDesigns = data.savedDesigns;
                        this.design_count = this.savedDesigns
                            ? this.savedDesigns.length
                            : 0;
                    })
                    .catch(({ response }) => {
                        // console.log(response);
                    });
            }
        },
        // Add Patch (New): load materials and patches by material
        loadPatchNewData() {
            const _this = this;
            _this.patchNewLoading = true;
            _this.patchMaterialsNew = [];
            _this.patchesByMaterialNew = {};
            ApiService.get("/all-designStudioPatchMaterials")
                .then(({ data }) => {
                    const materials =
                        data.material_list && data.material_list.rows
                            ? data.material_list.rows
                            : [];
                    _this.patchMaterialsNew = materials;
                    if (materials.length === 0) {
                        _this.patchNewLoading = false;
                        return;
                    }
                    const promises = materials.map((m) =>
                        ApiService.get("/patches-by-material/" + m.id).then(
                            (res) => ({ materialId: m.id, data: res.data })
                        )
                    );
                    return Promise.all(promises);
                })
                .then((results) => {
                    if (results && Array.isArray(results)) {
                        results.forEach((r) => {
                            const rows =
                                r.data.patch_list && r.data.patch_list.rows
                                    ? r.data.patch_list.rows
                                    : [];
                            _this.$set(
                                _this.patchesByMaterialNew,
                                r.materialId,
                                rows
                            );
                        });
                    }
                    _this.patchNewLoading = false;
                })
                .catch((err) => {
                    console.error("Add Patch (New) load error:", err);
                    _this.patchNewLoading = false;
                });
        },
        loadDsPatchInventory() {
            return ApiService.get("/my-patch-inventory")
                .then(({ data }) => {
                    this.dsPatchInventory = (data.inventory || []).filter(
                        (inv) => inv.remaining_quantity > 0
                    );
                })
                .catch(() => {
                    this.dsPatchInventory = [];
                });
        },
        placeInventoryPatch(inv) {
            if (!inv.patch || !inv.patch.image_path) return;
            const patchData = {
                id: inv.patch_id,
                image_name: inv.patch.image_name,
                image_path: inv.patch.image_path,
                width: inv.width || inv.patch.width,
                height: inv.height || inv.patch.height,
                material_id: inv.patch_material_id,
                inventory_id: inv.id,
                inventory_remaining: inv.remaining_quantity
            };
            this.placeImage(
                null,
                inv.patch.image_path,
                inv.patch.image_path,
                0,
                "patch",
                patchData
            );
        },
        toggleMaterialNew(materialId) {
            const isOpen = this.expandedMaterialIdsNew.indexOf(materialId) >= 0;
            if (isOpen) {
                this.expandedMaterialIdsNew = [];
            } else {
                this.expandedMaterialIdsNew = [materialId];
            }
        },
        filteredPatchesByMaterial(materialId) {
            const list = this.patchesByMaterialNew[materialId] || [];
            const q = (this.patchNewSearchQuery || "").trim().toLowerCase();
            if (!q) return list;
            const material = this.patchMaterialsNew.find(
                (m) => m.id === materialId
            );
            const materialName =
                material && material.name
                    ? material.name.toString().toLowerCase()
                    : "";
            const materialMatches = materialName.indexOf(q) !== -1;
            if (materialMatches) return list;
            return list.filter((p) => {
                const name = (p.image_name || p.name || "")
                    .toString()
                    .toLowerCase();
                return name.indexOf(q) !== -1;
            });
        },
        clearPatchNewSearch() {
            this.patchNewSearchQuery = "";
            this.expandedMaterialIdsNew = [];
        },
        // Patch price: get patch objects from ALL locations (not just active canvas)
        getPatchesFromCanvas() {
            const allPatches = [];
            const activeFlip = this.active_flip || "front";

            // 1. Collect patches from the ACTIVE canvas (live, may have unsaved changes)
            const canvas = this.backCanvas;
            if (canvas) {
                const objects =
                    (typeof canvas.getObjects === "function"
                        ? canvas.getObjects()
                        : canvas._objects || []) || [];
                const getVal = (o, key) =>
                    o.get && typeof o.get === "function" ? o.get(key) : o[key];
                objects.forEach((o) => {
                    const ctype = getVal(o, "ctype");
                    const pid = getVal(o, "patch_id");
                    const mid = getVal(o, "material_id");
                    if (
                        ctype === "patch" &&
                        pid != null &&
                        pid !== "" &&
                        mid != null &&
                        mid !== ""
                    ) {
                        allPatches.push({
                            patch_id: pid,
                            material_id: mid,
                            location: activeFlip
                        });
                    }
                });
            }

            // 2. Collect patches from OTHER locations via saved canvas data (localStorage)
            try {
                const stored = localStorage.getItem("new_canvas_elements");
                if (stored) {
                    const canvasData = JSON.parse(stored);
                    const locations = ["front", "back", "left", "right"];
                    locations.forEach((loc) => {
                        if (loc === activeFlip) return; // already counted from live canvas
                        if (canvasData[loc] && canvasData[loc] !== "") {
                            try {
                                const parsed = JSON.parse(canvasData[loc]);
                                if (
                                    parsed &&
                                    parsed.objects &&
                                    Array.isArray(parsed.objects)
                                ) {
                                    parsed.objects.forEach((obj) => {
                                        if (
                                            obj.ctype === "patch" &&
                                            obj.patch_id != null &&
                                            obj.patch_id !== "" &&
                                            obj.material_id != null &&
                                            obj.material_id !== ""
                                        ) {
                                            allPatches.push({
                                                patch_id: obj.patch_id,
                                                material_id: obj.material_id,
                                                location: loc
                                            });
                                        }
                                    });
                                }
                            } catch (e) {
                                /* skip malformed location data */
                            }
                        }
                    });
                }
            } catch (e) {
                /* skip localStorage read error */
            }

            return allPatches;
        },
        getSlabForQuantity(qty) {
            const slabs = [50, 100, 250, 500, 1000, 2500, 5000];
            const n = parseInt(qty, 10) || 0;
            const found = slabs.find((s) => s >= n);
            return found != null ? found : slabs[slabs.length - 1];
        },
        fetchPatchPricesForMaterial(materialId) {
            if (this.patchPriceCache[materialId]) return Promise.resolve();
            return ApiService.get(
                "/all-patches-with-prices?material_id=" + materialId
            )
                .then(({ data }) => {
                    const byPatch = {};
                    (data.patches || []).forEach((p) => {
                        const patchKey =
                            typeof p.id === "number"
                                ? p.id
                                : parseInt(p.id, 10);
                        byPatch[patchKey] = {
                            name: p.image_name || p.name || "Patch " + p.id,
                            width: p.width || null,
                            height: p.height || null
                        };
                        (p.prices || []).forEach((pr) => {
                            const qtyKey = Number(pr.quantity);
                            if (!isNaN(qtyKey)) {
                                byPatch[patchKey][qtyKey] = {
                                    retail_price:
                                        parseFloat(pr.retail_price) || 0,
                                    net_price: parseFloat(pr.net_price) || 0
                                };
                            }
                        });
                    });
                    this.$set(this.patchPriceCache, materialId, byPatch);
                })
                .catch((err) => {
                    console.warn(
                        "Patch prices fetch failed for material " + materialId,
                        err && err.message ? err.message : err
                    );
                });
        },
        ensurePatchMaterialsLoaded() {
            if ((this.patchMaterialsNew || []).length > 0) {
                return Promise.resolve();
            }
            return ApiService.get("/all-designStudioPatchMaterials")
                .then(({ data }) => {
                    const materials =
                        data.material_list && data.material_list.rows
                            ? data.material_list.rows
                            : [];
                    this.patchMaterialsNew = materials;
                })
                .catch(() => {
                    this.patchMaterialsNew = [];
                });
        },
        getNearestPatchSlabPrice(patchData, targetSlab) {
            if (!patchData || !targetSlab) return { slabPrice: null, usedSlab: 0 };
            const availableSlabs = Object.keys(patchData)
                .map((k) => Number(k))
                .filter((n) => !isNaN(n) && n > 0)
                .sort((a, b) => a - b);
            if (!availableSlabs.length) return { slabPrice: null, usedSlab: 0 };

            const greaterOrEqual = availableSlabs.find((s) => s >= targetSlab);
            const usedSlab =
                greaterOrEqual != null
                    ? greaterOrEqual
                    : availableSlabs[availableSlabs.length - 1];
            return {
                slabPrice: patchData[usedSlab] || null,
                usedSlab: usedSlab
            };
        },
        calculatePatchCost() {
            const patches = this.getPatchesFromCanvas();
            if (patches.length === 0) {
                this.patchCostTotal = 0;
                this.patchCostWarning = "";
                this.patchCostTooltipText = "";
                this.patchSlabQuantity = 0;
                this.patchCostDetails = [];
                this.$nextTick(() => {
                    if (
                        this.$refs.ItemDetails &&
                        typeof this.$refs.ItemDetails.updatePatchInBreakdown ===
                            "function"
                    ) {
                        this.$refs.ItemDetails.updatePatchInBreakdown();
                    }
                });
                return;
            }
            const materialIds = [...new Set(patches.map((p) => p.material_id))];
            Promise.all(
                [
                    this.ensurePatchMaterialsLoaded(),
                    ...materialIds.map((mid) =>
                        this.fetchPatchPricesForMaterial(mid)
                    )
                ]
            ).then(() => {
                const gender =
                    this.gender_groups_items &&
                    this.gender_groups_items[this.active_gender_key];
                const totalQty =
                    gender && gender.total_qty
                        ? parseInt(gender.total_qty, 10)
                        : 0;
                const slab = this.getSlabForQuantity(totalQty);
                this.patchSlabQuantity = slab;
                if (totalQty > 0 && totalQty < 50) {
                    this.patchCostWarning =
                        "Minimum 50 patches are required for the selected product.";
                } else {
                    this.patchCostWarning = "";
                }
                let total = 0;
                const details = [];
                const pidNum = (id) =>
                    typeof id === "number" ? id : parseInt(id, 10);
                const materialNameById = new Map(
                    (this.patchMaterialsNew || []).map((m) => [
                        String(m.id),
                        m.name
                    ])
                );
                const inventoryList = this.dsPatchInventory || [];
                patches.forEach(({ patch_id, material_id, location }) => {
                    const mid = pidNum(material_id);
                    const pid = pidNum(patch_id);
                    const patchData =
                        this.patchPriceCache[mid] &&
                        this.patchPriceCache[mid][pid];
                    if (!patchData) return;
                    const { slabPrice, usedSlab } =
                        this.getNearestPatchSlabPrice(patchData, slab);
                    const perPatchPrice =
                        slabPrice && slabPrice.retail_price != null
                            ? parseFloat(slabPrice.retail_price)
                            : 0;
                    let available = 0;
                    inventoryList.forEach((inv) => {
                        if (
                            inv.patch_id === pid &&
                            inv.patch_material_id === mid
                        ) {
                            available += parseInt(
                                inv.remaining_quantity || 0,
                                10
                            );
                        }
                    });

                    // New rule: inventory can fully cover product qty without slab charging.
                    const inventorySufficient = totalQty <= available;
                    const inventoryUsed = inventorySufficient
                        ? totalQty
                        : available;
                    const billableQty = totalQty > 0 ? Math.max(totalQty, 50) : 0;
                    const chargedQty = inventorySufficient
                        ? 0
                        : Math.max(0, billableQty - inventoryUsed);
                    const lineTotal = perPatchPrice * chargedQty;
                    total += lineTotal;
                    const patchName = patchData.name || "Patch " + pid;
                    const materialName =
                        materialNameById.get(String(material_id)) || "";
                    const loc = location
                        ? location.charAt(0).toUpperCase() + location.slice(1)
                        : "";
                    const detailTotalQty = totalQty;
                    details.push({
                        patchName,
                        materialName,
                        width: patchData.width || null,
                        height: patchData.height || null,
                        slab: usedSlab || slab,
                        quantity: detailTotalQty,
                        perPatchPrice,
                        total: lineTotal,
                        location: loc,
                        patch_id: pid,
                        material_id: mid,
                        totalQty: detailTotalQty,
                        inventory_used: inventoryUsed,
                        charged_quantity: chargedQty
                    });
                });
                this.patchCostTotal = parseFloat(total.toFixed(2));
                this.patchCostDetails = details;
                const hasInventoryUsed = details.some(
                    (d) => (d.inventory_used || 0) > 0
                );
                this.patchCostTooltipText =
                    "Based on product quantity slab (50, 100, 250, 500, 1000, 2500, 5000). Quantity slab used: " +
                    slab +
                    (hasInventoryUsed
                        ? ". Patches from your inventory are used first; you are charged only for additional patches needed."
                        : ". Patch cost = sum of (per-patch price × charged qty) for each patch.");
                if (totalQty > 0 && totalQty < 50) {
                    this.patchCostTooltipText +=
                        " Minimum 50 patches required for accurate pricing.";
                }
                this.$nextTick(() => {
                    if (
                        this.$refs.ItemDetails &&
                        typeof this.$refs.ItemDetails.updatePatchInBreakdown ===
                            "function"
                    ) {
                        this.$refs.ItemDetails.updatePatchInBreakdown();
                    }
                });
            });
        },
        autoPlaceSelectedPatch() {
            try {
                const configStr = localStorage.getItem("selectedPatchConfig");
                if (!configStr) return;
                const config = JSON.parse(configStr);
                if (!config || !config.patch_id || !config.image_path) return;
                // Check if a patch with this patch_id already exists on the canvas
                const canvas = this.backCanvas;
                if (canvas) {
                    const existing =
                        (canvas.getObjects
                            ? canvas.getObjects()
                            : canvas._objects || []) || [];
                    const alreadyPlaced = existing.some((o) => {
                        const ctype = o.get ? o.get("ctype") : o.ctype;
                        const pid = o.get ? o.get("patch_id") : o.patch_id;
                        return ctype === "patch" && pid == config.patch_id;
                    });
                    if (alreadyPlaced) {
                        localStorage.removeItem("selectedPatchConfig");
                        return;
                    }
                }
                const patchData = {
                    id: config.patch_id,
                    image_name: config.patch_name,
                    image_path: config.image_path,
                    height: config.height,
                    width: config.width,
                    material_id: config.material_id,
                    prices: config.prices || []
                };
                this.placeImage(
                    null,
                    config.image_path,
                    config.image_path,
                    0,
                    "patch",
                    patchData
                );
                localStorage.removeItem("selectedPatchConfig");
            } catch (e) {
                console.warn("Auto-place patch failed:", e);
            }
        },
        setNewDesign(id) {
            if (this.uploadModuleCanvas == 0) {
                this.uploadModuleCanvas++;
                this.saveCanvasData();
            }
            this.preserveSavedDesignPositions = true;
            // console.log("[DesignStudioV3] setNewDesign clicked", id);
            ApiService.get("/get-single-design/" + id)
                .then(({ data }) => {
                    let saved_json = data.design.canvas_json;
                    this.current_design_id = data.design.id;
                    let local_front_color = [];
                    let local_back_color = [];
                    let local_left_color = [];
                    let local_right_color = [];
                    if (data.design.front_color != null) {
                        JSON.parse(data.design.front_color).forEach((color) => {
                            local_front_color.push(color.hex);
                        });
                    } else {
                        local_front_color = null;
                    }
                    if (data.design.back_color != null) {
                        JSON.parse(data.design.back_color).forEach((color) => {
                            local_back_color.push(color.hex);
                        });
                    } else {
                        local_back_color = null;
                    }
                    if (data.design.left_color != null) {
                        JSON.parse(data.design.left_color).forEach((color) => {
                            local_left_color.push(color.hex);
                        });
                    } else {
                        local_left_color = null;
                    }
                    if (data.design.right_color != null) {
                        JSON.parse(data.design.right_color).forEach((color) => {
                            local_right_color.push(color.hex);
                        });
                    } else {
                        local_right_color = null;
                    }
                    let color_obj = {
                        front: local_front_color,
                        back: local_back_color,
                        left: local_left_color,
                        right: local_right_color
                    };
                    localStorage.setItem(
                        "canvas_design_colors",
                        JSON.stringify(color_obj)
                    );
                    // Set all_decoration_colors so ItemDetails can access it
                    this.all_decoration_colors = color_obj;

                    // Enable design areas based on design data and product availability
                    // Check which sides exist in the design
                    let designHasFront = data.design.front_color != null;
                    let designHasBack = data.design.back_color != null;
                    let designHasLeft = data.design.left_color != null;
                    let designHasRight = data.design.right_color != null;

                    // Get product's available imprint locations
                    let availableSides = {
                        front: false,
                        back: false,
                        left: false,
                        right: false
                    };

                    // Check imprint_locations from gender_groups_items to see which sides are available in product
                    if (
                        this.gender_groups_items &&
                        this.gender_groups_items.length > 0
                    ) {
                        let activeGenderKey = this.active_gender_key || 0;
                        if (
                            this.gender_groups_items[activeGenderKey] &&
                            this.gender_groups_items[activeGenderKey]
                                .imprint_locations
                        ) {
                            this.gender_groups_items[
                                activeGenderKey
                            ].imprint_locations.forEach((location) => {
                                let locationKey = location.location
                                    .toLowerCase()
                                    .trim();
                                // Use includes() to handle compound names like "left sleeve", "right sleeve"
                                if (locationKey.includes("front")) {
                                    availableSides.front = true;
                                } else if (locationKey.includes("back")) {
                                    availableSides.back = true;
                                } else if (locationKey.includes("left")) {
                                    availableSides.left = true;
                                } else if (locationKey.includes("right")) {
                                    availableSides.right = true;
                                }
                            });
                        }
                    }

                    // Hard block for side mismatch: do not apply design when saved sides are
                    // not available on current product (e.g. saved has left/right but product has front/back only).
                    const usedFlips = this.getUsedFlipsFromDesignResponse(
                        data.design
                    );
                    const availableFlips = [];
                    if (availableSides.front) availableFlips.push("Front");
                    if (availableSides.back) availableFlips.push("Back");
                    if (availableSides.left) availableFlips.push("Left");
                    if (availableSides.right) availableFlips.push("Right");
                    const availableFlipSet = new Set(availableFlips);
                    const missingFlips = usedFlips.filter(
                        (flip) => !availableFlipSet.has(flip)
                    );
                    if (missingFlips.length > 0) {
                        this.showDesignLocationMismatchModal(
                            data.design.name || "This design",
                            usedFlips,
                            availableFlips
                        );
                        this.preserveSavedDesignPositions = false;
                        return;
                    }
                    try {
                        if (
                            this.isDesignImprintTooSmall({
                                canvas_json: saved_json,
                                design_name: data.design.name
                            })
                        ) {
                            // console.log(
                            //     "[DesignStudioV3] setNewDesign blocked: imprint too small",
                            //     data.design.name
                            // );
                            this.showDesignImprintTooSmallModal(data.design.name);
                            this.preserveSavedDesignPositions = false;
                            return;
                        }
                    } catch (e) {}

                    // Enable sides that exist in design AND are available in product
                    // Also update imprint_locations to mark them as selected
                    if (
                        this.gender_groups_items &&
                        this.gender_groups_items.length > 0
                    ) {
                        let activeGenderKey = this.active_gender_key || 0;
                        if (
                            this.gender_groups_items[activeGenderKey] &&
                            this.gender_groups_items[activeGenderKey]
                                .imprint_locations
                        ) {
                            this.gender_groups_items[
                                activeGenderKey
                            ].imprint_locations.forEach((location) => {
                                let locationKey = location.location
                                    .toLowerCase()
                                    .trim();

                                // Enable if design has this side AND product supports it
                                // Use includes() to handle compound names like "left sleeve", "right sleeve"
                                if (
                                    locationKey.includes("front") &&
                                    designHasFront &&
                                    availableSides.front
                                ) {
                                    location.is_selected = true;
                                    this.front_show = true;
                                } else if (
                                    locationKey.includes("back") &&
                                    designHasBack &&
                                    availableSides.back
                                ) {
                                    location.is_selected = true;
                                    this.back_show = true;
                                } else if (
                                    locationKey.includes("left") &&
                                    designHasLeft &&
                                    availableSides.left
                                ) {
                                    location.is_selected = true;
                                    this.left_show = true;
                                } else if (
                                    locationKey.includes("right") &&
                                    designHasRight &&
                                    availableSides.right
                                ) {
                                    location.is_selected = true;
                                    this.right_show = true;
                                } else {
                                    // Disable if design doesn't have this side OR product doesn't support it
                                    if (
                                        locationKey.includes("front") ||
                                        locationKey.includes("back") ||
                                        locationKey.includes("left") ||
                                        locationKey.includes("right")
                                    ) {
                                        location.is_selected = false;
                                        if (locationKey.includes("front"))
                                            this.front_show = false;
                                        if (locationKey.includes("back"))
                                            this.back_show = false;
                                        if (locationKey.includes("left"))
                                            this.left_show = false;
                                        if (locationKey.includes("right"))
                                            this.right_show = false;
                                    }
                                }
                            });

                            // Update all colors' imprint_locations to keep them in sync
                            if (
                                this.gender_groups_items[activeGenderKey].colors
                            ) {
                                this.gender_groups_items[
                                    activeGenderKey
                                ].colors.forEach((color) => {
                                    if (color.imprint_locations) {
                                        color.imprint_locations.forEach(
                                            (loc, idx) => {
                                                if (
                                                    this.gender_groups_items[
                                                        activeGenderKey
                                                    ].imprint_locations[idx]
                                                ) {
                                                    loc.is_selected =
                                                        this.gender_groups_items[
                                                            activeGenderKey
                                                        ].imprint_locations[
                                                            idx
                                                        ].is_selected;
                                                }
                                            }
                                        );
                                    }
                                });
                            }

                            // Update print areas to reflect the changes
                            this.updatePrintAreas();

                            // Switch to the first available area of the design
                            // Priority order: front -> back -> left -> right
                            let firstAvailableArea = null;
                            if (designHasFront && availableSides.front) {
                                firstAvailableArea = "front";
                            } else if (designHasBack && availableSides.back) {
                                firstAvailableArea = "back";
                            } else if (designHasLeft && availableSides.left) {
                                firstAvailableArea = "left";
                            } else if (designHasRight && availableSides.right) {
                                firstAvailableArea = "right";
                            }

                            // Switch to the first available area if found
                            if (firstAvailableArea) {
                                this.flipTshirt(firstAvailableArea);
                            }
                        }
                    }

                    this.getClearCanvas(saved_json);
                    // Store original canvas JSON after canvas is loaded to detect changes
                    setTimeout(() => {
                        // Store the original canvas state after it's loaded
                        let currentCanvasJson = localStorage.getItem(
                            "new_canvas_elements"
                        );
                        if (currentCanvasJson) {
                            this.original_canvas_json = JSON.parse(
                                JSON.stringify(JSON.parse(currentCanvasJson))
                            );
                        }

                        if (
                            data.design.front_color != null &&
                            availableSides.front
                        )
                            this.prepareImprintLocations(true, "front");
                        if (
                            data.design.back_color != null &&
                            availableSides.back
                        )
                            this.prepareImprintLocations(true, "back");
                        if (
                            data.design.left_color != null &&
                            availableSides.left
                        )
                            this.prepareImprintLocations(true, "left");
                        if (
                            data.design.right_color != null &&
                            availableSides.right
                        )
                            this.prepareImprintLocations(true, "right");
                        this.preserveSavedDesignPositions = false;

                        // Restore name numbers and recalculate fees if design has name numbers
                        let nameNumbersRestored = false;

                        // First, try to restore from design_json (most reliable source)
                        if (data.design.design_json) {
                            try {
                                let designJson = JSON.parse(
                                    data.design.design_json
                                );
                                if (
                                    designJson &&
                                    designJson.allitems &&
                                    Array.isArray(designJson.allitems)
                                ) {
                                    // Find name numbers data from saved design - get data for each color
                                    let nameNumberDataByColor = {};
                                    designJson.allitems.forEach((item) => {
                                        if (
                                            item.color_id &&
                                            item.name_and_number_json &&
                                            (Array.isArray(
                                                item.name_and_number_json
                                            )
                                                ? item.name_and_number_json
                                                      .length > 0
                                                : typeof item.name_and_number_json ===
                                                  "object")
                                        ) {
                                            let itemPrices =
                                                typeof item.item_prices ===
                                                "string"
                                                    ? JSON.parse(
                                                          item.item_prices
                                                      )
                                                    : item.item_prices;

                                            nameNumberDataByColor[
                                                item.color_id
                                            ] = {
                                                name_and_number_json:
                                                    typeof item.name_and_number_json ===
                                                    "string"
                                                        ? JSON.parse(
                                                              item.name_and_number_json
                                                          )
                                                        : item.name_and_number_json,
                                                name_number_counts:
                                                    item.name_number_counts &&
                                                    typeof item.name_number_counts ===
                                                        "object"
                                                        ? item.name_number_counts
                                                        : null,
                                                item_prices: itemPrices,
                                                font_color_sizes_name:
                                                    item.font_color_sizes_name
                                                        ? typeof item.font_color_sizes_name ===
                                                          "string"
                                                            ? JSON.parse(
                                                                  item.font_color_sizes_name
                                                              )
                                                            : item.font_color_sizes_name
                                                        : null,
                                                font_color_sizes_number:
                                                    item.font_color_sizes_number
                                                        ? typeof item.font_color_sizes_number ===
                                                          "string"
                                                            ? JSON.parse(
                                                                  item.font_color_sizes_number
                                                              )
                                                            : item.font_color_sizes_number
                                                        : null,
                                                view_settings:
                                                    item.view_settings &&
                                                    typeof item.view_settings ===
                                                        "object"
                                                        ? item.view_settings
                                                        : null
                                            };
                                        }
                                    });

                                    // Restore name numbers data to matching colors
                                    if (
                                        Object.keys(nameNumberDataByColor)
                                            .length > 0
                                    ) {
                                        nameNumbersRestored = true;
                                        var productColorIds =
                                            this.gender_groups_items[
                                                this.active_gender_key
                                            ].colors.map(function (c) {
                                                return c.id;
                                            });
                                        var savedColorIds = Object.keys(
                                            nameNumberDataByColor
                                        ).map(Number);
                                        var firstSavedData = Object.values(
                                            nameNumberDataByColor
                                        )[0];
                                        this.gender_groups_items[
                                            this.active_gender_key
                                        ].colors.forEach((color) => {
                                            let colorData =
                                                nameNumberDataByColor[
                                                    color.id
                                                ] || firstSavedData;
                                            if (colorData) {
                                                // Restore name_and_number_json
                                                if (
                                                    colorData.name_and_number_json
                                                ) {
                                                    color.name_and_number_json =
                                                        JSON.parse(
                                                            JSON.stringify(
                                                                colorData.name_and_number_json
                                                            )
                                                        );
                                                }
                                                // selected_name_number: prefer inside name_and_number_json, else from item_prices (so NameAndNumber finds it)
                                                var snn =
                                                    (color.name_and_number_json &&
                                                        typeof color.name_and_number_json ===
                                                            "object" &&
                                                        !Array.isArray(
                                                            color.name_and_number_json
                                                        ) &&
                                                        color
                                                            .name_and_number_json
                                                            .selected_name_number) ||
                                                    (colorData.item_prices &&
                                                        colorData.item_prices
                                                            .selected_name_number);
                                                if (snn) {
                                                    color.selected_name_number =
                                                        JSON.parse(
                                                            JSON.stringify(snn)
                                                        );
                                                    if (
                                                        color.name_and_number_json &&
                                                        typeof color.name_and_number_json ===
                                                            "object" &&
                                                        !Array.isArray(
                                                            color.name_and_number_json
                                                        )
                                                    ) {
                                                        color.name_and_number_json.selected_name_number =
                                                            color.selected_name_number;
                                                    } else if (
                                                        Array.isArray(
                                                            color.name_and_number_json
                                                        )
                                                    ) {
                                                        color.name_and_number_json =
                                                            {
                                                                front: color.name_and_number_json,
                                                                back: color.name_and_number_json,
                                                                left: color.name_and_number_json,
                                                                right: color.name_and_number_json,
                                                                selected_name_number:
                                                                    color.selected_name_number
                                                            };
                                                    }
                                                }

                                                // Restore location-wise name/number colors (front, back, left, right)
                                                if (
                                                    colorData.view_settings &&
                                                    typeof colorData.view_settings ===
                                                        "object" &&
                                                    Object.keys(
                                                        colorData.view_settings
                                                    ).length > 0
                                                ) {
                                                    color.view_settings =
                                                        JSON.parse(
                                                            JSON.stringify(
                                                                colorData.view_settings
                                                            )
                                                        );
                                                } else if (
                                                    colorData.font_color_sizes_name ||
                                                    colorData.font_color_sizes_number
                                                ) {
                                                    // Legacy: build view_settings from single font_color_sizes so panel + right dropdowns show colors
                                                    var fn =
                                                        colorData.font_color_sizes_name ||
                                                        {};
                                                    var fnum =
                                                        colorData.font_color_sizes_number ||
                                                        {};
                                                    var built = {};
                                                    [
                                                        "front",
                                                        "back",
                                                        "left",
                                                        "right"
                                                    ].forEach(function (v) {
                                                        built[v] = {
                                                            nameSettings: {
                                                                fontFamily:
                                                                    fn.nameFontFamily ||
                                                                    "Verdana",
                                                                fontSize:
                                                                    String(
                                                                        fn.nameFontSize ||
                                                                            "21"
                                                                    ),
                                                                fontColor:
                                                                    fn.nameFontColor ||
                                                                    "#000000",
                                                                colorId:
                                                                    fn.color_id !=
                                                                    null
                                                                        ? fn.color_id
                                                                        : null,
                                                                colorName: null,
                                                                decor_upcharge:
                                                                    fn.decor_upcharge ||
                                                                    0
                                                            },
                                                            numberSettings: {
                                                                fontFamily:
                                                                    fnum.numberFontFamily ||
                                                                    "Verdana",
                                                                fontSize:
                                                                    String(
                                                                        fnum.numberFontSize ||
                                                                            "96"
                                                                    ),
                                                                fontColor:
                                                                    fnum.numberFontColor ||
                                                                    "#000000",
                                                                colorId:
                                                                    fnum.color_id !=
                                                                    null
                                                                        ? fnum.color_id
                                                                        : null,
                                                                colorName: null,
                                                                decor_upcharge:
                                                                    fnum.decor_upcharge ||
                                                                    0
                                                            }
                                                        };
                                                    });
                                                    color.view_settings = built;
                                                }
                                                if (
                                                    (!colorData.view_settings ||
                                                        Object.keys(
                                                            colorData.view_settings ||
                                                                {}
                                                        ).length === 0) &&
                                                    this.$refs
                                                        .nameAndNumberRef &&
                                                    (colorData.font_color_sizes_name ||
                                                        colorData.font_color_sizes_number)
                                                ) {
                                                    if (
                                                        colorData.font_color_sizes_name &&
                                                        this.$refs
                                                            .nameAndNumberRef
                                                            .setColorSizesForName
                                                    ) {
                                                        this.$refs.nameAndNumberRef.setColorSizesForName(
                                                            colorData.font_color_sizes_name
                                                        );
                                                    }
                                                    if (
                                                        colorData.font_color_sizes_number &&
                                                        this.$refs
                                                            .nameAndNumberRef
                                                            .setColorSizesForNumber
                                                    ) {
                                                        this.$refs.nameAndNumberRef.setColorSizesForNumber(
                                                            colorData.font_color_sizes_number
                                                        );
                                                    }
                                                }
                                            }
                                        });
                                        // Copy name/number data to other product colors so table + colors show on every color (e.g. red, grey)
                                        let colorsArr =
                                            this.gender_groups_items[
                                                this.active_gender_key
                                            ].colors;
                                        let sourceColor =
                                            colorsArr &&
                                            colorsArr.find(function (c) {
                                                return (
                                                    (c.name_and_number_json &&
                                                        (Array.isArray(
                                                            c.name_and_number_json
                                                        )
                                                            ? c
                                                                  .name_and_number_json
                                                                  .length > 0
                                                            : Object.keys(
                                                                  c.name_and_number_json
                                                              ).length > 0)) ||
                                                    (c.view_settings &&
                                                        typeof c.view_settings ===
                                                            "object" &&
                                                        Object.keys(
                                                            c.view_settings
                                                        ).length > 0)
                                                );
                                            });
                                        if (sourceColor && colorsArr) {
                                            let _thisCopy = this;
                                            let copyCount = 0;
                                            colorsArr.forEach(function (c) {
                                                if (c !== sourceColor) {
                                                    if (
                                                        sourceColor.name_and_number_json
                                                    ) {
                                                        _thisCopy.$set(
                                                            c,
                                                            "name_and_number_json",
                                                            JSON.parse(
                                                                JSON.stringify(
                                                                    sourceColor.name_and_number_json
                                                                )
                                                            )
                                                        );
                                                    }
                                                    if (
                                                        sourceColor.selected_name_number
                                                    ) {
                                                        _thisCopy.$set(
                                                            c,
                                                            "selected_name_number",
                                                            JSON.parse(
                                                                JSON.stringify(
                                                                    sourceColor.selected_name_number
                                                                )
                                                            )
                                                        );
                                                    }
                                                    if (
                                                        sourceColor.view_settings &&
                                                        typeof sourceColor.view_settings ===
                                                            "object"
                                                    ) {
                                                        _thisCopy.$set(
                                                            c,
                                                            "view_settings",
                                                            JSON.parse(
                                                                JSON.stringify(
                                                                    sourceColor.view_settings
                                                                )
                                                            )
                                                        );
                                                    }
                                                    copyCount++;
                                                }
                                            });
                                        }
                                        if (sourceColor) {
                                            const savedData =
                                                nameNumberDataByColor[
                                                    sourceColor.id
                                                ] || firstSavedData;
                                            const counts =
                                                savedData &&
                                                savedData.name_number_counts &&
                                                typeof savedData.name_number_counts ===
                                                    "object"
                                                    ? savedData.name_number_counts
                                                    : null;
                                            if (counts) {
                                                this.$set(
                                                    this.gender_groups_items[
                                                        this.active_gender_key
                                                    ],
                                                    "name_number_display_counts",
                                                    counts
                                                );
                                            }
                                        }
                                    }
                                }
                            } catch (e) {
                                console.log("Error parsing design_json:", e);
                            }
                        }

                        // Only restore from canvas if design_json didn't have the data (fallback)
                        // This avoids duplicate work and prevents overwriting properly restored data
                        if (!nameNumbersRestored) {
                            setTimeout(() => {
                                this.restoreNameNumbersFromCanvas();
                            }, 600);
                        }

                        // Recalculate fees and refresh panel + right dropdowns when name/number was restored
                        if (
                            nameNumbersRestored &&
                            this.$refs.nameAndNumberRef &&
                            this.$refs.ItemDetails
                        ) {
                            setTimeout(() => {
                                let idx =
                                    this.activeColorIndex >= 0
                                        ? this.activeColorIndex
                                        : 0;
                                localStorage.setItem("colorIndex", String(idx));
                                let _this = this;
                                this.$nextTick(function () {
                                    setTimeout(function () {
                                        // Re-apply copy to all colors right before load so red/any selected color has data
                                        var colorsArr =
                                            _this.gender_groups_items &&
                                            _this.gender_groups_items[
                                                _this.active_gender_key
                                            ] &&
                                            _this.gender_groups_items[
                                                _this.active_gender_key
                                            ].colors;
                                        var sourceColor =
                                            colorsArr &&
                                            colorsArr.find(function (c) {
                                                return (
                                                    (c.name_and_number_json &&
                                                        (Array.isArray(
                                                            c.name_and_number_json
                                                        )
                                                            ? c
                                                                  .name_and_number_json
                                                                  .length > 0
                                                            : Object.keys(
                                                                  c.name_and_number_json
                                                              ).length > 0)) ||
                                                    (c.view_settings &&
                                                        typeof c.view_settings ===
                                                            "object" &&
                                                        Object.keys(
                                                            c.view_settings
                                                        ).length > 0)
                                                );
                                            });
                                        if (sourceColor && colorsArr) {
                                            colorsArr.forEach(function (c) {
                                                if (c !== sourceColor) {
                                                    if (
                                                        sourceColor.name_and_number_json
                                                    ) {
                                                        _this.$set(
                                                            c,
                                                            "name_and_number_json",
                                                            JSON.parse(
                                                                JSON.stringify(
                                                                    sourceColor.name_and_number_json
                                                                )
                                                            )
                                                        );
                                                    }
                                                    if (
                                                        sourceColor.selected_name_number
                                                    ) {
                                                        _this.$set(
                                                            c,
                                                            "selected_name_number",
                                                            JSON.parse(
                                                                JSON.stringify(
                                                                    sourceColor.selected_name_number
                                                                )
                                                            )
                                                        );
                                                    }
                                                    if (
                                                        sourceColor.view_settings &&
                                                        typeof sourceColor.view_settings ===
                                                            "object"
                                                    ) {
                                                        _this.$set(
                                                            c,
                                                            "view_settings",
                                                            JSON.parse(
                                                                JSON.stringify(
                                                                    sourceColor.view_settings
                                                                )
                                                            )
                                                        );
                                                    }
                                                }
                                            });
                                        }
                                        var group =
                                            _this.gender_groups_items &&
                                            _this.gender_groups_items[
                                                _this.active_gender_key
                                            ];
                                        var activeColorObj =
                                            group &&
                                            group.colors &&
                                            group.colors[idx];
                                        if (_this.$refs.nameAndNumberRef) {
                                            if (
                                                typeof _this.$refs
                                                    .nameAndNumberRef
                                                    .syncActiveView ===
                                                "function"
                                            ) {
                                                _this.$refs.nameAndNumberRef.syncActiveView();
                                            }
                                            if (
                                                activeColorObj &&
                                                typeof _this.$refs
                                                    .nameAndNumberRef
                                                    .loadNameAndNumber ===
                                                    "function"
                                            ) {
                                                _this.$refs.nameAndNumberRef.loadNameAndNumber(
                                                    activeColorObj
                                                );
                                            } else {
                                                _this.$refs.nameAndNumberRef.loadFromColor();
                                            }
                                            _this.updateNameNumberFees(true);
                                        }
                                        if (_this.$refs.ItemDetails) {
                                            _this.$refs.ItemDetails.calculatePricing(
                                                _this.active_gender_key
                                            );
                                            if (
                                                typeof _this.$refs.ItemDetails
                                                    .syncNameNumberColorsForAllColors ===
                                                "function"
                                            ) {
                                                _this.$refs.ItemDetails.syncNameNumberColorsForAllColors();
                                            } else if (
                                                typeof _this.$refs.ItemDetails
                                                    .syncNameNumberColorsToImprintLocations ===
                                                "function"
                                            ) {
                                                _this.$refs.ItemDetails.syncNameNumberColorsToImprintLocations();
                                            }
                                        }
                                    }, 150);
                                });
                            }, 500);
                        }
                    }, 1000);
                })
                .catch((response) => {
                    this.preserveSavedDesignPositions = false;
                    // console.log(response);
                });
        },
        setNewTemplateDesign(template) {
            var _this = this;
            _this.saveCanvasData();
            let saved_json = template.canvas_json;
            this.current_design_id = template.id;
            // Clear original canvas JSON for templates (templates are new designs, not from My Designs)
            this.original_canvas_json = null;
            this.getCopyClearCanvas(saved_json);
            setTimeout(() => {
                this.prepareImprintLocations();
            }, 1000);
        },
        getCopyClearCanvas(saved_json) {
            let _this = this;

            _this.backCanvas.discardActiveObject();
            _this.onSelectedCleared();
            _this.backCanvas.clear();
            _this.backCanvas.renderAll();

            let type = localStorage.getItem("active_flip");
            /* eslint-disable */
            $("." + type).addClass("active");
            /* eslint-enable */
            this.tshirtImage = this.background_image;
            let elem = document.querySelector("#tcanvas").parentNode;
            if (type == "front" || type == "back") {
                _this.updateImageToBackCanvas();
            } else {
                let square = new fabric.Rect({
                    width: 630,
                    height: 540,

                    fill: _this.user_selected_values[_this.active_gender_key]
                        .color_hash
                });
                if (_this.backCanvas._objects.length > 0) {
                    _this.backCanvas._objects.forEach((canvas_obj) => {
                        if (canvas_obj.type != "rect") {
                            _this.backCanvas.add(square);
                        }
                    });
                } else {
                    _this.backCanvas.add(square);
                }

                elem.classList.add("left_right_sleeve_canvas");
            }

            let json = JSON.parse(saved_json);
            if (this.saved_json_data == null) {
                this.saved_json_data = json;
                if (this.active_flip != "front") {
                    this.saved_json_data[this.active_flip] = json["front"];
                    delete this.saved_json_data["front"];
                }
            } else {
                this.saved_json_data[this.active_flip] = json["front"];
            }
            let front_flips = JSON.parse(
                this.saved_json_data[this.active_flip]
            );
            if (type == "left" || type == "right") {
                let centerX = this.effectiveDesignAreaWidth / 2;
                let centerY = this.effectiveDesignAreaHeight / 2;
                for (let obj of front_flips.objects) {
                    if (obj.type !== "rect") {
                        obj.left = centerX;
                        obj.top = centerY;
                        obj.originX = obj.originX || "center";
                        obj.originY = obj.originY || "center";
                    }
                }
                this.saved_json_data[this.active_flip] =
                    JSON.stringify(front_flips);
            }
            saved_json = JSON.stringify(this.saved_json_data);
            localStorage.setItem("new_canvas_elements", saved_json);
            this.getLocalDesign(type);
            _this.saveCanvasData();
        },

        isNameNumberObject(obj) {
            if (!obj) return false;
            var ot =
                obj.objType ||
                (obj.toObject &&
                    typeof obj.toObject === "function" &&
                    obj.toObject().objType);
            return (
                ot === "name" ||
                ot === "number" ||
                (typeof ot === "string" &&
                    (ot.indexOf("name_") === 0 || ot.indexOf("number_") === 0))
            );
        },

        centerNameNumberInDesignArea() {
            if (!this.backCanvas || !this.design_box) return;
            let flip = (this.active_flip || "front").toLowerCase();
            let objs = this.backCanvas.getObjects();
            let nameObj = objs.find((o) => {
                var ot = o.objType || (o.toObject && o.toObject().objType);
                return (
                    ot === "name_" + flip ||
                    (typeof ot === "string" && ot.indexOf("name_") === 0)
                );
            });
            let numberObj = objs.find((o) => {
                var ot = o.objType || (o.toObject && o.toObject().objType);
                return (
                    ot === "number_" + flip ||
                    (typeof ot === "string" && ot.indexOf("number_") === 0)
                );
            });
            let left = parseFloat(this.front_canvas_left) || 0;
            let top = parseFloat(this.front_canvas_top) || 0;
            let w = parseFloat(this.front_canvas_width) || 200;
            let h = parseFloat(this.front_canvas_height) || 200;
            let cx = left + w / 2;
            let midY = top + h / 2;
            if (nameObj && nameObj.type === "text") {
                nameObj.set({
                    originX: "center",
                    originY: "center",
                    left: cx,
                    top: midY - h * 0.2
                });
                nameObj.set("clipPath", this.design_box);
                nameObj.setCoords();
            }
            if (numberObj && numberObj.type === "text") {
                numberObj.set({
                    originX: "center",
                    originY: "center",
                    left: cx,
                    top: midY + h * 0.15
                });
                numberObj.set("clipPath", this.design_box);
                numberObj.setCoords();
            }
            if (nameObj || numberObj) {
                this.backCanvas.renderAll();
                this.saveCanvasData();
            }
        },
        centerNameNumberInVisibleArea() {
            if (!this.backCanvas) return;
            let flip = (this.active_flip || "front").toLowerCase();
            let objs = this.backCanvas.getObjects();
            let nameObj = objs.find((o) => {
                var ot = o.objType || (o.toObject && o.toObject().objType);
                return (
                    ot === "name_" + flip ||
                    (typeof ot === "string" && ot.indexOf("name_") === 0)
                );
            });
            let numberObj = objs.find((o) => {
                var ot = o.objType || (o.toObject && o.toObject().objType);
                return (
                    ot === "number_" + flip ||
                    (typeof ot === "string" && ot.indexOf("number_") === 0)
                );
            });
            let w = parseFloat(this.effectiveDesignAreaWidth) || 200;
            let h = parseFloat(this.effectiveDesignAreaHeight) || 200;
            let cx = w / 2;
            let midY = h / 2;
            if (nameObj) {
                nameObj.set({
                    originX: "center",
                    originY: "center",
                    left: cx,
                    top: midY - h * 0.2
                });
                nameObj.set("clipPath", null);
                nameObj.setCoords();
            }
            if (numberObj) {
                numberObj.set({
                    originX: "center",
                    originY: "center",
                    left: cx,
                    top: midY + h * 0.15
                });
                numberObj.set("clipPath", null);
                numberObj.setCoords();
            }
        },

        // This preserves artwork but resets positions to current product's design area
        resetCanvasObjectPositions(canvasJson) {
            let _this = this;
            try {
                if (!canvasJson) return canvasJson;

                let parsedJson =
                    typeof canvasJson === "string"
                        ? JSON.parse(canvasJson)
                        : canvasJson;
                let modified = false;

                // Process each flip (front, back, left, right)
                ["front", "back", "left", "right"].forEach(function (flip) {
                    if (parsedJson[flip] && parsedJson[flip] !== "") {
                        try {
                            let flipData =
                                typeof parsedJson[flip] === "string"
                                    ? JSON.parse(parsedJson[flip])
                                    : parsedJson[flip];

                            if (
                                flipData &&
                                flipData.objects &&
                                Array.isArray(flipData.objects)
                            ) {
                                let designAreaCenter = null;

                                // Calculate design area center for front/back using image/no-image mode from design_area_data.
                                if (flip === "front" || flip === "back") {
                                    let currentFlip =
                                        flip.charAt(0).toUpperCase() +
                                        flip.slice(1);
                                    let currentDesignArea = null;
                                    if (
                                        _this.design_area_data &&
                                        Array.isArray(_this.design_area_data)
                                    ) {
                                        currentDesignArea =
                                            _this.design_area_data.find(
                                                function (area) {
                                                    return (
                                                        area &&
                                                        area.label &&
                                                        (area.label ===
                                                            currentFlip ||
                                                            (flip === "front" &&
                                                                area.label
                                                                    .toLowerCase()
                                                                    .includes(
                                                                        "front"
                                                                    )) ||
                                                            (flip === "back" &&
                                                                area.label
                                                                    .toLowerCase()
                                                                    .includes(
                                                                        "back"
                                                                    )))
                                                    );
                                                }
                                            );
                                    }
                                    let hasDesignAreaImage = !!(
                                        currentDesignArea &&
                                        ((currentDesignArea.image &&
                                            String(
                                                currentDesignArea.image
                                            ).trim() !== "") ||
                                            (currentDesignArea.thumbnail &&
                                                String(
                                                    currentDesignArea.thumbnail
                                                ).trim() !== "")) &&
                                        String(
                                            currentDesignArea.image ||
                                                currentDesignArea.thumbnail
                                        ).toLowerCase() !== "null"
                                    );
                                    let useCustomBoxFB =
                                        currentDesignArea &&
                                        currentDesignArea.use_custom_box ===
                                            true;
                                    // use_custom_box or no image: use per-flip dimensions (widthIn/heightIn, 0,0). Never use global front_canvas_*.
                                    if (
                                        !useCustomBoxFB &&
                                        hasDesignAreaImage &&
                                        currentDesignArea
                                    ) {
                                        let areaLeft =
                                            currentDesignArea.left !== undefined
                                                ? parseFloat(
                                                      currentDesignArea.left
                                                  )
                                                : null;
                                        let areaTop =
                                            currentDesignArea.top !== undefined
                                                ? parseFloat(
                                                      currentDesignArea.top
                                                  )
                                                : null;
                                        let areaWidth =
                                            currentDesignArea.width !==
                                            undefined
                                                ? parseFloat(
                                                      currentDesignArea.width
                                                  )
                                                : null;
                                        let areaHeight =
                                            currentDesignArea.height !==
                                            undefined
                                                ? parseFloat(
                                                      currentDesignArea.height
                                                  )
                                                : null;
                                        if (
                                            areaLeft !== null &&
                                            areaTop !== null &&
                                            areaWidth !== null &&
                                            areaHeight !== null &&
                                            areaWidth > 0 &&
                                            areaHeight > 0
                                        ) {
                                            designAreaCenter = {
                                                left: areaLeft + areaWidth / 2,
                                                top: areaTop + areaHeight / 2,
                                                width: areaWidth,
                                                height: areaHeight,
                                                areaLeft: areaLeft,
                                                areaTop: areaTop,
                                                hasImage: true
                                            };
                                        }
                                    } else {
                                        let widthInch =
                                            currentDesignArea &&
                                            (currentDesignArea.widthIn !=
                                                null ||
                                                currentDesignArea.width != null)
                                                ? parseFloat(
                                                      currentDesignArea.widthIn !=
                                                          null
                                                          ? currentDesignArea.widthIn
                                                          : currentDesignArea.width
                                                  )
                                                : null;
                                        let heightInch =
                                            currentDesignArea &&
                                            (currentDesignArea.heightIn !=
                                                null ||
                                                currentDesignArea.height !=
                                                    null)
                                                ? parseFloat(
                                                      currentDesignArea.heightIn !=
                                                          null
                                                          ? currentDesignArea.heightIn
                                                          : currentDesignArea.height
                                                  )
                                                : null;
                                        if (
                                            typeof widthInch === "number" &&
                                            !isNaN(widthInch) &&
                                            widthInch > 0 &&
                                            typeof heightInch === "number" &&
                                            !isNaN(heightInch) &&
                                            heightInch > 0
                                        ) {
                                            let maxW =
                                                _this.defaultWidthCanvas * 0.95;
                                            let maxH =
                                                _this.defaultHeightCanvas *
                                                0.95;
                                            let scale = Math.min(
                                                maxW / widthInch,
                                                maxH / heightInch
                                            );
                                            let rectW = widthInch * scale;
                                            let rectH = heightInch * scale;
                                            designAreaCenter = {
                                                left: rectW / 2,
                                                top: rectH / 2,
                                                width: rectW,
                                                height: rectH,
                                                areaLeft: 0,
                                                areaTop: 0,
                                                hasImage: false
                                            };
                                        } else {
                                            designAreaCenter = {
                                                left:
                                                    _this.defaultWidthCanvas /
                                                    2,
                                                top:
                                                    _this.defaultHeightCanvas /
                                                    2,
                                                width: _this.defaultWidthCanvas,
                                                height: _this.defaultHeightCanvas,
                                                areaLeft: 0,
                                                areaTop: 0,
                                                hasImage: false
                                            };
                                        }
                                    }
                                } else if (
                                    flip === "left" ||
                                    flip === "right"
                                ) {
                                    // For left/right - check if image exists in design_area_data
                                    let hasDesignAreaImage = false;
                                    let leftRightDesignArea = null;

                                    if (
                                        _this.design_area_data &&
                                        Array.isArray(_this.design_area_data)
                                    ) {
                                        let currentFlip =
                                            flip.charAt(0).toUpperCase() +
                                            flip.slice(1);
                                        leftRightDesignArea =
                                            _this.design_area_data.find(
                                                function (area) {
                                                    return (
                                                        area.label ===
                                                        currentFlip
                                                    );
                                                }
                                            );

                                        // Check for image in design_area_data OR thumbnail
                                        if (
                                            leftRightDesignArea &&
                                            ((leftRightDesignArea.image &&
                                                leftRightDesignArea.image !==
                                                    "" &&
                                                leftRightDesignArea.image !==
                                                    null) ||
                                                (leftRightDesignArea.thumbnail &&
                                                    leftRightDesignArea.thumbnail !==
                                                        "" &&
                                                    leftRightDesignArea.thumbnail !==
                                                        null))
                                        ) {
                                            hasDesignAreaImage = true;
                                        }
                                    }

                                    let useCustomBoxLR =
                                        leftRightDesignArea &&
                                        leftRightDesignArea.use_custom_box ===
                                            true;
                                    if (
                                        !useCustomBoxLR &&
                                        hasDesignAreaImage &&
                                        leftRightDesignArea
                                    ) {
                                        // Image exists (and not custom box) - use design area center from design_area_data
                                        let areaLeft =
                                            leftRightDesignArea.left !==
                                            undefined
                                                ? parseFloat(
                                                      leftRightDesignArea.left
                                                  )
                                                : null;
                                        let areaTop =
                                            leftRightDesignArea.top !==
                                            undefined
                                                ? parseFloat(
                                                      leftRightDesignArea.top
                                                  )
                                                : null;
                                        let areaWidth =
                                            leftRightDesignArea.width !==
                                            undefined
                                                ? parseFloat(
                                                      leftRightDesignArea.width
                                                  )
                                                : null;
                                        let areaHeight =
                                            leftRightDesignArea.height !==
                                            undefined
                                                ? parseFloat(
                                                      leftRightDesignArea.height
                                                  )
                                                : null;

                                        if (
                                            areaLeft !== null &&
                                            areaTop !== null &&
                                            areaWidth !== null &&
                                            areaHeight !== null &&
                                            areaWidth > 0 &&
                                            areaHeight > 0
                                        ) {
                                            designAreaCenter = {
                                                left: areaLeft + areaWidth / 2,
                                                top: areaTop + areaHeight / 2,
                                                width: areaWidth,
                                                height: areaHeight,
                                                areaLeft: areaLeft,
                                                areaTop: areaTop,
                                                hasImage: true
                                            };
                                        } else {
                                            // Fallback to canvas center
                                            designAreaCenter = {
                                                left:
                                                    _this.defaultWidthCanvas /
                                                    2,
                                                top:
                                                    _this.defaultHeightCanvas /
                                                    2
                                            };
                                        }
                                    } else {
                                        // No image - center in visible design area for THIS flip (use its design area dimensions, not active_flip)
                                        let widthInch =
                                            leftRightDesignArea &&
                                            (leftRightDesignArea.widthIn !=
                                                null ||
                                                leftRightDesignArea.width !=
                                                    null)
                                                ? parseFloat(
                                                      leftRightDesignArea.widthIn !=
                                                          null
                                                          ? leftRightDesignArea.widthIn
                                                          : leftRightDesignArea.width
                                                  )
                                                : null;
                                        let heightInch =
                                            leftRightDesignArea &&
                                            (leftRightDesignArea.heightIn !=
                                                null ||
                                                leftRightDesignArea.height !=
                                                    null)
                                                ? parseFloat(
                                                      leftRightDesignArea.heightIn !=
                                                          null
                                                          ? leftRightDesignArea.heightIn
                                                          : leftRightDesignArea.height
                                                  )
                                                : null;
                                        if (
                                            typeof widthInch === "number" &&
                                            !isNaN(widthInch) &&
                                            widthInch > 0 &&
                                            typeof heightInch === "number" &&
                                            !isNaN(heightInch) &&
                                            heightInch > 0
                                        ) {
                                            let maxW =
                                                _this.defaultWidthCanvas * 0.95;
                                            let maxH =
                                                _this.defaultHeightCanvas *
                                                0.95;
                                            let scale = Math.min(
                                                maxW / widthInch,
                                                maxH / heightInch
                                            );
                                            let rectW = widthInch * scale;
                                            let rectH = heightInch * scale;
                                            designAreaCenter = {
                                                left: rectW / 2,
                                                top: rectH / 2,
                                                width: rectW,
                                                height: rectH,
                                                areaLeft: 0,
                                                areaTop: 0,
                                                hasImage: false
                                            };
                                        } else {
                                            designAreaCenter = {
                                                left:
                                                    _this.defaultWidthCanvas /
                                                    2,
                                                top:
                                                    _this.defaultHeightCanvas /
                                                    2,
                                                width: _this.defaultWidthCanvas,
                                                height: _this.defaultHeightCanvas,
                                                areaLeft: 0,
                                                areaTop: 0,
                                                hasImage: false
                                            };
                                        }
                                    }
                                }

                                // Reset positions of all non-rect, non-image objects
                                // Preserve all other properties (colors, size, rotation, etc.)
                                if (designAreaCenter) {
                                    var areaLeft =
                                        designAreaCenter.areaLeft != null
                                            ? designAreaCenter.areaLeft
                                            : designAreaCenter.left;
                                    var areaTop =
                                        designAreaCenter.areaTop != null
                                            ? designAreaCenter.areaTop
                                            : designAreaCenter.top;
                                    var areaW = designAreaCenter.width || 200;
                                    var areaH = designAreaCenter.height || 200;
                                    var centerX = (areaLeft || 0) + areaW / 2;
                                    var centerY = (areaTop || 0) + areaH / 2;
                                    var nnClip = {
                                        type: "rect",
                                        left: areaLeft,
                                        top: areaTop,
                                        width: areaW,
                                        height: areaH,
                                        absolutePositioned: true
                                    };
                                    flipData.objects.forEach(function (obj) {
                                        if (
                                            obj.type === "rect" ||
                                            obj.type === "image"
                                        )
                                            return;
                                        var ot = obj.objType;
                                        var isName =
                                            ot === "name" ||
                                            (typeof ot === "string" &&
                                                ot.indexOf("name_") === 0);
                                        var isNumber =
                                            ot === "number" ||
                                            (typeof ot === "string" &&
                                                ot.indexOf("number_") === 0);
                                        if (isName || isNumber) {
                                            obj.clipPath =
                                                designAreaCenter.width &&
                                                designAreaCenter.height
                                                    ? nnClip
                                                    : null;
                                            obj.originX = "center";
                                            obj.originY = "center";
                                            obj.left = centerX;
                                            obj.top = isName
                                                ? centerY - areaH * 0.2
                                                : centerY + areaH * 0.15;
                                            modified = true;
                                            return;
                                        }
                                        // Resize and center within print area when we have dimensions (image, no-image, or use_custom_box)
                                        if (
                                            designAreaCenter.width &&
                                            designAreaCenter.height
                                        ) {
                                            // Calculate scale to fit object within 80% of design area
                                            let objWidth =
                                                obj.width * (obj.scaleX || 1);
                                            let objHeight =
                                                obj.height * (obj.scaleY || 1);
                                            let maxWidth =
                                                designAreaCenter.width * 0.8;
                                            let maxHeight =
                                                designAreaCenter.height * 0.8;

                                            if (objWidth > 0 && objHeight > 0) {
                                                let scaleX =
                                                    maxWidth / objWidth;
                                                let scaleY =
                                                    maxHeight / objHeight;
                                                let scale = Math.min(
                                                    scaleX,
                                                    scaleY,
                                                    1
                                                ); // Don't scale up, only down

                                                if (scale < 1) {
                                                    obj.scaleX =
                                                        (obj.scaleX || 1) *
                                                        scale;
                                                    obj.scaleY =
                                                        (obj.scaleY || 1) *
                                                        scale;
                                                }
                                            }

                                            // Set clipPath for all flips
                                            obj.clipPath = {
                                                type: "rect",
                                                left: designAreaCenter.areaLeft,
                                                top: designAreaCenter.areaTop,
                                                width: designAreaCenter.width,
                                                height: designAreaCenter.height,
                                                absolutePositioned: true
                                            };
                                        } else if (obj.clipPath) {
                                            obj.clipPath = null;
                                        }

                                        // Also reset clipPath position if it exists (use designAreaCenter for this flip, not global front_canvas_*)
                                        if (
                                            obj.clipPath &&
                                            obj.clipPath.type === "rect" &&
                                            designAreaCenter.width &&
                                            designAreaCenter.height
                                        ) {
                                            var clipLeft =
                                                designAreaCenter.areaLeft !=
                                                null
                                                    ? designAreaCenter.areaLeft
                                                    : 0;
                                            var clipTop =
                                                designAreaCenter.areaTop != null
                                                    ? designAreaCenter.areaTop
                                                    : 0;
                                            obj.clipPath.left = clipLeft;
                                            obj.clipPath.top = clipTop;
                                            obj.clipPath.width =
                                                designAreaCenter.width;
                                            obj.clipPath.height =
                                                designAreaCenter.height;
                                        }

                                        modified = true;
                                    });

                                    // Update the parsed JSON with reset positions
                                    parsedJson[flip] = JSON.stringify(flipData);
                                }
                            }
                        } catch (e) {
                            console.error(
                                "Error processing flip " + flip + ":",
                                e
                            );
                        }
                    }
                });

                return modified
                    ? typeof canvasJson === "string"
                        ? JSON.stringify(parsedJson)
                        : parsedJson
                    : canvasJson;
            } catch (e) {
                console.error("Error resetting canvas positions:", e);
                return canvasJson;
            }
        },
        getClearCanvas(saved_json) {
            let _this = this;
            _this.backCanvas.discardActiveObject();
            _this.onSelectedCleared();
            _this.backCanvas.clear();
            _this.backCanvas.renderAll();
            /* eslint-disable */
            let type = "front";
            $("." + type).addClass("active");
            /* eslint-enable */
            if (this.active_flip == "front" || this.active_flip == "back")
                _this.updateImageToBackCanvas();

            // Reset object positions in JSON before loading - this ensures current product's design area is used
            let resetJson = _this.resetCanvasObjectPositions(saved_json);
            localStorage.setItem("new_canvas_elements", resetJson);
            this.getLocalDesign(type);
            _this.saveCanvasData();
            this.active_gender_key = 0;
            localStorage.setItem("active_gender", this.active_gender);
            localStorage.setItem("active_gender_key", 0);

            localStorage.setItem(
                "active_tshirt_color",
                this.user_selected_values[this.active_gender_key].color_hash
            );
            this.tshirt_color =
                this.user_selected_values[this.active_gender_key].color_hash;
            if (
                this.canvas_elements[this.active_gender_key][
                    this.active_gender
                ] &&
                this.canvas_elements[this.active_gender_key][this.active_gender]
                    .length > 0
            ) {
                this.canvas_elements[this.active_gender_key][
                    this.active_gender
                ].forEach((element) => {
                    if (
                        element.type == "template" ||
                        element.type == "shape" ||
                        element.type == "patch" ||
                        element.type == "upload"
                    ) {
                        if (
                            element.flip == localStorage.getItem("active_flip")
                        ) {
                            fabric.Image.fromURL(
                                element.url,
                                function (image) {
                                    image.set({
                                        id: element.id,
                                        left: element.left,
                                        top: element.top,
                                        angle: element.angle,
                                        padding: element.padding,
                                        cornersize: element.cornersize,
                                        hasRotatingPoint: true,
                                        originX: "center",
                                        originY: "center",
                                        centeredRotation: true
                                    });
                                    image.scaleToHeight(100);
                                    image.scaleToWidth(100);
                                    canvas.add(image);
                                },
                                null,
                                { crossOrigin: "Anonymous" }
                            );
                        }
                    }
                });
            }
        },
        // prev() {
        //     this.step--;
        // },
        // next() {
        //     this.step++;
        // },
        getAvailablePrintFlipsFromProduct() {
            const imprintLocations =
                this.gender_groups_items &&
                this.gender_groups_items[this.active_gender_key || 0] &&
                this.gender_groups_items[this.active_gender_key || 0]
                    .imprint_locations
                    ? this.gender_groups_items[this.active_gender_key || 0]
                          .imprint_locations
                    : [];
            const supported = new Set();
            (imprintLocations || []).forEach((loc) => {
                const label =
                    (loc && (loc.location || loc.label_show || loc.label)) ||
                    "";
                const lower = String(label).toLowerCase();
                if (lower.includes("front")) supported.add("Front");
                if (lower.includes("back")) supported.add("Back");
                if (lower.includes("left")) supported.add("Left");
                if (lower.includes("right")) supported.add("Right");
            });
            if (this.front_show) supported.add("Front");
            if (this.back_show) supported.add("Back");
            if (this.left_show) supported.add("Left");
            if (this.right_show) supported.add("Right");
            // If we still can't infer anything, assume Front so we don't block incorrectly.
            if (supported.size === 0) supported.add("Front");
            return Array.from(supported);
        },
        getUsedFlipsFromDesignResponse(design) {
            const used = new Set();
            if (!design) return ["Front"];
            if (design.front_color != null || design.front_image)
                used.add("Front");
            if (design.back_color != null || design.back_image)
                used.add("Back");
            if (design.left_color != null || design.left_image)
                used.add("Left");
            if (design.right_color != null || design.right_image)
                used.add("Right");
            if (used.size === 0) used.add("Front");
            return Array.from(used);
        },
        showDesignLocationMismatchModal(
            designName,
            requiredFlips,
            availableFlips
        ) {
            this.designLocationMismatch = {
                designName: designName || "This design",
                requiredFlips: requiredFlips || [],
                availableFlips: availableFlips || []
            };
            this.$nextTick(() => {
                /* eslint-disable */
                $("#design-location-mismatch-modal").modal("show");
                /* eslint-enable */
            });
        },
        showDesignImprintTooSmallModal(designName) {
            this.designImprintTooSmall = {
                designName: designName || "This design"
            };
            this.$nextTick(() => {
                /* eslint-disable */
                $("#design-imprint-too-small-modal").modal("show");
                /* eslint-enable */
            });
        },
        getDesignAreaPixelDimensionsForFlip(flip) {
            if (!this.design_area_data || !Array.isArray(this.design_area_data)) {
                return null;
            }
            const label =
                flip.charAt(0).toUpperCase() + flip.slice(1);
            const area = this.design_area_data.find(
                (a) =>
                    a &&
                    a.label &&
                    (a.label === label ||
                        (flip === "front" &&
                            String(a.label).toLowerCase().includes("front")) ||
                        (flip === "back" &&
                            String(a.label).toLowerCase().includes("back")) ||
                        (flip === "left" &&
                            String(a.label).toLowerCase().includes("left")) ||
                        (flip === "right" &&
                            String(a.label).toLowerCase().includes("right")))
            );
            if (!area) return null;
            if (area.width != null && area.height != null) {
                const w = parseFloat(area.width);
                const h = parseFloat(area.height);
                if (w > 0 && h > 0) {
                    return { width: w, height: h };
                }
            }
            const eff = this.getEffectiveDesignAreaDimensionsForFlip(flip);
            if (eff && eff.width > 0 && eff.height > 0) {
                return eff;
            }
            const widthIn =
                area.widthIn != null
                    ? parseFloat(area.widthIn)
                    : area.width != null
                    ? parseFloat(area.width)
                    : null;
            const heightIn =
                area.heightIn != null
                    ? parseFloat(area.heightIn)
                    : area.height != null
                    ? parseFloat(area.height)
                    : null;
            if (
                typeof widthIn === "number" &&
                !isNaN(widthIn) &&
                widthIn > 0 &&
                typeof heightIn === "number" &&
                !isNaN(heightIn) &&
                heightIn > 0
            ) {
                const maxW = this.defaultWidthCanvas * 0.95;
                const maxH = this.defaultHeightCanvas * 0.95;
                const widthPx = widthIn * 96;
                const heightPx = heightIn * 96;
                const scale = Math.min(maxW / widthPx, maxH / heightPx);
                return {
                    width: Math.round(widthPx * scale),
                    height: Math.round(heightPx * scale)
                };
            }
            return null;
        },
        getMaxImprintDimensionsFromCanvasObjects(objects) {
            let maxW = 0;
            let maxH = 0;
            if (!Array.isArray(objects)) {
                return { maxW, maxH };
            }
            for (let j = 0; j < objects.length; j++) {
                const o = objects[j];
                if (!o || o.type === "rect" || this.isNameNumberObject(o)) {
                    continue;
                }
                const w =
                    (parseFloat(o.width) || 0) * (parseFloat(o.scaleX) || 1);
                const h =
                    (parseFloat(o.height) || 0) * (parseFloat(o.scaleY) || 1);
                if (w > maxW) maxW = w;
                if (h > maxH) maxH = h;
            }
            return { maxW, maxH };
        },
        isDesignImprintTooSmall(saved_design) {
            if (!saved_design || !saved_design.canvas_json) {
                return false;
            }
            if (!this.design_area_data || !Array.isArray(this.design_area_data)) {
                return false;
            }
            const parsed =
                typeof saved_design.canvas_json === "string"
                    ? JSON.parse(saved_design.canvas_json)
                    : saved_design.canvas_json;
            const flips = ["front", "back", "left", "right"];
            const FIT_MARGIN = 0.9;
            for (let i = 0; i < flips.length; i++) {
                const flip = flips[i];
                const raw = parsed && parsed[flip] ? parsed[flip] : null;
                if (!raw) continue;
                const flipData =
                    typeof raw === "string" ? JSON.parse(raw) : raw;
                const objects =
                    flipData && Array.isArray(flipData.objects)
                        ? flipData.objects
                        : [];
                const { maxW: maxObjW, maxH: maxObjH } =
                    this.getMaxImprintDimensionsFromCanvasObjects(objects);
                if (!(maxObjW > 0 || maxObjH > 0)) continue;

                const newDims =
                    this.getDesignAreaPixelDimensionsForFlip(flip);
                if (!newDims) continue;
                const newW = newDims.width;
                const newH = newDims.height;

                // Block only when artwork cannot fit in the new printable area
                // (same 90% rule used when loading/scaling on canvas).
                if (
                    maxObjW > newW * FIT_MARGIN ||
                    maxObjH > newH * FIT_MARGIN
                ) {
                    return true;
                }
            }
            return false;
        },
        getUsedFlipsFromSavedDesign(saved_design) {
            const used = new Set();
            // Preferred: canvas_json saved as new_canvas_elements object { front: "...", back: "...", ... }
            if (saved_design && saved_design.canvas_json) {
                try {
                    const parsed =
                        typeof saved_design.canvas_json === "string"
                            ? JSON.parse(saved_design.canvas_json)
                            : saved_design.canvas_json;
                    ["front", "back", "left", "right"].forEach((flip) => {
                        const raw =
                            parsed && parsed[flip] ? parsed[flip] : null;
                        if (!raw) return;
                        try {
                            const canvasJson =
                                typeof raw === "string" ? JSON.parse(raw) : raw;
                            const objects =
                                canvasJson && canvasJson.objects
                                    ? canvasJson.objects
                                    : [];
                            if (Array.isArray(objects) && objects.length > 0) {
                                used.add(
                                    flip.charAt(0).toUpperCase() + flip.slice(1)
                                );
                            }
                        } catch (e) {}
                    });
                } catch (e) {}
            }
            // Fallback: older saved design payload (product_details -> canvas_objects with element.flip)
            if (
                used.size === 0 &&
                saved_design &&
                saved_design.product_details
            ) {
                try {
                    (saved_design.product_details || []).forEach((pd) => {
                        const objs =
                            pd && pd.canvas_objects
                                ? JSON.parse(pd.canvas_objects)
                                : [];
                        (objs || []).forEach((el) => {
                            const flip =
                                el && el.flip
                                    ? String(el.flip).toLowerCase()
                                    : "";
                            if (flip === "front") used.add("Front");
                            if (flip === "back") used.add("Back");
                            if (flip === "left") used.add("Left");
                            if (flip === "right") used.add("Right");
                        });
                    });
                } catch (e) {}
            }
            // If we still can't infer, assume Front (safe, non-blocking).
            if (used.size === 0) used.add("Front");
            return Array.from(used);
        },
        setDesign(saved_design) {
            // Prevent applying a saved design that uses locations not supported by this product.
            // Example: product has only Front, but design contains both Front + Back.
            try {
                const available = this.getAvailablePrintFlipsFromProduct();
                const used = this.getUsedFlipsFromSavedDesign(saved_design);
                const availableSet = new Set(available.map((x) => String(x)));
                const missing = used.filter(
                    (x) => !availableSet.has(String(x))
                );
                if (missing.length > 0) {
                    this.showDesignLocationMismatchModal(
                        (saved_design &&
                            (saved_design.design_name || saved_design.name)) ||
                            "This design",
                        used,
                        available
                    );
                    return;
                }
            } catch (e) {}

            try {
                if (this.isDesignImprintTooSmall(saved_design)) {
                    // console.log(
                    //     "[DesignStudioV3] setDesign blocked: imprint too small",
                    //     (saved_design &&
                    //         (saved_design.design_name || saved_design.name)) ||
                    //         "This design"
                    // );
                    this.showDesignImprintTooSmallModal(
                        (saved_design &&
                            (saved_design.design_name || saved_design.name)) ||
                            "This design"
                    );
                    return;
                }
            } catch (e) {}

            this.canvas_elements = "";
            localStorage.setItem(
                "canvas_elements",
                JSON.stringify(this.canvas_elements)
            );
            let product_details = saved_design.product_details;
            let values = [];
            this.user_selected_values = [];
            this.product_title = saved_design["product_title"];
            this.product_number = saved_design["product_number"];
            this.product_id = saved_design.id;
            this.design_name = saved_design.design_name;
            this.base_price = saved_design.retail_base_price;
            this.base_price = this.base_price ? this.base_price.toFixed(2) : 0;
            let gender = product_details[0].gender;
            product_details.forEach((element) => {
                values.push({
                    [element.gender]: JSON.parse(element.canvas_objects)
                });
                this.genders.push(element.gender);
            });

            this.canvas_elements = values;
            localStorage.setItem(
                "canvas_elements",
                JSON.stringify(this.canvas_elements)
            );
            this.active_gender = gender;
            this.active_gender_key = 0;
            localStorage.setItem("active_gender", gender);
            localStorage.setItem("active_gender_key", 0);
            if (document.querySelector("#tshirtFacing")) {
                document.querySelector("#tshirtFacing").style.background =
                    this.user_selected_values[0].color_hash;
            }
            localStorage.setItem(
                "active_tshirt_color",
                this.user_selected_values[0].color_hash
            );
            this.tshirt_color = this.user_selected_values[0].color_hash;

            const _this = this;

            if (saved_design.canvas_json) {
                try {
                    let parsed =
                        typeof saved_design.canvas_json === "string"
                            ? JSON.parse(saved_design.canvas_json)
                            : saved_design.canvas_json;
                    parsed.products_id = String(this.product_id);
                    localStorage.setItem(
                        "new_canvas_elements",
                        JSON.stringify(parsed)
                    );
                } catch (e) {
                    console.warn("setDesign: invalid canvas_json", e);
                }
            } else {
                const elementsToAdd =
                    this.canvas_elements[this.active_gender_key] &&
                    this.canvas_elements[this.active_gender_key][
                        this.active_gender
                    ]
                        ? this.canvas_elements[this.active_gender_key][
                              this.active_gender
                          ]
                        : [];
                const addImagesToCanvas = () => {
                    if (!_this.backCanvas || !elementsToAdd.length) return;
                    elementsToAdd.forEach((element) => {
                        if (
                            (element.type === "template" ||
                                element.type === "shape" ||
                                element.type === "patch" ||
                                element.type === "upload") &&
                            element.flip === localStorage.getItem("active_flip")
                        ) {
                            fabric.Image.fromURL(
                                element.url,
                                function (image) {
                                    image.set({
                                        id: element.id,
                                        left: element.left,
                                        top: element.top,
                                        angle: element.angle,
                                        padding: element.padding,
                                        cornersize: element.cornersize,
                                        hasRotatingPoint: true,
                                        originX: "center",
                                        originY: "center",
                                        centeredRotation: true
                                    });
                                    image.scaleToHeight(100);
                                    image.scaleToWidth(100);
                                    _this.backCanvas.add(image);
                                    _this.backCanvas.renderAll();
                                    _this.saveCanvasData();
                                },
                                null,
                                { crossOrigin: "Anonymous" }
                            );
                        }
                    });
                };
                if (this.backCanvas) addImagesToCanvas();
                else this.$nextTick(() => setTimeout(addImagesToCanvas, 300));
            }

            if (
                saved_design.design_json &&
                this.gender_groups_items &&
                this.gender_groups_items.length > 0
            ) {
                try {
                    let designJson =
                        typeof saved_design.design_json === "string"
                            ? JSON.parse(saved_design.design_json)
                            : saved_design.design_json;
                    if (
                        designJson &&
                        designJson.allitems &&
                        Array.isArray(designJson.allitems)
                    ) {
                        let nameNumberDataByColor = {};
                        designJson.allitems.forEach((item) => {
                            if (
                                item.color_id &&
                                item.name_and_number_json &&
                                (Array.isArray(item.name_and_number_json)
                                    ? item.name_and_number_json.length > 0
                                    : typeof item.name_and_number_json ===
                                      "object")
                            ) {
                                let itemPrices =
                                    typeof item.item_prices === "string"
                                        ? JSON.parse(item.item_prices)
                                        : item.item_prices;
                                nameNumberDataByColor[item.color_id] = {
                                    name_and_number_json:
                                        typeof item.name_and_number_json ===
                                        "string"
                                            ? JSON.parse(
                                                  item.name_and_number_json
                                              )
                                            : item.name_and_number_json,
                                    name_number_counts:
                                        item.name_number_counts &&
                                        typeof item.name_number_counts ===
                                            "object"
                                            ? item.name_number_counts
                                            : null,
                                    item_prices: itemPrices,
                                    font_color_sizes_name:
                                        item.font_color_sizes_name
                                            ? typeof item.font_color_sizes_name ===
                                              "string"
                                                ? JSON.parse(
                                                      item.font_color_sizes_name
                                                  )
                                                : item.font_color_sizes_name
                                            : null,
                                    font_color_sizes_number:
                                        item.font_color_sizes_number
                                            ? typeof item.font_color_sizes_number ===
                                              "string"
                                                ? JSON.parse(
                                                      item.font_color_sizes_number
                                                  )
                                                : item.font_color_sizes_number
                                            : null,
                                    view_settings:
                                        item.view_settings &&
                                        typeof item.view_settings === "object"
                                            ? item.view_settings
                                            : null
                                };
                            }
                        });
                        if (
                            Object.keys(nameNumberDataByColor).length > 0 &&
                            this.gender_groups_items[this.active_gender_key] &&
                            this.gender_groups_items[this.active_gender_key]
                                .colors
                        ) {
                            var firstSavedDataSet = Object.values(
                                nameNumberDataByColor
                            )[0];
                            var _thisSetDesign = this;
                            this.gender_groups_items[
                                this.active_gender_key
                            ].colors.forEach((color) => {
                                let colorData =
                                    nameNumberDataByColor[color.id] ||
                                    firstSavedDataSet;
                                if (colorData) {
                                    if (colorData.name_and_number_json) {
                                        _thisSetDesign.$set(
                                            color,
                                            "name_and_number_json",
                                            JSON.parse(
                                                JSON.stringify(
                                                    colorData.name_and_number_json
                                                )
                                            )
                                        );
                                    }
                                    // selected_name_number: prefer inside name_and_number_json, else item_prices (so NameAndNumber finds it)
                                    var snn =
                                        (color.name_and_number_json &&
                                            typeof color.name_and_number_json ===
                                                "object" &&
                                            !Array.isArray(
                                                color.name_and_number_json
                                            ) &&
                                            color.name_and_number_json
                                                .selected_name_number) ||
                                        (colorData.item_prices &&
                                            colorData.item_prices
                                                .selected_name_number);
                                    if (snn) {
                                        var snnCopy = JSON.parse(
                                            JSON.stringify(snn)
                                        );
                                        _thisSetDesign.$set(
                                            color,
                                            "selected_name_number",
                                            snnCopy
                                        );
                                        if (
                                            color.name_and_number_json &&
                                            typeof color.name_and_number_json ===
                                                "object" &&
                                            !Array.isArray(
                                                color.name_and_number_json
                                            )
                                        ) {
                                            _thisSetDesign.$set(
                                                color.name_and_number_json,
                                                "selected_name_number",
                                                snnCopy
                                            );
                                        } else if (
                                            Array.isArray(
                                                color.name_and_number_json
                                            )
                                        ) {
                                            var arr =
                                                color.name_and_number_json;
                                            _thisSetDesign.$set(
                                                color,
                                                "name_and_number_json",
                                                {
                                                    front: arr,
                                                    back: arr,
                                                    left: arr,
                                                    right: arr,
                                                    selected_name_number:
                                                        snnCopy
                                                }
                                            );
                                        }
                                    }
                                    if (
                                        colorData.view_settings &&
                                        typeof colorData.view_settings ===
                                            "object" &&
                                        Object.keys(colorData.view_settings)
                                            .length > 0
                                    ) {
                                        _thisSetDesign.$set(
                                            color,
                                            "view_settings",
                                            JSON.parse(
                                                JSON.stringify(
                                                    colorData.view_settings
                                                )
                                            )
                                        );
                                    } else if (
                                        colorData.font_color_sizes_name ||
                                        colorData.font_color_sizes_number
                                    ) {
                                        var fn =
                                            colorData.font_color_sizes_name ||
                                            {};
                                        var fnum =
                                            colorData.font_color_sizes_number ||
                                            {};
                                        var built = {};
                                        [
                                            "front",
                                            "back",
                                            "left",
                                            "right"
                                        ].forEach(function (v) {
                                            built[v] = {
                                                nameSettings: {
                                                    fontFamily:
                                                        fn.nameFontFamily ||
                                                        "Verdana",
                                                    fontSize: String(
                                                        fn.nameFontSize || "21"
                                                    ),
                                                    fontColor:
                                                        fn.nameFontColor ||
                                                        "#000000",
                                                    colorId:
                                                        fn.color_id != null
                                                            ? fn.color_id
                                                            : null,
                                                    colorName: null,
                                                    decor_upcharge:
                                                        fn.decor_upcharge || 0
                                                },
                                                numberSettings: {
                                                    fontFamily:
                                                        fnum.numberFontFamily ||
                                                        "Verdana",
                                                    fontSize: String(
                                                        fnum.numberFontSize ||
                                                            "96"
                                                    ),
                                                    fontColor:
                                                        fnum.numberFontColor ||
                                                        "#000000",
                                                    colorId:
                                                        fnum.color_id != null
                                                            ? fnum.color_id
                                                            : null,
                                                    colorName: null,
                                                    decor_upcharge:
                                                        fnum.decor_upcharge || 0
                                                }
                                            };
                                        });
                                        _thisSetDesign.$set(
                                            color,
                                            "view_settings",
                                            built
                                        );
                                    }
                                    if (
                                        (!colorData.view_settings ||
                                            Object.keys(
                                                colorData.view_settings || {}
                                            ).length === 0) &&
                                        this.$refs.nameAndNumberRef &&
                                        (colorData.font_color_sizes_name ||
                                            colorData.font_color_sizes_number)
                                    ) {
                                        if (
                                            colorData.font_color_sizes_name &&
                                            this.$refs.nameAndNumberRef
                                                .setColorSizesForName
                                        ) {
                                            this.$refs.nameAndNumberRef.setColorSizesForName(
                                                colorData.font_color_sizes_name
                                            );
                                        }
                                        if (
                                            colorData.font_color_sizes_number &&
                                            this.$refs.nameAndNumberRef
                                                .setColorSizesForNumber
                                        ) {
                                            this.$refs.nameAndNumberRef.setColorSizesForNumber(
                                                colorData.font_color_sizes_number
                                            );
                                        }
                                    }
                                }
                            });
                            // Copy name/number data to other product colors so table + colors show on every color (e.g. red, grey)
                            let colorsArr =
                                this.gender_groups_items[this.active_gender_key]
                                    .colors;
                            let sourceColor =
                                colorsArr &&
                                colorsArr.find(function (c) {
                                    return (
                                        (c.name_and_number_json &&
                                            (Array.isArray(
                                                c.name_and_number_json
                                            )
                                                ? c.name_and_number_json
                                                      .length > 0
                                                : Object.keys(
                                                      c.name_and_number_json
                                                  ).length > 0)) ||
                                        (c.view_settings &&
                                            typeof c.view_settings ===
                                                "object" &&
                                            Object.keys(c.view_settings)
                                                .length > 0)
                                    );
                                });
                            if (sourceColor && colorsArr) {
                                let _this = this;
                                colorsArr.forEach(function (c) {
                                    if (c !== sourceColor) {
                                        if (sourceColor.name_and_number_json) {
                                            _this.$set(
                                                c,
                                                "name_and_number_json",
                                                JSON.parse(
                                                    JSON.stringify(
                                                        sourceColor.name_and_number_json
                                                    )
                                                )
                                            );
                                        }
                                        if (sourceColor.selected_name_number) {
                                            _this.$set(
                                                c,
                                                "selected_name_number",
                                                JSON.parse(
                                                    JSON.stringify(
                                                        sourceColor.selected_name_number
                                                    )
                                                )
                                            );
                                        }
                                        if (
                                            sourceColor.view_settings &&
                                            typeof sourceColor.view_settings ===
                                                "object"
                                        ) {
                                            _this.$set(
                                                c,
                                                "view_settings",
                                                JSON.parse(
                                                    JSON.stringify(
                                                        sourceColor.view_settings
                                                    )
                                                )
                                            );
                                        }
                                    }
                                });
                            }
                            // Use name_number_counts saved at save time (no recompute from JSON)
                            if (sourceColor) {
                                const savedData =
                                    nameNumberDataByColor[sourceColor.id] ||
                                    firstSavedDataSet;
                                const counts =
                                    savedData &&
                                    savedData.name_number_counts &&
                                    typeof savedData.name_number_counts ===
                                        "object"
                                        ? savedData.name_number_counts
                                        : null;
                                if (counts) {
                                    this.$set(
                                        this.gender_groups_items[
                                            this.active_gender_key
                                        ],
                                        "name_number_display_counts",
                                        counts
                                    );
                                }
                            }
                        }
                    }
                } catch (e) {
                    console.warn(
                        "setDesign: restore name-number from design_json",
                        e
                    );
                }
            }

            setTimeout(() => {
                if (saved_design.canvas_json && this.backCanvas) {
                    let resetJson = this.resetCanvasObjectPositions(
                        saved_design.canvas_json
                    );
                    if (resetJson) {
                        try {
                            let parsed =
                                typeof resetJson === "string"
                                    ? JSON.parse(resetJson)
                                    : resetJson;
                            parsed.products_id = String(this.product_id);
                            localStorage.setItem(
                                "new_canvas_elements",
                                JSON.stringify(parsed)
                            );
                        } catch (e) {}
                    }
                }
                this.preserveSavedDesignPositions = true;
                this.prepareImprintLocations(true, this.active_flip);
                this.preserveSavedDesignPositions = false;
                if (
                    saved_design.canvas_json &&
                    typeof this.restoreNameNumbersFromCanvas === "function"
                ) {
                    this.restoreNameNumbersFromCanvas();
                }
                // Set colorIndex so whichever color is selected (grey, red, etc.) gets name/number loaded
                let colorIdx =
                    this.activeColorIndex >= 0 ? this.activeColorIndex : 0;
                localStorage.setItem("colorIndex", String(colorIdx));
                let _thisSet = this;
                this.$nextTick(function () {
                    setTimeout(function () {
                        // Re-apply copy to all colors right before load so red/any selected color has data (in case of timing/order issues)
                        var colorsArr =
                            _thisSet.gender_groups_items &&
                            _thisSet.gender_groups_items[
                                _thisSet.active_gender_key
                            ] &&
                            _thisSet.gender_groups_items[
                                _thisSet.active_gender_key
                            ].colors;
                        var sourceColor =
                            colorsArr &&
                            colorsArr.find(function (c) {
                                return (
                                    (c.name_and_number_json &&
                                        (Array.isArray(c.name_and_number_json)
                                            ? c.name_and_number_json.length > 0
                                            : Object.keys(
                                                  c.name_and_number_json
                                              ).length > 0)) ||
                                    (c.view_settings &&
                                        typeof c.view_settings === "object" &&
                                        Object.keys(c.view_settings).length > 0)
                                );
                            });
                        if (sourceColor && colorsArr) {
                            colorsArr.forEach(function (c) {
                                if (c !== sourceColor) {
                                    if (sourceColor.name_and_number_json) {
                                        _thisSet.$set(
                                            c,
                                            "name_and_number_json",
                                            JSON.parse(
                                                JSON.stringify(
                                                    sourceColor.name_and_number_json
                                                )
                                            )
                                        );
                                    }
                                    if (sourceColor.selected_name_number) {
                                        _thisSet.$set(
                                            c,
                                            "selected_name_number",
                                            JSON.parse(
                                                JSON.stringify(
                                                    sourceColor.selected_name_number
                                                )
                                            )
                                        );
                                    }
                                    if (
                                        sourceColor.view_settings &&
                                        typeof sourceColor.view_settings ===
                                            "object"
                                    ) {
                                        _thisSet.$set(
                                            c,
                                            "view_settings",
                                            JSON.parse(
                                                JSON.stringify(
                                                    sourceColor.view_settings
                                                )
                                            )
                                        );
                                    }
                                }
                            });
                        }
                        var group =
                            _thisSet.gender_groups_items &&
                            _thisSet.gender_groups_items[
                                _thisSet.active_gender_key
                            ];
                        var activeColorObj =
                            group && group.colors && group.colors[colorIdx];
                        if (_thisSet.$refs.nameAndNumberRef) {
                            if (
                                typeof _thisSet.$refs.nameAndNumberRef
                                    .syncActiveView === "function"
                            ) {
                                _thisSet.$refs.nameAndNumberRef.syncActiveView();
                            }
                            if (
                                activeColorObj &&
                                typeof _thisSet.$refs.nameAndNumberRef
                                    .loadNameAndNumber === "function"
                            ) {
                                _thisSet.$refs.nameAndNumberRef.loadNameAndNumber(
                                    activeColorObj
                                );
                            } else {
                                _thisSet.$refs.nameAndNumberRef.loadFromColor();
                            }
                            if (
                                typeof _thisSet.updateNameNumberFees ===
                                "function"
                            )
                                _thisSet.updateNameNumberFees(true);
                            // Re-run ItemDetails pricing so name/number total count and fees refresh after restore
                            _thisSet.$nextTick(function () {
                                if (
                                    _thisSet.$refs.ItemDetails &&
                                    typeof _thisSet.$refs.ItemDetails
                                        .calculatePricing === "function"
                                ) {
                                    _thisSet.$refs.ItemDetails.calculatePricing(
                                        _thisSet.active_gender_key
                                    );
                                }
                            });
                            // Second pass after a short delay so Run Charge Breakdown shows correct counts even before user opens Names & Numbers panel
                            setTimeout(function () {
                                if (
                                    _thisSet.$refs.ItemDetails &&
                                    typeof _thisSet.$refs.ItemDetails
                                        .calculatePricing === "function"
                                ) {
                                    _thisSet.$refs.ItemDetails.calculatePricing(
                                        _thisSet.active_gender_key
                                    );
                                }
                            }, 400);
                        }
                        // Sync name/number colors for ALL product colors so dropdowns show on every color
                        if (_thisSet.$refs.ItemDetails) {
                            if (
                                typeof _thisSet.$refs.ItemDetails
                                    .syncNameNumberColorsForAllColors ===
                                "function"
                            ) {
                                _thisSet.$refs.ItemDetails.syncNameNumberColorsForAllColors();
                            } else if (
                                typeof _thisSet.$refs.ItemDetails
                                    .syncNameNumberColorsToImprintLocations ===
                                "function"
                            ) {
                                _thisSet.$refs.ItemDetails.syncNameNumberColorsToImprintLocations();
                            }
                        }
                        // Do not recenter name/number - preserve user position and stretch per location
                    }, 150);
                });
            }, 1200);
        },
        prev() {
            this.step--;
        },
        next() {
            this.step++;
        },
        flipTshirt(type) {
            var _this = this;
            if (_this.colors_validation) {
                this.$toast.error(this.colors_validation, {
                    position: "top-right",
                    queue: true
                });
                return true;
            }
            _this.resetElements(type);
            let selected_design_images = [];
            /* eslint-disable */
            if (type == "front") {
                $("#back_flipbtn").prop("disabled", true);
                $("#front_flipbtn").prop("disabled", false);
                $("#left_flipbtn").prop("disabled", false);
                $("#right_flipbtn").prop("disabled", false);
            }
            if (type == "back") {
                $("#back_flipbtn").prop("disabled", false);
                $("#front_flipbtn").prop("disabled", true);
                $("#left_flipbtn").prop("disabled", false);
                $("#right_flipbtn").prop("disabled", false);
            }
            if (type == "left") {
                $("#back_flipbtn").prop("disabled", false);
                $("#front_flipbtn").prop("disabled", false);
                $("#left_flipbtn").prop("disabled", true);
                $("#right_flipbtn").prop("disabled", false);
            }
            if (type == "right") {
                $("#back_flipbtn").prop("disabled", false);
                $("#front_flipbtn").prop("disabled", false);
                $("#left_flipbtn").prop("disabled", false);
                $("#right_flipbtn").prop("disabled", true);
            }
            /* eslint-enable */
            // USE gender_groups_items local variable
            let design_items = this.gender_groups_items;

            let get_canvas_colors = JSON.parse(
                localStorage.getItem("canvas_design_colors")
            );
            get_canvas_colors[_this.active_flip] = _this.design_current_colors;
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify(get_canvas_colors)
            );
            _this.design_current_colors = [];
            let design_images = JSON.parse(
                design_items[0]["colors"][this.activeColorIndex].id
            );
            let ele_img_front;
            let ele_img_back;
            let ele_img_left;
            let ele_img_right;
            design_items[0]["item"]["NewProductImages"].forEach((colors) => {
                if (
                    colors.color_id == design_images &&
                    colors.type == "front"
                ) {
                    selected_design_images.push({
                        front: colors.url
                    });
                }
                if (colors.color_id == design_images && colors.type == "back") {
                    selected_design_images.push({
                        back: colors.url
                    });
                }
                if (colors.color_id == design_images && colors.type == "left") {
                    selected_design_images.push({
                        left: colors.url
                    });
                }
                if (
                    colors.color_id == design_images &&
                    colors.type == "right"
                ) {
                    selected_design_images.push({
                        right: colors.url
                    });
                }
            });

            var front_img_required;
            var back_img_required;
            var left_img_required;
            var right_img_required;
            var default_color_img;
            if (selected_design_images.length > 0) {
                let filter_img = selected_design_images.filter(
                    (img) => "front" in img
                );
                if (filter_img.length > 0) {
                    ele_img_front = filter_img[0]["front"];
                } else {
                    front_img_required = true;
                }
                if (selected_design_images.length > 0) {
                    let filter_img = selected_design_images.filter(
                        (img) => "back" in img
                    );

                    if (filter_img.length > 0) {
                        ele_img_back = filter_img[0]["back"];
                    } else {
                        back_img_required = true;
                    }
                }
                if (selected_design_images.length > 0) {
                    let filter_img = selected_design_images.filter(
                        (img) => "left" in img
                    );
                    if (filter_img.length > 0) {
                        ele_img_left = filter_img[0]["left"];
                    } else {
                        left_img_required = true;
                    }
                }
                if (selected_design_images.length > 0) {
                    let filter_img = selected_design_images.filter(
                        (img) => "right" in img
                    );
                    if (filter_img.length > 0) {
                        ele_img_right = filter_img[0]["right"];
                    } else {
                        right_img_required = true;
                    }
                }
            } else {
                ele_img_front = "";
                ele_img_back = "";
                ele_img_left = "";
                ele_img_right = "";
            }
            Object.values(_this.design_area_data).forEach((element) => {
                if (element.label == "Front" && type == "front") {
                    let def_color = design_items[0]["item"][
                        "NewProductImages"
                    ].filter(
                        (color) =>
                            color.color_id == design_images &&
                            color.type != "front" &&
                            color.type != "back"
                    );
                    if (def_color.length > 0) {
                        default_color_img = def_color[0].url;
                    }
                    _this.background_image = ele_img_front
                        ? ele_img_front
                        : default_color_img;
                    if (front_img_required) {
                        // _this.$toast.error(
                        //     "please add front image for selected color",
                        //     {
                        //         position: "top-right",
                        //         queue: true
                        //     }
                        // );
                        _this.background_image = element.thumbnail
                            ? element.thumbnail
                            : "";
                    }

                    _this.front_canvas_height = parseFloat(element.height);
                    _this.front_canvas_width = parseFloat(element.width);
                    _this.front_canvas_top = element.top;
                    _this.front_canvas_left = element.left;
                    _this.front_canvas_angle = element.angle
                        ? element.angle
                        : 0;
                }
                if (element.label == "Back" && type == "back") {
                    let def_color = design_items[0]["item"][
                        "NewProductImages"
                    ].filter(
                        (color) =>
                            color.color_id == design_images &&
                            color.type != "front" &&
                            color.type != "back"
                    );
                    if (def_color.length > 0) {
                        default_color_img = def_color[0].url;
                    }
                    _this.background_image = ele_img_back
                        ? ele_img_back
                        : default_color_img;
                    if (back_img_required) {
                        // _this.$toast.error(
                        //     "please add back image for selected color",
                        //     {
                        //         position: "top-right",
                        //         queue: true
                        //     }
                        // );
                        _this.background_image = element.thumbnail
                            ? element.thumbnail
                            : "";
                    }

                    _this.front_canvas_height = parseFloat(element.height);
                    _this.front_canvas_width = parseFloat(element.width);
                    _this.front_canvas_top = element.top;
                    _this.front_canvas_left = element.left;
                    _this.front_canvas_angle = element.angle
                        ? element.angle
                        : 0;
                }
                if (element.label == "Left" && type == "left") {
                    // Priority: left image > element.thumbnail (fallback)
                    if (ele_img_left) {
                        _this.background_image = ele_img_left;
                        _this.background_image_sleeve = ele_img_left;
                    } else if (element.thumbnail) {
                        // Original behavior: directly use element.thumbnail (fallback)
                        _this.background_image_sleeve = _this.setUrl(
                            element.thumbnail
                        );
                        _this.background_image = _this.setUrl(
                            element.thumbnail
                        );
                    } else {
                        // If no thumbnail, set empty so color-based rectangle will be used
                        _this.background_image = "";
                        _this.background_image_sleeve = "";
                    }

                    // Set canvas dimensions from admin design area (element contains admin settings)
                    _this.popup_canvas_height = parseFloat(element.height);
                    _this.popup_canvas_width = parseFloat(element.width);
                    _this.popup_canvas_top = element.top;
                    _this.popup_canvas_left = element.left;
                    // For left/right, use same dimensions for front_canvas so design area uses admin settings
                    // This ensures objects are clipped within admin's design area
                    _this.front_canvas_height = parseFloat(element.height);
                    _this.front_canvas_width = parseFloat(element.width);
                    _this.front_canvas_top = element.top;
                    _this.front_canvas_left = element.left;
                    _this.front_canvas_angle = element.angle
                        ? element.angle
                        : 0;
                }
                if (element.label == "Right" && type == "right") {
                    // Priority: right image > element.thumbnail (fallback)
                    if (ele_img_right) {
                        _this.background_image = ele_img_right;
                    } else if (element.thumbnail) {
                        // Original behavior: directly use element.thumbnail (fallback)
                        _this.background_image = _this.setUrl(
                            element.thumbnail
                        );
                    } else {
                        // If no thumbnail, set empty so color-based rectangle will be used
                        _this.background_image = "";
                    }

                    // Set canvas dimensions from admin design area (element contains admin settings)
                    _this.popup_canvas_height = parseFloat(element.height);
                    _this.popup_canvas_width = parseFloat(element.width);
                    _this.popup_canvas_top = element.top;
                    _this.popup_canvas_left = element.left;
                    // For left/right, use same dimensions for front_canvas so design area uses admin settings
                    // This ensures objects are clipped within admin's design area
                    _this.front_canvas_height = parseFloat(element.height);
                    _this.front_canvas_width = parseFloat(element.width);
                    _this.front_canvas_top = element.top;
                    _this.front_canvas_left = element.left;
                    _this.front_canvas_angle = element.angle
                        ? element.angle
                        : 0;
                }
            });

            let canvasObject = JSON.stringify(_this.backCanvas);

            if (_this.canvasList == null) {
                _this.canvasList = { front: "", back: "", left: "", right: "" };
            }
            this.canvasList[_this.active_flip] = canvasObject;
            localStorage.setItem(
                "new_canvas_elements",
                JSON.stringify(this.canvasList)
            );
            _this.backCanvas.discardActiveObject();
            _this.onSelectedCleared();
            _this.backCanvas.clear();
            _this.canvasList = { front: "", back: "", left: "", right: "" };

            localStorage.setItem("active_flip", type);
            this.active_flip = type;

            let currentFlip =
                this.active_flip.charAt(0).toUpperCase() +
                this.active_flip.slice(1);
            let currentData = this.current_print_area.filter(function (
                printData
            ) {
                if (printData.label.includes(currentFlip)) return printData;
            });
            let productData = this.design_area_data.filter(function (
                printData
            ) {
                if (printData.label.includes(currentFlip)) return printData;
            });

            // Add null/undefined checks to prevent errors
            if (
                productData.length > 0 &&
                productData[0] &&
                productData[0].widthIn != null
            ) {
                this.front_canvas_width_inch = parseFloat(
                    productData[0].widthIn
                );
            } else if (
                currentData.length > 0 &&
                currentData[0] &&
                currentData[0].widthIn != null
            ) {
                this.front_canvas_width_inch = parseFloat(
                    currentData[0].widthIn
                );
            }

            if (
                productData.length > 0 &&
                productData[0] &&
                productData[0].heightIn != null
            ) {
                this.front_canvas_height_inch = parseFloat(
                    productData[0].heightIn
                );
            } else if (
                currentData.length > 0 &&
                currentData[0] &&
                currentData[0].heightIn != null
            ) {
                this.front_canvas_height_inch = parseFloat(
                    currentData[0].heightIn
                );
            }

            this.canvasList = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );
            if (this.canvasList[this.active_flip]) {
                fabric.util.enlivenObjects(
                    JSON.parse(this.canvasList[this.active_flip]).objects,
                    function (objects) {
                        var origRenderOnAddRemove =
                            _this.backCanvas.renderOnAddRemove;
                        _this.backCanvas.renderOnAddRemove = false;
                        const descriptors = JSON.parse(
                            _this.canvasList[_this.active_flip]
                        ).objects;
                        objects.forEach(function (o, idx) {
                            let type1 = o.ctype;
                            let onjType1 = o.objType;
                            let extension = o.iextension;
                            let product_id = o.product_id;
                            const desc = descriptors && descriptors[idx];
                            const patch_id = desc && desc.patch_id;
                            const material_id = desc && desc.material_id;
                            if (
                                type1 === "patch" &&
                                patch_id != null &&
                                material_id != null
                            ) {
                                if (o.set) {
                                    o.set("patch_id", patch_id);
                                    o.set("material_id", material_id);
                                } else {
                                    o.patch_id = patch_id;
                                    o.material_id = material_id;
                                }
                            }
                            if (type1 === "upload" && desc) {
                                if (o.set) {
                                    if (desc.uploadId != null)
                                        o.set("uploadId", desc.uploadId);
                                    if (desc.image_name != null)
                                        o.set("image_name", desc.image_name);
                                    if (desc.image_path != null)
                                        o.set("image_path", desc.image_path);
                                    if (desc.image_colors != null)
                                        o.set(
                                            "image_colors",
                                            desc.image_colors
                                        );
                                } else {
                                    if (desc.uploadId != null)
                                        o.uploadId = desc.uploadId;
                                    if (desc.image_name != null)
                                        o.image_name = desc.image_name;
                                    if (desc.image_path != null)
                                        o.image_path = desc.image_path;
                                    if (desc.image_colors != null)
                                        o.image_colors = desc.image_colors;
                                }
                            }
                            o.toObject = (function (toObject) {
                                return function () {
                                    const base = {
                                        ctype: type1,
                                        iextension: extension,
                                        image_name: o.image_name,
                                        image_path: o.image_path,
                                        width_inch: o.width_inch,
                                        height_inch: o.height_inch,
                                        objType: onjType1,
                                        product_id: product_id
                                    };
                                    if (
                                        type1 === "patch" &&
                                        patch_id != null &&
                                        material_id != null
                                    ) {
                                        base.patch_id = patch_id;
                                        base.material_id = material_id;
                                    }
                                    if (type1 === "upload") {
                                        base.uploadId =
                                            o.uploadId != null
                                                ? o.uploadId
                                                : o.get && o.get("uploadId");
                                        base.image_colors =
                                            o.image_colors != null
                                                ? o.image_colors
                                                : o.get &&
                                                  o.get("image_colors");
                                    }
                                    return fabric.util.object.extend(
                                        toObject.call(this),
                                        base
                                    );
                                };
                            })(o.toObject);
                            if (o.type !== "rect") {
                                // Clear clipPath if design_box doesn't exist (for left/right views without image)
                                if (!_this.design_box && o.clipPath) {
                                    o.clipPath = null;
                                }
                                _this.backCanvas.add(o);
                            }
                            // Re-apply fixed-size locks for patch objects loaded from storage
                            if (type1 === "patch") {
                                o.set({
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    lockUniScaling: true,
                                    hasControls: true
                                });
                                if (
                                    typeof o.setControlsVisibility ===
                                    "function"
                                ) {
                                    o.setControlsVisibility({
                                        mt: false,
                                        mb: false,
                                        ml: false,
                                        mr: false,
                                        tl: false,
                                        tr: false,
                                        bl: false,
                                        br: false,
                                        mtr: true
                                    });
                                }
                            }
                        });
                        // Ensure name/number objects are selectable when loaded (e.g. on back view)
                        _this.backCanvas.getObjects().forEach(function (obj) {
                            var ot =
                                obj.objType ||
                                (obj.toObject && obj.toObject().objType);
                            if (
                                ot &&
                                (ot === "name" ||
                                    ot === "number" ||
                                    (typeof ot === "string" &&
                                        (ot.indexOf("name_") === 0 ||
                                            ot.indexOf("number_") === 0)))
                            ) {
                                obj.set({
                                    selectable: true,
                                    evented: true,
                                    hasControls: true
                                });
                            }
                        });
                        _this.backCanvas.renderOnAddRemove =
                            origRenderOnAddRemove;
                        _this.backCanvas.renderAll();
                        // Recalculate patch pricing after location switch (aggregate all locations)
                        if (typeof _this.calculatePatchCost === "function") {
                            _this.$nextTick(() => _this.calculatePatchCost());
                        }
                    }
                ); //end enlivenObjects
            } else {
                // No objects on this location; still recalculate to aggregate other locations
                if (typeof _this.calculatePatchCost === "function") {
                    _this.$nextTick(() => _this.calculatePatchCost());
                }
            }
            /* eslint-disable */
            $("." + type).addClass("active");
            /* eslint-enable */
            this.tshirtImage = _this.background_image;
            fabric.Object.prototype.objectCaching = false;
            let elem = document.querySelector("#tcanvas").parentNode;
            let elem_image = document.querySelector("#bcanvas").parentNode;
            if (type == "front" || type == "back") {
                let hasValidImage =
                    _this.background_image &&
                    _this.background_image !== "" &&
                    _this.background_image !== "null" &&
                    _this.background_image !== null &&
                    typeof _this.background_image === "string" &&
                    _this.background_image.trim() !== "" &&
                    !_this.background_image.includes("null");
                let currentAreaFB = null;
                if (
                    _this.design_area_data &&
                    Array.isArray(_this.design_area_data)
                ) {
                    currentAreaFB = _this.design_area_data.find(
                        (a) =>
                            a && a.label && a.label.toLowerCase().includes(type)
                    );
                }
                let useCustomBoxFB =
                    currentAreaFB && currentAreaFB.use_custom_box === true;
                // When use_custom_box is true: show color rectangle instead of image, then add design area
                if (hasValidImage && !useCustomBoxFB) {
                    _this.imageCanvas.setBackgroundColor(
                        "",
                        _this.imageCanvas.renderAll.bind(_this.imageCanvas)
                    );
                    _this.imageCanvas.renderAll();
                    _this.updateImageToBackCanvas(_this.background_image);
                    _this.addDesignArea();
                    elem.classList.remove("left_right_sleeve_canvas");
                    elem_image.classList.remove("left-right-tshirt");
                } else {
                    let activeColor = localStorage.getItem(
                        "active_tshirt_color"
                    );
                    fabric.Object.prototype.objectCaching = false;
                    _this.imageCanvas.clear();
                    _this.imageCanvas.renderAll();
                    _this.background_image = "";
                    _this.imageCanvas.backgroundImage = 0;
                    _this.design_box = "";
                    if (
                        !activeColor ||
                        activeColor === "null" ||
                        activeColor === "#null" ||
                        activeColor === ""
                    ) {
                        activeColor =
                            _this.user_selected_values[
                                _this.active_gender_key
                            ] &&
                            _this.user_selected_values[_this.active_gender_key]
                                .color_hash
                                ? _this.user_selected_values[
                                      _this.active_gender_key
                                  ].color_hash
                                : "#FFFFFF";
                    }
                    _this.imageCanvas.setBackgroundColor(
                        activeColor,
                        _this.imageCanvas.renderAll.bind(_this.imageCanvas)
                    );
                    _this.imageCanvas.renderAll();
                    elem.classList.add("left_right_sleeve_canvas");
                    elem_image.classList.add("left-right-tshirt");
                    if (useCustomBoxFB) {
                        let fallbackDim =
                            _this.getEffectiveDesignAreaDimensionsForFlip(type);
                        if (fallbackDim) {
                            _this.front_canvas_width = fallbackDim.width;
                            _this.front_canvas_height = fallbackDim.height;
                            _this.front_canvas_left = 0;
                            _this.front_canvas_top = 0;
                            _this.front_canvas_angle = 0;
                        }
                        _this.addDesignArea();
                        if (_this.design_box) {
                            _this.backCanvas
                                .getObjects()
                                .forEach(function (obj) {
                                    if (obj.type !== "rect") {
                                        obj.set("clipPath", _this.design_box);
                                        obj.setCoords();
                                    }
                                });
                            _this.backCanvas.renderAll();
                        }
                    } else {
                        _this.backCanvas.getObjects().forEach(function (obj) {
                            if (obj.type !== "rect" && obj.clipPath) {
                                obj.set("clipPath", null);
                            }
                        });
                        _this.centerNameNumberInVisibleArea();
                        _this.backCanvas.renderAll();
                    }
                }
            } else if (type == "left" || type == "right") {
                // For left/right: if image available and not use_custom_box, use image; else show color rectangle
                let hasValidImage =
                    _this.background_image &&
                    _this.background_image !== "" &&
                    _this.background_image !== "null" &&
                    _this.background_image !== null &&
                    typeof _this.background_image === "string" &&
                    _this.background_image.trim() !== "" &&
                    !_this.background_image.includes("null");

                let currentAreaLR = null;
                if (
                    _this.design_area_data &&
                    Array.isArray(_this.design_area_data)
                ) {
                    currentAreaLR = _this.design_area_data.find(
                        (a) =>
                            a && a.label && a.label.toLowerCase().includes(type)
                    );
                }
                let useCustomBoxLR =
                    currentAreaLR && currentAreaLR.use_custom_box === true;

                if (hasValidImage && !useCustomBoxLR) {
                    // Image available - use image and show admin's print area
                    _this.imageCanvas.setBackgroundColor(
                        "",
                        _this.imageCanvas.renderAll.bind(_this.imageCanvas)
                    );
                    _this.imageCanvas.renderAll();
                    _this.updateImageToBackCanvas(_this.background_image);
                    _this.addDesignArea();

                    if (_this.design_box) {
                        _this.backCanvas.getObjects().forEach(function (obj) {
                            if (obj.type !== "rect") {
                                obj.set("clipPath", _this.design_box);
                                obj.setCoords();
                            }
                        });
                        _this.backCanvas.renderAll();
                    }

                    elem.classList.remove("left_right_sleeve_canvas");
                    elem_image.classList.remove("left-right-tshirt");
                } else {
                    // No image or use_custom_box: show color rectangle (CSS wala rectangle)
                    let activeColor = localStorage.getItem(
                        "active_tshirt_color"
                    );
                    fabric.Object.prototype.objectCaching = false;
                    _this.imageCanvas.clear();
                    _this.imageCanvas.renderAll();
                    _this.background_image = "";
                    _this.imageCanvas.backgroundImage = 0;
                    _this.design_box = "";
                    if (
                        !activeColor ||
                        activeColor === "null" ||
                        activeColor === "#null" ||
                        activeColor === ""
                    ) {
                        activeColor =
                            _this.user_selected_values[
                                _this.active_gender_key
                            ] &&
                            _this.user_selected_values[_this.active_gender_key]
                                .color_hash
                                ? _this.user_selected_values[
                                      _this.active_gender_key
                                  ].color_hash
                                : "#FFFFFF";
                    }
                    _this.imageCanvas.setBackgroundColor(
                        activeColor,
                        _this.imageCanvas.renderAll.bind(_this.imageCanvas)
                    );
                    _this.imageCanvas.renderAll();
                    elem.classList.add("left_right_sleeve_canvas");
                    elem_image.classList.add("left-right-tshirt");

                    if (useCustomBoxLR) {
                        let fallbackDim =
                            _this.getEffectiveDesignAreaDimensionsForFlip(type);
                        if (fallbackDim) {
                            _this.front_canvas_width = fallbackDim.width;
                            _this.front_canvas_height = fallbackDim.height;
                            _this.front_canvas_left = 0;
                            _this.front_canvas_top = 0;
                            _this.front_canvas_angle = 0;
                        }
                        _this.addDesignArea();
                        if (_this.design_box) {
                            _this.backCanvas
                                .getObjects()
                                .forEach(function (obj) {
                                    if (obj.type !== "rect") {
                                        obj.set("clipPath", _this.design_box);
                                        obj.setCoords();
                                    }
                                });
                            _this.backCanvas.renderAll();
                        }
                    } else {
                        _this.backCanvas.getObjects().forEach(function (obj) {
                            if (obj.type !== "rect" && obj.clipPath) {
                                obj.set("clipPath", null);
                            }
                        });
                        _this.centerNameNumberInVisibleArea();
                        _this.backCanvas.renderAll();
                    }
                }
            } else {
                let activeColor = localStorage.getItem("active_tshirt_color");
                fabric.Object.prototype.objectCaching = false;
                _this.imageCanvas.clear();
                _this.imageCanvas.renderAll();
                _this.background_image = "";
                _this.imageCanvas.backgroundImage = 0;
                _this.imageCanvas.setBackgroundColor(
                    activeColor == "null" ||
                        activeColor == "#null" ||
                        activeColor == ""
                        ? "#FFFFFF"
                        : activeColor,
                    _this.imageCanvas.renderAll.bind(_this.imageCanvas)
                );
                _this.imageCanvas.renderAll();

                elem.classList.add("left_right_sleeve_canvas");
                elem_image.classList.add("left-right-tshirt");
            }
            if (_this.distress_images[_this.active_flip]) {
                _this.updateDistressImage(
                    _this.distress_images[_this.active_flip]
                );
            } else {
                _this.selectedDistressImage = null;
            }
            this.$refs.nameAndNumberRef.loadNameAndNumber(
                design_items[0]["colors"][this.activeColorIndex]
            );
            let imprint_locations =
                this.gender_groups_items[this.active_gender_key]
                    .imprint_locations;
            if (imprint_locations.length > 0) {
                let imprint_location_index = imprint_locations.findIndex(
                    (location) => {
                        if (!location || !location.location) return false;
                        const locLower = location.location.toLowerCase().trim();
                        // Exact match
                        if (locLower === this.active_flip) {
                            return true;
                        }
                        // Handle compound names like "left sleeve" matching "left"
                        if (
                            this.active_flip === "left" &&
                            locLower.includes("left")
                        ) {
                            return true;
                        }
                        if (
                            this.active_flip === "right" &&
                            locLower.includes("right")
                        ) {
                            return true;
                        }
                        if (
                            this.active_flip === "front" &&
                            locLower.includes("front")
                        ) {
                            return true;
                        }
                        if (
                            this.active_flip === "back" &&
                            locLower.includes("back")
                        ) {
                            return true;
                        }
                        return false;
                    }
                );
                if (imprint_location_index != -1) {
                    this.$refs.ItemDetails.updateAccordianFlip(
                        imprint_location_index
                    );

                    // Auto-select the view if it's not already selected
                    if (
                        !imprint_locations[imprint_location_index].is_selected
                    ) {
                        imprint_locations[
                            imprint_location_index
                        ].is_selected = true;

                        // Update the corresponding show flag
                        if (this.active_flip === "front") {
                            this.front_show = true;
                        } else if (this.active_flip === "back") {
                            this.back_show = true;
                        } else if (this.active_flip === "left") {
                            this.left_show = true;
                        } else if (this.active_flip === "right") {
                            this.right_show = true;
                        }

                        // Update all colors' imprint_locations to keep them in sync
                        if (
                            this.gender_groups_items[this.active_gender_key]
                                .colors
                        ) {
                            this.gender_groups_items[
                                this.active_gender_key
                            ].colors.forEach((color) => {
                                if (
                                    color.imprint_locations &&
                                    color.imprint_locations[
                                        imprint_location_index
                                    ]
                                ) {
                                    color.imprint_locations[
                                        imprint_location_index
                                    ].is_selected = true;
                                }
                            });
                        }

                        // Update print areas to reflect the changes
                        this.$nextTick(() => {
                            this.updatePrintAreas();
                        });
                    }
                }
            }
        },
        check_tshirt_position(array, id, flip) {
            var r = false;
            var prev_id = "";
            if (array)
                for (var i = 0; i < array.length; i++) {
                    if (prev_id != id) {
                        if (flip === array[i].flip && array[i].id === id) {
                            r = array[i].id === id;
                        }
                        if (r == true) {
                            prev_id = id;
                        }
                    }
                }

            return r;
        },
        delete_object() {
            let _this = this;
            var activeObject = _this.backCanvas.getActiveObject();
            let activeGroup = _this.backCanvas.getActiveObject();
            /* eslint-disable */
            if (activeObject) {
                _this.backCanvas.remove(activeObject);
                $("#text-string").val("");
                _this.backCanvas.discardActiveObject().renderAll();
            } else if (activeGroup) {
                var objectsInGroup = activeGroup.getObjects();
                _this.backCanvas.discardActiveGroup();
                objectsInGroup.forEach(function (object) {
                    _this.backCanvas.remove(object);
                });
            }
            $(".deleteBtn").remove();
            $(".rotationBtn").remove();
            /* eslint-enable */
            _this.onSelectedCleared();
            // Recalculate patch pricing after delete (object already removed from canvas)
            if (typeof _this.calculatePatchCost === "function") {
                _this.$nextTick(() => _this.calculatePatchCost());
            }
            setTimeout(() => {
                this.prepareImprintLocations();
            }, 1000);
        },
        closeEdit(type) {
            let _this = this;
            _this.sideBarCanvasStatus = false;
            /* eslint-disable */
            if (type == "templates") {
                _this.selected_category_heading = false;
                _this.selected_template_category_show = false;
                _this.category_heading = true;
                this.edit_template = false;
                var category_object = JSON.parse(
                    localStorage.getItem("category_object")
                );

                _this.selected_template_category = category_object;
                _this.template_name = category_object.name;
                let canvasele =
                    this.canvas_elements[this.active_gender_key][
                        this.active_gender
                    ];
                category_object["template_images"].some(function (item, indx) {
                    if (
                        _this.check_tshirt_position(
                            canvasele,
                            item.category_id + "" + indx,
                            _this.active_flip
                        )
                    ) {
                        category_object["template_images"][
                            indx
                        ].selected_images = true;
                    } else {
                        category_object["template_images"][
                            indx
                        ].selected_images = false;
                        _this.showMenu();
                    }
                });
            } else if (type == "clipart") {
                this.category_heading = true;
                this.edit_template = false;
                this.selected_clipart_category_show = false;
                let activeObject = _this.backCanvas.getActiveObject();
                const clipartSubId =
                    activeObject &&
                    (activeObject.des_std_clipart_id != null
                        ? activeObject.des_std_clipart_id
                        : activeObject.clipart_subcategory_id);
                const clipartSubName =
                    activeObject && activeObject.clipart_category_name;
                // Prefer active clipart's stored subcategory so back opens that clipart's category.
                if (clipartSubId && clipartSubName) {
                    _this
                        .refetchClipartCategories()
                        .then(() => {
                            let clipart_sub_category_data =
                                _this.clipart_category.find((item) => {
                                    const models =
                                        item.DesignStudioClipartModels || [];
                                    return (
                                        models.some(
                                            (m) => m.id == clipartSubId
                                        ) || item.id == clipartSubId
                                    );
                                });
                            if (
                                clipart_sub_category_data &&
                                clipart_sub_category_data.id
                            ) {
                                _this.getClipartCliparts(
                                    clipart_sub_category_data.id,
                                    clipart_sub_category_data.category_name
                                );
                            } else {
                                _this.getClipartCliparts(
                                    clipartSubId,
                                    clipartSubName
                                );
                            }
                        })
                        .catch(() => {
                            _this.getClipartCliparts(
                                clipartSubId,
                                clipartSubName
                            );
                        });
                    $(".deleteBtn").remove();
                    $(".rotationBtn").remove();
                    _this.rotationAngle = 0;
                    _this.backCanvas.discardActiveObject().renderAll();
                    return;
                }
                // State-wise: last opened subcategory (when active object has no stored category).
                if (
                    _this.selected_clipart_category_id &&
                    _this.clipart_category_name
                ) {
                    _this.refetchClipartCategories();
                    _this.getClipartCliparts(
                        _this.selected_clipart_category_id,
                        _this.clipart_category_name
                    );
                    $(".deleteBtn").remove();
                    $(".rotationBtn").remove();
                    _this.rotationAngle = 0;
                    _this.backCanvas.discardActiveObject().renderAll();
                    return;
                }
                // Fallback: find subcategory from active object + clipart_category (e.g. Popular or edge case)
                var category_object = JSON.parse(
                    localStorage.getItem("category_object") || "null"
                );
                let clipart_image_data = (
                    this.all_cliparts_images || []
                ).filter((item) => {
                    return (
                        activeObject &&
                        activeObject.image_name &&
                        activeObject.image_name
                            .toLowerCase()
                            .split(" ")
                            .every((v) =>
                                item.image_name.toLowerCase().includes(v)
                            )
                    );
                });
                const applyClipartBack = () => {
                    let clipart_sub_category_id =
                        clipart_image_data[0] &&
                        clipart_image_data[0].des_std_clipart_id;
                    let clipart_sub_category_data = "";
                    _this.clipart_category.map((item) => {
                        let image_category = (
                            item.DesignStudioClipartModels || []
                        ).filter((item1) => {
                            return item1.id == clipart_sub_category_id;
                        });
                        if (image_category.length > 0) {
                            clipart_sub_category_data = item;
                        }
                    });
                    if (
                        clipart_sub_category_data &&
                        clipart_sub_category_data.id
                    ) {
                        _this.getClipartCliparts(
                            clipart_sub_category_data.id,
                            clipart_sub_category_data.category_name
                        );
                    } else {
                        _this.clipart_subcategory_div = false;
                        _this.clipart_category_div = true;
                        _this.clipart_name = "";
                    }
                };
                _this
                    .refetchClipartCategories()
                    .then(applyClipartBack)
                    .catch(applyClipartBack);
            } else if (type == "patch") {
                this.category_heading = true;
                this.edit_template = false;
                this.selected_clipart_category_show = false;
                this.selected_clipart_category = "";
                this.clipart_name = "";
                this.patchNewSearchQuery = "";
                this.expandedMaterialIdsNew = [];
                this.loadPatchNewData();
                this.loadDsPatchInventory();
            }
            if (type == "shape" || type == "upload") {
                this.category_heading = true;
                this.edit_template = false;
                this.selected_clipart_category_show = false;
                this.selected_clipart_category = "";
                this.clipart_name = "";
            }
            $(".deleteBtn").remove();
            $(".rotationBtn").remove();
            /* eslint-enable */
            _this.rotationAngle = 0;
            this.backCanvas.discardActiveObject().renderAll();
            _this.showMenu();
        },
        getImages(category_object, type, index) {
            let _this = this;
            localStorage.setItem("type", type);
            localStorage.setItem("index", index);
            localStorage.setItem(
                "category_object",
                JSON.stringify(category_object)
            );
            this.selected_category_heading = true;
            if (type == "templates") {
                this.getCategoryTemplates(category_object.id).then((data) => {
                    category_object.template_images = data.template_designs;
                    let canvasele =
                        this.canvas_elements[this.active_gender_key][
                            this.active_gender
                        ];

                    category_object["template_images"].some(function (
                        item,
                        indx
                    ) {
                        if (
                            _this.check_tshirt_position(
                                canvasele,
                                item.category_id + "" + indx,
                                _this.active_flip
                            )
                        ) {
                            category_object["template_images"][
                                indx
                            ].selected_images = true;
                        } else {
                            category_object["template_images"][
                                indx
                            ].selected_images = false;
                        }
                    });
                    this.selected_template_category_show = true;
                    this.category_heading = false;
                    this.edit_template = false;
                    this.template_name = category_object.name;
                    this.selected_template_category = category_object;
                    this.$forceUpdate();
                });
            } else if (type == "clipart") {
                this.category_heading = false;
                this.edit_template = false;
                this.selected_clipart_category_show = true;
                this.selected_clipart_category = category_object;
                this.clipart_name = category_object.name;
            }
        },
        getPopularCliparts(loader = true) {
            return new Promise((resolve, reject) => {
                this.isLoader = loader;
                ApiService.get("/popular-cliparts")
                    .then(({ data }) => {
                        this.isLoader = false;
                        this.show_popular_cliparts = data.cliparts.length > 0;
                        this.all_cliparts_images = data.all_cliparts_images;
                        resolve(data);
                    })
                    .catch((response) => {
                        this.isLoader = false;
                        // console.log(response);
                        reject(response);
                    });
            });
        },
        showPopularCliparts() {
            this.getPopularCliparts().then((data) => {
                this.selected_category_heading = true;
                this.category_heading = false;
                this.edit_template = false;
                this.selected_clipart_category_show = true;
                this.selected_clipart_category = {
                    id: "PopularC",
                    DesignStudioClipartImagesModels: data.cliparts
                };
                this.clipart_name = "Popular";
                this.clipart_category_div = false;
                this.clipart_subcategory_div = true;
            });
        },
        getCategoryTemplates(sub_category_id) {
            this.isLoader = true;
            return new Promise((resolve, reject) => {
                ApiService.get(`/template-designs/${sub_category_id}`)
                    //ApiService.get(`/template-designs/`)
                    .then(({ data }) => {
                        this.isLoader = false;
                        resolve(data);
                    })
                    .catch((response) => {
                        this.isLoader = false;
                        reject(response);
                    });
            });
        },
        getPopularTemplates(loader = true) {
            return new Promise((resolve, reject) => {
                this.isLoader = loader;
                ApiService.get("/popular-templates")
                    .then(({ data }) => {
                        this.isLoader = false;
                        let same_product_popular = [];
                        same_product_popular = data.templates;

                        this.show_popular_templates =
                            same_product_popular.length > 0;
                        this.all_templates_images = data.all_templates_images;

                        resolve(data);
                    })
                    .catch((response) => {
                        this.isLoader = false;
                        // console.log(response);
                        reject(response);
                    });
            });
        },
        showPopularTemplates() {
            this.getPopularTemplates().then((data) => {
                let same_product_temp = [];

                // If active_product_type is null, show all popular templates (skip filtering)
                if (!this.active_product_type) {
                    same_product_temp = data.templates;
                } else {
                    same_product_temp = data.templates.filter(
                        (new_template) =>
                            new_template.product_type_id ==
                            this.active_product_type
                    );
                }

                this.selected_template_subcategory = {
                    id: "PopularT",
                    template_images: same_product_temp
                };
                this.selected_category_heading = true;
                this.selected_template_category_show = false;
                this.selected_template_subcategory_show = true;
                this.category_heading = false;
                this.edit_template = false;
                this.template_name = "Popular";
                this.$forceUpdate();
            });
        },
        selectTemplateCategory(category) {
            this.selected_category_heading = true;
            this.selected_template_category_show = true;
            this.category_heading = false;
            this.edit_template = false;
            this.template_name = category.name;
            this.selected_template_category = category;
            this.$forceUpdate();
        },
        getCustomImages(sub_category) {
            this.getCategoryTemplates(sub_category.id).then((data) => {
                sub_category.template_images = [];
                data.template_designs.forEach((template_design) => {
                    // If active_product_type is null, show all templates (skip product_type_id check)
                    let productTypeMatch =
                        !this.active_product_type ||
                        template_design.product_type_id ==
                            this.active_product_type;

                    if (
                        (template_design.product_category_id == null ||
                            parseInt(template_design.product_category_id) ==
                                parseInt(this.product_items.category_id)) &&
                        productTypeMatch
                    ) {
                        sub_category.template_images.push(template_design);
                    }
                });
                this.selected_category_heading = true;
                this.selected_template_category_show = false;
                this.selected_template_subcategory_show = true;
                this.category_heading = false;
                this.edit_template = false;
                this.template_name = sub_category.name;
                this.selected_template_subcategory = sub_category;
                this.$forceUpdate();
            });
        },
        EditImages(type) {
            //debugger;
            this.selected_category_heading = false;
            if (type == "templates") {
                this.selectedType = "templates";
            } else if (type == "clipart") {
                this.selectedType = "clipart";
            } else if (type == "patch") {
                this.selectedType = "patch";
            } else if (type == "shape") {
                this.selectedType = "shape";
            } else if (type == "upload") {
                this.selectedType = "upload";
            }
            this.selected_template_category_show = false;
            this.selected_clipart_category_show = false;

            this.category_heading = false;
            this.edit_template = true;
        },
        placeImage(
            event,
            selected_image,
            template_category_id,
            selected_image_index,
            type,
            image_data
        ) {
            let _this = this;
            if (_this.uploadModuleCanvas == 0) {
                _this.uploadModuleCanvas++;
                _this.saveCanvasData();
            }
            // Support auto-placement (event = null) from Product Details patch selection
            const isChecked =
                event === null
                    ? true
                    : event && event.target && event.target.checked;
            if (isChecked) {
                var offset = 50;
                var left = 0;
                var top = 0;
                // If printAreaBond is available, use its visual center (reliable for rotated design areas like lanyards)
                if (_this.printAreaBond) {
                    left =
                        _this.printAreaBond.left +
                        _this.printAreaBond.width / 2;
                    top =
                        _this.printAreaBond.top +
                        _this.printAreaBond.height / 2;
                } else if (
                    _this.active_flip == "front" ||
                    _this.active_flip == "back"
                ) {
                    var w =
                        (_this.front_canvas_width ||
                            fabric.util.getRandomInt(
                                0 + offset,
                                200 - offset
                            )) / 2;
                    var h = _this.front_canvas_height / 2;
                    left = _this.front_canvas_left + w;
                    top = _this.front_canvas_top + h;
                } else {
                    // For left/right: check if image is available
                    let hasValidImage =
                        _this.background_image &&
                        _this.background_image !== "" &&
                        _this.background_image !== "null" &&
                        _this.background_image !== null &&
                        typeof _this.background_image === "string" &&
                        _this.background_image.trim() !== "" &&
                        !_this.background_image.includes("null");

                    if (
                        hasValidImage &&
                        _this.front_canvas_width &&
                        _this.front_canvas_height &&
                        _this.front_canvas_left !== undefined &&
                        _this.front_canvas_top !== undefined
                    ) {
                        // Image available - position within design area (admin's print area) same as front/back
                        var w =
                            (_this.front_canvas_width ||
                                fabric.util.getRandomInt(
                                    0 + offset,
                                    200 - offset
                                )) / 2;
                        var h = _this.front_canvas_height / 2;
                        left = _this.front_canvas_left + w;
                        top = _this.front_canvas_top + h;
                    } else {
                        // No image - position at visible design area center (resized canvas)
                        left = _this.effectiveDesignAreaWidth / 2;
                        top = _this.effectiveDesignAreaHeight / 2;
                    }
                }
                var angle = 0;
                //this condition only for diamond patch 
                if (type === "patch") {
                    const { image_name = "", image_path = "" } = image_data || {};
                    const patchMeta = `${image_name} ${image_path}`.toLowerCase();

                    angle = patchMeta.includes("diamond") ? 43 : 0;
                }
                var padding = 10;
                var cornersize = 10;
                this.isLoader = true;

                selected_image = this.loadImageFromCrossOrigin(selected_image);

                if (selected_image.indexOf(".svg") == -1) {
                    fabric.Image.fromURL(
                        selected_image,
                        function (image) {
                            const objProps = {
                                id:
                                    template_category_id +
                                    "" +
                                    selected_image_index,
                                ctype: type,
                                asas: "ssd",
                                image_name: image_data.image_name,
                                image_path: image_data.image_path,
                                height_inch: "",
                                width_inch: "",
                                left: left,
                                top: top,
                                angle: angle,
                                padding: padding,
                                cornersize: cornersize,
                                hasRotatingPoint: true,
                                originX: "center",
                                originY: "center",
                                centeredRotation: true
                            };
                            if (
                                type === "patch" &&
                                image_data.id != null &&
                                image_data.material_id != null
                            ) {
                                objProps.patch_id = image_data.id;
                                objProps.material_id = image_data.material_id;
                            }
                            if (type === "clipart") {
                                objProps.des_std_clipart_id =
                                    template_category_id;
                                objProps.clipart_category_name =
                                    _this.clipart_category_name || "";
                            }
                            image.set(objProps);
                            image.scaleToHeight(100);
                            image.scaleToWidth(100);
                            if (
                                type === "patch" &&
                                image_data.id != null &&
                                image_data.material_id != null
                            ) {
                                image.toObject = (function (toObject) {
                                    return function () {
                                        return fabric.util.object.extend(
                                            toObject.call(this),
                                            {
                                                ctype: type,
                                                image_name:
                                                    image_data.image_name,
                                                image_path:
                                                    image_data.image_path,
                                                patch_id: image_data.id,
                                                material_id:
                                                    image_data.material_id
                                            }
                                        );
                                    };
                                })(image.toObject);
                            } else if (type === "clipart") {
                                image.toObject = (function (toObject) {
                                    return function () {
                                        return fabric.util.object.extend(
                                            toObject.call(this),
                                            {
                                                ctype: type,
                                                image_name:
                                                    image_data.image_name,
                                                image_path:
                                                    image_data.image_path,
                                                des_std_clipart_id:
                                                    template_category_id,
                                                clipart_category_name:
                                                    _this.clipart_category_name ||
                                                    ""
                                            }
                                        );
                                    };
                                })(image.toObject);
                            }
                            // Patch: use admin-defined width/height (inches) for fixed size
                            if (
                                type === "patch" &&
                                image_data.width > 0 &&
                                image_data.height > 0 &&
                                _this.front_canvas_width > 0 &&
                                parseFloat(_this.front_canvas_width_inch) > 0
                            ) {
                                const pxPerInch =
                                    _this.front_canvas_width /
                                    parseFloat(_this.front_canvas_width_inch);
                                const targetW = image_data.width * pxPerInch;
                                const targetH = image_data.height * pxPerInch;
                                image.set({
                                    scaleX: targetW / image.width,
                                    scaleY: targetH / image.height,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    lockUniScaling: true,
                                    hasControls: true
                                });
                                image.setControlsVisibility({
                                    mt: false,
                                    mb: false,
                                    ml: false,
                                    mr: false,
                                    tl: false,
                                    tr: false,
                                    bl: false,
                                    br: false,
                                    mtr: true
                                });
                                image.set({
                                    height_inch: parseFloat(
                                        image_data.height
                                    ).toFixed(2),
                                    width_inch: parseFloat(
                                        image_data.width
                                    ).toFixed(2)
                                });
                            } else if (
                                _this.front_canvas_width &&
                                _this.front_canvas_height &&
                                _this.front_canvas_width > 0 &&
                                _this.front_canvas_height > 0
                            ) {
                                // Non-patch or patch without dimensions: scale to fit design area
                                const maxWidth = _this.front_canvas_width * 0.8;
                                const maxHeight =
                                    _this.front_canvas_height * 0.8;
                                const scaleX = maxWidth / image.width;
                                const scaleY = maxHeight / image.height;
                                const scale = Math.min(scaleX, scaleY, 1);
                                image.scale(scale);
                            } else {
                                // Fallback to default scaling
                                image.scaleToHeight(100);
                                image.scaleToWidth(100);
                            }
                            _this.backCanvas.add(image);
                            _this.turnOffImageZoomIfActive();
                            // Set clipPath for all views (front, back, left, right) if design_box exists - AFTER adding to canvas
                            if (_this.design_box) {
                                image.set("clipPath", _this.design_box);
                            }
                            _this.backCanvas.renderAll();
                            _this.selectImageProps = {
                                rotation: 0,
                                flipX: false,
                                flipY: false,
                                center: "left"
                            };
                            _this.backCanvas.setActiveObject(image);
                            _this.saveCanvasData();
                            if (
                                type === "patch" &&
                                typeof _this.calculatePatchCost === "function"
                            ) {
                                _this.$nextTick(() =>
                                    _this.calculatePatchCost()
                                );
                            }
                            _this.EditImages(type);
                            _this.isLoader = false;
                        },
                        { crossOrigin: "Anonymous" }
                    );
                } else {
                    fabric.loadSVGFromURL(
                        selected_image,
                        function (objects, options) {
                            // here I load SVG image
                            var shape = fabric.util.groupSVGElements(
                                objects,
                                options
                            );

                            var originalColors = [];
                            const shapeProps = {
                                id:
                                    "'" +
                                    template_category_id +
                                    "" +
                                    selected_image_index +
                                    "'",
                                ctype: type,
                                iextension: "svg",
                                asas: "ssd",
                                image_name: image_data.image_name,
                                image_path: image_data.image_path,
                                height_inch: "",
                                width_inch: "",
                                left: left,
                                top: top,
                                originalColors,
                                angle: angle,
                                padding: 0,
                                cornersize: 0,
                                hasRotatingPoint: true,
                                originX: "center",
                                originY: "center",
                                centeredRotation: true,
                                clipPath: null
                            };
                            if (
                                type === "patch" &&
                                image_data.id != null &&
                                image_data.material_id != null
                            ) {
                                shapeProps.patch_id = image_data.id;
                                shapeProps.material_id = image_data.material_id;
                            }
                            if (type === "clipart") {
                                shapeProps.des_std_clipart_id =
                                    template_category_id;
                                shapeProps.clipart_category_name =
                                    _this.clipart_category_name || "";
                            }
                            shape.set(shapeProps);

                            shape.scaleToWidth(100);

                            // Add default outline for shapes
                            if (type === "shape") {
                                shape.set({
                                    stroke: "#000000",
                                    strokeWidth: 3,
                                    strokeLineCap: "round",
                                    strokeLineJoin: "round"
                                });
                                // For complex shapes with _objects, apply stroke to each path
                                if (shape._objects && shape._objects.length) {
                                    shape._objects.forEach(function (obj) {
                                        obj.set({
                                            stroke: "#000000",
                                            strokeWidth: 3,
                                            strokeLineCap: "round",
                                            strokeLineJoin: "round"
                                        });
                                    });
                                }
                            }

                            shape.toObject = (function (toObject) {
                                return function () {
                                    const base = {
                                        ctype: type,
                                        image_name: image_data.image_name,
                                        image_path: image_data.image_path,
                                        width_inch: "",
                                        height_inch: "",
                                        iextension: "svg",
                                        products_id:
                                            localStorage.getItem("product_id")
                                    };
                                    if (
                                        type === "patch" &&
                                        image_data.id != null &&
                                        image_data.material_id != null
                                    ) {
                                        base.patch_id = image_data.id;
                                        base.material_id =
                                            image_data.material_id;
                                    }
                                    if (type === "clipart") {
                                        base.des_std_clipart_id =
                                            template_category_id;
                                        base.clipart_category_name =
                                            _this.clipart_category_name || "";
                                    }
                                    return fabric.util.object.extend(
                                        toObject.call(this),
                                        base
                                    );
                                };
                            })(shape.toObject);
                            // Patch SVG: use admin-defined width/height (inches) for fixed size
                            if (
                                type === "patch" &&
                                image_data.width > 0 &&
                                image_data.height > 0 &&
                                _this.front_canvas_width > 0 &&
                                parseFloat(_this.front_canvas_width_inch) > 0
                            ) {
                                const pxPerInch =
                                    _this.front_canvas_width /
                                    parseFloat(_this.front_canvas_width_inch);
                                const targetW = image_data.width * pxPerInch;
                                const targetH = image_data.height * pxPerInch;
                                shape.set({
                                    scaleX: targetW / shape.width,
                                    scaleY: targetH / shape.height,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    lockUniScaling: true,
                                    hasControls: true
                                });
                                shape.setControlsVisibility({
                                    mt: false,
                                    mb: false,
                                    ml: false,
                                    mr: false,
                                    tl: false,
                                    tr: false,
                                    bl: false,
                                    br: false,
                                    mtr: true
                                });
                                shape.set({
                                    height_inch: parseFloat(
                                        image_data.height
                                    ).toFixed(2),
                                    width_inch: parseFloat(
                                        image_data.width
                                    ).toFixed(2)
                                });
                            } else if (
                                _this.front_canvas_width &&
                                _this.front_canvas_height &&
                                _this.front_canvas_width > 0 &&
                                _this.front_canvas_height > 0
                            ) {
                                // Non-patch or patch without dimensions: scale to fit design area
                                const maxWidth = _this.front_canvas_width * 0.8;
                                const maxHeight =
                                    _this.front_canvas_height * 0.8;
                                const scaleX = maxWidth / shape.width;
                                const scaleY = maxHeight / shape.height;
                                const scale = Math.min(scaleX, scaleY, 1);
                                shape.scale(scale);
                            } else {
                                // Fallback to default scaling
                                shape.scaleToHeight(100);
                            }
                            _this.selectImageProps = {
                                rotation: 0,
                                flipX: false,
                                flipY: false,
                                center: "left"
                            };
                            _this.backCanvas.add(shape);
                            _this.turnOffImageZoomIfActive();
                            // Set clipPath for all views (front, back, left, right) if design_box exists - AFTER adding to canvas
                            if (_this.design_box) {
                                shape.set("clipPath", _this.design_box);
                                shape.set("controlsAboveOverlay", true);
                            }
                            _this.backCanvas.renderAll();
                            _this.backCanvas.setActiveObject(shape);

                            // here we just save object in localstorage
                            _this.saveCanvasData();
                            if (
                                type === "patch" &&
                                typeof _this.calculatePatchCost === "function"
                            ) {
                                _this.$nextTick(() =>
                                    _this.calculatePatchCost()
                                );
                            }
                            _this.active_flip =
                                localStorage.getItem("active_flip");
                            _this.imagesSelectedCanvasType = _this.active_flip;
                            _this.EditImages(type);
                            _this.isLoader = false;

                            _this.active_flip =
                                localStorage.getItem("active_flip");
                            let canvasObject = JSON.stringify(_this.backCanvas);
                            let canvasList1 = {};
                            let previouscanvasList = {};
                            previouscanvasList = JSON.parse(
                                localStorage.getItem("new_canvas_elements")
                            );
                            if (previouscanvasList != null) {
                                if (
                                    previouscanvasList["front"] != null &&
                                    _this.active_flip != "front"
                                ) {
                                    canvasList1["front"] =
                                        previouscanvasList["front"];
                                }
                                if (
                                    previouscanvasList["back"] != null &&
                                    _this.active_flip != "back"
                                ) {
                                    canvasList1["back"] =
                                        previouscanvasList["back"];
                                }
                                if (
                                    previouscanvasList["left"] != null &&
                                    _this.active_flip != "left"
                                ) {
                                    canvasList1["left"] =
                                        previouscanvasList["left"];
                                }
                                if (
                                    previouscanvasList["right"] != null &&
                                    _this.active_flip != "right"
                                ) {
                                    canvasList1["right"] =
                                        previouscanvasList["right"];
                                }
                            }
                            canvasList1[_this.active_flip] = canvasObject;
                            (canvasList1["products_id"] =
                                localStorage.getItem("product_id")),
                                localStorage.setItem(
                                    "new_canvas_elements",
                                    JSON.stringify(canvasList1)
                                );
                        },
                        null,
                        { crossOrigin: "Anonymous" }
                    );
                }
                if (
                    _this.canvas_elements[_this.active_gender_key] &&
                    _this.canvas_elements[_this.active_gender_key][
                        _this.active_gender
                    ] &&
                    _this.canvas_elements[_this.active_gender_key][
                        _this.active_gender
                    ].length == 0
                ) {
                    const canvasEl = {
                        id: template_category_id + "" + selected_image_index,
                        url: selected_image,
                        ctype: type,
                        left: left,
                        top: top,
                        padding: padding,
                        cornersize: cornersize,
                        angle: angle,
                        flip: localStorage.getItem("active_flip")
                    };
                    if (
                        type === "patch" &&
                        image_data.id != null &&
                        image_data.material_id != null
                    ) {
                        canvasEl.patch_id = image_data.id;
                        canvasEl.material_id = image_data.material_id;
                    }
                    _this.canvas_elements[_this.active_gender_key][
                        _this.active_gender
                    ].push(canvasEl);
                } else {
                    const canvasEl2 = {
                        id: template_category_id + "" + selected_image_index,
                        url: selected_image,
                        ctype: type,
                        left: left,
                        top: top,
                        padding: padding,
                        cornersize: cornersize,
                        angle: angle,
                        flip: localStorage.getItem("active_flip")
                    };
                    if (
                        type === "patch" &&
                        image_data.id != null &&
                        image_data.material_id != null
                    ) {
                        canvasEl2.patch_id = image_data.id;
                        canvasEl2.material_id = image_data.material_id;
                    }
                    _this.canvas_elements[_this.active_gender_key][
                        _this.active_gender
                    ].push(canvasEl2);
                }
                localStorage.setItem(
                    "canvas_elements",
                    JSON.stringify(_this.canvas_elements)
                );
                _this.rotationAngle = 0;
                if (
                    _this.imagesSelectedCanvasType !=
                    localStorage.getItem("active_flip")
                ) {
                    _this.saveCanvasData();
                }
                if (_this.redo.length > 0 && _this.undo.length == 0) {
                    _this.saveCanvasData();
                }
            }
        },
        bindUploadedDesignImage(selected_image, image_data, extractedColors) {
            let _this = this;
            _this.currentUploadRecord = image_data || null;
            // Show current image + colors in upload panel (hides browse, shows swatches) when selecting from list or after upload
            if (selected_image) _this.uploaded_design_image = selected_image;
            if (image_data && image_data.image_name)
                _this.uploaded_image_name = image_data.image_name;
            // Use extracted colors from ColorThief when provided (so selection/loadUploadFromCanvasObject won't overwrite with empty)
            var colorsForPanelAndObject =
                extractedColors && extractedColors.length > 0
                    ? extractedColors
                    : null;
            if (colorsForPanelAndObject) {
                _this.uploadedImageTopColors = _this.dedupeColors(
                    colorsForPanelAndObject
                );
            } else if (image_data && image_data.image_colors) {
                try {
                    const raw = image_data.image_colors;
                    const obj = typeof raw === "string" ? JSON.parse(raw) : raw;
                    _this.uploadedImageTopColors = _this.dedupeColors(
                        obj && Array.isArray(obj.colors) ? obj.colors : []
                    );
                } catch (e) {
                    _this.uploadedImageTopColors = [];
                }
            }
            var offset = 50;
            var left = 0;
            var top = 0;
            // If printAreaBond is available, use its visual center (reliable for rotated design areas like lanyards)
            if (_this.printAreaBond) {
                left = _this.printAreaBond.left + _this.printAreaBond.width / 2;
                top = _this.printAreaBond.top + _this.printAreaBond.height / 2;
            } else if (
                _this.active_flip == "front" ||
                _this.active_flip == "back"
            ) {
                var w =
                    (_this.front_canvas_width ||
                        fabric.util.getRandomInt(0 + offset, 200 - offset)) / 2;
                var h = _this.front_canvas_height / 2;
                left = _this.front_canvas_left + w;
                top = _this.front_canvas_top + h;
            } else {
                // For left/right: check if image is available
                let hasValidImage =
                    _this.background_image &&
                    _this.background_image !== "" &&
                    _this.background_image !== "null" &&
                    _this.background_image !== null &&
                    typeof _this.background_image === "string" &&
                    _this.background_image.trim() !== "" &&
                    !_this.background_image.includes("null");

                if (
                    hasValidImage &&
                    _this.front_canvas_width &&
                    _this.front_canvas_height &&
                    _this.front_canvas_left !== undefined &&
                    _this.front_canvas_top !== undefined
                ) {
                    // Image available - position within design area (admin's print area) same as front/back
                    var w =
                        (_this.front_canvas_width ||
                            fabric.util.getRandomInt(
                                0 + offset,
                                200 - offset
                            )) / 2;
                    var h = _this.front_canvas_height / 2;
                    left = _this.front_canvas_left + w;
                    top = _this.front_canvas_top + h;
                } else {
                    // No image - position at visible design area center (resized canvas)
                    left = _this.effectiveDesignAreaWidth / 2;
                    top = _this.effectiveDesignAreaHeight / 2;
                }
            }
            if (_this.uploadModuleCanvas == 0) {
                _this.uploadModuleCanvas++;
                _this.saveCanvasData();
            }
            _this.setUploadDraftSnapshot();
            var angle = 0;

            var padding = 10;
            var cornersize = 10;
            if (selected_image.indexOf(".svg") == -1) {
                selected_image = _this.loadImageFromCrossOrigin(selected_image);
                fabric.Image.fromURL(
                    selected_image,
                    function (image) {
                        image.set({
                            id: 0,
                            ctype: "upload",
                            iextension: "png",
                            asas: "ssd",
                            width_inch: "",
                            height_inch: "",
                            left: left,
                            top: top,
                            angle: angle,
                            padding: padding,
                            cornersize: cornersize,
                            hasRotatingPoint: true,
                            originX: "center",
                            originY: "center",
                            centeredRotation: true
                        });
                        if (image_data) {
                            image.set("uploadId", image_data.id || null);
                            image.set(
                                "image_name",
                                image_data.image_name || ""
                            );
                            if (image_data.image)
                                image.set("image_path", image_data.image);
                            var imageColorsJson = colorsForPanelAndObject
                                ? JSON.stringify({
                                      colors: colorsForPanelAndObject
                                  })
                                : image_data.image_colors != null
                                ? typeof image_data.image_colors === "string"
                                    ? image_data.image_colors
                                    : JSON.stringify(image_data.image_colors)
                                : null;
                            image.set("image_colors", imageColorsJson);
                        }
                        // Scale image based on design area for all views (front, back, left, right)
                        if (
                            _this.front_canvas_width &&
                            _this.front_canvas_height &&
                            _this.front_canvas_width > 0 &&
                            _this.front_canvas_height > 0
                        ) {
                            // Calculate scale to fit within design area (use 80% of design area to leave some padding)
                            const maxWidth = _this.front_canvas_width * 0.8;
                            const maxHeight = _this.front_canvas_height * 0.8;
                            const scaleX = maxWidth / image.width;
                            const scaleY = maxHeight / image.height;
                            const scale = Math.min(scaleX, scaleY, 1); // Don't scale up, only down
                            image.scale(scale);
                        } else {
                            // Fallback to default scaling
                            image.scaleToHeight(100);
                            image.scaleToWidth(100);
                        }
                        image.toObject = (function (toObject) {
                            return function () {
                                return fabric.util.object.extend(
                                    toObject.call(this),
                                    {
                                        ctype: "upload",
                                        iextension: "png",
                                        image_name:
                                            image.get("image_name") != null
                                                ? image.get("image_name")
                                                : image_data &&
                                                  image_data.image_name,
                                        image_path:
                                            image.get("image_path") != null
                                                ? image.get("image_path")
                                                : image_data &&
                                                  image_data.image,
                                        uploadId: image.get("uploadId"),
                                        image_colors: image.get("image_colors"),
                                        width_inch: "",
                                        height_inch: "",
                                        products_id:
                                            localStorage.getItem("product_id")
                                    }
                                );
                            };
                        })(image.toObject);
                        _this.backCanvas.add(image);
                        _this.turnOffImageZoomIfActive();
                        // Set clipPath for all views (front, back, left, right) if design_box exists - AFTER adding to canvas
                        if (_this.design_box) {
                            image.set("clipPath", _this.design_box);
                            _this.backCanvas.renderAll();
                        }
                        _this.selectImageProps = {
                                rotation: 0,
                                flipX: false,
                                flipY: false,
                                center: "left"
                            };
                        _this.backCanvas.setActiveObject(image);
                        _this.saveCanvasData();
                        _this.refreshCombinedColorsForCurrentSide();
                    },
                    null,
                    { crossOrigin: "anonymous" }
                );
            } else {
                fabric.loadSVGFromURL(
                    selected_image,
                    function (objects, options) {
                        // here I load SVG image
                        var shape = fabric.util.groupSVGElements(
                            objects,
                            options
                        );

                        var originalColors = [];
                        shape.set({
                            id: 0,
                            ctype: "upload",
                            iextension: "svg",
                            asas: "ssd",
                            width_inch: "",
                            height_inch: "",
                            left: left,
                            top: top,
                            originalColors,
                            angle: angle,
                            padding: 0,
                            cornersize: 0,
                            hasRotatingPoint: true,
                            originX: "center",
                            originY: "center",
                            centeredRotation: true
                        });
                        if (image_data) {
                            shape.set("uploadId", image_data.id || null);
                            shape.set(
                                "image_name",
                                image_data.image_name || ""
                            );
                            if (image_data.image)
                                shape.set("image_path", image_data.image);
                            var shapeColorsJson = colorsForPanelAndObject
                                ? JSON.stringify({
                                      colors: colorsForPanelAndObject
                                  })
                                : image_data.image_colors != null
                                ? typeof image_data.image_colors === "string"
                                    ? image_data.image_colors
                                    : JSON.stringify(image_data.image_colors)
                                : null;
                            shape.set("image_colors", shapeColorsJson);
                        }
                        // Scale shape based on design area for all views (front, back, left, right)
                        if (
                            _this.front_canvas_width &&
                            _this.front_canvas_height &&
                            _this.front_canvas_width > 0 &&
                            _this.front_canvas_height > 0
                        ) {
                            // Calculate scale to fit within design area (use 80% of design area to leave some padding)
                            const maxWidth = _this.front_canvas_width * 0.8;
                            const maxHeight = _this.front_canvas_height * 0.8;
                            const scaleX = maxWidth / shape.width;
                            const scaleY = maxHeight / shape.height;
                            const scale = Math.min(scaleX, scaleY, 1); // Don't scale up, only down
                            shape.scale(scale);
                        } else {
                            // Fallback to default scaling
                            shape.scaleToWidth(100);
                        }
                        shape.toObject = (function (toObject) {
                            return function () {
                                return fabric.util.object.extend(
                                    toObject.call(this),
                                    {
                                        ctype: "upload",
                                        iextension: "svg",
                                        image_name:
                                            shape.get("image_name") != null
                                                ? shape.get("image_name")
                                                : image_data &&
                                                  image_data.image_name,
                                        image_path:
                                            shape.get("image_path") != null
                                                ? shape.get("image_path")
                                                : image_data &&
                                                  image_data.image,
                                        uploadId: shape.get("uploadId"),
                                        image_colors: shape.get("image_colors"),
                                        width_inch: "",
                                        height_inch: "",
                                        products_id:
                                            localStorage.getItem("product_id")
                                    }
                                );
                            };
                        })(shape.toObject);
                        // Scale shape based on design area for all views (front, back, left, right)
                        if (
                            _this.front_canvas_width &&
                            _this.front_canvas_height &&
                            _this.front_canvas_width > 0 &&
                            _this.front_canvas_height > 0
                        ) {
                            // Only scale if not already scaled above
                            if (!shape.scaleX || shape.scaleX === 1) {
                                const maxWidth = _this.front_canvas_width * 0.8;
                                const maxHeight =
                                    _this.front_canvas_height * 0.8;
                                const scaleX = maxWidth / shape.width;
                                const scaleY = maxHeight / shape.height;
                                const scale = Math.min(scaleX, scaleY, 1); // Don't scale up, only down
                                shape.scale(scale);
                            }
                        } else {
                            // Fallback to default scaling
                            shape.scaleToHeight(100);
                        }
                        _this.selectImageProps = {
                                rotation: 0,
                                flipX: false,
                                flipY: false,
                                center: "left"
                            };
                        _this.backCanvas.add(shape);
                        _this.turnOffImageZoomIfActive();
                        // Set clipPath for all views (front, back, left, right) if design_box exists - AFTER adding to canvas
                        if (_this.design_box) {
                            shape.set("clipPath", _this.design_box);
                            shape.set("controlsAboveOverlay", true);
                        }
                        _this.backCanvas.renderAll();
                        _this.backCanvas.setActiveObject(shape);
                        _this.saveCanvasData();
                        _this.refreshCombinedColorsForCurrentSide();

                        _this.active_flip = localStorage.getItem("active_flip");
                        _this.imagesSelectedCanvasType = _this.active_flip;
                        let canvasObject = JSON.stringify(_this.backCanvas);
                        let canvasList1 = {};
                        let previouscanvasList = {};
                        previouscanvasList = JSON.parse(
                            localStorage.getItem("new_canvas_elements")
                        );
                        if (previouscanvasList != null) {
                            if (
                                previouscanvasList["front"] != null &&
                                _this.active_flip != "front"
                            ) {
                                canvasList1["front"] =
                                    previouscanvasList["front"];
                            }
                            if (
                                previouscanvasList["back"] != null &&
                                _this.active_flip != "back"
                            ) {
                                canvasList1["back"] =
                                    previouscanvasList["back"];
                            }
                            if (
                                previouscanvasList["left"] != null &&
                                _this.active_flip != "left"
                            ) {
                                canvasList1["left"] =
                                    previouscanvasList["left"];
                            }
                            if (
                                previouscanvasList["right"] != null &&
                                _this.active_flip != "right"
                            ) {
                                canvasList1["right"] =
                                    previouscanvasList["right"];
                            }
                        }
                        canvasList1[_this.active_flip] = canvasObject;
                        (canvasList1["products_id"] =
                            localStorage.getItem("product_id")),
                            localStorage.setItem(
                                "new_canvas_elements",
                                JSON.stringify(canvasList1)
                            );
                    },
                    null,
                    { crossOrigin: "anonymous" }
                );
            }
            if (
                _this.canvas_elements[_this.active_gender_key] &&
                _this.canvas_elements[_this.active_gender_key][
                    _this.active_gender
                ] &&
                _this.canvas_elements[_this.active_gender_key][
                    _this.active_gender
                ].length == 0
            ) {
                _this.canvas_elements[_this.active_gender_key][
                    _this.active_gender
                ].push({
                    id: 0,
                    url: selected_image,
                    ctype: "upload",
                    left: left,
                    top: top,
                    padding: padding,
                    cornersize: cornersize,
                    angle: angle,
                    flip: localStorage.getItem("active_flip")
                });
            } else {
                _this.canvas_elements[_this.active_gender_key][
                    _this.active_gender
                ].push({
                    id: 0,
                    url: selected_image,
                    ctype: "upload",
                    left: left,
                    top: top,
                    padding: padding,
                    cornersize: cornersize,
                    angle: angle,
                    flip: localStorage.getItem("active_flip")
                });
            }
            localStorage.setItem(
                "canvas_elements",
                JSON.stringify(_this.canvas_elements)
            );

            if (
                _this.imagesSelectedCanvasType !=
                localStorage.getItem("active_flip")
            ) {
                _this.saveCanvasData();
            }
        },
        showMenu(resetActiveObject, id) {
            if (id === "nn-tab1" && !this.isNameNumberAllowedForCurrentService) {
                return;
            }
            if (
                id === "nn-tab1" &&
                this.isEmbroideryServiceForNameNumber &&
                this.active_flip !== "front"
            ) {
                this.$toast.error(
                    "For Embroidery, Names & Numbers is available only on Front location.",
                    {
                        position: "top-right"
                    }
                );
                return;
            }
            // Close design history when any menu item is clicked
            if (this.showDesignHistory) {
                this.closeDesignHistory();
            }
            /* eslint-disable */
            let active = $(".main_panel_check.show.active");
            /* eslint-enable */
            // When switching away from Names & Numbers panel (outer click), run same cleanup as Close/Save so unfilled name/number is cleared and placeholders don't stay
            if (
                active.length === 1 &&
                active[0].id === "nn-tab" &&
                id !== "nn-tab1"
            ) {
                if (
                    this.$refs.nameAndNumberRef &&
                    typeof this.$refs.nameAndNumberRef.runCloseCleanup ===
                        "function"
                ) {
                    this.$refs.nameAndNumberRef.runCloseCleanup();
                }
            }
            // Names & Numbers: nav link id is nn-tab1 but panel id is nn-tab (aria-labelledby="nn-tab"), so treat nn-tab1 as "same tab" when nn-tab is already active (avoids double-click to open)
            var isSameTab =
                active.length == 1 &&
                (active[0].getAttribute("aria-labelledby") == id ||
                    typeof id === "undefined" ||
                    (id === "nn-tab1" && active[0].id === "nn-tab"));
            if (isSameTab) {
                // already on this tab — do not close
            } else {
                active.removeClass("show").removeClass("active");
            }
            this.disable_tshirt_canvas = false;

            //active.removeClass("show").removeClass("active");

            this.active_class = "";
            this.selected_category_heading = false;
            this.category_heading = true;
            this.selected_template_category_show = false;
            this.selected_template_subcategory_show = false;
            this.selected_clipart_category_show = false;
            this.edit_template = false;
            if (resetActiveObject && this.backCanvas) {
                var activeObject = this.backCanvas.getActiveObjects();

                if (Object.entries(activeObject).length > 0) {
                    activeObject[0].canvas.discardActiveObject().renderAll();
                }
                this.onSelectedCleared();
            }
            if (id == "nn-tab1") {
                if (this.back_show) {
                    this.$refs.nameAndNumberRef.enableName();
                } else {
                    this.$refs.nameAndNumberRef.disableName();
                }
                // Do not switch view when opening Names & Numbers panel - stay on current location so second location (e.g. back) name/number can be selected without view switching

                document
                    .getElementById("nn-tab")
                    .classList.add("active", "show");
                // Highlight left sidebar Names & Numbers tab (same as Add Clipart when opening via canvas selection)
                /* eslint-disable */
                $(".nav-link.active").removeClass("active");
                /* eslint-enable */
                var nnTab1El = document.getElementById("nn-tab1");
                if (nnTab1El) nnTab1El.classList.add("active");
                this.selectedCheckbox = false;
                //this.disable_tshirt_canvas = true;
                // this.$refs.nameAndNumberRef.removeSelections();
                // let design = JSON.parse(localStorage.getItem('design'));
                // USE gender_groups_items local variable
                let design = this.gender_groups_items;
                this.$refs.nameAndNumberRef.loadNameAndNumber(
                    design[0].colors[this.activeColorIndex]
                );
                // Refresh Run Charge / sync dropdowns when panel opens; do NOT overwrite name_number_display_counts (set design counts stay correct)
                this.$nextTick(() => {
                    if (typeof this.updateNameNumberFees === "function") {
                        this.updateNameNumberFees(true);
                    }
                    // Keep right-side decoration dropdowns in sync with name/number colors (avoid "Select color" after opening panel)
                    if (
                        this.$refs.ItemDetails &&
                        typeof this.$refs.ItemDetails
                            .syncNameNumberColorsToImprintLocations ===
                            "function"
                    ) {
                        this.$refs.ItemDetails.syncNameNumberColorsToImprintLocations();
                    }
                });
            }
            if (id == "add-clipart-tab") {
                this.clipart_category_div = true;
                this.clipart_subcategory_div = false;
                this.clipart_search_query = null;
                this.clipart_subcategory_search_query = null;
                this.active_class = "";
                this.refetchClipartCategories();
            }
            if (id == "designs-tab") {
                this.design_tab_active = true;
                this.archive_tab_active = false;
            }
            if (id == "archive-tab") {
                this.archive_tab_active = true;
                this.design_tab_active = false;
            }
            if (id == "add-upload-tab") {
                this.uploaded_image_name = null;
                this.showUploadForm = false; // Show list + Upload New Image, not edit screen
            }
            if (id == "add-patch-new-tab") {
                this.patchNewSearchQuery = "";
                this.expandedMaterialIdsNew = [];
                this.loadPatchNewData();
                this.loadDsPatchInventory();
            }
        },
        getAllTempateDesign() {
            let _this = this;
            if (!_this.isAuthenticatedClient) {
                return;
            }

            ApiService.get("/get-template-design-image")
                .then(({ data }) => {
                    _this.saved_Template_design_list = data.template;
                })
                .catch(({ response }) => {
                    // console.log(response);
                });
        },
        closeMenu(menu_id) {
            if (menu_id === "add-text") {
                /* eslint-disable */
                $(".deleteBtn").remove();
                $(".rotationBtn").remove();
                /* eslint-enable */

                if (this.backCanvas && this.backCanvas.getActiveObject()) {
                    var activeObject = this.backCanvas.getActiveObject();
                    if (activeObject && activeObject.type === "text") {
                        this.backCanvas.discardActiveObject();
                        this.backCanvas.renderAll();
                    }
                }

                this.onSelectedCleared(menu_id);
            }
            if (menu_id === "designs") {
                this.design_tab_active = false;
            }
            if (menu_id === "archive") {
                this.archive_tab_active = false;
            }
            // When closing Name & Number tab (Save or Cross), discard canvas active object so selection is cleared
            if (
                menu_id === "nn-tab" &&
                this.backCanvas &&
                this.backCanvas.getActiveObject()
            ) {
                this.backCanvas.discardActiveObject();
                this.backCanvas.renderAll();
                this.onSelectedCleared(menu_id);
            }
            /* eslint-disable */
            $("#default1-tab").click();
            /* eslint-enable */
            this.active_class = "active";
            let menu = document.querySelector("#" + menu_id);
            if (menu) {
                menu.classList.remove("active");
                menu.classList.remove("show");
                document.querySelector("#default1").classList.add("active");
                document.querySelector("#default1").classList.add("show");
                // When closing any menu (especially nn-tab), clear Names & Numbers left nav highlight
                if (menu_id === "nn-tab") {
                    var nnTab1El = document.getElementById("nn-tab1");
                    if (nnTab1El) nnTab1El.classList.remove("active");
                }
            }
            var menu_nav = document.querySelector("#" + menu_id + "-tab");
            if (menu_id === "nn-tab") {
                menu_nav = document.querySelector("#" + menu_id);
                var nnTab1El = document.getElementById("nn-tab1");
                if (nnTab1El) nnTab1El.classList.remove("active");
            }
            if (menu_id === "templates") {
                menu_nav = document.querySelector("#add-" + menu_id + "-tab");
            }
            if (menu_id === "upload") {
                menu_nav = document.querySelector("#add-" + menu_id + "-tab");
            }

            if (menu_nav) {
                menu_nav.classList.remove("active");
            }
            // Ensure nn-tab1 highlight is gone after DOM updates / Bootstrap (e.g. when panel closed after cross delete)
            if (menu_id === "nn-tab") {
                this.$nextTick(() => {
                    var el = document.getElementById("nn-tab1");
                    if (el) el.classList.remove("active");
                });
                setTimeout(function () {
                    var el = document.getElementById("nn-tab1");
                    if (el) el.classList.remove("active");
                }, 50);
            }
            this.selected_category_heading = false;
            this.category_heading = true;
            this.edit_template = false;
            this.selected_template_category_show = false;
            this.selected_clipart_category_show = false;
        },
        openDesignHistory(designId) {
            this.selectedDesignHistoryId = designId;
            this.showDesignHistory = true;
        },
        closeDesignHistory() {
            this.showDesignHistory = false;
            this.selectedDesignHistoryId = null;
        },
        closeSelectedCategory(type) {
            if (type == "templates") {
                if (this.template_name == "Popular") {
                    this.selected_category_heading = false;
                    this.category_heading = true;
                    this.template_name = "";
                    this.selected_template_category_show = false;
                } else {
                    this.selected_category_heading =
                        this.selected_template_subcategory_show;
                    this.category_heading =
                        !this.selected_template_subcategory_show;
                    if (this.selected_template_subcategory_show) {
                        this.template_name =
                            this.selected_template_category.name;
                    }
                    this.selected_template_category_show =
                        this.selected_template_subcategory_show;
                }

                this.selected_template_subcategory_show = false;
            } else if (type == "clipart") {
                this.clipart_subcategory_div = false;
                this.clipart_category_div = true;
                this.category_heading = true;
                this.selected_category_heading = false;
                this.selected_clipart_category_show = false;
                this.clipart_name = "";
                this.refetchClipartCategories();
            } else if (type == "clipart_image") {
                if (this.clipart_name == "Popular") {
                    this.clipart_subcategory_div = false;
                    this.clipart_category_div = true;
                    this.category_heading = true;
                    this.selected_category_heading = false;
                    this.selected_clipart_category_show = false;
                    this.refetchClipartCategories();
                } else {
                    this.category_heading = true;
                    this.edit_template = false;
                    this.selected_clipart_category_show = false;
                    this.clipart_category_div = false;
                    this.selected_category_heading = false;
                    this.getClipartCliparts(
                        this.selected_clipart_category_id,
                        this.clipart_category_name
                    );
                }
                this.clipart_name = "";
            }
            this.$forceUpdate();
        },
        selectImage() {
            this.$refs.fileInput.click();
        },

        // When user clicks "Upload New Image": show form and clear previous preview so old image does not stay visible
        onUploadNewImage() {
            this.showUploadForm = true;
            this.currentUploadRecord = null;
            this.uploaded_design_image = null;
            this.uploaded_image_name = "";
            this.uploadedImageTopColors = [];
            this.image_uploaded = {};
            this.tempUploadedFile = null;
            this.setUploadDraftSnapshot();
        },

        //upload image
        ImageUpload() {
            if (!this.isAuthenticatedClient) {
                this.$toast.error("Please login", { position: "top-right" });
                return;
            }
            if (this.uploadModuleCanvas == 0) {
                this.uploadModuleCanvas++;
                this.saveCanvasData();
            }

            this.isLoader = true;
            new Promise(() => {
                ApiService.post("/design-studio-upload", this.image_uploaded)
                    .then(({ data }) => {
                        if (!data.success) {
                            this.isLoader = false;
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            // Clear preview so failed upload does not keep showing
                            this.uploaded_design_image = null;
                            this.uploaded_image_name = "";
                            this.uploadedImageTopColors = [];
                            this.image_uploaded = {};
                            return;
                        }

                        this.uploadedImages.unshift(data.upload_data);

                        // Keep user's draft colors (including manually added "Add More Color")
                        // so upload save does not overwrite them with freshly extracted colors.
                        var draftColors = this.dedupeColors(
                            (this.uploadedImageTopColors || [])
                                .filter((color) => !!color)
                                .map((color) => String(color).toUpperCase())
                        );

                        // Extract colors FIRST (while we still have tempUploadedFile), then bind so UI shows them
                        var extractedColors = [];
                        if (this.tempUploadedFile) {
                            var isRaster =
                                this.tempUploadedFile.type &&
                                this.tempUploadedFile.type.match(
                                    /^image\/(jpeg|png|jpg|webp)$/i
                                );

                            if (
                                isRaster &&
                                this.tempUploadedFile.imageElement
                            ) {
                                try {
                                    var colorThief = new ColorThief();
                                    var palette = colorThief.getPalette(
                                        this.tempUploadedFile.imageElement,
                                        6
                                    );

                                    if (palette && palette.length > 0) {
                                        extractedColors = (palette || []).map(
                                            function (rgb) {
                                                var r = rgb[0];
                                                var g = rgb[1];
                                                var b = rgb[2];
                                                return (
                                                    "#" +
                                                    [r, g, b]
                                                        .map(function (x) {
                                                            return x
                                                                .toString(16)
                                                                .padStart(
                                                                    2,
                                                                    "0"
                                                                );
                                                        })
                                                        .join("")
                                                );
                                            }
                                        );
                                    }
                                } catch (err) {}
                                this.tempUploadedFile = null;
                            }
                        }

                        var resolvedColors =
                            draftColors.length > 0
                                ? draftColors
                                : this.dedupeColors(
                                      (extractedColors || []).map((color) =>
                                          String(color).toUpperCase()
                                      )
                                  );
                        // Bind upload using resolved colors so canvas object stores
                        // exactly what user sees/saves in upload panel.
                        this.bindUploadedDesignImage(
                            data.image_file_path,
                            data.upload_data,
                            resolvedColors
                        );
                        this.uploadedImageTopColors = resolvedColors;
                        this.foundColorsCount = resolvedColors.length;
                        this.saveUploadColors();

                        setTimeout(() => {
                            this.isLoader = false;
                            this.$toast.success("Image uploaded successfully", {
                                position: "top-right"
                            });
                            this.image_uploaded = {};
                            this.image_width = "";
                            this.image_height = "";
                            this.image_size = "";
                            this.showUploadForm = false;
                            this.setUploadDraftSnapshot();
                            if (this.backCanvas) {
                                this.backCanvas.discardActiveObject();
                                this.backCanvas.requestRenderAll();
                            }
                        }, 2000);
                    })
                    .catch((response) => {
                        this.isLoader = false;
                        // Clear preview so failed upload does not keep showing
                        this.uploaded_design_image = null;
                        this.uploaded_image_name = "";
                        this.uploadedImageTopColors = [];
                        this.image_uploaded = {};
                        if (response.status == 401) {
                            this.$router.push({ name: "/client/login" });
                        }
                    });
            });
        },

        getUploadedImages() {
            return new Promise(() => {
                ApiService.get("/get-design-studio-upload")
                    .then(({ data }) => {
                        this.uploadedImages = data.images_list;
                    })
                    .catch((response) => {
                        if (response.status == 401) {
                            this.$router.push({ name: "/client/login" });
                        }
                    });
            });
        },

        deleteUploadedImage(id) {
            if (!confirm("Do you really want to delete?")) {
                return;
            }
            this.isLoader = true;
            ApiService.delete(`/delete-upload-image/${id}`)
                .then(() => {
                    this.isLoader = false;
                    this.getUploadedImages();
                })
                .catch(() => {
                    this.isLoader = false;
                });
        },

        setActiveGender(gender, key) {
            let _this = this;
            this.active_gender = gender;
            this.active_gender_key = key;
            localStorage.setItem("active_gender", gender);
            localStorage.setItem("active_gender_key", key);

            _this.imageCanvas.setBackgroundImage(
                _this.tshirtImage,
                canvas.renderAll.bind(canvas),
                {
                    backgroundColor: _this.user_selected_values[key].color_hash
                }
            );
            localStorage.setItem(
                "active_tshirt_color",
                this.user_selected_values[key].color_hash
            );
            this.canvas_elements = JSON.parse(
                localStorage.getItem("canvas_elements")
            );
            if (
                this.canvas_elements[key] &&
                this.canvas_elements[key][gender] &&
                this.canvas_elements[key][gender].length > 0
            ) {
                this.canvas_elements[key][gender].forEach((element) => {
                    if (
                        element.type == "template" ||
                        element.type == "shape" ||
                        element.type == "patch" ||
                        element.type == "upload"
                    ) {
                        if (
                            element.flip == localStorage.getItem("active_flip")
                        ) {
                            fabric.Image.fromURL(
                                element.url,
                                function (image) {
                                    image.set({
                                        id: element.id,
                                        left: element.left,
                                        top: element.top,
                                        angle: element.angle,
                                        padding: element.padding,
                                        cornersize: element.cornersize,
                                        hasRotatingPoint: true,
                                        originX: "center",
                                        originY: "center",
                                        centeredRotation: true
                                    });
                                    image.scaleToHeight(100);
                                    image.scaleToWidth(100);
                                    canvas.add(image);
                                }.bind(this),
                                {
                                    crossOrigin: "Anonymous"
                                }
                            );
                        }
                    }
                });
            }
        },

        clearDesigns() {
            let _this = this;
            // Changed by jinendra
            _this.$refs.ItemDetails.resetImprintColors();
            _this.backCanvas.discardActiveObject().renderAll();
            _this.onSelectedCleared();
            _this.backCanvas.clear();
            if (
                _this.$refs.nameAndNumberRef &&
                _this.$refs.nameAndNumberRef.clearAllEntries
            ) {
                _this.$refs.nameAndNumberRef.clearAllEntries();
            }

            this.canvasList = { front: "", back: "" };

            localStorage.removeItem("new_canvas_elements");
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify({ front: "" })
            );
            _this.resetElements();

            let type = localStorage.getItem("active_flip");
            /* eslint-disable */
            $("." + type).addClass("active");
            this.tshirtImage = this.background_image;
            fabric.Object.prototype.objectCaching = false;
            if (type == "front" || type == "back") {
                _this.updateImageToBackCanvas();
            } else {
                let square = new fabric.Rect({
                    width: 630,
                    height: 540,

                    fill: _this.user_selected_values[_this.active_gender_key]
                        .color_hash
                });
                if (_this.backCanvas._objects.length > 0) {
                    _this.backCanvas._objects.forEach((canvas_obj) => {
                        if (canvas_obj.type != "rect") {
                            _this.backCanvas.add(square);
                        }
                    });
                } else {
                    _this.backCanvas.add(square);
                }
                _this.imagesSelectedCanvasType = "";
            }

            this.saved_json_data = null;
            // Clear original canvas JSON and current design ID when clearing designs
            this.original_canvas_json = null;
            this.current_design_id = null;
            _this.addDesignArea();
            _this.backCanvas.renderAll();
            $("#reset_popup").modal("hide");
            _this.undo = [];
            _this.redo = [];

            $("#redoObj").prop("disabled", true).removeClass("active");
            $("#undoObj").prop("disabled", true).removeClass("active");
            _this.firstImageActive = 0;
            _this.undoObject = 0;
            _this.state = [];
            _this.uploadModuleCanvas = 0;
            _this.selectedDistressImage = null;
            $("#newResetbtn").prop("disabled", true);
            _this.imagesSelectedCanvasType = "";
            _this.updateAdditionalFeesInDashboard();
            if (typeof _this.calculatePatchCost === "function") {
                _this.calculatePatchCost();
            }
            /* eslint-enable */
        },

        saveNewDesigns(saved_flag) {
            let _this = this;
            this.saved_type = saved_flag;
            let designStatus = this.checkObjectCanvas();
            if (!designStatus && _this.colors_validation == "") {
                _this.$toast.clear();
                _this.$toast.error(
                    "Please add some design ( Text, Clipart or ArtWork ) to this product",
                    { duration: 2000, position: "top-right", queue: false }
                );
                return;
            }
            let design_items = JSON.parse(
                JSON.stringify(this.gender_groups_items)
            );
            if (!this.validateData(design_items)) {
                return;
            }
            if (design_items.length == 0) {
                return;
            }
            if (this.saved_type == "cart") {
                if (design_items[0]["item"]["price_decoration_bulk"]) {
                    let decoration_pricing = "";
                    if (
                        typeof design_items[0]["item"][
                            "price_decoration_bulk"
                        ] === "string"
                    ) {
                        decoration_pricing = JSON.parse(
                            design_items[0]["item"]["price_decoration_bulk"]
                        );
                    } else {
                        decoration_pricing =
                            design_items[0]["item"]["price_decoration_bulk"];
                    }
                    let total_cart_quantity = parseInt(
                        design_items[0].total_qty
                    );
                    if (decoration_pricing) {
                        if (
                            design_items[0]["item"].decoration_type == 1 ||
                            design_items[0]["item"].decoration_type == 5
                        ) {
                            let minimum_quantity =
                                decoration_pricing["print_location1"][0][
                                    "quantity"
                                ];
                            if (minimum_quantity > total_cart_quantity) {
                                this.$toast.error(
                                    "Quantity should be greater than " +
                                        minimum_quantity,
                                    {
                                        position: "top-right",
                                        queue: true
                                    }
                                );
                                return;
                            }
                        } else if (
                            design_items[0]["item"].decoration_type == 2 || design_items[0]["item"].decoration_type == 4
                        ) {
                            let minimum_quantity =
                                decoration_pricing[0]["quantity1"];
                            if (minimum_quantity > total_cart_quantity) {
                                this.$toast.error(
                                    "Quantity should be greater than " +
                                        minimum_quantity,
                                    {
                                        position: "top-right",
                                        queue: true
                                    }
                                );
                                return;
                            }
                        } else if (
                            design_items[0]["item"].decoration_type == 3
                        ) {
                            let minimum_quantity =
                                decoration_pricing[0]["quantity"];
                            if (minimum_quantity > total_cart_quantity) {
                                this.$toast.error(
                                    "Quantity should be greater than " +
                                        minimum_quantity,
                                    {
                                        position: "top-right",
                                        queue: true
                                    }
                                );
                                return;
                            }
                        }
                    }
                }
            }
            this.saved_design.item_type = "single";
            this.saved_design.name = "";
            this.backCanvas.discardActiveObject().renderAll();
            /* eslint-disable */
            if (this.isAuthenticatedClient) {
                // Check if design has been modified
                let designModified = false;
                if (
                    this.saved_type == "cart" &&
                    this.current_design_id &&
                    this.original_canvas_json
                ) {
                    // Get current canvas state
                    let currentCanvasJson = localStorage.getItem(
                        "new_canvas_elements"
                    );
                    if (currentCanvasJson) {
                        try {
                            let currentCanvas = JSON.parse(currentCanvasJson);
                            let originalCanvas = this.original_canvas_json;

                            // Helper function to normalize objects for comparison
                            // Removes properties that might differ due to serialization but don't affect design
                            // Position (left, top) is excluded from comparison - only position changes won't be considered as new design
                            let normalizeObjects = (objects) => {
                                if (!Array.isArray(objects)) return [];

                                // Recursive function to normalize a single object
                                let normalizeSingleObject = (obj) => {
                                    if (!obj || obj.type === "rect")
                                        return null; // Ignore rect objects

                                    // Create a normalized version with only essential design properties
                                    // Excluding left, top, and all position-related properties
                                    let normalized = {
                                        type: obj.type,
                                        width: Math.round(obj.width || 0),
                                        height: Math.round(obj.height || 0),
                                        scaleX:
                                            Math.round(
                                                (obj.scaleX || 1) * 100
                                            ) / 100,
                                        scaleY:
                                            Math.round(
                                                (obj.scaleY || 1) * 100
                                            ) / 100,
                                        angle: Math.round(obj.angle || 0)
                                    };

                                    // Only include these properties if they exist
                                    // Excluding width_inch and height_inch as they are calculated values that can change with position
                                    if (obj.ctype !== undefined)
                                        normalized.ctype = obj.ctype;
                                    if (obj.objType !== undefined)
                                        normalized.objType = obj.objType;
                                    if (obj.image_name !== undefined)
                                        normalized.image_name = obj.image_name;
                                    if (obj.image_path !== undefined)
                                        normalized.image_path = obj.image_path;
                                    // width_inch and height_inch are excluded - they are calculated based on position/design area

                                    // Include color properties (fill and stroke) for all object types to detect color changes
                                    if (
                                        obj.fill !== undefined &&
                                        obj.fill !== null &&
                                        obj.fill !== ""
                                    ) {
                                        normalized.fill = obj.fill;
                                    }
                                    // Include stroke (outline) color if it exists and is not transparent
                                    if (
                                        obj.stroke !== undefined &&
                                        obj.stroke !== null &&
                                        obj.stroke !== "" &&
                                        obj.stroke !== "transparent" &&
                                        obj.stroke !== "none"
                                    ) {
                                        normalized.stroke = obj.stroke;
                                        // Also include strokeWidth if stroke exists
                                        if (obj.strokeWidth !== undefined) {
                                            normalized.strokeWidth = Math.round(
                                                obj.strokeWidth || 0
                                            );
                                        }
                                    }

                                    // For text objects, include text content
                                    if (
                                        obj.type === "text" ||
                                        obj.type === "i-text" ||
                                        obj.type === "textbox"
                                    ) {
                                        normalized.text = obj.text || "";
                                        normalized.fontSize = Math.round(
                                            obj.fontSize || 0
                                        );
                                        normalized.fontFamily =
                                            obj.fontFamily || "";
                                    }

                                    // For images, include image path
                                    if (obj.type === "image") {
                                        normalized.src = obj.src || "";
                                    }

                                    // For group objects, normalize nested objects recursively
                                    if (
                                        obj.type === "group" &&
                                        Array.isArray(obj.objects)
                                    ) {
                                        let normalizedNested = obj.objects
                                            .map(normalizeSingleObject)
                                            .filter((o) => o !== null); // Remove nulls (rect objects)

                                        if (normalizedNested.length > 0) {
                                            // Sort nested objects for consistent comparison
                                            normalizedNested.sort((a, b) => {
                                                if (a.type !== b.type) {
                                                    return (
                                                        a.type || ""
                                                    ).localeCompare(
                                                        b.type || ""
                                                    );
                                                }
                                                if (
                                                    a.image_path &&
                                                    b.image_path
                                                ) {
                                                    return (
                                                        a.image_path || ""
                                                    ).localeCompare(
                                                        b.image_path || ""
                                                    );
                                                }
                                                if (a.text && b.text) {
                                                    return (
                                                        a.text || ""
                                                    ).localeCompare(
                                                        b.text || ""
                                                    );
                                                }
                                                return 0;
                                            });
                                            normalized.objects =
                                                normalizedNested;
                                        }
                                    }

                                    return normalized;
                                };

                                // Normalize all objects
                                let normalized = objects
                                    .map(normalizeSingleObject)
                                    .filter((o) => o !== null); // Remove nulls (rect objects)

                                // Sort for consistent comparison
                                normalized.sort((a, b) => {
                                    if (a.type !== b.type) {
                                        return (a.type || "").localeCompare(
                                            b.type || ""
                                        );
                                    }
                                    // For images, sort by image path
                                    if (a.image_path && b.image_path) {
                                        return (
                                            a.image_path || ""
                                        ).localeCompare(b.image_path || "");
                                    }
                                    // For text, sort by text content
                                    if (a.text && b.text) {
                                        return (a.text || "").localeCompare(
                                            b.text || ""
                                        );
                                    }
                                    // Fallback: sort by a combination of properties
                                    let aKey = `${a.type}_${
                                        a.image_path || a.text || ""
                                    }_${a.width}_${a.height}_${a.scaleX}_${
                                        a.scaleY
                                    }`;
                                    let bKey = `${b.type}_${
                                        b.image_path || b.text || ""
                                    }_${b.width}_${b.height}_${b.scaleX}_${
                                        b.scaleY
                                    }`;
                                    return aKey.localeCompare(bKey);
                                });

                                return normalized;
                            };

                            // Compare canvas JSONs to detect changes
                            // Collect ALL objects from ALL sides and compare as a whole set
                            // This way, position-only changes (even across sides) won't be considered as new design
                            let sides = ["front", "back", "left", "right"];
                            let allCurrentObjects = [];
                            let allOriginalObjects = [];

                            // Collect all objects from all sides
                            for (let side of sides) {
                                let currentSide = currentCanvas[side] || "";
                                let originalSide = originalCanvas[side] || "";

                                try {
                                    if (currentSide) {
                                        let currentSideObj =
                                            JSON.parse(currentSide);
                                        let currentObjects = normalizeObjects(
                                            currentSideObj.objects || []
                                        );
                                        allCurrentObjects =
                                            allCurrentObjects.concat(
                                                currentObjects
                                            );
                                    }
                                    if (originalSide) {
                                        let originalSideObj =
                                            JSON.parse(originalSide);
                                        let originalObjects = normalizeObjects(
                                            originalSideObj.objects || []
                                        );
                                        allOriginalObjects =
                                            allOriginalObjects.concat(
                                                originalObjects
                                            );
                                    }
                                } catch (e) {
                                    // If parsing fails for a side, we'll still compare what we have
                                }
                            }

                            // Sort both arrays consistently for comparison
                            allCurrentObjects.sort((a, b) => {
                                if (a.type !== b.type) {
                                    return (a.type || "").localeCompare(
                                        b.type || ""
                                    );
                                }
                                if (a.image_path && b.image_path) {
                                    return (a.image_path || "").localeCompare(
                                        b.image_path || ""
                                    );
                                }
                                if (a.text && b.text) {
                                    return (a.text || "").localeCompare(
                                        b.text || ""
                                    );
                                }
                                let aKey = `${a.type}_${
                                    a.image_path || a.text || ""
                                }_${a.width}_${a.height}_${a.scaleX}_${
                                    a.scaleY
                                }`;
                                let bKey = `${b.type}_${
                                    b.image_path || b.text || ""
                                }_${b.width}_${b.height}_${b.scaleX}_${
                                    b.scaleY
                                }`;
                                return aKey.localeCompare(bKey);
                            });

                            allOriginalObjects.sort((a, b) => {
                                if (a.type !== b.type) {
                                    return (a.type || "").localeCompare(
                                        b.type || ""
                                    );
                                }
                                if (a.image_path && b.image_path) {
                                    return (a.image_path || "").localeCompare(
                                        b.image_path || ""
                                    );
                                }
                                if (a.text && b.text) {
                                    return (a.text || "").localeCompare(
                                        b.text || ""
                                    );
                                }
                                let aKey = `${a.type}_${
                                    a.image_path || a.text || ""
                                }_${a.width}_${a.height}_${a.scaleX}_${
                                    a.scaleY
                                }`;
                                let bKey = `${b.type}_${
                                    b.image_path || b.text || ""
                                }_${b.width}_${b.height}_${b.scaleX}_${
                                    b.scaleY
                                }`;
                                return aKey.localeCompare(bKey);
                            });

                            let currentJson = JSON.stringify(allCurrentObjects);
                            let originalJson =
                                JSON.stringify(allOriginalObjects);

                            // Compare the complete sets (ignoring position)
                            if (currentJson !== originalJson) {
                                designModified = true;
                            }
                        } catch (e) {
                            // If comparison fails, assume design is modified to be safe
                            designModified = true;
                        }
                    } else {
                        // No current canvas, assume modified
                        designModified = true;
                    }
                } else {
                    // No original canvas stored or no current_design_id, assume modified
                    designModified = true;
                }

                // If design is unchanged and adding to cart, skip save modal and directly add to cart
                if (
                    this.saved_type == "cart" &&
                    this.current_design_id &&
                    !designModified
                ) {
                    // Skip save modal and directly add to cart with existing design ID
                    this.addToCart();
                    return;
                }

                this.$validator.reset("add_save_form");
                // For preventing paste and delete in design
                $("#save_design_modal").modal("show");
                $(document).on("show.bs.modal", ".modal", function () {
                    $(".modal").not(this).modal("hide");
                });
            } else {
                $("#login").modal("show");
                $("#save_design_modal").modal("hide");
                return true;
            }
            /* eslint-enable */
        },

        async loadImageAsync(url) {
            return new Promise((resolve) => {
                let d = new Date();

                let time = d.getHours();
                let corsImage = new Image();
                corsImage.crossOrigin = "Anonymous";
                corsImage.src = url + "?no-cache&" + time;
                fabric.Image.fromURL(
                    corsImage.src,
                    function (img) {
                        resolve(img);
                    },
                    { crossOrigin: "anonymous" }
                );
            });
        },

        updateNameNumberColorDecorUpCharge() {
            const vinylColorsList = this.prepareVendorColorsList("vinyl");

            // Check if nameAndNumberRef exists
            if (!this.$refs.nameAndNumberRef) {
                console.warn(
                    "updateNameNumberColorDecorUpCharge: nameAndNumberRef is not available"
                );
                return;
            }

            const nameVinylColorObj =
                this.$refs.nameAndNumberRef.colorSizesForName;
            var nameDecorUp = 0;
            if (nameVinylColorObj && nameVinylColorObj.color_id) {
                const nameColorObj = vinylColorsList.find(
                    (color) => color.color_id == nameVinylColorObj.color_id
                );
                if (nameColorObj) {
                    nameDecorUp = parseFloat(nameColorObj.decor_upcharge || 0);
                } else if (
                    this.$refs.nameAndNumberRef.vinyl_color_list &&
                    this.$refs.nameAndNumberRef.vinyl_color_list.length > 0
                ) {
                    const vc =
                        this.$refs.nameAndNumberRef.vinyl_color_list.find(
                            (color) => color.id == nameVinylColorObj.color_id
                        );
                    if (vc) nameDecorUp = parseFloat(vc.decor_upcharge || 0);
                }
                if (this.$refs.nameAndNumberRef.setColorSizesForName) {
                    this.$refs.nameAndNumberRef.setColorSizesForName({
                        decor_upcharge: nameDecorUp
                    });
                }
            }

            const numberVinylColorObj =
                this.$refs.nameAndNumberRef.colorSizesForNumber;
            var numberDecorUp = 0;
            if (numberVinylColorObj && numberVinylColorObj.color_id) {
                const numberColorObj = vinylColorsList.find(
                    (color) => color.color_id == numberVinylColorObj.color_id
                );
                if (numberColorObj) {
                    numberDecorUp = parseFloat(
                        numberColorObj.decor_upcharge || 0
                    );
                } else if (
                    this.$refs.nameAndNumberRef.vinyl_color_list &&
                    this.$refs.nameAndNumberRef.vinyl_color_list.length > 0
                ) {
                    const vc =
                        this.$refs.nameAndNumberRef.vinyl_color_list.find(
                            (color) => color.id == numberVinylColorObj.color_id
                        );
                    if (vc) numberDecorUp = parseFloat(vc.decor_upcharge || 0);
                }
                if (this.$refs.nameAndNumberRef.setColorSizesForNumber) {
                    this.$refs.nameAndNumberRef.setColorSizesForNumber({
                        decor_upcharge: numberDecorUp
                    });
                }
            }
        },

        calcNameNumberFees(color) {
            // Get fees from VendorFees (only if rollup_fee_id exists)
            let name_fees = 0;
            let number_fees = 0;

            // Get VendorFees from current design item (same source as getColorMixFeeFromVendorServices)
            var item =
                this.gender_groups_items &&
                this.active_gender_key != null &&
                this.gender_groups_items[this.active_gender_key] &&
                this.gender_groups_items[this.active_gender_key].item
                    ? this.gender_groups_items[this.active_gender_key].item
                    : null;
            const vendorFees = item && item.VendorFees ? item.VendorFees : [];

            // Get name fee from VendorFees (only if rollup_fee_id exists)
            const nameService = vendorFees.find(
                (service) =>
                    service.rollup_fee_id &&
                    (service.type === "name" ||
                        (service.ecomm_display &&
                            service.ecomm_display
                                .toLowerCase()
                                .includes("name")))
            );
            if (nameService && nameService.retail_cost) {
                name_fees = parseFloat(nameService.retail_cost) || 0;
            }

            // Get number fee from VendorFees (only if rollup_fee_id exists)
            const numberService = vendorFees.find(
                (service) =>
                    service.rollup_fee_id &&
                    (service.type === "number" ||
                        (service.ecomm_display &&
                            service.ecomm_display
                                .toLowerCase()
                                .includes("number")))
            );
            if (numberService && numberService.retail_cost) {
                number_fees = parseFloat(numberService.retail_cost) || 0;
            }

            const name_decor_up_charge =
                this.$refs.nameAndNumberRef &&
                this.$refs.nameAndNumberRef.colorSizesForName
                    ? this.$refs.nameAndNumberRef.colorSizesForName
                          .decor_upcharge
                    : 0;
            const number_decor_up_charge =
                this.$refs.nameAndNumberRef &&
                this.$refs.nameAndNumberRef.colorSizesForNumber
                    ? this.$refs.nameAndNumberRef.colorSizesForNumber
                          .decor_upcharge
                    : 0;

            let front_name_fees = 0;
            let front_number_fees = 0;
            let back_name_fees = 0;
            let back_number_fees = 0;
            let left_name_fees = 0;
            let left_number_fees = 0;
            let right_name_fees = 0;
            let right_number_fees = 0;
            let front_name_decor_up_fees = 0;
            let front_number_decor_up_fees = 0;
            let back_name_decor_up_fees = 0;
            let back_number_decor_up_fees = 0;
            let left_name_decor_up_fees = 0;
            let left_number_decor_up_fees = 0;
            let right_name_decor_up_fees = 0;
            let right_number_decor_up_fees = 0;
            var snn = color.selected_name_number || {};
            var nnJson = color.name_and_number_json;

            function isRealName(val) {
                if (!val || typeof val !== "string") return false;
                var t = val.trim();
                if (t === "") return false;
                var u = t.toUpperCase();
                if (u === "YOUR NAME" || u === "ENTER NAME") return false;
                if (/^\d+$/.test(t)) return false; // numeric-only = jersey/quantity, not name
                return true;
            }
            function isRealNumber(val) {
                if (val === null || val === undefined) return false;
                var t = val.toString().trim();
                return t !== "" && t !== "00";
            }

            if (nnJson) {
                if (Array.isArray(nnJson)) {
                    // Common table: same rows for all locations; fee per location where name/number enabled
                    nnJson.forEach(function (nameNumber) {
                        if (isRealName(nameNumber.name)) {
                            if (snn.front && snn.front.name) {
                                front_name_fees += parseFloat(name_fees);
                                front_name_decor_up_fees +=
                                    parseFloat(name_decor_up_charge);
                            }
                            if (snn.back && snn.back.name) {
                                back_name_fees += parseFloat(name_fees);
                                back_name_decor_up_fees +=
                                    parseFloat(name_decor_up_charge);
                            }
                            if (snn.left && snn.left.name) {
                                left_name_fees += parseFloat(name_fees);
                                left_name_decor_up_fees +=
                                    parseFloat(name_decor_up_charge);
                            }
                            if (snn.right && snn.right.name) {
                                right_name_fees += parseFloat(name_fees);
                                right_name_decor_up_fees +=
                                    parseFloat(name_decor_up_charge);
                            }
                        }
                        if (isRealNumber(nameNumber.number)) {
                            if (snn.front && snn.front.number) {
                                front_number_fees += parseFloat(number_fees);
                                front_number_decor_up_fees += parseFloat(
                                    number_decor_up_charge
                                );
                            }
                            if (snn.back && snn.back.number) {
                                back_number_fees += parseFloat(number_fees);
                                back_number_decor_up_fees += parseFloat(
                                    number_decor_up_charge
                                );
                            }
                            if (snn.left && snn.left.number) {
                                left_number_fees += parseFloat(number_fees);
                                left_number_decor_up_fees += parseFloat(
                                    number_decor_up_charge
                                );
                            }
                            if (snn.right && snn.right.number) {
                                right_number_fees += parseFloat(number_fees);
                                right_number_decor_up_fees += parseFloat(
                                    number_decor_up_charge
                                );
                            }
                        }
                    });
                } else if (typeof nnJson === "object") {
                    // Front view - count only real names/numbers (exclude placeholders YOUR NAME, 00)
                    if (nnJson.front && Array.isArray(nnJson.front)) {
                        nnJson.front.forEach(function (nn) {
                            if (
                                isRealName(nn.name) &&
                                snn.front &&
                                snn.front.name
                            ) {
                                front_name_fees += parseFloat(name_fees);
                                front_name_decor_up_fees +=
                                    parseFloat(name_decor_up_charge);
                            }
                            if (
                                isRealNumber(nn.number) &&
                                snn.front &&
                                snn.front.number
                            ) {
                                front_number_fees += parseFloat(number_fees);
                                front_number_decor_up_fees += parseFloat(
                                    number_decor_up_charge
                                );
                            }
                        });
                    }
                    // Back view
                    if (nnJson.back && Array.isArray(nnJson.back)) {
                        nnJson.back.forEach(function (nn) {
                            if (
                                isRealName(nn.name) &&
                                snn.back &&
                                snn.back.name
                            ) {
                                back_name_fees += parseFloat(name_fees);
                                back_name_decor_up_fees +=
                                    parseFloat(name_decor_up_charge);
                            }
                            if (
                                isRealNumber(nn.number) &&
                                snn.back &&
                                snn.back.number
                            ) {
                                back_number_fees += parseFloat(number_fees);
                                back_number_decor_up_fees += parseFloat(
                                    number_decor_up_charge
                                );
                            }
                        });
                    }
                    // Left view
                    if (nnJson.left && Array.isArray(nnJson.left)) {
                        var leftSel = snn.left || {};
                        nnJson.left.forEach(function (nn) {
                            if (isRealName(nn.name) && leftSel.name === true) {
                                left_name_fees += parseFloat(name_fees);
                                left_name_decor_up_fees +=
                                    parseFloat(name_decor_up_charge);
                            }
                            if (
                                isRealNumber(nn.number) &&
                                leftSel.number === true
                            ) {
                                left_number_fees += parseFloat(number_fees);
                                left_number_decor_up_fees += parseFloat(
                                    number_decor_up_charge
                                );
                            }
                        });
                    }
                    // Right view
                    if (nnJson.right && Array.isArray(nnJson.right)) {
                        var rightSel = snn.right || {};
                        nnJson.right.forEach(function (nn) {
                            if (isRealName(nn.name) && rightSel.name === true) {
                                right_name_fees += parseFloat(name_fees);
                                right_name_decor_up_fees +=
                                    parseFloat(name_decor_up_charge);
                            }
                            if (
                                isRealNumber(nn.number) &&
                                rightSel.number === true
                            ) {
                                right_number_fees += parseFloat(number_fees);
                                right_number_decor_up_fees += parseFloat(
                                    number_decor_up_charge
                                );
                            }
                        });
                    }
                }
            }

            return {
                front_name_fees,
                front_number_fees,
                back_name_fees,
                back_number_fees,
                left_name_fees,
                left_number_fees,
                right_name_fees,
                right_number_fees,
                front_name_decor_up_fees,
                front_number_decor_up_fees,
                back_name_decor_up_fees,
                back_number_decor_up_fees,
                left_name_decor_up_fees,
                left_number_decor_up_fees,
                right_name_decor_up_fees,
                right_number_decor_up_fees
            };
        },

        // Count name/number entries from JSON (same logic as ItemDetails) - for display after restore
        countNameNumberFromJson(nnJson, selectedNameNumber) {
            // Only from nnJson.selected_name_number when object; for array use passed param (no fallback)
            const snn =
                nnJson &&
                typeof nnJson === "object" &&
                !Array.isArray(nnJson) &&
                nnJson.selected_name_number
                    ? nnJson.selected_name_number
                    : selectedNameNumber || {};
            const isRealName = (val) => {
                if (!val || typeof val !== "string") return false;
                const t = val.trim();
                if (t === "") return false;
                const u = t.toUpperCase();
                if (u === "YOUR NAME" || u === "ENTER NAME") return false;
                if (/^\d+$/.test(t)) return false;
                return true;
            };
            const isRealNumber = (val) => {
                if (val === null || val === undefined) return false;
                return (
                    val.toString().trim() !== "" &&
                    val.toString().trim() !== "00"
                );
            };
            let frontNameCount = 0,
                backNameCount = 0,
                frontNumberCount = 0,
                backNumberCount = 0;
            let leftNameCount = 0,
                leftNumberCount = 0,
                rightNameCount = 0,
                rightNumberCount = 0;
            if (!nnJson) {
                return {
                    frontNameCount,
                    backNameCount,
                    frontNumberCount,
                    backNumberCount,
                    leftNameCount,
                    leftNumberCount,
                    rightNameCount,
                    rightNumberCount
                };
            }
            if (typeof nnJson === "object" && !Array.isArray(nnJson)) {
                const views = [
                    { key: "front", nameKey: "name", numberKey: "number" },
                    { key: "back", nameKey: "name", numberKey: "number" },
                    { key: "left", nameKey: "name", numberKey: "number" },
                    { key: "right", nameKey: "name", numberKey: "number" }
                ];
                views.forEach((view) => {
                    const arr = nnJson[view.key];
                    if (!Array.isArray(arr)) return;
                    const viewSel = snn[view.key] || {};
                    let nameCount = 0,
                        numberCount = 0;
                    arr.forEach((nn) => {
                        if (isRealName(nn.name) && viewSel.name === true)
                            nameCount++;
                        if (isRealNumber(nn.number) && viewSel.number === true)
                            numberCount++;
                    });
                    if (view.key === "front") {
                        frontNameCount = nameCount;
                        frontNumberCount = numberCount;
                    } else if (view.key === "back") {
                        backNameCount = nameCount;
                        backNumberCount = numberCount;
                    } else if (view.key === "left") {
                        leftNameCount = nameCount;
                        leftNumberCount = numberCount;
                    } else if (view.key === "right") {
                        rightNameCount = nameCount;
                        rightNumberCount = numberCount;
                    }
                });
            } else if (Array.isArray(nnJson) && nnJson.length > 0) {
                // Common table: same rows for all locations
                nnJson.forEach((nn) => {
                    if (isRealName(nn.name)) {
                        if ((snn.front || {}).name === true) frontNameCount++;
                        if ((snn.back || {}).name === true) backNameCount++;
                        if ((snn.left || {}).name === true) leftNameCount++;
                        if ((snn.right || {}).name === true) rightNameCount++;
                    }
                    if (isRealNumber(nn.number)) {
                        if ((snn.front || {}).number === true)
                            frontNumberCount++;
                        if ((snn.back || {}).number === true) backNumberCount++;
                        if ((snn.left || {}).number === true) leftNumberCount++;
                        if ((snn.right || {}).number === true)
                            rightNumberCount++;
                    }
                });
            }
            return {
                frontNameCount,
                backNameCount,
                frontNumberCount,
                backNumberCount,
                leftNameCount,
                leftNumberCount,
                rightNameCount,
                rightNumberCount
            };
        },

        updateNameNumberFees(skipClearDisplayCountsOrEditedView) {
            // Do not clear name_number_display_counts on panel click so Run Charge quantity does not reset
            this.updateNameNumberColorDecorUpCharge();
            this.gender_groups_items[this.active_gender_key].colors.forEach(
                (color) => {
                    const res = this.calcNameNumberFees(color);

                    color.front_name_fees = res.front_name_fees;
                    color.front_number_fees = res.front_number_fees;
                    color.back_name_fees = res.back_name_fees;
                    color.back_number_fees = res.back_number_fees;
                    color.left_name_fees = res.left_name_fees;
                    color.left_number_fees = res.left_number_fees;
                    color.right_name_fees = res.right_name_fees;
                    color.right_number_fees = res.right_number_fees;
                    color.front_name_decor_up_fees =
                        res.front_name_decor_up_fees;
                    color.front_number_decor_up_fees =
                        res.front_number_decor_up_fees;
                    color.back_name_decor_up_fees = res.back_name_decor_up_fees;
                    color.back_number_decor_up_fees =
                        res.back_number_decor_up_fees;
                    color.left_name_decor_up_fees = res.left_name_decor_up_fees;
                    color.left_number_decor_up_fees =
                        res.left_number_decor_up_fees;
                    color.right_name_decor_up_fees =
                        res.right_name_decor_up_fees;
                    color.right_number_decor_up_fees =
                        res.right_number_decor_up_fees;
                }
            );
            // Live counting: when user edits one location, update only that location's count. When panel just opened (skip=true), do NOT overwrite counts (set design counts stay correct; color may have legacy 12).
            var activeIdx =
                this.activeColorIndex >= 0 ? this.activeColorIndex : 0;
            var activeColor =
                this.gender_groups_items[this.active_gender_key].colors[
                    activeIdx
                ];
            var skipOverwriteCounts =
                skipClearDisplayCountsOrEditedView === true;
            var editedView =
                !skipOverwriteCounts &&
                typeof skipClearDisplayCountsOrEditedView === "string" &&
                ["front", "back", "left", "right"].indexOf(
                    skipClearDisplayCountsOrEditedView
                ) >= 0
                    ? skipClearDisplayCountsOrEditedView
                    : null;
            if (
                activeColor &&
                typeof this.countNameNumberFromJson === "function" &&
                !skipOverwriteCounts
            ) {
                var liveCounts = this.countNameNumberFromJson(
                    activeColor.name_and_number_json,
                    activeColor.selected_name_number
                );
                var prev =
                    this.gender_groups_items[this.active_gender_key]
                        .name_number_display_counts;
                var merged =
                    prev &&
                    typeof prev === "object" &&
                    (editedView === "front" ||
                        editedView === "back" ||
                        editedView === "left" ||
                        editedView === "right")
                        ? {
                              frontNameCount:
                                  editedView === "front"
                                      ? liveCounts.frontNameCount || 0
                                      : prev.frontNameCount || 0,
                              backNameCount:
                                  editedView === "back"
                                      ? liveCounts.backNameCount || 0
                                      : prev.backNameCount || 0,
                              leftNameCount:
                                  editedView === "left"
                                      ? liveCounts.leftNameCount || 0
                                      : prev.leftNameCount || 0,
                              rightNameCount:
                                  editedView === "right"
                                      ? liveCounts.rightNameCount || 0
                                      : prev.rightNameCount || 0,
                              frontNumberCount:
                                  editedView === "front"
                                      ? liveCounts.frontNumberCount || 0
                                      : prev.frontNumberCount || 0,
                              backNumberCount:
                                  editedView === "back"
                                      ? liveCounts.backNumberCount || 0
                                      : prev.backNumberCount || 0,
                              leftNumberCount:
                                  editedView === "left"
                                      ? liveCounts.leftNumberCount || 0
                                      : prev.leftNumberCount || 0,
                              rightNumberCount:
                                  editedView === "right"
                                      ? liveCounts.rightNumberCount || 0
                                      : prev.rightNumberCount || 0
                          }
                        : liveCounts;
                this.$set(
                    this.gender_groups_items[this.active_gender_key],
                    "name_number_display_counts",
                    merged
                );
            }

            if (
                this.$refs.ItemDetails &&
                this.$refs.ItemDetails.calculatePricing
            ) {
                this.$refs.ItemDetails.calculatePricing(this.active_gender_key);
                if (this.$refs.ItemDetails.syncNameNumberColorsForAllColors) {
                    this.$refs.ItemDetails.syncNameNumberColorsForAllColors();
                }
                if (
                    this.$refs.ItemDetails
                        .syncNameNumberColorsToImprintLocations
                ) {
                    this.$refs.ItemDetails.syncNameNumberColorsToImprintLocations();
                }
            } else if (typeof console !== "undefined" && console.warn) {
                console.warn(
                    "[DesignStudioV3] updateNameNumberFees: ItemDetails ref or calculatePricing missing"
                );
            }
            this.$nextTick(() => this.updateColorsValidationExceed());
        },

        restoreNameNumbersFromCanvas() {
            // Check canvas for name/number text objects and restore name_and_number_json with actual values
            // This is a fallback when design_json doesn't have the data
            try {
                let canvasJson = localStorage.getItem("new_canvas_elements");
                if (!canvasJson) return;

                let parsedCanvas = JSON.parse(canvasJson);
                let hasNameNumbers = false;
                let nameNumberValues = {
                    front: { names: [], numbers: [] },
                    back: { names: [], numbers: [] },
                    left: { names: [], numbers: [] },
                    right: { names: [], numbers: [] }
                };

                function extractNN(objects, out) {
                    if (!objects || !out) return;
                    objects.forEach((obj) => {
                        if (obj.type !== "text" || !obj.text) return;
                        const t = obj.text.toString().trim();
                        const ot = obj.objType;
                        const isName =
                            ot === "name" ||
                            (typeof ot === "string" &&
                                ot.indexOf("name_") === 0);
                        const isNumber =
                            ot === "number" ||
                            (typeof ot === "string" &&
                                ot.indexOf("number_") === 0);
                        if (isName && t && t !== "YOUR NAME") {
                            out.names.push(t);
                            hasNameNumbers = true;
                        } else if (isNumber && t && t !== "00") {
                            out.numbers.push(t);
                            hasNameNumbers = true;
                        }
                    });
                }

                if (parsedCanvas.front) {
                    try {
                        let fc =
                            typeof parsedCanvas.front === "string"
                                ? JSON.parse(parsedCanvas.front)
                                : parsedCanvas.front;
                        if (fc && fc.objects)
                            extractNN(fc.objects, nameNumberValues.front);
                    } catch (e) {}
                }
                if (parsedCanvas.back) {
                    try {
                        let bc =
                            typeof parsedCanvas.back === "string"
                                ? JSON.parse(parsedCanvas.back)
                                : parsedCanvas.back;
                        if (bc && bc.objects)
                            extractNN(bc.objects, nameNumberValues.back);
                    } catch (e) {}
                }
                if (parsedCanvas.left && parsedCanvas.left !== "") {
                    try {
                        let lc =
                            typeof parsedCanvas.left === "string"
                                ? JSON.parse(parsedCanvas.left)
                                : parsedCanvas.left;
                        if (lc && lc.objects)
                            extractNN(lc.objects, nameNumberValues.left);
                    } catch (e) {}
                }
                if (parsedCanvas.right && parsedCanvas.right !== "") {
                    try {
                        let rc =
                            typeof parsedCanvas.right === "string"
                                ? JSON.parse(parsedCanvas.right)
                                : parsedCanvas.right;
                        if (rc && rc.objects)
                            extractNN(rc.objects, nameNumberValues.right);
                    } catch (e) {}
                }

                // If name numbers found in canvas, restore selected_name_number and name_and_number_json with actual values
                // Only restore if data doesn't already exist (avoid overwriting design_json data)
                if (
                    hasNameNumbers &&
                    this.gender_groups_items &&
                    this.gender_groups_items[this.active_gender_key]
                ) {
                    this.gender_groups_items[
                        this.active_gender_key
                    ].colors.forEach((color) => {
                        // Skip if name_and_number_json already has data (was restored from design_json)
                        var hasActualValues = false;
                        if (color.name_and_number_json) {
                            if (
                                Array.isArray(color.name_and_number_json) &&
                                color.name_and_number_json.length > 0
                            ) {
                                hasActualValues =
                                    color.name_and_number_json.some(
                                        (nn) =>
                                            (nn.name &&
                                                nn.name.trim() !== "") ||
                                            (nn.number &&
                                                nn.number.toString().trim() !==
                                                    "")
                                    );
                            } else if (
                                typeof color.name_and_number_json === "object"
                            ) {
                                ["front", "back", "left", "right"].forEach(
                                    function (view) {
                                        var arr =
                                            color.name_and_number_json[view];
                                        if (
                                            arr &&
                                            arr.some(function (nn) {
                                                return (
                                                    (nn.name &&
                                                        nn.name.trim() !==
                                                            "") ||
                                                    (nn.number &&
                                                        nn.number
                                                            .toString()
                                                            .trim() !== "")
                                                );
                                            })
                                        ) {
                                            hasActualValues = true;
                                        }
                                    }
                                );
                            }
                        }
                        if (hasActualValues) return;

                        // Initialize selected_name_number if not exists
                        if (!color.selected_name_number) {
                            color.selected_name_number = {
                                front: { name: false, number: false },
                                back: { name: false, number: false },
                                left: { name: false, number: false },
                                right: { name: false, number: false }
                            };
                        }

                        if (nameNumberValues.front.names.length > 0)
                            color.selected_name_number.front.name = true;
                        if (nameNumberValues.front.numbers.length > 0)
                            color.selected_name_number.front.number = true;
                        if (nameNumberValues.back.names.length > 0)
                            color.selected_name_number.back.name = true;
                        if (nameNumberValues.back.numbers.length > 0)
                            color.selected_name_number.back.number = true;
                        if (nameNumberValues.left.names.length > 0)
                            color.selected_name_number.left.name = true;
                        if (nameNumberValues.left.numbers.length > 0)
                            color.selected_name_number.left.number = true;
                        if (nameNumberValues.right.names.length > 0)
                            color.selected_name_number.right.name = true;
                        if (nameNumberValues.right.numbers.length > 0)
                            color.selected_name_number.right.number = true;

                        if (
                            !color.name_and_number_json ||
                            !Array.isArray(color.name_and_number_json)
                        ) {
                            color.name_and_number_json = [];
                        }

                        let allNames = [
                            ...new Set([
                                ...nameNumberValues.front.names,
                                ...nameNumberValues.back.names,
                                ...nameNumberValues.left.names,
                                ...nameNumberValues.right.names
                            ])
                        ];
                        let allNumbers = [
                            ...new Set([
                                ...nameNumberValues.front.numbers,
                                ...nameNumberValues.back.numbers,
                                ...nameNumberValues.left.numbers,
                                ...nameNumberValues.right.numbers
                            ])
                        ];

                        // Create entries with actual values
                        let maxEntries = Math.max(
                            allNames.length,
                            allNumbers.length,
                            1
                        );
                        color.name_and_number_json = [];

                        for (let i = 0; i < maxEntries; i++) {
                            color.name_and_number_json.push({
                                name: i < allNames.length ? allNames[i] : null,
                                number:
                                    i < allNumbers.length ? allNumbers[i] : null
                            });
                        }

                        // If no entries created but we have selected_name_number, create at least one entry
                        if (
                            color.name_and_number_json.length === 0 &&
                            (color.selected_name_number.front.number ||
                                color.selected_name_number.back.name ||
                                color.selected_name_number.back.number)
                        ) {
                            color.name_and_number_json.push({
                                name: color.selected_name_number.back.name
                                    ? ""
                                    : null,
                                number:
                                    color.selected_name_number.front.number ||
                                    color.selected_name_number.back.number
                                        ? ""
                                        : null
                            });
                        }
                    });

                    // Recalculate fees after restoring name numbers (only if we actually restored data)
                    if (this.$refs.nameAndNumberRef && this.$refs.ItemDetails) {
                        setTimeout(() => {
                            this.updateNameNumberFees();
                            // Also force calculatePricing to ensure breakdown is updated
                            if (this.$refs.ItemDetails) {
                                this.$refs.ItemDetails.calculatePricing(
                                    this.active_gender_key
                                );
                            }
                        }, 500);
                    }
                }
            } catch (e) {
                console.log("Error restoring name numbers from canvas:", e);
            }
        },

        getAllCanvasDesignColors(activeFlip = null) {
            let flips = ["front", "back", "left", "right"];

            let canvas_design_colors = localStorage.getItem(
                "canvas_design_colors"
            );
            if (canvas_design_colors) {
                canvas_design_colors = JSON.parse(canvas_design_colors);
            } else {
                canvas_design_colors = {};
            }

            let all_obj_colors = [];
            for (let flip of flips) {
                if (activeFlip && activeFlip != flip) {
                    continue;
                }
                let obj_colors = canvas_design_colors[flip]
                    ? canvas_design_colors[flip]
                    : [];
                if (obj_colors.length == 0) {
                    continue;
                }

                var matchColors =
                    /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
                obj_colors.forEach((color) => {
                    if (matchColors.exec(color)) {
                        color = this.rgbToHex(color);
                    }
                });
                all_obj_colors = all_obj_colors.concat(obj_colors);
            }

            return [...new Set(all_obj_colors)];
        },

        updateAdditionalFeesInDashboard() {
            let {
                non_standard_colors,
                standard_colors,
                decoration_colors,
                current_active_flip_standard_colors,
                current_active_flip_specialty_ink_colors,
                current_active_flip_stock_colors,
                current_active_flip_custom_colors
            } = this.calcAdditionalFees();

            this.total_non_standard_colors = [];
            this.current_standard_colors = current_active_flip_standard_colors;
            this.current_specialty_ink_colors =
                current_active_flip_specialty_ink_colors;
            this.current_stock_colors = current_active_flip_stock_colors;
            this.current_custom_colors = current_active_flip_custom_colors;
            this.gender_groups_items.forEach((gender, g_i) => {
                gender.colors.forEach((color) => {
                    if (this.active_gender_key == g_i) {
                        this.total_non_standard_colors =
                            this.total_non_standard_colors.concat(
                                non_standard_colors
                            );
                        color.non_standard_colors = non_standard_colors;
                        color.standard_colors = standard_colors;
                        // color.non_standard_fees = non_standard_fees * color.total_qty_gender_wise;
                        color.decoration_colors = decoration_colors;
                    }
                });
            });

            this.total_non_standard_colors = [
                ...new Set(this.total_non_standard_colors)
            ];

            // Get custom color fee from VendorOtherServices
            const decoration_type =
                this.gender_groups_items[this.active_gender_key].item
                    .decoration_type;
            const activeServiceData =
                this.gender_groups_items[this.active_gender_key]
                    .activeServiceData;
            const serviceName =
                activeServiceData && activeServiceData.name
                    ? activeServiceData.name.toLowerCase()
                    : "";

            // Get custom color fee from VendorOtherServices
            let colorMixFeePerColor = this.getColorMixFeeFromVendorServices(
                decoration_type,
                serviceName
            );

            if (colorMixFeePerColor !== null && colorMixFeePerColor > 0) {
                this.non_standard_fee_per_color = colorMixFeePerColor;
                // Calculate: unique non-standard color count × fee per color (NO quantity multiplication)
                this.total_non_standard_fees =
                    this.total_non_standard_colors.length * colorMixFeePerColor;
            } else {
                // No fallback - only use VendorFees with rollup_fee_id
                this.total_non_standard_fees = 0;
                this.non_standard_fee_per_color = 0;
            }

            // this.$refs.dashBoardComp.$forceUpdate();
        },

        // Get Custom Color Fee from VendorFees (using ecomm_display for matching)
        getColorMixFeeFromVendorServices(decorationType, serviceName) {
            // Get VendorFees from product item data
            const item =
                this.gender_groups_items &&
                typeof this.active_gender_key !== "undefined" &&
                this.gender_groups_items[this.active_gender_key] &&
                this.gender_groups_items[this.active_gender_key].item
                    ? this.gender_groups_items[this.active_gender_key].item
                    : null;

            const vendorFees = item && item.VendorFees ? item.VendorFees : [];

            if (
                !vendorFees ||
                !Array.isArray(vendorFees) ||
                vendorFees.length === 0
            ) {
                return null;
            }

            // Determine which service to use based on decoration type or service name
            let targetService = null;

            if (decorationType == 1) {
                // Screen Print - use Custom Ink Mix Fee
                targetService = vendorFees.find(
                    (service) =>
                        service.type === "custom_ink_mix" ||
                        (service.ecomm_display &&
                            service.ecomm_display
                                .toLowerCase()
                                .includes("ink mix fee"))
                );
            } else if (decorationType == 2 || decorationType == 4) {
                // Embroidery - use Thread Fee
                targetService = vendorFees.find(
                    (service) =>
                        service.type === "thread_fee" ||
                        (service.ecomm_display &&
                            service.ecomm_display
                                .toLowerCase()
                                .includes("thread mix fee"))
                );
            } else {
                // For PCNA (decoration_type 0), check service name for "print" or "embroidery"
                const serviceNameLower = serviceName
                    ? serviceName.toLowerCase()
                    : "";
                const isEmbroidery =
                    serviceNameLower.includes("embroidery") ||
                    serviceNameLower.includes("emb");
                const isPrint = serviceNameLower.includes("print");

                if (isEmbroidery) {
                    // Embroidery service = Thread Mix Fee
                    targetService = vendorFees.find(
                        (service) =>
                            service.type === "thread_fee" ||
                            (service.ecomm_display &&
                                service.ecomm_display
                                    .toLowerCase()
                                    .includes("thread mix fee"))
                    );
                } else if (isPrint) {
                    // Print service = Ink Mix Fee
                    targetService = vendorFees.find(
                        (service) =>
                            service.type === "custom_ink_mix" ||
                            (service.ecomm_display &&
                                service.ecomm_display
                                    .toLowerCase()
                                    .includes("ink mix fee"))
                    );
                }
                // If neither embroidery nor print, targetService remains null (no fee)
            }

            if (targetService && targetService.retail_cost) {
                return parseFloat(targetService.retail_cost) || 0;
            }

            return null;
        },

        calcAdditionalFees() {
            let all_obj_colors = this.getAllCanvasDesignColors();
            let current_active_flip_obj_colors = this.getAllCanvasDesignColors(
                this.active_flip
            );
            let non_standard_colors =
                this.prepareNonStandardColors(all_obj_colors);
            let decoration_colors =
                this.prepareDecorationColors(all_obj_colors);
            let standard_colors = this.prepareStandardColors(all_obj_colors);
            let current_active_flip_standard_colors =
                this.prepareStandardColors(current_active_flip_obj_colors);
            let current_active_flip_specialty_ink_colors =
                this.prepareSpecialtyInkColors(current_active_flip_obj_colors);
            let current_active_flip_stock_colors = this.prepareStockColors(
                current_active_flip_obj_colors
            );
            let current_active_flip_custom_colors = this.prepareCustomColors(
                current_active_flip_obj_colors
            );
            return {
                non_standard_colors,
                decoration_colors,
                standard_colors,
                current_active_flip_standard_colors,
                current_active_flip_specialty_ink_colors,
                current_active_flip_stock_colors,
                current_active_flip_custom_colors
            };
        },

        hasPatchInCanvasObjects(objects) {
            if (!Array.isArray(objects)) return false;
            for (const obj of objects) {
                if (!obj) continue;
                if (obj.ctype === "patch" || obj.type1 === "patch") return true;
                if (Array.isArray(obj.objects) && this.hasPatchInCanvasObjects(obj.objects)) {
                    return true;
                }
            }
            return false;
        },

        hasNameNumberEnabled(canvasDesignColors) {
            const locationKeys = ["front", "back", "left", "right"];
            if (!canvasDesignColors || typeof canvasDesignColors !== "object") {
                return { name: false, number: false };
            }

            let nameEnabled = false;
            let numberEnabled = false;

            for (const location of locationKeys) {
                const colors = Array.isArray(canvasDesignColors[location])
                    ? canvasDesignColors[location]
                    : [];
                for (const color of colors) {
                    if (!color || typeof color !== "object") continue;
                    const selected = color.selected_name_number || {};
                    const locationSelected = selected[location] || {};
                    if (locationSelected.name) nameEnabled = true;
                    if (locationSelected.number) numberEnabled = true;
                    if (nameEnabled && numberEnabled) {
                        return { name: true, number: true };
                    }
                }
            }

            return { name: nameEnabled, number: numberEnabled };
        },

        buildEnabledServicePayload(canvasDesignColors, parsedCanvasJson) {
            const locationKeys = ["front", "back", "left", "right"];
            let patchObjectExists = false;
            const canvasJson = parsedCanvasJson || {};

            for (const location of locationKeys) {
                const rawCanvas = canvasJson[location];
                if (!rawCanvas) continue;
                let parsed = rawCanvas;
                if (typeof rawCanvas === "string") {
                    try {
                        parsed = JSON.parse(rawCanvas);
                    } catch (e) {
                        parsed = null;
                    }
                }
                if (parsed && this.hasPatchInCanvasObjects(parsed.objects)) {
                    patchObjectExists = true;
                    break;
                }
            }

            const nnEnabled = this.hasNameNumberEnabled(canvasDesignColors);
            const nameNumberEnabled = !!(nnEnabled.name || nnEnabled.number);

            const serviceName = (this.currentActiveServiceName || "")
                .toString()
                .trim()
                .toLowerCase();
            const decoratorId = Number(this.currentActiveDecoratorId || 0);

            const patchEnabled =
                serviceName === "patch application" && patchObjectExists;
            const isNameNumberServiceAllowed =
                decoratorId === 20 &&
                [
                    "screen print",
                    "digital transfer",
                    "embroidery",
                    "patch application"
                ].includes(serviceName);
            const effectiveNameNumberEnabled =
                isNameNumberServiceAllowed && nameNumberEnabled;

            return {
                patch: patchEnabled,
                // Keep name + number same, so My Designs treats Name/Number as one capability.
                name: effectiveNameNumberEnabled,
                number: effectiveNameNumberEnabled
            };
        },

        async autoSaveDesign() {
            // Auto-save design without showing modal (for add to cart)
            let _this = this;
            try {
                let new_canvas_elements = localStorage.getItem(
                    "new_canvas_elements"
                );
                let parsedJson = new_canvas_elements
                    ? JSON.parse(new_canvas_elements)
                    : null;
                if (!parsedJson) return null;

                _this.active_flip = localStorage.getItem("active_flip");
                parsedJson[_this.active_flip] = JSON.stringify(
                    _this.backCanvas
                );

                if (parsedJson && this.build_id) {
                    this.saved_design.build_id = this.build_id;
                }
                if (parsedJson && this.build_item_id) {
                    this.saved_design.build_item_id = this.build_item_id;
                }

                let get_canvas_colors = JSON.parse(
                    localStorage.getItem("canvas_design_colors") || "{}"
                );
                get_canvas_colors[_this.active_flip] =
                    _this.design_current_colors;
                localStorage.setItem(
                    "canvas_design_colors",
                    JSON.stringify(get_canvas_colors)
                );

                // Prepare design data
                let thumbnailDataUrl = "";
                try {
                    thumbnailDataUrl = this.backCanvas.toDataURL();
                } catch (e) {
                    thumbnailDataUrl = "";
                }
                let autoSaveData = {
                    name: "Design_" + Date.now(),
                    product_id: localStorage.getItem("product_id"),
                    user_id: this.currentUserClient.id,
                    canvas_json: JSON.stringify(parsedJson),
                    image: thumbnailDataUrl,
                    status: 1,
                    item_type: "single",
                    canvas_design_image: [],
                    canvas_design_colors: get_canvas_colors,
                    enabled_service: this.buildEnabledServicePayload(
                        get_canvas_colors,
                        parsedJson
                    ),
                    design_area_inches: this.design_area_inches
                };

                // Save design
                const { data } = await ApiService.post(
                    "/save-design-image-v2",
                    autoSaveData
                );
                if (data.design_id) {
                    return data.design_id;
                }
                return null;
            } catch (error) {
                console.error("Error in autoSaveDesign:", error);
                return null;
            }
        },

        async save_all_design() {
            if (!this.validateData(this.gender_groups_items)) {
                return;
            }
            let _this = this;
            _this.$validator
                .validateAll("add_save_form")
                .then(async (isValid) => {
                    if (!isValid) {
                        return;
                    }
                    let canvas_designs = _this.checkObjectCanvas();
                    if (!canvas_designs && _this.colors_validation == "") {
                        _this.$toast.clear();
                        _this.$toast.error(
                            "Please add some design ( Text, Clipart or ArtWork ) to this product",
                            {
                                duration: 2000,
                                position: "top-right",
                                queue: false
                            }
                        );
                        return;
                    }
                    _this.isLoader = true;
                    _this.popup_sync_count = 5;
                    // setTimeout(async () => {
                    this.cart_save_design = true;
                    let new_canvas_elements = localStorage.getItem(
                        "new_canvas_elements"
                    );
                    let parsedJson = new_canvas_elements
                        ? JSON.parse(new_canvas_elements)
                        : null;
                    _this.active_flip = localStorage.getItem("active_flip");
                    parsedJson[_this.active_flip] = JSON.stringify(
                        _this.backCanvas
                    );
                    if (parsedJson && this.build_id) {
                        this.saved_design.build_id = this.build_id;
                    }
                    if (parsedJson && this.build_item_id) {
                        this.saved_design.build_item_id = this.build_item_id;
                    }
                    let flips = [];
                    let get_canvas_colors = JSON.parse(
                        localStorage.getItem("canvas_design_colors")
                    );
                    get_canvas_colors[_this.active_flip] =
                        _this.design_current_colors;
                    localStorage.setItem(
                        "canvas_design_colors",
                        JSON.stringify(get_canvas_colors)
                    );
                    if (!this.front_show) {
                        delete parsedJson.front;
                        delete get_canvas_colors.front;
                    } else {
                        flips.push("front");
                    }
                    if (!this.back_show) {
                        delete parsedJson.back;
                        delete get_canvas_colors.back;
                    } else {
                        flips.push("back");
                    }
                    if (!this.left_show) {
                        delete parsedJson.left;
                        delete get_canvas_colors.left;
                    } else {
                        flips.push("left");
                    }
                    if (!this.right_show) {
                        delete parsedJson.right;
                        delete get_canvas_colors.right;
                    } else {
                        flips.push("right");
                    }
                    this.saved_design.canvas_json = JSON.stringify(parsedJson);
                    //this.saved_design.design_json = new_canvas_elements;
                    this.saved_design.product_id =
                        localStorage.getItem("product_id");
                    this.saved_design.user_id = this.currentUserClient.id;
                    this.backCanvas._objects = this.backCanvas._objects.filter(
                        function (val) {
                            return val.type != "rect";
                        }
                    );
                    try {
                        this.saved_design.image = this.backCanvas.toDataURL();
                    } catch (e) {
                        this.saved_design.image = "";
                    }
                    this.saved_design.name =
                        this.saved_design.name != null
                            ? this.saved_design.name
                            : _this.cart_status != ""
                            ? _this.cart_status
                            : Date.now();

                    if (_this.cart_status == "") {
                        //_this.only_save_designs = true;
                        //await _this.addToCart();
                    }
                    //flips = ["front", "back", "left", "right"];
                    let designStatus = this.checkObjectCanvas();
                    let no_of_locations = 0;
                    new_canvas_elements = JSON.parse(
                        localStorage.getItem("new_canvas_elements")
                    );
                    if (new_canvas_elements != null) {
                        new_canvas_elements[_this.active_flip] = JSON.stringify(
                            _this.backCanvas
                        );
                        if ("front" in new_canvas_elements) {
                            if (new_canvas_elements["front"] !== "") {
                                JSON.parse(
                                    new_canvas_elements["front"]
                                ).objects.forEach((canvas_obj) => {
                                    if (canvas_obj.type != "rect") {
                                        no_of_locations++;
                                    }
                                });
                            }
                        }
                        if ("back" in new_canvas_elements) {
                            if (new_canvas_elements["back"] !== "") {
                                JSON.parse(
                                    new_canvas_elements["back"]
                                ).objects.forEach((canvas_obj) => {
                                    if (canvas_obj.type != "rect") {
                                        no_of_locations++;
                                    }
                                });
                            }
                        }
                        if ("left" in new_canvas_elements) {
                            if (new_canvas_elements["left"] !== "") {
                                JSON.parse(
                                    new_canvas_elements["left"]
                                ).objects.forEach((canvas_obj) => {
                                    if (canvas_obj.type != "rect") {
                                        no_of_locations++;
                                    }
                                });
                            }
                        }
                        if ("right" in new_canvas_elements) {
                            if (new_canvas_elements["right"] !== "") {
                                JSON.parse(
                                    new_canvas_elements["right"]
                                ).objects.forEach((canvas_obj) => {
                                    if (canvas_obj.type != "rect") {
                                        no_of_locations++;
                                    }
                                });
                            }
                        }
                    }
                    if (!designStatus) {
                        this.$toast.error(
                            "Please add design on the Product !",
                            {
                                position: "top-right"
                            }
                        );
                        this.isLoader = false;
                        return true;
                    }
                    let image_response = [];
                    for (let flip of flips) {
                        let objects = new_canvas_elements[flip]
                            ? JSON.parse(new_canvas_elements[flip]).objects
                            : [];
                        if (objects.length == 0) {
                            continue;
                        }
                        let tempCanvas = new fabric.Canvas();
                        let rectHeight = 0;
                        let rectWidth = 0;
                        let rectTop = 0;
                        let rectLeft = 0;
                        objects.forEach((canvas_obj) => {
                            // console.log(canvas_obj);
                            if (
                                "clipPath" in canvas_obj &&
                                canvas_obj.clipPath.type == "rect"
                            ) {
                                //  console.log(canvas_obj.clipPath.width, canvas_obj.clipPath.height)
                                rectHeight = canvas_obj.clipPath.height;
                                rectWidth = canvas_obj.clipPath.width;
                                rectTop = canvas_obj.clipPath.top;
                                rectLeft = canvas_obj.clipPath.left;
                            }
                        });
                        // Keep save-design export behavior aligned with preview/cart export
                        // so My Designs thumbnails do not get a different crop result.
                        const hasCustomBox =
                            typeof this.useCustomBoxForFlip === "function" &&
                            this.useCustomBoxForFlip(flip);
                        const useRectForFrontBack =
                            (flip === "front" || flip === "back") &&
                            (hasCustomBox || !this.hasDesignAreaImageForFlip(flip));
                        let effDims =
                            flip === "left" || flip === "right"
                                ? this.getEffectiveDesignAreaDimensionsForFlip(
                                      flip
                                  )
                                : useRectForFrontBack
                                ? this.getEffectiveDesignAreaDimensionsForFlip(
                                      flip
                                  )
                                : null;
                        if (
                            effDims &&
                            effDims.width > 0 &&
                            effDims.height > 0
                        ) {
                            // Custom box true -> product color background, otherwise transparent.
                            tempCanvas.setWidth(effDims.width);
                            tempCanvas.setHeight(effDims.height);
                            let bgColor = null;
                            if (hasCustomBox) {
                                bgColor =
                                    localStorage.getItem(
                                        "active_tshirt_color"
                                    ) ||
                                    (this.user_selected_values &&
                                        this.user_selected_values[
                                            this.active_gender_key
                                        ] &&
                                        this.user_selected_values[
                                            this.active_gender_key
                                        ].color_hash) ||
                                    "#FFFFFF";
                                if (
                                    !bgColor ||
                                    bgColor === "null" ||
                                    bgColor === "#null" ||
                                    bgColor === ""
                                ) {
                                    bgColor = "#FFFFFF";
                                }
                            }
                            tempCanvas.setBackgroundColor(
                                bgColor,
                                tempCanvas.renderAll.bind(tempCanvas)
                            );
                        } else {
                            tempCanvas.setWidth(this.defaultWidthCanvas);
                            tempCanvas.setHeight(this.defaultHeightCanvas);
                        }
                        let localCanvasJson = JSON.parse(
                            new_canvas_elements[flip]
                        );
                        if (localCanvasJson.objects.length > 0) {
                            localCanvasJson.objects =
                                localCanvasJson.objects.filter(function (val) {
                                    return val.type != "rect";
                                });
                        }
                        const setCrossOriginOnImagesSave = (objects) => {
                            if (!objects || !Array.isArray(objects)) return;
                            objects.forEach((obj) => {
                                if (
                                    obj.type === "image" ||
                                    (obj.src && obj.crossOrigin == null)
                                ) {
                                    obj.crossOrigin = "anonymous";
                                }
                                if (obj.objects)
                                    setCrossOriginOnImagesSave(obj.objects);
                            });
                        };
                        const jsonForLoadSave = JSON.parse(
                            JSON.stringify(localCanvasJson)
                        );
                        if (jsonForLoadSave.objects)
                            setCrossOriginOnImagesSave(jsonForLoadSave.objects);
                        await _this.convertCanvasJsonImageUrlsToDataUrls(
                            jsonForLoadSave
                        );
                        await new Promise((resolveLoad) => {
                            tempCanvas.loadFromJSON(
                                JSON.stringify(jsonForLoadSave),
                                function () {
                                    if (
                                        effDims &&
                                        effDims.width > 0 &&
                                        effDims.height > 0
                                    ) {
                                        tempCanvas
                                            .getObjects()
                                            .forEach(function (obj) {
                                                if (obj.clipPath)
                                                    obj.set("clipPath", null);
                                            });
                                    }
                                    _this
                                        .waitForCanvasImagesToLoad(tempCanvas)
                                        .then(() => {
                                            tempCanvas.renderAll();
                                            // Export full current canvas and let transparent-trim
                                            // normalize bounds later. This avoids clipRect offset
                                            // mismatches that can cut top pixels in My Designs.
                                            image_response.push({
                                                label: flip,
                                                url: tempCanvas.toDataURL({
                                                    format: "image/png",
                                                    quality: 1.0
                                                })
                                            });
                                            resolveLoad();
                                        });
                                }
                            );
                        });
                    }
                    let allitems = [];
                    if (_this.saved_design.item_type == "build") {
                        // let checkSizeOfNameAndNumber =this.$refs.
                        //   this.$refs.nameAndNumberRef.nameAndNumberAddToCart();
                        // if (checkSizeOfNameAndNumber == 0) {
                        //             return true;
                        // }
                        let allColorAndSizesname = "";
                        let allColorAndSizesnumber = "";
                        let nameAndNumbers = [];
                        if (this.$refs.nameAndNumberRef.addInputName) {
                            nameAndNumbers =
                                this.$refs.nameAndNumberRef.addInputName.filter(
                                    (nn) => nn.name != "" || nn.number
                                );
                        }
                        if (nameAndNumbers.length > 0) {
                            allColorAndSizesname =
                                this.$refs.nameAndNumberRef.colorSizesForName;
                            allColorAndSizesnumber =
                                this.$refs.nameAndNumberRef.colorSizesForNumber;
                        }
                        let design_items = this.gender_groups_items;
                        for (let design_item of design_items) {
                            /* eslint-disable */
                            let total_quantity = 0;
                            let total_price = 0;
                            /* eslint-enable */
                            //Get selected colors and sizes
                            for (let [colorIndex, color] of Object.entries(
                                design_item["colors"]
                            )) {
                                let items = [];
                                let image_response_back = [];
                                let selected_design_images = [];
                                design_items[0]["item"][
                                    "NewProductImages"
                                ].forEach((colors) => {
                                    if (
                                        colors.color_id == color.id &&
                                        colors.type == "front"
                                    ) {
                                        selected_design_images.push({
                                            front: colors.url
                                        });
                                    }
                                    if (
                                        colors.color_id == color.id &&
                                        colors.type == "back"
                                    ) {
                                        selected_design_images.push({
                                            back: colors.url
                                        });
                                    }
                                });

                                let selected_flip = ["front", "back"];
                                if (image_response_back.length == 0) {
                                    for (let flip1 of selected_flip) {
                                        let objects = new_canvas_elements[flip1]
                                            ? JSON.parse(
                                                  new_canvas_elements[flip1]
                                              ).objects
                                            : [];
                                        if (objects.length == 0) {
                                            continue;
                                        }
                                        let tempCanvas = new fabric.Canvas();
                                        /* eslint-disable */
                                        let rectHeight = 0;
                                        let rectWidth = 0;
                                        let rectTop = 0;
                                        let rectLeft = 0;
                                        for (let canvas_obj of objects) {
                                            if (
                                                "clipPath" in canvas_obj &&
                                                canvas_obj.clipPath.type ==
                                                    "rect"
                                            ) {
                                                rectHeight =
                                                    canvas_obj.clipPath.height;
                                                rectWidth =
                                                    canvas_obj.clipPath.width;
                                                rectTop =
                                                    canvas_obj.clipPath.top;
                                                rectLeft =
                                                    canvas_obj.clipPath.left;
                                            }
                                        }
                                        /* eslint-enable */
                                        tempCanvas.setWidth(
                                            this.defaultWidthCanvas
                                        );
                                        tempCanvas.setHeight(
                                            this.defaultHeightCanvas
                                        );
                                        let localCanvasJson = JSON.parse(
                                            new_canvas_elements[flip1]
                                        );
                                        if (
                                            localCanvasJson.objects.length > 0
                                        ) {
                                            localCanvasJson.objects =
                                                localCanvasJson.objects.filter(
                                                    function (val) {
                                                        return (
                                                            val.type != "rect"
                                                        );
                                                    }
                                                );
                                        }
                                        if (
                                            localCanvasJson.objects.length == 0
                                        ) {
                                            continue;
                                        }
                                        const setCrossOriginOnImagesSave2 = (
                                            objects
                                        ) => {
                                            if (
                                                !objects ||
                                                !Array.isArray(objects)
                                            )
                                                return;
                                            objects.forEach((obj) => {
                                                if (
                                                    obj.type === "image" ||
                                                    (obj.src &&
                                                        obj.crossOrigin == null)
                                                ) {
                                                    obj.crossOrigin =
                                                        "anonymous";
                                                }
                                                if (obj.objects)
                                                    setCrossOriginOnImagesSave2(
                                                        obj.objects
                                                    );
                                            });
                                        };
                                        const jsonForLoadSave2 = JSON.parse(
                                            JSON.stringify(localCanvasJson)
                                        );
                                        if (jsonForLoadSave2.objects)
                                            setCrossOriginOnImagesSave2(
                                                jsonForLoadSave2.objects
                                            );
                                        await _this.convertCanvasJsonImageUrlsToDataUrls(
                                            jsonForLoadSave2
                                        );
                                        await tempCanvas.loadFromJSON(
                                            JSON.stringify(jsonForLoadSave2),
                                            function () {
                                                tempCanvas.renderAll();
                                            }
                                        );
                                        let canvasImgUrlArr =
                                            selected_design_images.filter(
                                                function (currentImage) {
                                                    return currentImage[flip1];
                                                }
                                            );
                                        let canvasImgUrl = "";
                                        if (canvasImgUrlArr.length > 0) {
                                            canvasImgUrl =
                                                canvasImgUrlArr[0][flip1];
                                        }
                                        let imgObj = await _this.loadImageAsync(
                                            canvasImgUrl
                                        );
                                        // Calculate scale to maintain aspect ratio (contain approach)
                                        const scaleX =
                                            _this.defaultWidthCanvas /
                                            imgObj.width;
                                        const scaleY =
                                            _this.defaultHeightCanvas /
                                            imgObj.height;
                                        const scale = Math.min(scaleX, scaleY); // Use smaller scale to maintain aspect ratio

                                        // Calculate scaled dimensions and center position
                                        const scaledWidth =
                                            imgObj.width * scale;
                                        const scaledHeight =
                                            imgObj.height * scale;
                                        const left =
                                            (_this.defaultWidthCanvas -
                                                scaledWidth) /
                                            2;
                                        const top =
                                            (_this.defaultHeightCanvas -
                                                scaledHeight) /
                                            2;

                                        // Set canvas background to transparent to avoid showing canvas edges
                                        tempCanvas.setBackgroundColor(
                                            null,
                                            tempCanvas.renderAll.bind(
                                                tempCanvas
                                            )
                                        );

                                        await tempCanvas.setBackgroundImage(
                                            imgObj,
                                            tempCanvas.renderAll.bind(
                                                tempCanvas
                                            ),
                                            {
                                                scaleX: scale,
                                                scaleY: scale,
                                                left: left,
                                                top: top,
                                                crossOrigin: "anonymous"
                                            }
                                        );
                                        _this.imgHeight = imgObj.height;
                                        _this.imgWidth = imgObj.width;
                                        if (imgObj._element === null) {
                                            _this.$toast.error(
                                                "Something went wrong while loading the design area images, please refresh the page and try again.",
                                                {
                                                    position: "top-right",
                                                    queue: true,
                                                    duration: 10000,
                                                    pauseOnHover: true
                                                }
                                            );
                                        } else {
                                            // Crop to actual image bounds to avoid canvas background
                                            image_response_back.push({
                                                label: flip1,
                                                url: tempCanvas.toDataURL({
                                                    left: left,
                                                    top: top,
                                                    width: scaledWidth,
                                                    height: scaledHeight,
                                                    multiplier: 0.6
                                                })
                                            });
                                        }
                                    } // flip close
                                }

                                for (let size of color["unique_sizes"]) {
                                    // Get all the background images of selected colors
                                    items.push({
                                        sub_product_id: size.id,
                                        Size: size.Size,
                                        user_id: _this.currentUserClient.id,
                                        case_price: size.price_base,
                                        markup_price: size.markup_price,
                                        markup_percentage:
                                            design_item.markup_percentage,
                                        ink_price: size.ink_price,
                                        decoration_discount_percentage:
                                            size.decoration_discount_percentage ||
                                            0,
                                        decoration_discount_value:
                                            size.decoration_discount_value || 0,
                                        single_location_price:
                                            size.single_location_price,
                                        quantity: size.quantity,
                                        discount: size.discount
                                            ? size.discount
                                            : 0.0,
                                        unit_price: size.cost,
                                        total_price: size.total_cost
                                    });
                                }

                                let isNameNumberExists =
                                    color.name_and_number_json.filter(
                                        (nn) => nn.name != "" || nn.number
                                    );

                                let imprint_locations = JSON.parse(
                                    JSON.stringify(
                                        design_item.imprint_locations
                                    )
                                );
                                imprint_locations.forEach((location) => {
                                    location.colors = location.colors.filter(
                                        (lcolor) => lcolor.color
                                    );
                                });

                                color.name_and_number_json =
                                    color.name_and_number_json.filter(
                                        (nn) => nn.name != "" || nn.number
                                    );

                                allitems.push({
                                    user_id: _this.currentUserClient.id,
                                    item_id: design_item.item.id,
                                    decoration_type:
                                        design_item.item.decoration_type,
                                    decoration_price_template:
                                        design_item.item
                                            .decoration_price_template,
                                    price_decoration_bulk:
                                        design_item.item.price_decoration_bulk,
                                    more_decorations:
                                        design_item.item.more_decoration,
                                    gender_size_id: design_item.gender_id,
                                    color_id: color.id,
                                    color_hash: color.hash,
                                    items: items,
                                    total_dark_category_fee:
                                        color.total_dark_category_fee,
                                    total_light_category_fee:
                                        color.total_light_category_fee,
                                    total_design_fee: color.total_design_fee,
                                    total_discount_value:
                                        color.total_discount_value || 0,
                                    total_quantity: color.total_qty_gender_wise,
                                    total_price: color.total_cost_gender_wise,
                                    imprint_locations: imprint_locations,
                                    imprint_locations_price:
                                        colorIndex == 0
                                            ? design_item.total_color_fee
                                            : 0,
                                    setup_fee:
                                        colorIndex == 0
                                            ? color.total_setup_fee
                                            : 0,
                                    t_shirt_24_hour: this.is24Tshirt,
                                    design_image: image_response_back,
                                    front_number_fees:
                                        color.front_number_fees || 0,
                                    back_name_fees: color.back_name_fees || 0,
                                    back_number_fees:
                                        color.back_number_fees || 0,
                                    front_number_decor_up_fees:
                                        color.front_number_decor_up_fees || 0,
                                    back_name_decor_up_fees:
                                        color.back_name_decor_up_fees || 0,
                                    back_number_decor_up_fees:
                                        color.back_number_decor_up_fees || 0,
                                    non_standard_fees: color.non_standard_fees,
                                    non_standard_colors:
                                        color.non_standard_colors,
                                    standard_colors: color.standard_colors,
                                    decoration_colors: color.decoration_colors,
                                    name_and_number_json:
                                        isNameNumberExists.length
                                            ? color.name_and_number_json
                                            : null,
                                    font_color_sizes_name: allColorAndSizesname,
                                    font_color_sizes_number:
                                        allColorAndSizesnumber,
                                    selected_name_number:
                                        color.selected_name_number
                                });
                            }
                        }

                        this.saved_design.allitems = allitems;
                        this.saved_design.product_items = design_items;
                    }

                    // Single save only: build design_json so name/number restores on set design (build code untouched). Skip empty colors/entries.
                    if (
                        _this.saved_design.item_type === "single" &&
                        this.gender_groups_items &&
                        this.gender_groups_items.length > 0
                    ) {
                        // Sync current view states to active color so location-wise name/number colors are saved
                        if (
                            this.$refs.nameAndNumberRef &&
                            typeof this.$refs.nameAndNumberRef
                                .saveAllViewsToColor === "function"
                        ) {
                            this.$refs.nameAndNumberRef.saveAllViewsToColor();
                        }
                        let allitemsSingle = [];
                        let design_item = this.gender_groups_items[0];
                        let allColorAndSizesname = "";
                        let allColorAndSizesnumber = "";
                        if (this.$refs.nameAndNumberRef) {
                            allColorAndSizesname =
                                this.$refs.nameAndNumberRef.colorSizesForName ||
                                "";
                            allColorAndSizesnumber =
                                this.$refs.nameAndNumberRef
                                    .colorSizesForNumber || "";
                        }
                        (design_item.colors || []).forEach((color) => {
                            let nnJson = color.name_and_number_json;
                            let hasNN =
                                nnJson &&
                                ((Array.isArray(nnJson) && nnJson.length > 0) ||
                                    (typeof nnJson === "object" &&
                                        Object.keys(nnJson).length > 0));
                            if (!hasNN) return;
                            // Filter out empty entries (name and number both blank) from name_and_number_json
                            let filteredNN = null;
                            if (Array.isArray(nnJson)) {
                                filteredNN = nnJson.filter(
                                    (e) =>
                                        (e.name &&
                                            e.name.toString().trim() !== "") ||
                                        (e.number !== undefined &&
                                            e.number !== null &&
                                            e.number.toString().trim() !== "")
                                );
                                if (filteredNN.length === 0) return;
                            } else {
                                filteredNN = {};
                                ["front", "back", "left", "right"].forEach(
                                    (view) => {
                                        if (
                                            nnJson[view] &&
                                            Array.isArray(nnJson[view])
                                        ) {
                                            let nonEmpty = nnJson[view].filter(
                                                (e) =>
                                                    (e.name &&
                                                        e.name
                                                            .toString()
                                                            .trim() !== "") ||
                                                    (e.number !== undefined &&
                                                        e.number !== null &&
                                                        e.number
                                                            .toString()
                                                            .trim() !== "")
                                            );
                                            if (nonEmpty.length > 0)
                                                filteredNN[view] = nonEmpty;
                                        }
                                    }
                                );
                                if (Object.keys(filteredNN).length === 0)
                                    return;
                            }
                            // Location-wise name/number colors (front, back, left, right each can have different colors)
                            let view_settings = null;
                            if (
                                color.view_settings &&
                                typeof color.view_settings === "object"
                            ) {
                                view_settings = {};
                                ["front", "back", "left", "right"].forEach(
                                    (view) => {
                                        let vs = color.view_settings[view];
                                        if (
                                            vs &&
                                            (vs.nameSettings ||
                                                vs.numberSettings)
                                        ) {
                                            view_settings[view] = {
                                                nameSettings: vs.nameSettings
                                                    ? Object.assign(
                                                          {},
                                                          vs.nameSettings
                                                      )
                                                    : undefined,
                                                numberSettings:
                                                    vs.numberSettings
                                                        ? Object.assign(
                                                              {},
                                                              vs.numberSettings
                                                          )
                                                        : undefined
                                            };
                                        }
                                    }
                                );
                                if (Object.keys(view_settings).length === 0)
                                    view_settings = null;
                            }
                            // Save name/number counts at save time so restore can use them for display (no recompute on edit)
                            let name_number_counts = null;
                            if (
                                typeof _this.countNameNumberFromJson ===
                                "function"
                            ) {
                                name_number_counts =
                                    _this.countNameNumberFromJson(
                                        color.name_and_number_json,
                                        color.selected_name_number
                                    );
                            }
                            // Per-location name/number color, font, size (same structure as add-to-cart) for design_json
                            let font_color_sizes_name_save = null;
                            let font_color_sizes_number_save = null;
                            if (
                                color.view_settings &&
                                typeof color.view_settings === "object"
                            ) {
                                let namePerLoc = {};
                                let numPerLoc = {};
                                ["front", "back", "left", "right"].forEach(
                                    function (view) {
                                        let vs = color.view_settings[view];
                                        if (vs && vs.nameSettings) {
                                            namePerLoc[view] = {
                                                nameFontFamily:
                                                    vs.nameSettings
                                                        .fontFamily ||
                                                    "Verdana",
                                                nameFontColor:
                                                    vs.nameSettings.fontColor ||
                                                    "#000000",
                                                nameFontSize:
                                                    vs.nameSettings.fontSize ||
                                                    "21",
                                                color_id:
                                                    vs.nameSettings.colorId !=
                                                    null
                                                        ? vs.nameSettings
                                                              .colorId
                                                        : vs.nameSettings
                                                              .color_id || null,
                                                decor_upcharge:
                                                    vs.nameSettings
                                                        .decor_upcharge != null
                                                        ? vs.nameSettings
                                                              .decor_upcharge
                                                        : 0
                                            };
                                        }
                                        if (vs && vs.numberSettings) {
                                            numPerLoc[view] = {
                                                numberFontFamily:
                                                    vs.numberSettings
                                                        .fontFamily ||
                                                    "Verdana",
                                                numberFontColor:
                                                    vs.numberSettings
                                                        .fontColor || "#000000",
                                                numberFontSize:
                                                    vs.numberSettings
                                                        .fontSize || "96",
                                                color_id:
                                                    vs.numberSettings.colorId !=
                                                    null
                                                        ? vs.numberSettings
                                                              .colorId
                                                        : vs.numberSettings
                                                              .color_id || null,
                                                decor_upcharge:
                                                    vs.numberSettings
                                                        .decor_upcharge != null
                                                        ? vs.numberSettings
                                                              .decor_upcharge
                                                        : 0
                                            };
                                        }
                                    }
                                );
                                if (Object.keys(namePerLoc).length > 0)
                                    font_color_sizes_name_save = namePerLoc;
                                if (Object.keys(numPerLoc).length > 0)
                                    font_color_sizes_number_save = numPerLoc;
                            }
                            if (font_color_sizes_name_save == null)
                                font_color_sizes_name_save =
                                    allColorAndSizesname || null;
                            if (font_color_sizes_number_save == null)
                                font_color_sizes_number_save =
                                    allColorAndSizesnumber || null;
                            allitemsSingle.push({
                                color_id: color.id,
                                name_and_number_json: filteredNN,
                                name_number_counts: name_number_counts,
                                item_prices: {
                                    selected_name_number:
                                        color.selected_name_number || null
                                },
                                font_color_sizes_name:
                                    font_color_sizes_name_save,
                                font_color_sizes_number:
                                    font_color_sizes_number_save,
                                view_settings: view_settings
                            });
                        });
                        this.saved_design.design_json =
                            allitemsSingle.length > 0
                                ? JSON.stringify({ allitems: allitemsSingle })
                                : "";
                    }

                    for (const [location, locationColors] of Object.entries(
                        get_canvas_colors
                    )) {
                        get_canvas_colors[location] =
                            this.prepareDecorationColors(locationColors);
                    }
                    const trimmedDesignImages = [];
                    for (const img of image_response) {
                        if (!img || !img.url) continue;
                        const trimmedUrl =
                            await this.trimTransparentPixelsFromDataUrl(img.url);
                        trimmedDesignImages.push({
                            ...img,
                            url: trimmedUrl || img.url
                        });
                    }

                    this.saved_design.canvas_design_image =
                        trimmedDesignImages.length > 0
                            ? trimmedDesignImages
                            : image_response;
                    if (
                        !this.saved_design.image &&
                        this.saved_design.canvas_design_image.length > 0 &&
                        this.saved_design.canvas_design_image[0].url
                    ) {
                        this.saved_design.image =
                            this.saved_design.canvas_design_image[0].url;
                    }
                    this.saved_design.canvas_design_colors = get_canvas_colors;
                    this.saved_design.enabled_service =
                        this.buildEnabledServicePayload(
                            get_canvas_colors,
                            parsedJson
                        );
                    this.saved_design.no_of_locations = no_of_locations;
                    this.saved_design.design_area_inches =
                        this.design_area_inches;
                    _this.popup_sync_count = 50;

                    let currentApiUrl = "/save-design-image-v2";
                    if (_this.saved_design.item_type == "build") {
                        currentApiUrl = "/create-build";
                    }
                    // Refresh design listing
                    this.design_tab_active = false;
                    ApiService.post(currentApiUrl, this.saved_design)
                        .then(async ({ data }) => {
                            if (data.success == false) {
                                this.$toast.error(data.error, {
                                    position: "top-right"
                                });
                                this.isLoader = false;
                                return false;
                            }

                            this.popup_sync_count = 100;
                            this.cart_save_design = false;
                            /* eslint-disable */
                            $("#save_design_modal").modal("hide");
                            /* eslint-enable */
                            if (this.saved_type == "cart") {
                                // Set current_design_id if design was just saved
                                if (data.design_id) {
                                    this.current_design_id = data.design_id;
                                }
                                await this.addToCart();
                            }
                            this.saved_type == "";
                            this.isLoader = false;
                            this.only_save_designs = false;
                            // Refresh design listing
                            this.design_tab_active = true;
                            this.$toast.success(data.message, {
                                position: "top-right"
                            });

                            if (_this.cart_status == "") {
                                this.saved_design.name = null;
                            } else {
                                this.saved_design.name = null;
                            }
                            _this.cart_status = "";
                            _this.saved_design.save_canvas_images = "";
                            _this.save_design_images = "";
                            _this.popup_sync_count = 0;
                            if (_this.saved_design.item_type == "build") {
                                _this.skip_leave_confirm_box = true;
                                this.$router.push({ name: "BuildListV3" });
                                return false;
                            }
                        })
                        .catch((response) => {
                            this.popup_sync_count = 0;
                            this.cart_save_design = false;
                            this.only_save_designs = false;
                            this.isLoader = false;
                            // console.log(response);
                            this.$toast.error(response.error, {
                                position: "top-right"
                            });
                        });
                });
        },

        change_product() {
            localStorage.removeItem("canvas_elements");
            localStorage.removeItem("active_gender");
            localStorage.removeItem("active_gender_key");
            localStorage.removeItem("active_flip");
            localStorage.removeItem("category_object");
            localStorage.removeItem("type");
            localStorage.removeItem("index");
            localStorage.removeItem("design");
            localStorage.removeItem("colorIndex");
            localStorage.removeItem("colorIdArr");
            this.$route.push({ path: "/category/apparel" });
        },
        async addDeleteBtn(x, y, z, e) {
            /* eslint-disable */
            $(".deleteBtn").remove();
            $(".rotationBtn").remove();
            /* eslint-enable */
            if (e === undefined) {
                return;
            }
            let noOfColors = [];
            if (e._objects && e._objects.length) {
                const rgba2hex = (rgba) =>
                    `#${rgba
                        .match(
                            /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/
                        )
                        .slice(1)
                        .map((n, i) =>
                            (i === 3
                                ? Math.round(parseFloat(n) * 255)
                                : parseFloat(n)
                            )
                                .toString(16)
                                .padStart(2, "0")
                                .replace("NaN", "")
                        )
                        .join("")}`;
                fabric.Object.prototype.objectCaching = false;
                var reg = /^#([0-9a-f]{3}){1,2}$/i;
                var matchColors =
                    /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
                e._objects.forEach((e) => {
                    let hexColor = "";
                    if (matchColors.exec(e.fill)) {
                        hexColor = rgba2hex(e.fill);
                    }
                    if (reg.test(e.fill) || hexColor) {
                        noOfColors.push(e.fill);
                    }
                });
            }
            var btnLeft = e.left;
            var btnTop = e.top;
            /* eslint-disable */
            var btnToRight = e.left;
            /* eslint-enable */
            Object.values(e.oCoords).forEach(function (a) {
                if (a.x < btnLeft) {
                    btnLeft = a.x;
                } else if (a.x > btnLeft) {
                    btnToRight = a.x;
                }
                if (a.y < btnTop) {
                    btnTop = a.y;
                }
            });
            let DbtnLeft = btnLeft - 10;
            let DbtnTop = btnTop - this.front_canvas_height / 8;
            let HwbtnTop = btnTop + e.getScaledHeight() + 40;

            let RbtnToRight = btnLeft + e.getScaledWidth();
            let heightInch =
                this.active_flip == "front" || this.active_flip == "back"
                    ? this.front_canvas_height
                    : this.defaultHeightCanvas;
            let widthInch =
                this.active_flip == "front" || this.active_flip == "back"
                    ? this.front_canvas_width
                    : this.defaultWidthCanvas;

            this.rotationAngle = e.angle ? parseInt(e.angle) : 0;

            // Patch objects: use admin-defined dimensions directly (no recalculation)
            const objCtype = e.ctype || (e.get && e.get("ctype"));
            if (
                objCtype === "patch" &&
                e.height_inch &&
                e.width_inch &&
                parseFloat(e.height_inch) > 0 &&
                parseFloat(e.width_inch) > 0
            ) {
                heightInch = parseFloat(e.height_inch).toFixed(2);
                widthInch = parseFloat(e.width_inch).toFixed(2);
            } else {
                heightInch = parseFloat(
                    ((e.height * e.scaleY) / heightInch) *
                        parseFloat(this.front_canvas_height_inch)
                ).toFixed(2);
                widthInch = parseFloat(
                    ((e.width * e.scaleX) / widthInch) *
                        parseFloat(this.front_canvas_width_inch)
                ).toFixed(2);
            }
            e.height_inch = heightInch;
            e.width_inch = widthInch;
            let currentActiveObject = this.backCanvas.getActiveObject();
            currentActiveObject.toObject = (function (toObject) {
                return function () {
                    return fabric.util.object.extend(toObject.call(this), {
                        width_inch: widthInch,
                        height_inch: heightInch
                    });
                };
            })(currentActiveObject.toObject);
            var deleteBtn =
                '<img src="/maincss/images/close-round.svg" class="deleteBtn" style="position:absolute;top:' +
                DbtnTop +
                "px !important;left:" +
                DbtnLeft +
                'px !important;cursor:pointer;width:20px;height:20px;"/>';
            /* eslint-disable */
            let hastcanvas = $(".canvas-container").find("#tcanvas");
            /* eslint-enable */
            var rBtn =
                '<label  class="rotationBtn" style="position:absolute;top:' +
                DbtnTop +
                "px !important;left:" +
                RbtnToRight +
                'px !important;cursor:pointer;background:#44484f;color: #ffffff;border-radius: 8px;padding: 2px;line-height: 17px;max-width: 35px;text-align: center;">' +
                Math.round(e.angle) +
                "<span>&#176;</span></label>";
            var hwBtn =
                '<label  class="rotationBtn" style="position:absolute;top:' +
                HwbtnTop +
                "px !important;left:" +
                RbtnToRight +
                'px !important;cursor:pointer;background:#44484f;color: #ffffff;border-radius: 8px;padding: 5px;line-height: 17px;max-width: 120px;margin-top: 12px;">' +
                heightInch +
                " <span>&#8243;</span> <b>&#215;</b> " +
                widthInch +
                " <span>&#8243;</span></label>";
            if (hastcanvas.length) {
                hastcanvas.closest(".canvas-container").append(deleteBtn);
                hastcanvas.closest(".canvas-container").append(rBtn);
                hastcanvas.closest(".canvas-container").append(hwBtn);
            }
            setTimeout(() => {
                this.prepareImprintLocations();
            }, 1000);
        },
        onObjectSelected(e) {
            if (!e) {
                return;
            }
            var selectedObject = e.target;
            var objType =
                selectedObject.objType ||
                (selectedObject.toObject &&
                    selectedObject.toObject().objType) ||
                "";
            var isNameNumber =
                objType === "name" ||
                objType === "number" ||
                (typeof objType === "string" &&
                    (objType.startsWith("name_") ||
                        objType.startsWith("number_")));

            const isPatchObject =
                selectedObject.ctype === "patch" ||
                (selectedObject.get && selectedObject.get("ctype") === "patch");

            if (isPatchObject) {
                // Patches: fixed size – allow move & rotate only, no scaling
                selectedObject.set({
                    lockMovementX: false,
                    lockMovementY: false,
                    lockRotation: false,
                    lockScalingX: true,
                    lockScalingY: true,
                    lockUniScaling: true,
                    hasControls: true
                });
                selectedObject.setControlsVisibility({
                    mt: false,
                    mb: false,
                    ml: false,
                    mr: false,
                    tl: false,
                    tr: false,
                    bl: false,
                    br: false,
                    mtr: true
                });
            } else if (isNameNumber) {
                selectedObject.set({
                    lockMovementX: false,
                    lockMovementY: false,
                    lockRotation: true,
                    lockScalingX: false,
                    lockScalingY: false
                });
            } else {
                selectedObject.set({
                    lockMovementX: false,
                    lockMovementY: false,
                    lockRotation: false,
                    lockScalingX: false,
                    lockScalingY: false
                });
            }

            selectedObject.set({
                borderColor: "#44484f",
                cornerColor: "#44484f",
                transparentCorners: false,
                cornerStyle: "square",
                uniScaleTransform: true,
                cornersize: 12,
                cornerStrokeColor: "#ffffff"
            });
            // square.opacity=1
            listLine.forEach(function (obj) {
                obj.opacity = 1;
            });
            this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );
            this.syncSelectedArtDimensions(selectedObject);
            selectedObject.hasRotatingPoint = true;
            /* eslint-disable */
            if (
                selectedObject &&
                selectedObject.type === "text" &&
                isNameNumber
            ) {
                this.showMenu(false, "nn-tab1");
            } else if (selectedObject && selectedObject.type === "text") {
                $("#add-text-tab").click();
                let {
                    text,
                    fontFamily,
                    fontStyle,
                    fontSize,
                    textAlign,
                    fontWeight,
                    underline,
                    linethrough,
                    id,
                    fill,
                    angle,
                    textDecoration,
                    shadow,
                    paintFirst,
                    strokeWidth,
                    stroke
                } = selectedObject;

                let embossX = 0;
                let embossY = 0;
                let embossColour = "#000000";
                let embossBlur = 0;
                if (shadow != null && shadow.blur > 0) {
                    embossX = shadow.offsetX;
                    embossY = shadow.offsetY;
                    embossColour = shadow.color;
                    embossBlur = shadow.blur;
                }
                this.textData = {
                    id,
                    text,
                    fontFamily: fontFamily,
                    fontStyle: fontStyle,
                    fontWeight: this.normalizeFontWeightForToolbar(fontWeight),
                    fontSize: fontSize,
                    color: fill ? fill : "#D3D3D3",
                    rotation: angle,
                    textAlign,
                    textDecoration: linethrough ? "linethrough" : textDecoration,
                    textUDecoration: underline ? "underline" : "",
                    underline: underline,
                    layer: "",
                    flip: "",
                    flipX: !!selectedObject.flipX,
                    flipY: !!selectedObject.flipY,
                    center: this.computeHorizontalAlignKey(selectedObject),
                    embossX: embossX,
                    embossY: embossY,
                    embossColour: embossColour,
                    embossBlur: embossBlur,
                    paintFirst: paintFirst,
                    strokeWidth: strokeWidth,
                    stroke: stroke,
                    linethrough: linethrough
                };
                setTimeout(function () {
                    let textArea = $("#text_area_box")[0];
                    textArea.scrollTop = textArea.scrollHeight;
                }, 200);
            } else if (
                selectedObject &&
                (selectedObject.ctype === "clipart" ||
                    selectedObject.ctype === "templates" ||
                    selectedObject.ctype === "shape" ||
                    selectedObject.ctype === "patch" ||
                    selectedObject.ctype === "upload")
            ) {
                this.selectImageProps = {
                    rotation: selectedObject.angle,
                    flipX: !!selectedObject.flipX,
                    flipY: !!selectedObject.flipY,
                    center: this.computeHorizontalAlignKey(selectedObject)
                };
                this.EditImages(selectedObject.ctype);

                if (selectedObject.ctype == "upload") {
                    this.loadUploadFromCanvasObject(selectedObject);
                    if (selectedObject.iextension == "svg") {
                        $("#add-" + selectedObject.ctype + "-tab").click();
                    } else {
                        $("#add-" + selectedObject.ctype + "-tab").click();
                        this.category_heading = true;
                        this.edit_template = false;
                    }
                } else {
                    if (selectedObject.ctype === "patch") {
                        $("#add-patch-new-tab").click();
                    } else {
                        $("#add-" + selectedObject.ctype + "-tab").click();
                    }
                }
            } else {
                this.$forceUpdate();
            }
            /* eslint-enable */

            this.selected_object_colors =
                this.getSelectedObjectColors(selectedObject);
        },
        syncSelectedArtDimensions(selectedObject) {
            if (!selectedObject || typeof selectedObject !== "object") {
                this.selected_art_dimensions = null;
                return;
            }

            const rawWidth = selectedObject.width_inch;
            const rawHeight = selectedObject.height_inch;

            if (rawWidth == null || rawHeight == null) {
                this.selected_art_dimensions = null;
                return;
            }

            const parsedWidth = parseFloat(rawWidth);
            const parsedHeight = parseFloat(rawHeight);

            if (
                !Number.isFinite(parsedWidth) ||
                parsedWidth <= 0 ||
                !Number.isFinite(parsedHeight) ||
                parsedHeight <= 0
            ) {
                this.selected_art_dimensions = null;
                return;
            }

            this.selected_art_dimensions = {
                width: parsedWidth.toFixed(2),
                height: parsedHeight.toFixed(2)
            };
        },
        getSelectedObjectColors(activeObject) {
            const rgba2hex = (rgba) =>
                `#${rgba
                    .match(
                        /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/
                    )
                    .slice(1)
                    .map((n, i) =>
                        (i === 3
                            ? Math.round(parseFloat(n) * 255)
                            : parseFloat(n)
                        )
                            .toString(16)
                            .padStart(2, "0")
                            .replace("NaN", "")
                    )
                    .join("")}`;
            var colorListValue = [];
            if (activeObject) {
                // For shapes, include both fill and stroke (outline) colors
                if (activeObject.ctype === "shape") {
                    var reg = /^#([0-9a-f]{3}){1,2}$/i;
                    var matchColors =
                        /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;

                    // Get fill color
                    if (activeObject.fill) {
                        let hexColor = "";
                        if (matchColors.exec(activeObject.fill)) {
                            hexColor = rgba2hex(activeObject.fill);
                        }
                        if (reg.test(activeObject.fill) || hexColor) {
                            colorListValue.push(activeObject.fill);
                        }
                    }

                    // Get stroke (outline) color
                    if (activeObject.stroke) {
                        let strokeHexColor = "";
                        if (matchColors.exec(activeObject.stroke)) {
                            strokeHexColor = rgba2hex(activeObject.stroke);
                        }
                        if (reg.test(activeObject.stroke) || strokeHexColor) {
                            colorListValue.push(activeObject.stroke);
                        }
                    }
                } else if (
                    activeObject._objects &&
                    activeObject._objects.length
                ) {
                    fabric.Object.prototype.objectCaching = false;
                    var reg = /^#([0-9a-f]{3}){1,2}$/i;
                    var matchColors =
                        /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
                    activeObject._objects.forEach((e) => {
                        // Get fill color
                        let hexColor = "";
                        if (matchColors.exec(e.fill)) {
                            hexColor = rgba2hex(e.fill);
                        }
                        if (reg.test(e.fill) || hexColor) {
                            colorListValue.push(e.fill);
                        }
                        // Get stroke (outline) color for each path
                        if (
                            e.stroke &&
                            e.stroke !== "transparent" &&
                            e.stroke !== "none" &&
                            e.stroke !== ""
                        ) {
                            let strokeHexColor = "";
                            if (matchColors.exec(e.stroke)) {
                                strokeHexColor = rgba2hex(e.stroke);
                            }
                            if (reg.test(e.stroke) || strokeHexColor) {
                                colorListValue.push(e.stroke);
                            }
                        }
                    });
                    // Also check main object's stroke if it exists
                    if (
                        activeObject.stroke &&
                        activeObject.stroke !== "transparent" &&
                        activeObject.stroke !== "none" &&
                        activeObject.stroke !== ""
                    ) {
                        let strokeHexColor = "";
                        if (matchColors.exec(activeObject.stroke)) {
                            strokeHexColor = rgba2hex(activeObject.stroke);
                        }
                        if (reg.test(activeObject.stroke) || strokeHexColor) {
                            colorListValue.push(activeObject.stroke);
                        }
                    }
                } else {
                    colorListValue = [];
                }
            }
            if (activeObject.paths && activeObject.paths.length) {
                colorListValue.push(activeObject.fill);
            }
            if (activeObject.fill && colorListValue.length == 0) {
                colorListValue.push(activeObject.fill);
            }

            return [...new Set(colorListValue)];
        },
        onSelectedCleared() {
            /* eslint-disable */
            $(".deleteBtn").remove();
            $(".rotationBtn").remove();
            /* eslint-enable */
            let color_code = "";

            if (this.vendor_colors_list.length > 0) {
                let color_list = this.vendor_colors_list;
                if (color_list.length > 0) {
                    color_code =
                        color_list[0].color_value != null &&
                        color_list[0].color_value != ""
                            ? color_list[0].color_value
                            : "#D3D3D3";
                }
            }
            this.textData = {
                text: "",
                fontFamily: "Arial",
                fontStyle: "",
                fontSize: 50,
                color: color_code,
                rotation: 0,
                textAlign: "left",
                layer: "",
                flip: "",
                flipX: false,
                flipY: false,
                center: "",
                textDecoration: "",
                textUDecoration: "",
                fontWeight: 100,
                embossX: 0,
                embossY: 0,
                embossColour: "#53565A",
                embossBlur: 0,
                paintFirst: null,
                strokeWidth: 0,
                stroke: "",
                underline: "",
                linethrough: ""
            };
            this.edit_template = false;

            listLine.forEach(function (obj) {
                obj.opacity = 0;
            });
            this.backCanvas.discardActiveObject();
            /* eslint-disable */
            $("#text-string").val("");
            $("#text_area_box").val("");
            $("#texteditor").css("display", "none");
            $("#imageeditor").css("display", "none");
            /* eslint-enable */
            this.active_class = "active";
            this.$forceUpdate();
        },
        groupArrayOfObjects(list, key) {
            return list.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        },
        wow() {
            alert();
        },
        SetColorCanvas(val, colorId) {
            if (!colorId) {
                return;
            }

            // 1) Update active color / design data (same as before)
            this.activeIndex = colorId;
            const _this = this;

            const get_product = JSON.stringify(this.product_items);
            const unique_colors = JSON.parse(get_product).MainNewSubProducts;
            const main_colors = [];
            _this.groupedSizesByColors = _this.groupArrayOfObjects(
                unique_colors,
                "color_id"
            );

            Object.values(_this.groupedSizesByColors).forEach((element) => {
                main_colors.push(element[0].Color);
            });

            const newArray = main_colors.filter((el) => el.id == colorId);
            if (!newArray || !newArray[0]) {
                return;
            }

            const design = this.gender_groups_items;

            design[0].color.id = newArray[0].id;
            design[0].color.color_name = newArray[0].name;
            design[0].color.hash = newArray[0].hex;
            design[0].color.category = newArray[0].category;
            design[0].color.shades = newArray[0].shades;
            design[0].color.swatches = newArray[0].swatches;

            design[0].colors.forEach((col, ind) => {
                if (parseInt(col.id) === parseInt(colorId)) {
                    _this.activeColorIndex = ind;
                }
            });

            localStorage.setItem("colorIndex", _this.activeColorIndex);
            localStorage.setItem("active_tshirt_color", newArray[0].hex);

            this.tshirt_color = newArray[0].hex;

            if (
                this.$refs.nameAndNumberRef &&
                design[0].colors[this.activeColorIndex]
            ) {
                this.$refs.nameAndNumberRef.loadNameAndNumber(
                    design[0].colors[this.activeColorIndex]
                );
            }

            // 2) Reuse the same view logic as print-area click
            //    (flipTshirt handles background image, rectangles, design area etc.)
            const currentFlip =
                (this.active_flip && this.active_flip.toLowerCase()) || "front";
            this.flipTshirt(currentFlip);

            // 3) Keep dashboard fees in sync (was previously at the end of SetColorCanvas)
            this.updateAdditionalFeesInDashboard();
            if (this.$refs.dashBoardComp) {
                this.$refs.dashBoardComp.$forceUpdate();
            }
        },

        loadImageFromCrossOrigin(imageUrl) {
            if (!imageUrl) return "Image URL is required";

            const date = new Date();
            let getHours = date.getHours();
            const attrImg = new Image();
            attrImg.crossOrigin = "Anonymous";
            attrImg.src = imageUrl + "?no-cache&" + getHours;

            return attrImg.src;
        },
        updateImageToBackCanvas(imgUrl = false) {
            let _this = this;
            _this.isLoader = true;
            let canvasImgUrl = imgUrl ? imgUrl : _this.background_image;

            // Skip if URL is empty, null, or contains design-studio/v3 (invalid URL)
            if (
                !canvasImgUrl ||
                canvasImgUrl === "" ||
                canvasImgUrl === "null" ||
                canvasImgUrl.includes("design-studio/v3")
            ) {
                _this.isLoader = false;
                return;
            }

            // let canvasColor = color
            //     ? color
            //     : _this.user_selected_values[_this.active_gender_key]
            //           .color_hash;
            // console.log(color);
            const d = new Date();

            let time = d.getHours();
            const corsImage = new Image();
            corsImage.crossOrigin = "Anonymous";
            corsImage.src = canvasImgUrl + "?no-cache&" + time;

            // Check image Domains
            if (
                typeof canvasImgUrl !== "undefined" &&
                canvasImgUrl.search("sanmar.com") >= 0
            ) {
                _this.isLoader = false;
                _this.$toast.error(
                    "There is a issue with loading cross domain images",
                    {
                        position: "top-right",
                        queue: true,
                        duration: 10000,
                        pauseOnHover: true
                    }
                );
            }
            // Update canvas Image

            fabric.Image.fromURL(
                corsImage.src,
                (imgObj) => {
                    // Calculate scale to maintain aspect ratio (contain approach)
                    // Use the smaller scale to ensure image fits within canvas
                    const scaleX = _this.defaultWidthCanvas / imgObj.width;
                    const scaleY = _this.defaultHeightCanvas / imgObj.height;
                    const scale = Math.min(scaleX, scaleY); // Use smaller scale to maintain aspect ratio

                    // Calculate scaled dimensions and center position
                    const scaledWidth = imgObj.width * scale;
                    const scaledHeight = imgObj.height * scale;
                    const left = (_this.defaultWidthCanvas - scaledWidth) / 2;
                    const top = (_this.defaultHeightCanvas - scaledHeight) / 2;

                    _this.imageCanvas.setBackgroundImage(
                        imgObj,
                        _this.imageCanvas.renderAll.bind(_this.imageCanvas),
                        {
                            //backgroundColor: canvasColor,
                            scaleX: scale,
                            scaleY: scale,
                            left: left,
                            top: top,
                            crossOrigin: "anonymous"
                        }
                    );
                    _this.imgHeight = imgObj.height;
                    _this.imgWidth = imgObj.width;
                    _this.isLoader = false;
                    if (imgObj._element === null) {
                        _this.$toast.error(
                            "Something went wrong while loading the design area images, please refresh the page and try again.",
                            {
                                position: "top-right",
                                queue: true,
                                duration: 10000,
                                pauseOnHover: true
                            }
                        );
                    }
                },
                {
                    crossOrigin: "anonymous"
                }
            );
        },
        cancelLogin: function () {
            localStorage.setItem("login_cancelled", true);
        },
        designColorsHtml(colors) {
            let output = "";
            if (colors == null) return false;
            if (colors !== null && colors !== "null" && this.isJSON(colors)) {
                let colorsParse = JSON.parse(colors).length
                    ? JSON.parse(colors)
                    : [];

                let limitColorsArr =
                    colorsParse.length > 4
                        ? colorsParse.slice(0, 4)
                        : colorsParse;
                output += `<ul class="select_colors">`;
                limitColorsArr.forEach((element) => {
                    output += `<li style="background-color: ${element};"></li>`;
                });
                if (colorsParse.length > 4) {
                    output += `<li class="more_color_link"><a href="javascript:;">+${
                        colorsParse.slice(4).length
                    }</a></li>`;
                }
                output += `</ul>`;
            }
            return output;
        },
        isJSON(str) {
            try {
                JSON.parse(str);
                return true;
            } catch (error) {
                return false;
            }
        },
        prepareStandardColors(objColors) {
            // This function is now deprecated - Standard Colors replaced by Stock Colors
            // Keeping for backward compatibility but returning empty array
            return [];
        },
        prepareStockColors(objColors) {
            let colors = [];
            objColors.forEach((colorHex) => {
                let vendorColor = this.vendor_colors_list.find(
                    (col) =>
                        col.color_value.toLowerCase() == colorHex.toLowerCase()
                );
                if (vendorColor) {
                    const colorType = String(
                        vendorColor.color_type || ""
                    )
                        .replace(/['"]/g, "")
                        .trim()
                        .toLowerCase();
                    const upcharge = parseFloat(
                        vendorColor.decor_upcharge || 0
                    );
                    const stock =
                        vendorColor.stock === true || vendorColor.stock === 1;
                    // Only include colors with stock = true AND upcharge = 0/null/empty
                    if (stock && upcharge === 0 && colorType !== "vinyl") {
                        colors.push({
                            name: vendorColor.color_name,
                            hex: vendorColor.color_value
                        });
                    }
                }
            });
            return colors;
        },
        prepareSpecialtyInkColors(objColors) {
            let colors = [];
            objColors.forEach((colorHex) => {
                let vendorColor = this.vendor_colors_list.find(
                    (col) =>
                        col.color_value.toLowerCase() == colorHex.toLowerCase()
                );
                if (vendorColor) {
                    const colorType = String(
                        vendorColor.color_type || ""
                    )
                        .replace(/['"]/g, "")
                        .trim()
                        .toLowerCase();
                    const upcharge = parseFloat(
                        vendorColor.decor_upcharge || 0
                    );
                    const stock =
                        vendorColor.stock === true || vendorColor.stock === 1;
                    // Only include colors with stock = true AND upcharge > 0
                    if (stock && upcharge > 0 && colorType !== "vinyl") {
                        colors.push({
                            name:
                                vendorColor.color_name ||
                                vendorColor.color_value,
                            hex: vendorColor.color_value,
                            upcharge: upcharge
                        });
                    }
                }
            });
            return colors;
        },
        prepareCustomColors(objColors) {
            let colors = [];
            objColors.forEach((colorHex) => {
                let vendorColor = this.vendor_colors_list.find(
                    (col) =>
                        col.color_value.toLowerCase() == colorHex.toLowerCase()
                );
                if (vendorColor) {
                    const colorType = String(
                        vendorColor.color_type || ""
                    )
                        .replace(/['"]/g, "")
                        .trim()
                        .toLowerCase();
                    const stock =
                        vendorColor.stock === true || vendorColor.stock === 1;
                    const upcharge = parseFloat(
                        vendorColor.decor_upcharge || 0
                    );
                    // Include only non-vinyl colors with stock = false
                    if (!stock && colorType !== "vinyl") {
                        colors.push({
                            name:
                                vendorColor.color_name ||
                                vendorColor.color_value,
                            hex: vendorColor.color_value,
                            upcharge: upcharge
                        });
                    }
                }
            });
            return colors;
        },
        prepareNonStandardColors(objColors) {
            let unmatchedColors = [];
            let vinylHexCodes = this.vinyl_color_list.map((color) => color.hex);
            objColors.forEach((colorHex) => {
                if (!vinylHexCodes.includes(colorHex)) {
                    let colorMatch = this.vendor_colors_list.findIndex(
                        (col) =>
                            col.color_value.toLowerCase() ==
                            colorHex.toLowerCase()
                    );
                    if (colorMatch == -1) {
                        unmatchedColors.push(colorHex);
                    }
                }
            });
            return unmatchedColors;
        },
        prepareDecorationColors(objColors = []) {
            let colors = [];
            objColors.forEach((colorHex) => {
                let vendorColor = this.vendor_colors_list.find(
                    (col) =>
                        col.color_value.toLowerCase() == colorHex.toLowerCase()
                );
                if (vendorColor) {
                    colors.push({
                        name: vendorColor.color_name,
                        hex: vendorColor.color_value
                    });
                } else {
                    colors.push({
                        hex: colorHex
                    });
                }
            });
            return colors;
        },

        refreshVendorColorsList() {
            if (
                !this.product_items ||
                !this.product_items.Decorators ||
                !this.product_items.Decorators.length
            ) {
                this.vendor_colors_list = [];
                return;
            }
            let decoratorToUse = null;
            if (this.product_items.default_decorator_id) {
                decoratorToUse = this.product_items.Decorators.find(
                    (d) => d.id === this.product_items.default_decorator_id
                );
            }
            if (!decoratorToUse) {
                decoratorToUse = this.product_items.Decorators[0];
            }
            let vendor_colors_source = [];
            if (decoratorToUse && decoratorToUse.VendorColors) {
                vendor_colors_source = decoratorToUse.VendorColors;
            }
            this.vendor_colors_list = this.prepareColors(vendor_colors_source);
        },
        prepareColors(colors) {
            let filteredColorsInput = [];
            let colorTypeToFilter = "";

            // First, try to get color_type from decoration service's master_service
            try {
                const genderGroups = this.gender_groups_items;
                const activeGenderKey = this.active_gender_key;
                const activeServiceData =
                    genderGroups &&
                    genderGroups[activeGenderKey] &&
                    genderGroups[activeGenderKey].activeServiceData
                        ? genderGroups[activeGenderKey].activeServiceData
                        : null;
                // console.log("active service data" + JSON.stringify(activeServiceData));
                if (
                    activeServiceData &&
                    activeServiceData.master_service &&
                    activeServiceData.master_service.color_type
                ) {
                    colorTypeToFilter =
                        activeServiceData.master_service.color_type.toLowerCase();
                }
            } catch (e) {
                console.warn(
                    "Error getting color_type from activeServiceData:",
                    e
                );
            }

            // Fallback to decoration_type if color_type is not available (backward compatibility)
            // if (!colorTypeToFilter) {
            //     const currentDecorationType = this.product_items.decoration_type;
            //     if (currentDecorationType == 1) {
            //         colorTypeToFilter = "ink";
            //     } else if (currentDecorationType == 2) {
            //         colorTypeToFilter = "thread";
            //     } else if (currentDecorationType == 3) {
            //         colorTypeToFilter = "vinyl";
            //     }
            // }

            // Filter colors based on color_type
            // No color type or "none" → show only stock + specialty (no custom ink/thread in tabs)
            let noColorTypeFilter = false;
            if (
                colorTypeToFilter &&
                colorTypeToFilter !== "none" &&
                Array.isArray(colors)
            ) {
                filteredColorsInput = colors.filter(
                    (vc) => vc.Color && vc.Color.type === colorTypeToFilter
                );
            } else if (!colorTypeToFilter || colorTypeToFilter === "none") {
                // No color type → show all vendor colors but only stock+specialty (exclude custom)
                noColorTypeFilter = true;
                filteredColorsInput = Array.isArray(colors) ? colors : [];
            } else {
                console.warn(
                    "prepareColors: Input vendor colors is not an array."
                );
                return [];
            }
            let allColors = [];

            commonData.colorShades.forEach((shade) => {
                filteredColorsInput.forEach((colorWrapper) => {
                    const color = colorWrapper.Color;

                    if (color && color.hex && color.shades) {
                        let shadesArray = [];
                        try {
                            if (typeof color.shades === "string") {
                                shadesArray = JSON.parse(color.shades);
                            } else if (Array.isArray(color.shades)) {
                                shadesArray = color.shades;
                            }
                        } catch (e) {
                            /* Ignore */
                        }

                        if (
                            Array.isArray(shadesArray) &&
                            shadesArray.includes(shade)
                        ) {
                            let alreadyExisted = allColors.find(
                                (col) => col.color_id == color.color_id
                            );
                            if (!alreadyExisted) {
                                const normalizedColorType = String(
                                    color.type ||
                                        colorWrapper.color_type ||
                                        ""
                                )
                                    .replace(/['"]/g, "")
                                    .trim()
                                    .toLowerCase();
                                allColors.push({
                                    color_id: color.color_id,
                                    color_name: color.name,
                                    color_pms: color.pms,
                                    decor_upcharge: colorWrapper.decor_upcharge,
                                    color_value: color.hex, // Use hex
                                    swatches: color.swatches,
                                    stock: colorWrapper.stock || false,
                                    color_type: normalizedColorType
                                });
                            }
                        }
                    }
                });
            });
            filteredColorsInput.forEach((colorWrapper) => {
                const color = colorWrapper.Color;

                if (color && color.hex) {
                    let shadesArray = [];
                    try {
                        if (typeof color.shades === "string") {
                            shadesArray = JSON.parse(color.shades);
                        } else if (Array.isArray(color.shades)) {
                            shadesArray = color.shades;
                        }
                    } catch (e) {
                        /* ignore */
                    }

                    if (
                        !Array.isArray(shadesArray) ||
                        shadesArray.length === 0
                    ) {
                        let alreadyExisted = allColors.find(
                            (col) => col.color_id == color.color_id
                        );
                        if (!alreadyExisted) {
                            const normalizedColorType = String(
                                color.type ||
                                    colorWrapper.color_type ||
                                    ""
                            )
                                .replace(/['"]/g, "")
                                .trim()
                                .toLowerCase();
                            allColors.push({
                                color_id: color.color_id,
                                color_name: color.name,
                                color_pms: color.pms,
                                decor_upcharge: colorWrapper.decor_upcharge,
                                color_value: color.hex, // Use hex
                                swatches: color.swatches,
                                stock: colorWrapper.stock || false,
                                color_type: normalizedColorType
                            });
                        }
                    }
                }
            });
            return allColors;
        },
        getVinylColors() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-vinyl-colors")
                    .then(({ data }) => {
                        this.vinyl_color_list = data.color;
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },
        prepareVendorColorsList(colorType) {
            const product =
                this.gender_groups_items[this.active_gender_key].item;

            let list = [];
            if (product.Decorators && product.Decorators.length) {
                let vendorColors = [];
                if (product.default_decorator_id) {
                    let default_decorator = product.Decorators.find(
                        (decorator) =>
                            decorator.id == product.default_decorator_id
                    );
                    if (default_decorator && default_decorator.VendorColors) {
                        vendorColors = default_decorator.VendorColors;
                    }
                } else {
                    if (
                        product.Decorators[0] &&
                        product.Decorators[0].VendorColors
                    ) {
                        vendorColors = product.Decorators[0].VendorColors;
                    }
                }

                if (vendorColors && vendorColors.length > 0) {
                    list = vendorColors.filter(
                        (color) => color.Color && color.Color.type == colorType
                    );
                }
            }

            return list;
        },
        prepareNameAndNumbers() {
            const genders = this.gender_groups_items;
            genders.forEach((gender) => {
                gender.colors.forEach((color) => {
                    color.selected_name_number = {
                        front: { name: false, number: false },
                        back: { name: false, number: false },
                        left: { name: false, number: false },
                        right: { name: false, number: false }
                    };
                    var entries = [];
                    if (color.unique_sizes) {
                        color.unique_sizes.forEach((size) => {
                            for (let i = 0; i < size.quantity; i++) {
                                entries.push({
                                    name: "",
                                    number: "",
                                    size: size.Size.size
                                });
                            }
                        });
                    }
                    color.name_and_number_json = {
                        front: JSON.parse(JSON.stringify(entries)),
                        back: JSON.parse(JSON.stringify(entries)),
                        left: JSON.parse(JSON.stringify(entries)),
                        right: JSON.parse(JSON.stringify(entries))
                    };
                });
            });
        },
        changeNameAndNumbersAfterQtyUpdate() {
            this.gender_groups_items.forEach((gender) => {
                gender.colors.forEach((color) => {
                    function updateOneArray(arr) {
                        if (!arr || !Array.isArray(arr)) return;
                        var uniqueSizes = color.unique_sizes || [];
                        function nextSerialId() {
                            var max = 0;
                            for (var j = 0; j < arr.length; j++) {
                                var n = arr[j] && arr[j].id;
                                var num =
                                    typeof n === "number" ? n : parseInt(n, 10);
                                if (!isNaN(num) && num > max) max = num;
                            }
                            return max + 1;
                        }
                        var nextId = nextSerialId();
                        var bySize = {};
                        arr.forEach(function (item) {
                            var s = item && item.size;
                            if (s != null) {
                                if (!bySize[s]) bySize[s] = [];
                                bySize[s].push(item);
                            }
                        });
                        var newArr = [];
                        uniqueSizes.forEach(function (size) {
                            var sizeKey = size.Size && size.Size.size;
                            if (sizeKey == null) return;
                            var qty = parseInt(size.quantity, 10) || 0;
                            var list = (bySize[sizeKey] || []).slice(0, qty);
                            for (var i = list.length; i < qty; i++) {
                                list.push({
                                    id: nextId,
                                    name: "",
                                    number: String(nextId),
                                    size: sizeKey,
                                    visible: true
                                });
                                nextId++;
                            }
                            newArr.push.apply(newArr, list);
                        });
                        arr.splice(0, arr.length);
                        arr.push.apply(arr, newArr);
                    }
                    if (Array.isArray(color.name_and_number_json)) {
                        updateOneArray(color.name_and_number_json);
                    } else if (
                        color.name_and_number_json &&
                        typeof color.name_and_number_json === "object"
                    ) {
                        ["front", "back", "left", "right"].forEach(function (
                            view
                        ) {
                            if (color.name_and_number_json[view])
                                updateOneArray(
                                    color.name_and_number_json[view]
                                );
                        });
                    }
                });
            });
            var activeColor =
                this.gender_groups_items[this.active_gender_key] &&
                this.gender_groups_items[this.active_gender_key].colors[
                    this.activeColorIndex
                ];
            if (
                activeColor &&
                this.$refs.nameAndNumberRef &&
                this.$refs.nameAndNumberRef.loadNameAndNumber
            ) {
                this.$refs.nameAndNumberRef.loadNameAndNumber(activeColor);
            }
        }
    },

    async beforeMount() {
        this.isLoader = true;
        if (
            this.$route.params.id &&
            localStorage.getItem("share_design_id") != this.$route.params.id
        ) {
            await this.getShareDesign(this.$route.params.id);
        }

        //this.bind();
        localStorage.removeItem("new_canvas_elements");
        localStorage.setItem(
            "canvas_design_colors",
            JSON.stringify({ front: "" })
        );
        this.getData();
        setTimeout(async () => {
            this.getTemplateData();
        }, 400);
        this.getAllTempateDesign();
        this.getPopularTemplates(false);
        this.getPopularCliparts(false);
        localStorage.setItem("canvas_elements", "");

        if (this.isAuthenticatedClient) {
            this.getUploadedImages();
        }
        var design = JSON.parse(localStorage.getItem("design"))
            ? JSON.parse(localStorage.getItem("design"))
            : "";

        if (design && design.length > 0) {
            this.product_items = design[0].item;

            let noOfColorsCount = 0;
            let decorationsData = [];

            try {
                if (typeof this.product_items.decorations === "string") {
                    decorationsData = JSON.parse(
                        this.product_items.decorations
                    );
                } else {
                    decorationsData = this.product_items.decorations;
                }
            } catch (e) {
                console.error("Could not parse decorations data:", e);
                decorationsData = [];
            }

            const decorationsList =
                decorationsData && decorationsData[0]
                    ? decorationsData[0].decoration_type_list
                    : [];
            const activeService = decorationsList.find(
                (service) =>
                    service.is_default === true || service.is_default === 1
            );

            if (activeService && activeService.max_colors) {
                noOfColorsCount = activeService.max_colors;
            } else if (this.product_items.PrintTemplate) {
                noOfColorsCount = this.product_items.PrintTemplate.no_of_colors;
            } else if (this.product_items.Embroidery) {
                noOfColorsCount = this.product_items.Embroidery.no_of_colors;
            } else {
                noOfColorsCount = 6; // Safe default
            }

            this.colors_count = parseInt(noOfColorsCount) || 0;

            if (
                this.product_items.Vendor &&
                !this.product_items.Vendor.newVendorColors
            ) {
                this.product_items.Vendor.newVendorColors = [];
            }
            if (design[0].colors && design[0].colors.length > 0) {
                design[0].colors.forEach((color) => {
                    if (!color.imprint_locations) {
                        color.imprint_locations = JSON.parse(
                            JSON.stringify(design[0].imprint_locations || [])
                        );
                    }
                });
            }
        }
        this.gender_groups_items = design;

        // FIRST AREA SELECTED FROM IMPRINT LOCATIONS
        let imprint_locations =
            this.gender_groups_items[this.active_gender_key].imprint_locations;
        if (imprint_locations.length > 0) {
            let imprint_location = imprint_locations.find(
                (location) => location.is_selected
            );
            if (imprint_location) {
                this.active_flip = imprint_location.location
                    .toLowerCase()
                    .trim();
            }
        }

        this.is24Tshirt = JSON.parse(localStorage.getItem("is24Tshirt"));
        if (design == "") {
            /* eslint-disable */
            $("#design-studio").modal("show");
            $(document).on("show.bs.modal", ".modal", function () {
                $(".modal").not(this).modal("hide");
            });
            /* eslint-enable */
        }
        design.forEach((ele) => {
            this.genders.push(ele.gender_name);
            let gname = ele.gender_name;
            var items = {
                [gname]: []
            };
            this.canvas_elements.push(items);
        });

        this.active_gender = this.genders[0];
        this.active_gender_key = 0;
        localStorage.setItem("active_gender", this.genders[0]);
        localStorage.setItem("active_gender_key", 0);

        localStorage.setItem("active_flip", this.active_flip);
        this.product_items = design[0].item;

        this.refreshVendorColorsList();

        // if ("PrintTemplate" in this.product_items) {
        //     this.colors_count = this.product_items.PrintTemplate.no_of_colors;
        // } else if ("Embroidery" in this.product_items) {
        //     this.colors_count = this.product_items.Embroidery.no_of_colors;
        // }
        this.product_id = design[0].item["id"];
        this.product_title = design[0].item["name"];
        this.product_number = design[0].item["product_number"];
        this.base_price = design[0].item["retail_base_price"];

        this.base_price = design[0].item["price_base"];

        design.forEach((element, ind) => {
            element["colors"].forEach((color) => {
                this.user_selected_values.push({
                    color_id: color.id,
                    color: color.color_name,
                    swatches: color.swatches,
                    color_hash: color.hash,
                    shades: color.shades,
                    category: color.category,
                    default_selection: color.default_selection,
                    total_qty_gender_wise: color.total_qty_gender_wise,
                    total_cost_gender_wise: color.total_cost_gender_wise,
                    unit_price: color.unique_sizes[0].cost,
                    unique_sizes: color.unique_sizes,
                    imprint_locations: color.imprint_locations,
                    gender: this.genders[ind]
                });
            });
        });
        if (this.user_selected_values.length > 0) {
            let previousColorIndex =
                localStorage.getItem("colorIndex") != null
                    ? localStorage.getItem("colorIndex")
                    : 0;
            this.activeIndex =
                this.user_selected_values[previousColorIndex].color_id;
            this.activeColorIndex = previousColorIndex;
            localStorage.removeItem("colorIdArr");
        }
        localStorage.setItem(
            "active_tshirt_color",
            this.user_selected_values[0].color_hash
        );
        this.tshirt_color = this.user_selected_values[0].color_hash;
        localStorage.setItem("product_id", this.product_id);
        let get_product = JSON.stringify(this.product_items);
        let _this = this;
        let design_images = JSON.parse(
            design[0]["colors"][this.activeColorIndex].id
        );

        this.active_product_type = JSON.parse(get_product).product_type_id;
        localStorage.setItem("product_type_id", this.active_product_type);
        _this.design_area_data = JSON.parse(
            JSON.parse(get_product).design_areas
        );
        if (typeof _this.design_area_data == "string") {
            _this.design_area_data = JSON.parse(_this.design_area_data);
        }
        _this.design_area_inches = [];
        Object.values(_this.design_area_data).forEach((element) => {
            this.design_area_inches.push({
                label_show: element.label_show
                    ? element.label_show
                    : element.label,
                label: element.label,
                widthIn: element.widthIn,
                heightIn: element.heightIn
            });
            if (element.label == "Front") {
                _this.front_show = true;
                if (element.short_thumbnail_image) {
                    this.front_icon_canvas_type = this.setUrl(
                        element.short_thumbnail_image
                    );
                }

                if (this.active_flip == "front") {
                    let selected_design_images = [];
                    design[0]["item"]["NewProductImages"].forEach((colors) => {
                        if (
                            colors.color_id == design_images &&
                            colors.type == "front"
                        ) {
                            selected_design_images.push({
                                front: colors.url
                            });
                        }
                        if (
                            colors.color_id == design_images &&
                            colors.type == "back"
                        ) {
                            selected_design_images.push({
                                back: colors.url
                            });
                        }
                    });

                    let default_color_img = "";

                    let def_color = design[0]["item"][
                        "NewProductImages"
                    ].filter(
                        (color) =>
                            color.color_id == design_images &&
                            color.type != "front" &&
                            color.type != "back"
                    );

                    if (def_color.length > 0) {
                        default_color_img = def_color[0].url;
                    }

                    var ele_img = "";
                    var ele_img_back = "";
                    if (selected_design_images.length > 0) {
                        let filter_img = selected_design_images.filter(
                            (img) => "front" in img
                        );

                        if (filter_img.length > 0) {
                            ele_img = filter_img[0]["front"];
                        }
                        let filter_img_back = selected_design_images.filter(
                            (img) => "back" in img
                        );

                        if (filter_img_back.length > 0) {
                            ele_img_back = filter_img_back[0]["back"];
                        }
                    } else {
                        ele_img = "";
                        ele_img_back = "";
                    }
                    _this.background_image = ele_img
                        ? ele_img
                        : default_color_img;

                    if (ele_img_back) {
                        default_color_img = ele_img_back;
                    }
                    if (
                        default_color_img.length == 0 ||
                        (ele_img_back == "" && ele_img)
                    ) {
                        _this.back_show = false;
                        _this.removeBackCanvas = false;
                    } else {
                        _this.back_show = true;
                        _this.removeBackCanvas = true;
                    }

                    _this.front_canvas_height = parseFloat(element.height);
                    _this.front_canvas_width = parseFloat(element.width);
                    _this.front_canvas_top = element.top;
                    _this.front_canvas_left = element.left;
                    _this.front_canvas_angle = element.angle
                        ? element.angle
                        : 0;
                }
            }
            if (element.label == "Back") {
                if (element.short_thumbnail_image) {
                    this.back_icon_canvas_type = _this.setUrl(
                        element.short_thumbnail_image
                    );
                }
            }
            if (element.label == "Back" && _this.removeBackCanvas == 1) {
                _this.back_show = true;
            }
            if (element.label == "Left" || element.label == "Left Sleeve") {
                if (element.short_thumbnail_image) {
                    this.left_icon_canvas_type = _this.setUrl(
                        element.short_thumbnail_image
                    );
                }
                _this.left_show = element.selected;
            }
            if (element.label == "Right" || element.label == "Right Sleeve") {
                if (element.short_thumbnail_image) {
                    this.right_icon_canvas_type = _this.setUrl(
                        element.short_thumbnail_image
                    );
                }
                _this.right_show = element.selected;
            }
        });
        this.updatePrintAreas();
        this.prepareNameAndNumbers();
        this.isLoader = false;
    },
    async mounted() {
        var vm = this;
        vm.isLoader = true;
        let _this = this;
        const observer = new MutationObserver(() => {
            const divs = document.querySelectorAll(".main-div");

            divs.forEach((div) => {
                const hasVisibleChild = Array.from(div.children).some(
                    (child) => {
                        const style = window.getComputedStyle(child);
                        return (
                            style.display !== "none" &&
                            style.visibility !== "hidden" &&
                            child.offsetHeight > 0
                        );
                    }
                );

                const hasText = div.textContent.trim().length > 0;

                if (!hasVisibleChild && !hasText) {
                    div.remove();
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        /* eslint-disable */
        // Using event delegation for better reliability
        $(document).on("click", "#undoObj", function () {
            if (_this.undo.length === 0) {
                return;
            }
            _this.undoActive = true;
            _this.redoActive = false;
            _this.replay(_this.undo, _this.redo, "#redoObj", this);
            if (_this.undo.length == 0) {
                _this.design_current_colors = [];
                $("#newResetbtn").prop("disabled", true);
                $(".new_arts_color").addClass("d-none");
            }
        });
        $(document).on("click", "#redoObj", function () {
            if (_this.redo.length === 0) {
                return;
            }
            // Set flags BEFORE replay (same as keyboard handler)
            _this.undoActive = false;
            _this.redoActive = true;
            _this.replay(_this.redo, _this.undo, "#undoObj", this);
            $(".new_arts_color").removeClass("d-none");
            if (_this.undo.length == 0) {
                $("#newResetbtn").prop("disabled", true);
            } else {
                $("#newResetbtn").prop("disabled", false);
            }
        });
        document.addEventListener("keydown", this.controlUndoRedoObject);
        if (
            this.$route.params.id &&
            localStorage.getItem("share_design_id") != this.$route.params.id
        ) {
            await this.getShareDesign(this.$route.params.id);
        }
        $("#back_flipbtn").prop("disabled", true);
        // slider js start
        let timer = 0;
        if (
            this.$route.params.id &&
            localStorage.getItem("share_design_id") != this.$route.params.id
        ) {
            timer = 5000;
        }
        timer = 1000;
        if (
            this.$route.params.id &&
            localStorage.getItem("share_design_id") != this.$route.params.id
        ) {
            timer = 5000;
        }
        setTimeout(function () {
            _this.updateImageToBackCanvas(_this.background_image);
            _this.getLocalDesign();

            // Auto-place patch from Product Details selection (if available)
            _this.$nextTick(() => {
                _this.autoPlaceSelectedPatch();
                // Load patch inventory and recalc patch cost so breakdown and header use inventory when Design Studio loads with a patch
                _this.loadDsPatchInventory().then(() => {
                    if (typeof _this.calculatePatchCost === "function") {
                        _this.calculatePatchCost();
                    }
                });
            });
        }, timer);

        // Recalculate patch cost when Colors & Qty Details drawer opens so breakdown shows Patch Cost
        _this.$nextTick(() => {
            if (typeof $ !== "undefined") {
                $("#exampleModalRight").on("show.bs.modal", function () {
                    if (typeof _this.calculatePatchCost === "function") {
                        _this.calculatePatchCost();
                    }
                });
            }
        });

        $(document).ready(function () {
            $(".clearfix button,a").tooltip();
        });

        vm.isLoader = false;
        window.test = this;
        $(document.body).on("click", ".deleteBtn", function () {
            vm.delete_object();
        });
        /* eslint-enable */
        try {
            // this.product_id = "";
            let product_values = JSON.parse(
                localStorage.getItem("product_values")
            );

            if (product_values) {
                this.product_title = product_values[0]["product_title"];
                this.product_number = product_values[0]["product_number"];
                this.product_id = product_values[0]["id"];
                this.design_name = product_values[0]["design_name"];
                this.base_price = product_values[0]["retail_base_price"];
                this.base_price = this.base_price
                    ? this.base_price.toFixed(2)
                    : 0;
                this.setDesign(product_values[0]["product_details"]);
                this.user_selected_values = JSON.parse(
                    localStorage.getItem("user_selected_values")
                );
            }
            localStorage.setItem("product_id", this.product_id);

            // Detect first selected imprint location from product details and set active_flip
            if (
                this.user_selected_values &&
                this.user_selected_values.length > 0
            ) {
                // Check the first color's imprint_locations for selected side
                const firstColor = this.user_selected_values[0];
                if (
                    firstColor &&
                    firstColor.imprint_locations &&
                    firstColor.imprint_locations.length > 0
                ) {
                    // Find the first selected imprint location
                    const firstSelectedLocation =
                        firstColor.imprint_locations.find(
                            (location) => location.is_selected === true
                        );

                    if (
                        firstSelectedLocation &&
                        firstSelectedLocation.location
                    ) {
                        // Extract side name from location (e.g., "Left", "Right", "Front", "Back")
                        const locationName = firstSelectedLocation.location
                            .toLowerCase()
                            .trim();

                        // Map location name to active_flip value
                        let detectedSide = null;
                        if (locationName.includes("left")) {
                            detectedSide = "left";
                        } else if (locationName.includes("right")) {
                            detectedSide = "right";
                        } else if (locationName.includes("front")) {
                            detectedSide = "front";
                        } else if (locationName.includes("back")) {
                            detectedSide = "back";
                        }

                        // Set active_flip if a valid side was detected
                        if (detectedSide) {
                            this.active_flip = detectedSide;
                            localStorage.setItem("active_flip", detectedSide);
                        }
                    }
                }
            }

            // Read rush option data from localStorage
            const storedRushOptionId = localStorage.getItem(
                "selectedRushOptionId"
            );
            this.selectedRushOptionId =
                storedRushOptionId && storedRushOptionId !== ""
                    ? storedRushOptionId
                    : null;

            // Read selected rush option date from localStorage
            const storedRushOptionDate = localStorage.getItem(
                "selectedRushOptionDate"
            );
            // Store as string to pass through props (Vue props work better with primitives)
            this.selectedRushOptionDate = storedRushOptionDate || null;

            try {
                const storedVendorServices =
                    localStorage.getItem("vendorServices");
                this.vendorServices = storedVendorServices
                    ? JSON.parse(storedVendorServices)
                    : [];
            } catch (e) {
                console.error(
                    "Error parsing vendorServices from localStorage:",
                    e
                );
                this.vendorServices = [];
            }
        } catch (e) {
            // Silently handle error
        }

        document.body.addEventListener("keydown", this.objectClone, false);

        this.getVinylColors();

        setTimeout(() => {
            if (this.$route.hash == "#upload") {
                document.getElementById("add-upload-tab").click();
            } else if (this.$route.hash == "#designs") {
                document.getElementById("designs-tab").click();
            }
        }, 2000);

        // Check if active_flip is stored in localStorage (from product details selection)
        const storedActiveFlip = localStorage.getItem("active_flip");
        if (
            storedActiveFlip &&
            ["front", "back", "left", "right"].includes(storedActiveFlip)
        ) {
            this.active_flip = storedActiveFlip;
        }

        if (this.active_flip != "front") {
            setTimeout(() => {
                this.flipTshirt(this.active_flip);
            }, 3000);
        }
        // Read the pricingFlag from the route query
        const flagFromQuery = this.$route.query.pricingFlag;

        if (flagFromQuery !== undefined) {
            // Convert to number and store it
            this.receivedPricingFlag = Number(flagFromQuery);
        } else {
            // If flag is not in URL, maybe default or handle error
            console.warn(
                "DesignStudioV3 Mounted: pricingFlag not found in URL query. Defaulting might occur."
            );
        }

        // Check for designHistoryId query parameter to auto-open design history
        const designHistoryId = this.$route.query.designHistoryId;
        if (designHistoryId) {
            // Wait for designs tab to open, then open history
            setTimeout(() => {
                this.openDesignHistory(designHistoryId);
            }, 2500);
        }
    },
    beforeDestroy() {
        this.disableImageZoomPan();
        document.body.removeEventListener("keydown", this.objectClone);
        document.removeEventListener("keydown", this.controlUndoRedoObject);
        if (typeof $ !== "undefined") {
            $("#exampleModalRight").off("show.bs.modal");
        }
    },
    computed: {
        ...mapGetters([
            "currentUserClient",
            "isAuthenticatedClient",
            "adminOptions"
        ]),
        totalDsPatchInventoryQty() {
            const list = this.dsPatchInventory || [];
            return list.reduce(
                (sum, inv) => sum + parseInt(inv.remaining_quantity || 0, 10),
                0
            );
        },
        // When false: only Stock + Specialty color tabs (e.g. Laser); when true: show Custom Ink/Thread
        hasServiceColorType() {
            try {
                const g = this.gender_groups_items;
                const key = this.active_gender_key;
                const active =
                    g && g[key] && g[key].activeServiceData
                        ? g[key].activeServiceData
                        : null;
                const colorType =
                    active &&
                    active.master_service &&
                    active.master_service.color_type
                        ? String(active.master_service.color_type).toLowerCase()
                        : "";
                return colorType !== "" && colorType !== "none";
            } catch (e) {
                return true;
            }
        },
        currentActiveServiceName() {
            const active =
                this.gender_groups_items &&
                typeof this.active_gender_key !== "undefined" &&
                this.gender_groups_items[this.active_gender_key] &&
                this.gender_groups_items[this.active_gender_key].activeServiceData
                    ? this.gender_groups_items[this.active_gender_key]
                          .activeServiceData
                    : null;
            if (!active) return "";
            return (
                (active.master_service && active.master_service.service_name) ||
                active.name ||
                ""
            )
                .toString()
                .trim()
                .toLowerCase();
        },
        currentActiveDecoratorId() {
            const active =
                this.gender_groups_items &&
                typeof this.active_gender_key !== "undefined" &&
                this.gender_groups_items[this.active_gender_key] &&
                this.gender_groups_items[this.active_gender_key].activeServiceData
                    ? this.gender_groups_items[this.active_gender_key]
                          .activeServiceData
                    : null;
            const serviceDecoratorId =
                active &&
                (active.decorator_id ||
                    active.decoratorId ||
                    active.default_decorator_id);
            const productDecoratorId =
                this.product_items &&
                this.product_items.default_decorator_id;
            return Number(serviceDecoratorId || productDecoratorId || 0);
        },
        isEmbroideryServiceForNameNumber() {
            return this.currentActiveServiceName.includes("embroidery");
        },
        isNameNumberAllowedForCurrentService() {
            const allowedServiceNames = [
                "screen print",
                "digital transfer",
                "patch application",
                "embroidery"
            ];
            const isAllowedService = allowedServiceNames.includes(
                this.currentActiveServiceName
            );
            // Restrict to ImprintCity decorator context only.
            if (!isAllowedService || this.currentActiveDecoratorId !== 20) {
                return false;
            }
            if (this.isEmbroideryServiceForNameNumber) {
                return this.active_flip === "front";
            }
            return true;
        },
        myDesignServiceFilter() {
            const serviceName = (this.currentActiveServiceName || "")
                .toString()
                .trim()
                .toLowerCase();
            if (serviceName === "patch application") {
                return {
                    patch_enabled: true,
                    include_name_number_with_patch:
                        this.isNameNumberAllowedForCurrentService
                };
            }
            if (this.isNameNumberAllowedForCurrentService) {
                return { name_number_enabled: true };
            }
            return {};
        },
        emptyBoxesCount() {
            // Calculate how many empty boxes to show based on desired count
            const desired = this.desiredColorCount;
            const found = this.uploadedImageTopColors.length;

            if (!desired || desired <= 0) {
                return 0; // No empty boxes if no desired count
            }
            return Math.max(0, desired - found); // Empty boxes = desired - found
        },
        tag() {
            return this.$route.params.tag;
        },
        hasCustomBox() {
            if (!this.design_area_data || !Array.isArray(this.design_area_data))
                return false;
            return this.design_area_data.some(
                (area) => area && area.use_custom_box === true
            );
        },
        // True only when the current view (active_flip) shows the custom box / imprint area
        currentViewHasCustomBox() {
            if (
                !this.design_area_data ||
                !Array.isArray(this.design_area_data) ||
                !this.active_flip
            )
                return false;
            const flip = (this.active_flip || "").toLowerCase();
            const areas = this.design_area_data;
            const area = areas.find(
                (a) =>
                    a &&
                    a.label &&
                    ((flip === "front" &&
                        a.label.toLowerCase().includes("front")) ||
                        (flip === "back" &&
                            a.label.toLowerCase().includes("back")) ||
                        (flip === "left" &&
                            a.label.toLowerCase().includes("left")) ||
                        (flip === "right" &&
                            a.label.toLowerCase().includes("right")))
            );
            return !!(area && area.use_custom_box === true);
        },
        shirtDivStyle() {
            const w = this.effectiveDesignAreaWidth || 0;
            const h = this.effectiveDesignAreaHeight || 0;
            // Only apply design-area center offset when current view has custom imprint box;
            // otherwise it pushes the product image down too much (e.g. 100–180px)
            const centerOffsetX = this.currentViewHasCustomBox
                ? this.designAreaCenterOffsetX || 0
                : 0;
            const centerOffsetY = this.currentViewHasCustomBox
                ? this.designAreaCenterOffsetY || 0
                : 0;
            const tx = (this.imagePanX || 0) + centerOffsetX;
            const ty = (this.imagePanY || 0) + centerOffsetY;
            const scale =
                this.zoom != null && typeof this.zoom === "number"
                    ? this.zoom
                    : 1;
            return {
                width: w + "px",
                height: h + "px",
                display: "flex",
                position: "relative",
                justifyContent: "center",
                overflow: "hidden",
                transform:
                    "translate(" + tx + "px, " + ty + "px) scale(" + scale + ")"
            };
        },
        // Offset to center the dynamic design area (blue rectangle) in the viewport
        designAreaCenterOffsetX() {
            const w = this.effectiveDesignAreaWidth || 0;
            const left = parseFloat(this.front_canvas_left);
            const width = parseFloat(this.front_canvas_width);
            if (
                typeof left !== "number" ||
                isNaN(left) ||
                typeof width !== "number" ||
                isNaN(width) ||
                width <= 0
            ) {
                return 0;
            }
            const centerX = left + width / 2;
            return w / 2 - centerX;
        },
        designAreaCenterOffsetY() {
            const h = this.effectiveDesignAreaHeight || 0;
            const top = parseFloat(this.front_canvas_top);
            const height = parseFloat(this.front_canvas_height);
            if (
                typeof top !== "number" ||
                isNaN(top) ||
                typeof height !== "number" ||
                isNaN(height) ||
                height <= 0
            ) {
                return 0;
            }
            const centerY = top + height / 2;
            return h / 2 - centerY;
        },
        // Extra top margin only when use_custom_box is true AND height <= 4 inches
        designAreaMarginTopClass() {
            const flip = this.active_flip;
            const areas = this.design_area_data
                ? Array.isArray(this.design_area_data)
                    ? this.design_area_data
                    : typeof this.design_area_data === "object"
                    ? Object.values(this.design_area_data)
                    : []
                : [];
            let area = null;
            if (flip && areas.length) {
                area = areas.find(
                    (a) =>
                        a &&
                        a.label &&
                        ((flip === "front" &&
                            a.label.toLowerCase().includes("front")) ||
                            (flip === "back" &&
                                a.label.toLowerCase().includes("back")) ||
                            (flip === "left" &&
                                a.label.toLowerCase().includes("left")) ||
                            (flip === "right" &&
                                a.label.toLowerCase().includes("right")))
                );
            }
            if (!area || area.use_custom_box !== true) return "mt_20";
            let heightInch =
                area.heightIn != null
                    ? parseFloat(area.heightIn)
                    : area.height != null
                    ? parseFloat(area.height)
                    : null;
            if (heightInch == null || isNaN(heightInch)) {
                const h = parseFloat(this.front_canvas_height_inch);
                if (typeof h === "number" && !isNaN(h)) heightInch = h;
            }
            if (
                typeof heightInch !== "number" ||
                isNaN(heightInch) ||
                heightInch >= 4
            )
                return "mt_30";
            let widthInch =
                area.widthIn != null
                    ? parseFloat(area.widthIn)
                    : area.width != null
                        ? parseFloat(area.width)
                        : null;

            if (widthInch == null || isNaN(widthInch)) {
                const w = parseFloat(this.front_canvas_width_inch);
                if (typeof w === "number" && !isNaN(w)) widthInch = w;
            }
            if (
                typeof heightInch === "number" &&
                !isNaN(heightInch) &&
                heightInch < 4 &&
                typeof widthInch === "number" &&
                !isNaN(widthInch) &&
                widthInch < 4
            ) {
                return "mt_50";
            }

            return "design_area_mt_250";
        },
        // Left/right no-image fallback: resize whole color box + border to design area aspect (admin width/height)
        effectiveDesignAreaWidth() {
            if (
                this.active_flip !== "front" &&
                this.active_flip !== "back" &&
                this.active_flip !== "left" &&
                this.active_flip !== "right"
            ) {
                return this.defaultWidthCanvas;
            }
            let area = null;
            if (this.design_area_data && Array.isArray(this.design_area_data)) {
                area = this.design_area_data.find(
                    (a) =>
                        a &&
                        a.label &&
                        ((this.active_flip === "front" &&
                            a.label.toLowerCase().includes("front")) ||
                            (this.active_flip === "back" &&
                                a.label.toLowerCase().includes("back")) ||
                            (this.active_flip === "left" &&
                                a.label.toLowerCase().includes("left")) ||
                            (this.active_flip === "right" &&
                                a.label.toLowerCase().includes("right")))
                );
            }
            let useCustomBox = area && area.use_custom_box === true;
            if (
                !useCustomBox &&
                this.background_image &&
                this.background_image !== "" &&
                this.background_image !== "null" &&
                this.background_image !== null
            ) {
                return this.defaultWidthCanvas;
            }
            if (useCustomBox) {
                let dim = this.getEffectiveDesignAreaDimensionsForFlip(
                    this.active_flip
                );
                if (dim && dim.width) return dim.width;
                return this.defaultWidthCanvas;
            }
            let w = parseFloat(this.front_canvas_width_inch);
            let h = parseFloat(this.front_canvas_height_inch);
            if (
                typeof w !== "number" ||
                isNaN(w) ||
                w <= 0 ||
                typeof h !== "number" ||
                isNaN(h) ||
                h <= 0
            ) {
                return this.defaultWidthCanvas;
            }
            let maxW = this.defaultWidthCanvas * 0.95;
            let maxH = this.defaultHeightCanvas * 0.95;
            let scale = Math.min(maxW / w, maxH / h);
            return Math.round(w * scale);
        },
        effectiveDesignAreaHeight() {
            if (
                this.active_flip !== "front" &&
                this.active_flip !== "back" &&
                this.active_flip !== "left" &&
                this.active_flip !== "right"
            ) {
                return this.defaultHeightCanvas;
            }
            let area = null;
            if (this.design_area_data && Array.isArray(this.design_area_data)) {
                area = this.design_area_data.find(
                    (a) =>
                        a &&
                        a.label &&
                        ((this.active_flip === "front" &&
                            a.label.toLowerCase().includes("front")) ||
                            (this.active_flip === "back" &&
                                a.label.toLowerCase().includes("back")) ||
                            (this.active_flip === "left" &&
                                a.label.toLowerCase().includes("left")) ||
                            (this.active_flip === "right" &&
                                a.label.toLowerCase().includes("right")))
                );
            }
            let useCustomBox = area && area.use_custom_box === true;
            if (
                !useCustomBox &&
                this.background_image &&
                this.background_image !== "" &&
                this.background_image !== "null" &&
                this.background_image !== null
            ) {
                return this.defaultHeightCanvas;
            }
            if (useCustomBox) {
                let dim = this.getEffectiveDesignAreaDimensionsForFlip(
                    this.active_flip
                );
                if (dim && dim.height) return dim.height;
                return this.defaultHeightCanvas;
            }
            let w = parseFloat(this.front_canvas_width_inch);
            let h = parseFloat(this.front_canvas_height_inch);
            if (
                typeof w !== "number" ||
                isNaN(w) ||
                w <= 0 ||
                typeof h !== "number" ||
                isNaN(h) ||
                h <= 0
            ) {
                return this.defaultHeightCanvas;
            }
            let maxW = this.defaultWidthCanvas * 0.95;
            let maxH = this.defaultHeightCanvas * 0.95;
            let scale = Math.min(maxW / w, maxH / h);
            return Math.round(h * scale);
        },

        currentActiveServiceData() {
            if (
                this.gender_groups_items &&
                typeof this.active_gender_key !== "undefined" &&
                this.gender_groups_items[this.active_gender_key] &&
                this.gender_groups_items[this.active_gender_key]
                    .activeServiceData
            ) {
                return this.gender_groups_items[this.active_gender_key]
                    .activeServiceData;
            }

            console.warn(
                "currentActiveServiceData: Could not find stored activeServiceData."
            );
            return null;
        },
        // Check if service has color type (for showing/hiding custom ink/thread color tabs)
        hasServiceColorType() {
            try {
                if (
                    this.gender_groups_items &&
                    typeof this.active_gender_key !== "undefined" &&
                    this.gender_groups_items[this.active_gender_key] &&
                    this.gender_groups_items[this.active_gender_key].item
                ) {
                    const decorationType =
                        this.gender_groups_items[this.active_gender_key].item
                            .decoration_type;
                    // If decoration_type is 0, null, or undefined, return false (no color type - like Laser)
                    // If decoration_type is 1 (screen print) or 2 (embroidery), return true
                    if (
                        decorationType === 0 ||
                        decorationType === "0" ||
                        decorationType === null ||
                        decorationType === undefined
                    ) {
                        return false;
                    }
                    return true;
                }
            } catch (e) {
                console.error("Error checking hasServiceColorType:", e);
            }
            return true; // Default to true to show tabs
        },
        isPatchEnabledForCurrentService() {
            const service = this.currentActiveServiceData;
            if (!service) return false;

            // OR condition: service name is "Patch Application" (case-insensitive)
            const serviceName = (
                (service.master_service &&
                    service.master_service.service_name) ||
                service.name ||
                ""
            )
                .trim()
                .toLowerCase();
            if (serviceName === "patch application") return true;

            // Existing condition: Vendor + Product Apply Patch flags
            const productPatchEnabled =
                service.patch_enabled === true ||
                service.patch_enabled === 1 ||
                service.patch_enabled === "1" ||
                service.patch_enabled === "true";
            if (!productPatchEnabled) return false;
            const vs =
                this.vendorServices &&
                this.vendorServices.find(
                    (v) =>
                        v.id === service.id ||
                        v.service_id ===
                            (service.master_service &&
                                service.master_service.id)
                );
            const vendorPatchEnabled =
                vs &&
                (vs.vendor_patch_enabled === true ||
                    vs.vendor_patch_enabled === 1 ||
                    vs.vendor_patch_enabled === "1" ||
                    vs.vendor_patch_enabled === "true");
            return !!vendorPatchEnabled;
        },

        specialtyInkColors() {
            return this.current_specialty_ink_colors || [];
        },

        totalSpecialtyInkUpcharge() {
            if (
                !this.current_specialty_ink_colors ||
                !Array.isArray(this.current_specialty_ink_colors)
            ) {
                return 0;
            }
            return this.current_specialty_ink_colors.reduce((total, color) => {
                return total + (parseFloat(color.upcharge) || 0);
            }, 0);
        },
        totalCustomColorsUpcharge() {
            if (
                !this.current_custom_colors ||
                !Array.isArray(this.current_custom_colors)
            ) {
                return 0;
            }
            return this.current_custom_colors.reduce((total, color) => {
                return total + (parseFloat(color.upcharge) || 0);
            }, 0);
        },
        combinedCustomAndThreadPrice() {
            let total = this.totalCustomColorsUpcharge || 0;
            const serviceData = this.currentActiveServiceData;
            const colorType =
                serviceData &&
                serviceData.master_service &&
                serviceData.master_service.color_type
                    ? String(serviceData.master_service.color_type).toLowerCase()
                    : "";
            const isInkOrThread =
                colorType === "ink" || colorType === "thread";
            if (
                this.total_non_standard_colors &&
                this.total_non_standard_colors.length &&
                isInkOrThread
            ) {
                total += this.total_non_standard_fees || 0;
            }
            return total;
        },
        showCombinedCustomAndThread() {
            const hasCustomColors =
                this.current_custom_colors &&
                this.current_custom_colors.length > 0;
            const hasThreadColors =
                this.total_non_standard_colors &&
                this.total_non_standard_colors.length > 0;
            return hasCustomColors || hasThreadColors;
        },
        combinedCustomAndThreadColors() {
            const customHex =
                (this.current_custom_colors || []).map((c) => c.hex) || [];
            const threadHex = this.total_non_standard_colors || [];
            return customHex.concat(threadHex);
        },
        combinedCustomAndThreadLabel() {
            const serviceData = this.currentActiveServiceData;
            if (!serviceData) return "Custom Colors";

            // Check color_type first (most reliable)
            if (
                serviceData.master_service &&
                serviceData.master_service.color_type
            ) {
                const colorType = (
                    serviceData.master_service.color_type || ""
                ).toLowerCase();
                if (colorType === "ink") return "Custom Ink Colors";
                if (colorType === "thread") return "Custom Thread Colors";
                if (colorType === "none") return "Custom Colors";
            }

            // Fallback: Check decoration_type
            const group =
                this.gender_groups_items &&
                this.gender_groups_items[this.active_gender_key];
            const item = group && group.item;
            if (item) {
                if (
                    item.decoration_type === 1 ||
                    item.decoration_type === 5
                )
                    return "Custom Ink Colors";
                if (item.decoration_type === 2 || item.decoration_type === 4) return "Custom Thread Colors";
            }

            return "Custom Colors";
        },
        stockColorsLabel() {
            const serviceData = this.currentActiveServiceData;
            if (!serviceData) return "Stock Colors";

            // Check color_type first (most reliable)
            if (
                serviceData.master_service &&
                serviceData.master_service.color_type
            ) {
                const colorType = (
                    serviceData.master_service.color_type || ""
                ).toLowerCase();
                if (colorType === "ink") return "Stock Ink Colors";
                if (colorType === "thread") return "Stock Thread Colors";
                if (colorType === "none") return "Stock Colors";
            }

            // Fallback: Check decoration_type
            const group =
                this.gender_groups_items &&
                this.gender_groups_items[this.active_gender_key];
            const item = group && group.item;
            if (item) {
                if (
                    item.decoration_type === 1 ||
                    item.decoration_type === 5
                )
                    return "Stock Ink Colors";
                if (item.decoration_type === 2 || item.decoration_type === 4) return "Stock Thread Colors";
            }

            return "Stock Colors";
        },
        // Check if service has a color type (not "none" or null)
        hasServiceColorType() {
            try {
                const serviceData = this.currentActiveServiceData;
                if (!serviceData) return false;

                // Check master_service.color_type first
                if (
                    serviceData.master_service &&
                    serviceData.master_service.color_type
                ) {
                    const colorType = (
                        serviceData.master_service.color_type || ""
                    ).toLowerCase();
                    // If color_type is "none" or empty, return false (hide custom ink/thread tab)
                    if (colorType === "none" || colorType === "") return false;
                    return true;
                }

                // Fallback: if no color_type found, assume it has color type (backward compatibility)
                return true;
            } catch (e) {
                console.error("Error checking hasServiceColorType:", e);
                return true; // Default to true for backward compatibility
            }
        },
        decorationMethodName() {
            // Get service name from activeServiceData
            if (this.currentActiveServiceData) {
                // Priority 1: Check ecomm_display directly (already enriched from Product Details)
                if (this.currentActiveServiceData.ecomm_display) {
                    return this.currentActiveServiceData.ecomm_display;
                }

                // Priority 2: Check master_service.ecomm_display
                if (
                    this.currentActiveServiceData.master_service &&
                    this.currentActiveServiceData.master_service.ecomm_display
                ) {
                    return this.currentActiveServiceData.master_service
                        .ecomm_display;
                }

                // Priority 3: Try master_service_id for direct store lookup (dynamic)
                const serviceId =
                    (this.currentActiveServiceData.master_service &&
                        this.currentActiveServiceData.master_service.id) ||
                    this.currentActiveServiceData.master_service_id;
                if (serviceId) {
                    const storeEcommDisplayName =
                        this.getEcommDisplayName(serviceId);
                    if (storeEcommDisplayName) {
                        return storeEcommDisplayName;
                    }
                }
            }
            return null;
        },

        applicableOtherServices() {
            const allVendorServices =
                (this.gender_groups_items &&
                    typeof this.active_gender_key !== "undefined" &&
                    this.gender_groups_items[this.active_gender_key] &&
                    this.gender_groups_items[this.active_gender_key].item &&
                    this.gender_groups_items[this.active_gender_key].item
                        .VendorOtherServices) ||
                null;

            if (!allVendorServices || !Array.isArray(allVendorServices)) {
                return [];
            }

            const visibleServices = allVendorServices;
            return visibleServices;
        },
        template_category_search() {
            if (this.template_search_query) {
                return this.all_templates_images.filter((item) => {
                    // If active_product_type is null, show all templates (skip product_type_id check)
                    let productTypeMatch =
                        !this.active_product_type ||
                        item.product_type_id == this.active_product_type;

                    if (productTypeMatch) {
                        return this.template_search_query
                            .toLowerCase()
                            .split(" ")
                            .every((v) => item.name.toLowerCase().includes(v));
                    }
                });
            } else {
                return this.templates;
            }
        },
        template_subcategory_search() {
            if (this.template_subcategory_search_query) {
                return this.all_templates_images.filter((item) => {
                    // If active_product_type is null, show all templates (skip product_type_id check)
                    let productTypeMatch =
                        !this.active_product_type ||
                        item.product_type_id == this.active_product_type;

                    if (productTypeMatch) {
                        return this.template_subcategory_search_query
                            .toLowerCase()
                            .split(" ")
                            .every((v) => item.name.toLowerCase().includes(v));
                    }
                });
            } else {
                return this.selected_template_category
                    .DesignStudioTemplateSubCategories
                    ? this.selected_template_category
                          .DesignStudioTemplateSubCategories
                    : [];
            }
        },
        saved_template_category() {
            if (this.template_search_query) {
                return this.savedDesigns.filter((item) => {
                    return this.template_search_query
                        .toLowerCase()
                        .split(" ")
                        .every((v) => item.name.toLowerCase().includes(v));
                });
            } else {
                return this.templates;
            }
        },
        clipart_category_search() {
            if (this.clipart_search_query) {
                return this.all_cliparts_images.filter((item) => {
                    return this.clipart_search_query
                        .toLowerCase()
                        .split(" ")
                        .every((v) =>
                            item.image_name.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.clipart_category;
            }
        },
        clipart_subcategory_search() {
            if (this.clipart_subcategory_search_query) {
                return this.all_cliparts_images.filter((item) => {
                    return this.clipart_subcategory_search_query
                        .toLowerCase()
                        .split(" ")
                        .every((v) =>
                            item.image_name.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.cliparts;
            }
        },
        // Add Patch (New): filtered materials by search (material name or patch names)
        patchMaterialsNewFiltered() {
            const q = (this.patchNewSearchQuery || "").trim().toLowerCase();
            if (!q) return this.patchMaterialsNew || [];
            const materials = this.patchMaterialsNew || [];
            return materials.filter((material) => {
                const materialName = (material.name || "")
                    .toString()
                    .toLowerCase();
                if (materialName.indexOf(q) !== -1) return true;
                const patches = this.patchesByMaterialNew[material.id] || [];
                return patches.some((p) => {
                    const name = (p.image_name || p.name || "")
                        .toString()
                        .toLowerCase();
                    return name.indexOf(q) !== -1;
                });
            });
        },
        // Current product quantity for patch price (watch to recalc)
        currentTotalQtyForPatch() {
            const g =
                this.gender_groups_items &&
                this.gender_groups_items[this.active_gender_key];
            return g && g.total_qty ? g.total_qty : 0;
        },
        openLoginModal: function () {
            /* eslint-disable */
            $("#login").modal("show");
            /* eslint-enable */
        }
    },
    watch: {
        active_gender_key() {
            this.refreshVendorColorsList();
        },
        activeServiceColorKey() {
            this.refreshVendorColorsList();
        },
        patchNewSearchQuery(q) {
            const trimmed = (q || "").trim();
            if (!trimmed) {
                this.expandedMaterialIdsNew = [];
            } else {
                this.expandedMaterialIdsNew =
                    this.patchMaterialsNewFiltered.map((m) => m.id);
            }
        },
        currentTotalQtyForPatch() {
            if (typeof this.calculatePatchCost === "function") {
                this.calculatePatchCost();
            }
        },
        isNameNumberAllowedForCurrentService(allowed) {
            if (allowed) return;
            var nnTab = document.querySelector("#nn-tab");
            if (nnTab) {
                nnTab.classList.remove("active");
                nnTab.classList.remove("show");
            }
            var nnTab1 = document.getElementById("nn-tab1");
            if (nnTab1) {
                nnTab1.classList.remove("active");
            }
        }
    },
    created() {
        let _this = this;
        _this.checkObjectCanvas();
        window.addEventListener(
            "beforeunload",
            function (event) {
                let designStatus = false;
                let previouscanvasList = JSON.parse(
                    localStorage.getItem("new_canvas_elements")
                );
                if (previouscanvasList != null) {
                    if ("front" in previouscanvasList) {
                        if (previouscanvasList["front"] !== "") {
                            JSON.parse(
                                previouscanvasList["front"]
                            ).objects.forEach((canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            });
                        }
                    }
                    if ("back" in previouscanvasList) {
                        if (previouscanvasList["back"] !== "") {
                            JSON.parse(
                                previouscanvasList["back"]
                            ).objects.forEach((canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            });
                        }
                    }
                    if ("left" in previouscanvasList) {
                        if (previouscanvasList["left"] !== "") {
                            JSON.parse(
                                previouscanvasList["left"]
                            ).objects.forEach((canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            });
                        }
                    }
                    if ("right" in previouscanvasList) {
                        if (previouscanvasList["right"] !== "") {
                            JSON.parse(
                                previouscanvasList["right"]
                            ).objects.forEach((canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            });
                        }
                    }
                }
                if (designStatus) return event.preventDefault();
            },
            { capture: true }
        );
    }
};
export default design_tool;
</script>

<style scoped>
.current-upload-section {
    padding: 15px;
    background: #f8f9fa;
    border-radius: 6px;
    margin-top: 15px;
}

.current-upload-header h6 {
    color: #333;
    font-size: 14px;
    margin-bottom: 10px;
}

.uploaded-image-preview {
    text-align: center;
    padding: 10px;
    background: white;
    border-radius: 4px;
    border: 1px solid #ddd;
}

.preview-thumbnail {
    max-width: 100%;
    max-height: 150px;
    object-fit: contain;
}

/* Bar stays in .design_studio_right_side: .outside_costs is display:none at some breakpoints (_design_studio_v3.scss). */
.design_studio_bottom_btns {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    position: relative;
    z-index: 5;
    flex-shrink: 0;
    background: #fff;
    border-top: 1px solid #e0e0e0;
}

 .design_studio_bottom_btns .buttons_inner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px 16px;
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 12px 40px;
    box-sizing: border-box;
}

 .design_studio_bottom_btns .left_btn {
    flex: 0 1 auto;
    min-width: 0;
}

 .design_studio_bottom_btns .right_btn {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 18px;
    flex: 0 0 auto;
    margin-left: auto;
}

.back_to_product_btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    background-color: #fff;
    border: 1px solid #0079c1;
    border-radius: 4px;
    color: #0079c1;
    font-size: 12px;
    font-weight: 400;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    height: 48px;
    min-width: 177px;
}

.back_to_product_btn:hover {
    background-color: #f5f5f5;
    text-decoration: none;
    color: #0079c1;
}

.create_build_btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    background-color: #0079c1 !important;
    border: 1px solid #0079c1;
    border-radius: 4px;
    color: #fff;
    font-size: 12px;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    height: 48px;
    min-width: 208px;
}

.create_build_btn:hover:not(:disabled) {
    background-color: #0066a3;
    border-color: #0066a3;
}

.create_build_btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.add_to_cart_btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    background-color: #f2790c;
    border: 1px solid #f2790c;
    border-radius: 4px;
    color: #fff;
    font-size: 12px;
    font-weight: 400;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    height: 48px;
    min-width: 165px;
}

.add_to_cart_btn:hover {
    background-color: #e06a0a;
    border-color: #e06a0a;
    text-decoration: none;
    color: #fff;
}

.add_to_cart_btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
.design_studio_tool .patch-new-accordion {
    max-height: 75vh;
    overflow-y: auto;
}
.design_studio_tool .patch-new-accordion .arrow_icon {
    width: 14px;
    height: 14px;
    padding: 0px !important;
    position: relative;
    top: 0px;
}
.design_studio_tool .patch-new-accordion .patch_acco_title {
    color: #121212;
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: -0.28px;
    text-align: left;
    padding: 0px;
    margin-left: 0px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 110px;
}
.design_studio_tool .patch-new-accordion .arrow_icon.up {
    transform: rotate(180deg);
}
.design_studio_up.product_details_update_v3
    .design_studio_tool
    #add-patch-new
    .patch-new-patches-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px !important;
    margin-top: 15px;
}
.design_studio_tool .patch-new-accordion .patch-new-material-section {
    box-shadow: 0px 2px 8px 0px #00000014;
    background-color: #fff;
    border: 1px solid #b6b6b666;
    padding: 16px;
}
.design_studio_tool
    .patch-new-accordion
    .patch-new-patches-grid
    .patch-new-grid-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    min-width: 0;
    padding-left: 0px;
    max-width: 22.8%;
    width: 100%;
}
.design_studio_tool
    .patch-new-accordion
    .patch-new-patches-grid
    .patch-new-grid-item
    img {
    padding: 0px !important;
    height: auto;
    max-height: 100px;
    object-fit: contain;
    width: 100%;
}
.design_studio_tool
    .patch-new-accordion
    .patch-new-patches-grid
    .patch-new-grid-item
    label {
    top: inherit;
    border: 1px solid #b6b6b666;
    padding: 8px !important;
    margin-bottom: 8px;
    min-width: 70px;
    min-height: 74px;
}
.design_studio_tool
    .patch-new-accordion
    .patch-new-patches-grid
    .patch-new-grid-item
    .patch-new-name {
    max-width: 58px;
    word-break: break-word !important;
    color: #606060;
    font-size: 8px;
    line-height: 12px;
}

/* Center the Save Design modal in the viewport */

#save_design_modal .design_build_modal {
    max-width: 900px;
    margin: 0 auto;
}

#save_design_modal.show .design_build_modal {
    display: flex;
    align-items: center;
    min-height: 100vh;
}
.design_studio_tool {
    min-height: 80vh;
}
.design_area_section {
    height: 70vh;
    @media (max-width: 1441px) {
        height: 80vh;
    }
}
.design_slider_with_color {
    max-width: 240px;
}
/* Messages float above design area without pushing it down */
.design_area_block_msg_overlay {
    position: relative !important;
}
.custom_box_message_ds {
    display: block !important;
    position: absolute !important;
    top: 30px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    z-index: 15 !important;
    margin: 0 !important;
    padding: 10px 14px !important;
    width: fit-content !important;
    max-width: 320px !important;
    background: #e8f4fc !important;
    border: 1px solid #2196f3 !important;
    border-radius: 4px !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
    color: #1565c0 !important;
    text-align: center !important;
}
/* Extra top margin (250px) when use_custom_box true and height >= 4 inches */
.design_area_mt_250 {
    margin-top: 250px !important;
}
/* Canvas Zoom toggle - below Reset */
.canvas-zoom-toggle {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-left: 8px;
    cursor: pointer;
    font-size: 14px;
    color: #121212;
    font-weight: 600;
    user-select: none;
}
.canvas-zoom-toggle-label{
    font-size: 14px;
    color: #121212;
    font-weight: 600;
    font-family: 'mulish';
}
.canvas-zoom-toggle input[type="checkbox"] {
    cursor: pointer;
    width: 16px;
    height: 16px;
}
.canvas-zoom-toggle-label {
    white-space: nowrap;
}

/* Overlay when Image Zoom is on: captures wheel and drag so product image zooms/pans */
.image-zoom-overlay {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    cursor: grab;
}
.image-zoom-overlay:active {
    cursor: grabbing;
}

/* Message shown above canvas only when Image Zoom toggle is ON - absolute so design area doesn't move */
.image-zoom-canvas-message {
    display: none !important;
    position: absolute !important;
    top: 30px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    z-index: 15 !important;
    margin: 0 !important;
    padding: 4px 10px !important;
    width: fit-content !important;
    max-width: 280px !important;
    background: #fff3cd !important;
    border: 1px solid #ffc107 !important;
    border-radius: 4px !important;
    color: #856404 !important;
    font-size: 12px !important;
    text-align: center !important;
    line-height: 1.3 !important;
}
.image-zoom-canvas-message.visible {
    display: block !important;
}
/* Close button on overlay messages (image zoom + image unavailable) */
.message-with-close {
    padding-right: 28px !important;
}
.message-close-btn {
    position: absolute !important;
    top: 4px !important;
    right: 6px !important;
    width: 20px !important;
    height: 20px !important;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    color: inherit !important;
    font-size: 18px !important;
    line-height: 1 !important;
    cursor: pointer !important;
    opacity: 0.8;
}
.message-close-btn:hover {
    opacity: 1;
}
.custom_box_message_ds.message-with-close {
    padding-right: 28px !important;
}
.design_studio_up.product_details_update_v3
    .design_studio_tool
    .left_panel.clipart_panel {
    min-height: 80vh;
    max-height: 80vh;
}

/* Upload New Image Button Styles */
.upload-new-image-btn-wrapper {
    padding: 0 12px;
}

.upload-new-image-btn {
    background: #0079c1 !important;
    color: #fff !important;
    border: none !important;
    border-radius: 4px !important;
    padding: 12px 16px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    cursor: pointer !important;
    transition: all 0.3s ease !important;
}

.upload-new-image-btn:hover {
    background: #005a8d !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 8px rgba(0, 121, 193, 0.3) !important;
}

.upload-new-image-btn:active {
    transform: translateY(0) !important;
}

.upload-new-image-btn svg {
    vertical-align: middle;
}

/* Uploaded Images List Section */
.uploaded-images-list-section {
    padding: 0;
}

.uploaded-images-list-section .tools_headding {
    padding: 0 12px;
}

.uploaded-images-list-section .categorys_open {
    padding: 0 12px;
}

/* Back to List Button */

.btn-back-to-list {
    background: transparent !important;
    color: #0079c1 !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    padding: 8px 0px !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    display: flex !important;
    align-items: center !important;
    gap: 6px !important;
    cursor: pointer !important;
    transition: all 0.3s ease !important;
    width: auto !important;
}

.btn-back-to-list:focus {
    outline: none !important;
    box-shadow: none !important;
}

.btn-back-to-list svg {
    flex-shrink: 0 !important;
}

.btn-back-to-list span {
    white-space: nowrap !important;
}
back-to-list-header {
    border: none !important;
}

/* Number of Colors Input - Disabled State */
.upload-group input[type="number"]:disabled {
    background-color: #f5f5f5 !important;
    cursor: not-allowed !important;
    opacity: 0.8 !important;
}
</style>

<style>
.design_studio_up .design_footer-flex .owl-stage {
    transform: none !important;
}
.design_studio_up .design_footer-flex .owl-stage-outer {
    transform: none !important;
}
.design_studio_up #save_design_modal .design_build_modal .modal-body {
    padding: 24px 20px !important;
}
.design_studio_up .responsive_color_slider{
    display: none !important;
}
@media (max-width: 1700px) {
.design_studio_up .desktop_color_slider{
    display: none !important;
}
.design_studio_up .responsive_color_slider{
    display: flex !important;
    justify-content: flex-end !important;
    margin-left: 0px !important;
}
.design_studio_up .responsive_color_slider .design_studio_slider{
        margin-top: 24px;
        padding-top: 0px;
}
.design_studio_up .responsive_color_slider .slider_col, .design_studio_up .responsive_color_slider .col-md-6{
    padding: 0px;
    display: flex;
    justify-content: flex-end;
    margin-right: 4px;
}

.design_studio_up .responsive_color_slider .design_footer-flex{
    margin-right: 0px !important;
}
.design_studio_up .responsive_color_slider .carousel_center_minimum .thumb_slider_footer{
    margin-right: 0px;
}
}

@media screen and (max-width: 1350px) {
    .design_studio_up .responsive_color_slider .slider_col, .design_studio_up .responsive_color_slider .col-md-6{
        margin-right: 0px;
    }
}
</style>
